webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/ZN45Wj/%3F1685203786283&title=Zaina&summary=In%20her%20eyes%2C%20there%20%20is%20a%20mysterious%20secret%3B%20a%20city%20of%20secrets%20and%20a%20unique%20power...%20%20Whoever%20dived%20into%20her%20eyes%2C%20he%20would%20enter%20other%20depths%2C%20settled%20in%20them%20and%20never%20wanted%20to%20leave.%20Zaina%20ia%20a%20Challenge%2C%20a%20confrontation%2C%20a%20silence%20and%20a%20revelation...%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/ZN45Wj/%3F1685203786283",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=In%20her%20eyes%2C%20there%20%20is%20a%20mysterious%20secret%3B%20a%20city%20of%20secrets%20and%20a%20unique%20power...%20%20Whoever%20dived%20into%20her%20eyes%2C%20he%20would%20enter%20other%20depths%2C%20s%0Dhttps://textcafe.co/books/ZN45Wj/%3F1685203786283&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/ZN45Wj/%3F1685203786283&posttype=link&caption=In%20her%20eyes%2C%20there%20%20is%20a%20mysterious%20secret%3B%20a%20city%20of%20secrets%20and%20a%20unique%20power...%20%20Whoever%20dived%20into%20her%20eyes%2C%20he%20would%20enter%20other%20depths%2C%20settled%20in%20them%20and%20never%20wanted%20to%20leave.%20Zaina%20ia%20a%20Challenge%2C%20a%20confrontation%2C%20a%20silence%20and%20a%20revelation...%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/ZN45Wj/%3F1685203786283&description=In%20her%20eyes%2C%20there%20%20is%20a%20mysterious%20secret%3B%20a%20city%20of%20secrets%20and%20a%20unique%20power...%20%20Whoever%20dived%20into%20her%20eyes%2C%20he%20would%20enter%20other%20depths%2C%20settled%20in%20them%20and%20never%20wanted%20to%20leave.%20Zaina%20ia%20a%20Challenge%2C%20a%20confrontation%2C%20a%20silence%20and%20a%20revelation...%20&media=https://textcafe.co/books/ZN45Wj/media/FC-9789948043430.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon UK',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.co.uk/s?k=9789948043430&i=stripbooks&linkCode=qs',
        alt: ''
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9789948043430').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/ZN45Wj/media/FC-9789948043430.jpg?1685203786283',
        alt: 'Zaina'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "nav", "text/ch001", "text/ch002", "text/ch003", "text/ch004", "text/Section0001", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/ZN45Wj/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_text_title_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_ch001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_ch002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_ch003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_ch004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_Section0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_last__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_last__);
/*jshint esversion: 6 */















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/nav",
    "name": "nav",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_nav___default.a
  }, {
    "path": "/text/ch001",
    "name": "text/ch001",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default.a
  }, {
    "path": "/text/ch002",
    "name": "text/ch002",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default.a
  }, {
    "path": "/text/ch003",
    "name": "text/ch003",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default.a
  }, {
    "path": "/text/ch004",
    "name": "text/ch004",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default.a
  }, {
    "path": "/text/Section0001",
    "name": "text/Section0001",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_text_Section0001___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZN45Wj/media/FC-9789948043430.jpg?1685203786283",
      "alt": "This image is the cover for the book Zaina"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Zaina\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In her eyes, there  is a mysterious secret; a city of secrets and a unique power...  Whoever dived into her eyes, he would enter other depths, settled in them and never wanted to leave. Zaina ia a Challenge, a confrontation, a silence and a revelation...  Zaina is all what  a girl needs. Zaina is love, patience, strength and beauty... Zaina belongs to Zaina’s time only.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rania Namer Eitah\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rania Namer Eitah is a writer of prose stories, novels, and poetry. She was born in Syria, in 1981. She holds a Bachelor of Arts degree in English literature, from Damascus University. She also holds a postgraduate educational certificate from Damascus University, in English language, and is also a human development trainer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Zaina")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Rania Namer Eitah is a writer of prose stories, novels, and poetry. She was born in Syria, in 1981. She holds a Bachelor of Arts degree in English literature, from Damascus University. She also holds a postgraduate educational certificate from Damascus University, in English language, and is also a human development trainer.")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("How much I love to place my head on her pillow and between her arms. Her warm touch was the last thing I felt before closing my eyes. In her hands, there is peace and reassurance that I desire to surround our world today. She made me see myself and discover my identity. She made me up from her words and her feelings. She drew my way in knowledge. And created the writer I am today. To the lady of my thoughts and the lady of my pens. To my soulmate and my entire life. To my mother.")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('h1', [_vm._v("Copyright Information ©")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rania Namer Eitah 2022")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("The right of Rania Namer Eitah. to be identified as author of this work has been asserted by her in accordance with Federal Law No. (7) of UAE, Year 2002, Concerning Copyrights and Neighboring Rights.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to legal prosecution and civil claims for damages.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("ISBN 9789948043423 (Paperback)")]), _vm._v(" "), _c('p', [_vm._v("ISBN 9789948043430 (E-Book)")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Application Number: MC-10-01-7447971")]), _vm._v(" "), _c('p', [_vm._v("Age Classification: E")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("The age group that matches the content of the books has been classified according to the age classification system issued by the National Media Council.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Printer Name: iPrint Global Ltd")]), _vm._v(" "), _c('p', [_vm._v("Printer Address: Witchford, England")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("First Published 2022")]), _vm._v(" "), _c('p', [_vm._v("AUSTIN MACAULEY PUBLISHERS FZE")]), _vm._v(" "), _c('p', [_vm._v("Sharjah Publishing City")]), _vm._v(" "), _c('p', [_vm._v("P.O Box [519201]")]), _vm._v(" "), _c('p', [_vm._v("Sharjah, UAE")]), _vm._v(" "), _c('p', [_vm._v("www.austinmacauley.ae")]), _vm._v(" "), _c('p', [_vm._v("+971 655 95 202")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Thanks and Appreciation")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To the wonderful lady who supports me and stays by my side. To my best friend, who provides me with love and passion, to my dearest sister. "), _c('strong', [_vm._v("Nour Al-Huda Eitah")])]), _vm._v(" "), _c('p', [_c('strong', [_c('br')])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("On the glass of my window, I drew a heart and wrote his name inside it; the one that captivated me for years!")]), _vm._v(" "), _c('p', [_vm._v("I have become like the genie that waits for his master to touch the lamp, so that he can come out and say, “Your wishes are my commands.”")]), _vm._v(" "), _c('p', [_vm._v("I will fulfill all his wishes, not just three. What I wish most was to remain his captive for life, and I won’t devote his third wish for my freedom.")]), _vm._v(" "), _c('p', [_vm._v("Love is the sultan who sits on the throne of the heart and orders it to act; love freezes the mind and makes it paralyzed. It makes thinking a non-existent quality within the lover. The heart becomes the controller because it is the obedient of the authority of love. For the sake of love, the rules are broken and even become forbidden!")]), _vm._v(" "), _c('p', [_vm._v("Love has different laws, it only follows itself, it may destroy entire human bridges to reach its goal, to reach its lover, to capture his heart, to become a power over two hearts, and to become the strongest among all sultans.")]), _vm._v(" "), _c('p', [_vm._v("I stand every day on the balcony of my house, wearing my white dress and putting a pink hat on my head. I watch the wide sea, the gulls flying over my head, a very charming view, a green space on one side, and my house flowers garden on the other side… I love the smell of flowers that takes me to another world.")]), _vm._v(" "), _c('p', [_vm._v("To the world in which I live with the noble man whom I have always loved, for long years ago, he settled in my heart, my mind, and my feelings and occupied my thoughts. He stole my freedom, and drove the lovers away.")]), _vm._v(" "), _c('p', [_vm._v("Every day I imagine this scene, every day I imagine myself between his arms.")]), _vm._v(" "), _c('p', [_vm._v("My name is Zaina; I work in the city center. I am a lonely and a sad girl! My house overlooks a small lake where you can hardly see water, no birds, no garden, it is a spacious and very old house, but it is solid against wind and storms.")]), _vm._v(" "), _c('p', [_vm._v("All I own were a brown dress, a scarf, an apron, and a basket made of straw, which I carry every day. I filled it with the vegetables that I brought from my small land that placed behind my house, from which I live with my mother and my sisters; Salma and Reem. Salma is a year younger than me, and Reem, my sweetheart, is the youngest of us.")]), _vm._v(" "), _c('p', [_vm._v("Each has its own room and this is the most beautiful thing! Our house is spacious and has two floors. My father built it with his own hands when he came to this small town. He painted it in light blue according to my desire – I loved this color because it is close to my eye color – and he decorated it with some antiques that he used to buy from a merchant who came every month to the city, to sell his cheap and beautiful goods. On the upper floor, there are the bedrooms, and at the bottom, there is a large living room with a fireplace inside. My father put a painting that I chose myself from the merchant, with a red flower painted inside and the sea behind it. There is also a small room for guests. The furniture of the house is very simple but comfortable. My father furnished the hall with carpets for fear of the cold, and he used to go to the forest and cut wood with his hands, the house remained warm and affectionate until he left us! Despite the fire that was not extinguished in it, the frozen hearts inside it turned it into permanent frost!")]), _vm._v(" "), _c('p', [_vm._v("Each one keeps her secrets apart from the other, especially Salma. Her mother’s friend and her spoiled daughter, she does not even resemble Ream and me, but rather she resembles my mother. As for Reem and I, we have very beautiful blue eyes!")]), _vm._v(" "), _c('p', [_vm._v("My eyes are very beautiful and have seduced many men. My eyes are the guide of the lovers to me, but they refused to pay attention to anyone; my eyes are very arrogant and proud of their charming beauty.")]), _vm._v(" "), _c('p', [_vm._v("I go every day to the market in the city center, not far from my house, but the road is bumpy. When you walk on that road, you feel that you are at the beginning of time, before people know the paved roads!")]), _vm._v(" "), _c('p', [_vm._v("Our city is deprived of many things. It is an underdeveloped city. No one paid any attention to it, or rather it is forgotten, or perhaps it is a cursed city and development is afraid to approach it!")]), _vm._v(" "), _c('p', [_vm._v("I meet female co-workers, each of them sells what is in her basket, some of them sell clothes, some of them sell embroideries, and some of them sell things for girls. It is a nice time that we spend together. Girls should sell everything in their baskets and get back to their houses with money or their families will get upset and deprived them from dinner, so they come to market the next day hungry.")]), _vm._v(" "), _c('p', [_vm._v("As for me, praise is to God, I have no concern; my vegetables are wonderful. I grow them myself in my small land behind my house. A very small land but I take care of it a lot; it is the reason for my livelihood that God has honored me with. I always sell everything and get back to my house with money and food and empty baskets.")]), _vm._v(" "), _c('p', [_vm._v("Many families depend on me in providing them with vegetables, so that sometimes I bring two or more baskets with me. When the sale is plentiful, one of the boys helps me in transporting my goods to the market for a small amount. This is the boys’ job: Helping girls to transport their baskets. The best of them is Jawad. He is smart and handsome boy.")]), _vm._v(" "), _c('p', [_vm._v("He loves me because I am generous with him, and I also love him very much, as he understands me very quickly. I also love his beautiful appearance, but poverty and fatigue hide a lot of his handsomeness. Like me, he is responsible for providing his family with money and food after his father passed away.")]), _vm._v(" "), _c('p', [_vm._v("He has a very cruel mother; if he does not bring her money every day, he will stay alone in a chair in front of the house all night. She does not allow him to enter the house, and this is why he is trying to deceive everyone in order not to return empty-handed to his mother.")]), _vm._v(" "), _c('p', [_vm._v("Our city’s houses are very old and they are cold. No affection and there is that sad smile on the faces. People concern is only to earn living and feed their children.")]), _vm._v(" "), _c('p', [_vm._v("In our city, women (especially young ones) who sell everything the house needs are better than their men who work in construction. As for our customers, they are either from inside the city or from neighboring cities.")]), _vm._v(" "), _c('p', [_vm._v("There are no schools, and learning is neglected, actually, it has restricted to a group of girls.")]), _vm._v(" "), _c('p', [_vm._v("Some families are more fortunate and richer than others; this of course has its reasons.")]), _vm._v(" "), _c('p', [_vm._v("Ten years ago, a wealthy man came to our city. He observed the beauty of our girls, so he offered to choose one of them every year. The girl would be as his daughter. He will take care of her and educate her. The girl’s family would receive a sum of money for giving up their daughter to the man completely. When the girl reaches the age of marriage, the noble man will choose a rich husband for that girl. So, this is the reason behind sadness in some families and the reason for her abundant livelihood as well!")]), _vm._v(" "), _c('p', [_vm._v("In the beginning, it was difficult for parents to see their daughters leaving their houses easily and they knew they wouldn’t come back, but the amount the nobleman provided for the families was large, so some families were the ones who exposed their girls to him! Especially, after Madeleine, a girl from a nearby city, came and show people how happy she was after staying at the nobleman house. She said that he educated her and provided her with money. She clarified that the nobleman teaches and trains girls to become noble women, and then marry them to nobles as well.")]), _vm._v(" "), _c('p', [_vm._v("People liked her story, and some girls wished to go with the nobleman, but the choice was not up to them, but rather to the nobleman himself. The girls gathered every year in the city square and he chose the most beautiful one between them.")]), _vm._v(" "), _c('p', [_vm._v("Two years after his arrival, the turn was for someone my age, but when I saw him, I fell in love with him. I did not accept to go with him, but rather asked Salma to appear instead of me. My mother refused and wanted me to appear because I am the most beautiful. I appeared in the worst look; I threw myself in the mud and became so dirty. When the nobleman saw me, he turned his face away because of my disgusting appearance. My father asked Salma to appear in front of him, but he did not choose her, so he did not take anyone from our family.")]), _vm._v(" "), _c('p', [_vm._v("My mother became very angry, and blamed me for losing the amount she would get from the nobleman. My sick father died afterwards. I worked after his death to make up for them; they ignored me and considered me just a reason for their living. The most hateful to me was my sister Salma, who discovered that I am the most beautiful and that I am a reason for her late marriage. Her hatred toward me increased every day. I became a lonely girl after my father’s death and my family denial of me.")]), _vm._v(" "), _c('p', [_vm._v("However, I am still in love and determined to marry that noble man, for I refused all the proposals. I knew how much he loves science, so I go every day to the city sage to teach me and educate me. I read a lot until I became proficient, but unfortunately, I cannot tell anyone about it; it stayed a secret between me and the city sage.")]), _vm._v(" "), _c('p', [_vm._v("The chosen girls were living in a wonderful house as a boarding school. I snuck in there once, and saw how much that nobleman cares about them! He teaches them everything until they become elegant and beautiful ladies. Sometimes he sent some of them to visit the city with their husbands to show the city people how he takes care of their girls and also to encourage them to send them to his school.")]), _vm._v(" "), _c('p', [_vm._v("I did not care about any of them, all that occupies my mind and my heart is that day when he will become my husband; I was sure of that, and I always dreamed of how our first meeting would be, and how he would admire my blue eyes and my shiny black hair!")]), _vm._v(" "), _c('p', [_vm._v("But how would I meet him with that worn out dress and old shoes? I thought about this a lot and decided the following: I earn a lot of money, so I should save a tiny amount every day, and keep it for myself, until I collect the price of the dress, shoes and hat.")]), _vm._v(" "), _c('p', [_vm._v("I am an educated person, so he will definitely admire me and my way of talking. I began to learn to write poetry, I read a lot and started writing, every day I write a poem on two sheets of paper; I keep one for myself and the other I send to him. I hid my papers and the money that I was saving in a small hole beside my father’s grave.")]), _vm._v(" "), _c('p', [_vm._v("I went to work every day, and upon return, I put a letter that titled ‘A wonderful love poem’ in his mailbox! I tried very hard to make sure that he was reading my letters, but I could not, and then I began to address the letters of: (Letters from The girl with blue eyes). So when he sees me, he will recognize that I am the one who sends him letters from the color of my eyes.")]), _vm._v(" "), _c('p', [_vm._v("I used to go out early every day, and go toward his house to check on him from a back window, while he was still sleeping wrapped in his white blanket, and before returning home, I passed by and saw him drinking a cup of tea, how beautiful the cup is in his hands! I wish to be by his side and give him the cup with my own hands, and sip the last drop of his cup!")]), _vm._v(" "), _c('p', [_vm._v("One time, I saw him reading one of my letters, and put it in a small drawer. He kept them, I can’t believe! On that day, I was overwhelmed with happiness. I went home dancing. I did not feel the length of the distance from the intensity of joy. I did not feel cold or hunger, but was filled with boundless happiness.")]), _vm._v(" "), _c('p', [_vm._v("When I arrived home the same happy day, I was greeted by my little sister Reem, who is very beautiful, very intelligent, and exactly like me. She was hoping that she would be chosen; everyone expected that because she is the most beautiful! She asked me, “What should I wear tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you so excited?” I answered her.")]), _vm._v(" "), _c('p', [_vm._v("“You will leave your family, and you will leave in our hearts the wound of your departure.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I want to learn and educate and become a noble lady, then marry a gentleman, and perhaps marry the noble, Kareem himself.”")]), _vm._v(" "), _c('p', [_vm._v("Her answer shocked me. Her ambition was very high; unlike all the girls that he chose. She would not cry but would perhaps introduce herself to him! I reassured her in a tone full of pity. “Do not worry, my little girl, I will buy you a beautiful dress in the morning to go with it, but do not hope that you will marry the nobleman himself. He is much older than you.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, Zaina! The important thing is the dress and we leave the rest to its time.”")]), _vm._v(" "), _c('p', [_vm._v("What an answer; it stole my joy, but no, I will not bother myself. I will borrow her dress from the clothes seller, and if he chooses her, we will pay for it from the money that the nobleman will give us; otherwise, I will pay from my savings. What is important now is Reem, and I will collect money for myself later.")]), _vm._v(" "), _c('p', [_vm._v("Indeed, the next day came, and Reem was the one who was chosen, because she is the most beautiful. The nobleman looked directly into her blue eyes with a great admiration and said to her, “How beautiful the blue eyes are.”")]), _vm._v(" "), _c('p', [_vm._v("What a painful moment to me!")]), _vm._v(" "), _c('p', [_vm._v("Reem smiled and said, “Yes sir, is there anything more beautiful than the blue eyes?”")]), _vm._v(" "), _c('p', [_vm._v("He took her and went, and the fire started burning my chest, and the feeling of jealousy was eating me. I was the reason; I was the one who alerted him to the beauty of blue eyes. How stupid I am! But no, he knows that Reem is young and cannot even recognize between letters. He will test her and discover how ignorant she is, and that she does not know how to read and write.")]), _vm._v(" "), _c('p', [_vm._v("I will forget what happened and continue my life. I will enjoy the money that he left for us, but my mother took the money. She was very happy. She told me that I do not have the right to ask for any penny from it, she will buy a new house. My sister will marry our neighbor’s son who proposed to her immediately after Reem had left with the nobleman.")]), _vm._v(" "), _c('p', [_vm._v("Salma accepted his proposal which made me happy and would no longer feel guilty that I am the prettiest and that she will not marry because of me. The big surprise was that they didn’t want to live with me; my mother told me that I have to stay in our old house and support myself. At the same time, I had to give her half of what I earn, and a quarter to Salma. This is their right from my father’s property. I accepted; I had no other choice. I didn’t argue her. I was so distracted and what occupied me at that time was how nobleman looked at Reem’s eyes!")]), _vm._v(" "), _c('p', [_vm._v("I did not sleep for nights; the picture of Reem with the nobleman was engraved in my mind and my heart. I stopped sending him poems for a while. I went to work every day depressed. Jawad helped me as usual; he took care of me as I took care of him. He knew when I am sad by looking into my eyes.")]), _vm._v(" "), _c('p', [_vm._v("On terrifying rainy days, he slept beside the fireplace in my house; he did that out of fear for me, and other times when his mother refused to let him stay at home.")]), _vm._v(" "), _c('p', [_vm._v("On one of the bleak rainy nights, my door knocked; I opened it and found my friend Laila in front of me. She was crying and mourning, I asked her to get in. She cried for an entire hour, and after she calmed down, she began to explain: Her husband loved another woman, and he wanted to marry her, but she didn’t marry him unless he divorced Laila. Laila was pregnant in her last month and didn’t have any one in the world, but a mean brother. He did not bother himself to open the door of his house when she sought to refuge to him.")]), _vm._v(" "), _c('p', [_vm._v("I was very happy that Laila came to stay with me, as I was alone all day long. She pulled me out of the depression that Reem left inside me. I went back to writing and sending poems to my wonderful man. This time, I was sending my mail with my little friend Jawad, who used to put it directly in the small mailbox that located in front of the gate of the noble man’s palace. Every evening, I sneaked behind his garden, enjoying watching him reading my letters. After finishing reading my letters, he put them in his little drawer.")]), _vm._v(" "), _c('p', [_vm._v("I waited eagerly for Laila’s new baby to be born. I was happy that a new life would enter my miserable world. Laila is my friend since childhood. A diligent girl, who works hard to earn her food. We went to the market together every day. We spent beautiful days; we laughed a lot and suffered from weather and lack of customer. When she came back with her basket empty, I used to put her a little money. Her brother was an unjust man. He let her married to the first man who proposed to her. She suffered with him a lot. I am happy that he expelled her and that she will not give birth and torture another soul with him and the most beautiful thing is that she will not return to live with her brother!")]), _vm._v(" "), _c('p', [_vm._v("Laila’s brother is married to our friend Maryam; he has a beautiful baby girl named (Sarah). He is waiting impatiently for her to grow up a little to be chosen by the nobleman, but Maryam will not allow him, as she is all she has, and she even intends to escape with her daughter when she reaches the appropriate age!")]), _vm._v(" "), _c('p', [_vm._v("Maryam is like us; she works and sells the cloth, which her brother Hazem brings for her from neighboring villages. They shared the profits. Maryam and I were not close friends, on the contrary, we were not very attracted to each other, but in adversity we always side to side as if we were two sisters!")]), _vm._v(" "), _c('p', [_vm._v("Hazem is an excellent young man; he was several years older than us.")]), _vm._v(" "), _c('p', [_vm._v("We all loved and respected him. He was a reliable man who could help in every way.")]), _vm._v(" "), _c('p', [_vm._v("I am late to marriage in the eyes of the people of the city; all of my friends got married at the age of sixteen, and some of them before that, but I am still young! I do not like the marriage of young girls.")]), _vm._v(" "), _c('p', [_vm._v("I loved my nobleman nine years ago, and I am waiting to be over twenty, and become a noble lady and marry him. I will disclose to him that l love him. I do not think that the nobleman exceeded thirty-three, when he moved to our city he was twenty-four years. He is still young and handsome.")]), _vm._v(" "), _c('p', [_vm._v("I am sure we will get married and have children. I will try to make him care about our city, and give up the idea of ​​taking girls in this way. I will convince him to educate everyone in the city. He is very kind; I am certain of him, and he will do everything for developing our city.")]), _vm._v(" "), _c('p', [_vm._v("Maryam visited us and brought her daughter Sarah with her. I was very happy with this visit, but Maryam was not happy at all. She talked about her husband’s injustice to her, and that her brother could no longer tolerate his oppression to her. Maryam never spoke about her husband in this way! Tears filled her eyes, and her voice suffocated from one phrase to another. There are some bruises on her face and her hands. Whoever looks at her notices the extent of the suffering and grief she is subjected to! We asked her to be patient since we could do nothing for her. She shook her head without saying a word; her heart was filled with pain and grief overwhelmed her soul.")]), _vm._v(" "), _c('p', [_vm._v("Suddenly, Laila cried out, “The time has come, the time has come!”")]), _vm._v(" "), _c('p', [_vm._v("We summoned the midwife of the village, I was very confused, but I remembered my mother when she gave birth to Reem. I went back years; I loved Reem and took care of her. I raised her as if I were her mother despite my young age! But Reem left us without regret for us. Sometimes, I miss her deeply, because she was the only one who was smiling at me! It’s okay, what important now is to be happy, educated and have a good life.")]), _vm._v(" "), _c('p', [_vm._v("We were so frightened but at the same time, we were effective and active. Laila’s screaming was so high that it penetrated the walls and reached the sky. She was suffering and I was agonized by her screams. I started to pray for her. Maryam did all the tasks; she prepared towels, water, and the baby’s clothing. I was stunned by the strength of Maryam, there is no stronger than her in situations like this, despite all her pain and miserable life, she took care of Laila as if she was her own sister. Two hours of waiting, shouting, praying, and crying! Finally, a beautiful sound of crying rose around the house. Laila stopped screaming and groaning in pain and a new voice of life began to flow inside my house. Umm Salem (the midwife) headed toward me carrying a wonderful, beautiful baby girl.")]), _vm._v(" "), _c('p', [_vm._v("She put her between my arms. The baby was like a little angel and she was shining like a little star in the dark night.")]), _vm._v(" "), _c('p', [_vm._v("The midwife said, “A beautiful girl, good tidings, and livelihood. What will you call her?”")]), _vm._v(" "), _c('p', [_vm._v("Laila shouted, “Zaina… I’ll call her Zaina, and Zaina will be her beautiful aunt.”")]), _vm._v(" "), _c('p', [_vm._v("How could she speak after all that screaming and pain?")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t stop myself from crying, I was so happy; she will call her daughter Zaina!")]), _vm._v(" "), _c('p', [_vm._v("I dressed the baby and then took her back to her mother’s lap. I took out half of my savings; the money I kept for buying the dress and the shoes, I went shopping. I had to buy food for the weak mother and some clothes for the new baby. I was happy even though I was spending my money. I don’t care; I will work hard and collect another amount. The point now is to keep Salma and little Zaina warm and healthy.")]), _vm._v(" "), _c('p', [_vm._v("I bought clothes for the baby and the mother. I also bought food. We spent a very beautiful night. It was the most beautiful night we had. We ate, laughed, and kissed the little girl. Maryam stayed with us till the morning, and Umm Salem did not leave us until she was reassured that everything was fine.")]), _vm._v(" "), _c('p', [_vm._v("Laila and I pledged that we would raise her well, and we would teach her to become a noble lady. We would never present her to the nobleman when she is ten years old.")]), _vm._v(" "), _c('p', [_vm._v("I asked Laila to stay home and take care of the baby. She also had to rest and took care of herself. I woke up early every day wearing my dress and putting on my apron. I collected my vegetables, cleaned them, and arranged them in the baskets in charming ways to draw attentions to them. I put Laila’s embroideries in elegant way in her basket and asked Jawad to carry it.")]), _vm._v(" "), _c('p', [_vm._v("Laila is skilled in making embroideries, but they don’t always have customers. On occasions, she sold a lot, but on normal days, her basket always returned as she took it; full without even selling one piece.")]), _vm._v(" "), _c('p', [_vm._v("We spent beautiful times that I sold all my goods every day. Although it was tiring to work hard alone and to sell different goods, I was happy. I spent from my own profit on food and what I gained from Laila’s goods; I gave them to her to keep for little Zaina needs. Jawad was very happy also that he never slept outside his house in that period because his share of what we gained was enough to keep his mother satisfied.")]), _vm._v(" "), _c('p', [_vm._v("I stopped writing new poems for the nobleman; I sent him old poems I kept for such time. I was so organized and ready for any circumstances.")]), _vm._v(" "), _c('p', [_vm._v("After few weeks, Laila recovered completely and started working with me. We went to the market with baby Zaina. Who finished first went back to the house with the baby. When the little Zaina got tired, Laila stayed at home to take care of her.")]), _vm._v(" "), _c('p', [_vm._v("One day, I asked Laila to stay at home with her daughter; I told her, “Her temperature is high, you don’t need to go. I work today and you are looking after her.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “I don’t know. I feel a tingling in my heart.”")]), _vm._v(" "), _c('p', [_vm._v("I said to her, “Do not be afraid, you did not sleep yesterday. Sleep now and take care of your baby, and I will bring food with me.”")]), _vm._v(" "), _c('p', [_vm._v("At afternoon, I went home; I did not find Laila, I only found Zaina crying and her temperature was high. I took her immediately to the doctor of the city. I gave Zaina the medicine which enabled her to sleep. She was a baby and she would recover quickly.")]), _vm._v(" "), _c('p', [_vm._v("I sent Jawad to look for Laila all over the city, and the first place he went, of course, to her brother’s house. He knocked on the door a lot, but no one answered. He went to her ex-husband’s house, he didn’t find anyone. It was clear that he had sold the house and left the city. He went to live far away with his new wife.")]), _vm._v(" "), _c('p', [_vm._v("Jawad searched everywhere but in vain. I couldn’t move out from the house for three days. I couldn’t leave the baby alone. I spent on myself from the money I saved for the dress and the shoes which I would wear in front of the nobleman. That was the tenth time I collected the money and I spent it. It’s okay, I will collect it again. Money is very useful in time of crisis. Jawad bought me everything I needed.")]), _vm._v(" "), _c('p', [_vm._v("On the fourth day, little Zaina started laughing. I gave her the medicine which would keep her sleeping for two hours and I asked Jawad to stay with her. I had to go to work. I collected my vegetables and went to the market.")]), _vm._v(" "), _c('p', [_vm._v("People in the market gathered around me and asked me about the reason of my absence. I said nothing; I don’t like to speak about my own life. I didn’t want also anyone to know about Little Zaina whom I left alone with a little boy in the house. I didn’t even want them to know about being Laila living with me. The presence of Laila and little Zaina in my life is the reason for my happiness, despite all the pain that I suffer from my undefined love. I sold everything; I was happy but at the same time, I was worried about Laila.")]), _vm._v(" "), _c('p', [_vm._v("On my way back, I saw a young man whose hand was injured and bleeding, I hurried towards him and asked him, “What happened? What is wrong with you? Do you want help?”")]), _vm._v(" "), _c('p', [_vm._v("He told me that he owned a horse and that he had been robbed, and he wanted to go back to his town. All he wanted was the price of the train ticket to come back. I gave him the price of the ticket, and it was almost all I had. I wrapped his hand by my hair tie.")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Go… I wish you to get well.”")]), _vm._v(" "), _c('p', [_vm._v("He promised me that he would come back and give me my money back. He asked me about my name. I told him, “Zaina, I work downtown, but it’s okay, go, I don’t want the money, be safe!”")]), _vm._v(" "), _c('p', [_vm._v("He thanked me, looked at my eyes, and said, “Your eyes are so beautiful!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Go now, I have to go home.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and went back to my house. His words pleased me a lot; I felt that I was still beautiful. I flew with my imagination to the moment when noble Karim would tell me that my eyes are the most beautiful he had ever seen, but he would definitely not say it, because Reem’s eyes had the same shape and color of my eyes. The young man’s words made me feel that I still exist. Perhaps I disappeared from existence because of worries and circumstances. All this would not make me give up. I will achieve what I waited for. Life is not for specific people, and there is a place for everyone.")]), _vm._v(" "), _c('p', [_vm._v("I arrived home exhausted. The baby is still sleeping. I thanked Jawad and gave him the rest of the money. I asked him to buy me a loaf of bread. I haven’t eaten since yesterday, but I can no longer stand. If I get tired, who will take care of that child and the affairs of the house? Jawad noticed the blood on my apron so he asked me curiously about it.")]), _vm._v(" "), _c('p', [_vm._v("I told him, “It’s okay, dear, I helped a wounded person.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad bought a loaf; we shared it together.")]), _vm._v(" "), _c('p', [_vm._v("While we were eating, he asked me, “You haven’t sent messages to the nobleman for a week.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him, “Laila’s absence worries me greatly.”")]), _vm._v(" "), _c('p', [_vm._v("He was right, I should send letters or the nobleman will forget me.")]), _vm._v(" "), _c('p', [_vm._v("Jawad left me and went back to his house. I washed my clothes from the blood of that stranger. I said to myself I wish I had not told him who I am; he would definitely not come back. I didn’t even ask him about his name, and I don’t know anything about him.")]), _vm._v(" "), _c('p', [_vm._v("I won’t think about him right now; I have more important things to do.")]), _vm._v(" "), _c('p', [_vm._v("At evening, I started writing a poem while little Zaina was laughing in front of me. I will send the letter tomorrow with Jawad. I will never stop writing letters again.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, I woke up on a knock on my door. I was so tired. I opened my eyes hardly and rose up lazily. I opened the door and found Laila in front of me. I looked at her and shouted, “It is really you!”")]), _vm._v(" "), _c('p', [_vm._v("I rubbed my eyes until I could see well; it was Laila with Maryam and Sarah. Laila was covered with blood. “What happened?” I yelled. Laila’s hands were bleeding, Sarah was crying hard, and Maryam was dazed.")]), _vm._v(" "), _c('p', [_vm._v("I sent Jawad to bring the city doctor. I started cleaning Laila. Sarah couldn’t stop crying and Maryam was in deep shocked. I asked them never speak until the doctor leaves. Laila’s wounds were cleaned. The doctor treated her, and then she fell into a deep sleep; she slept for two consecutive days!")]), _vm._v(" "), _c('p', [_vm._v("At that time, I tried to calm Sarah and feed her. Maryam remained silent. Laila woke up on the third day and began to speak on her own.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “When you went to work on the day of my disappearance, Sarah came crying and said, ‘Come, save my mother.’ I don’t know how she got here, but she was very tired. I left Zaina and ran to her. I saw my brother beating her. I pushed him away. He left immediately, but he came back an hour later with a whip and started to hit us both. I couldn’t prevent myself from hitting him. He became so violent and pushed Maryam on the floor, which obliged me to bring a knife from the kitchen and stuck it in his stomach; he died instantly.”")]), _vm._v(" "), _c('p', [_vm._v("“We closed the door, and watched the body for two days. Then, an idea occurred to me; the ceiling of the inner room was made of worn wood and so fragile. I climbed over it at night and dropped it after I put my brother’s body under it. I cut my hands; it is not easy to drop a ceiling. I put a piece of wood inside the wound I caused to him. If anyone sees him, he will think that the roof was the cause of his death. Then we came to you!”")]), _vm._v(" "), _c('p', [_vm._v("Laila slept again after telling me what happened; she was running away from her brother’s image by sleeping; has she ever imagined that she would finish his life in such a way. His violence obliged her to kill him. She defended his wife and child.")]), _vm._v(" "), _c('p', [_vm._v("I prepared Reem’s room for Maryam and her daughter to sleep in. My house was old, but it was full of warmth and love.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, the police came and interrogated us; everything seemed normal. Maryam did not say a word; I was cleverly and resourcefully able to convince them that she was so fond of her husband and his death was a shock for her which made her unable to speak again. They asked why everyone was staying with me. I told them that she left the house a week ago because of her fear that her house would collapse in any moment. Her husband was out of the city at the time. When he returned he did not find her, so they didn’t see each other before his death. What happened had happened. Laila convinced them that her brother was neglectful, and that she warned him that if he did not fix the house, she would take his family to live with her. This is actually what happened. The police did not suspect anything. Laila and Maryam looked very sad; for despite his brutality, they didn’t accept that ending to him! They didn’t ever imagine they would kill him.")]), _vm._v(" "), _c('p', [_vm._v("The police declared the house unfit for habitation and that the death was just an accident. They buried the body immediately. We held a simple funeral for him; not many people attended.")]), _vm._v(" "), _c('p', [_vm._v("The nobleman sent one of his men to offer his condolences to Maryam and Laila. He sent them a sum of money. He used, when someone dies in the city, to send him a sum of money, with enough food for a week for everyone in the house.")]), _vm._v(" "), _c('p', [_vm._v("My family members had increased; we became five beautiful women living in one house. A month passed since Sarah’s father passed away. Maryam never uttered a word; the house was quiet. I was the only one who was going to work; the money I gained was enough for us with what the nobleman sent us. The news of the death spread all over City.")]), _vm._v(" "), _c('p', [_vm._v("My mother and Salma heard the news, so they came to me. I was very happy when I saw my mother at the door. I approached her and wanted to hug her, but she kept me away from her with her usual cruelty, and began to scold and scream, “What is this, my house has become a hotel, and you bring your friends with their daughters to stay here?”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t know what to say. Salma’s looks were very malicious; a hateful smile filled her face and eyes.")]), _vm._v(" "), _c('p', [_vm._v("“There’s no need to talk like that, Mom, they are going through an ordeal, and I have to help them.”")]), _vm._v(" "), _c('p', [_vm._v("“Where did you get the money from?” she asked me in disgust. “You have not sent me money for a long time, you perhaps are spending it on them and on their children; she completed angrily.”")]), _vm._v(" "), _c('p', [_vm._v("“No, mom, I don’t spend on anyone,” I replied sadly. She broke my heart by her tyranny.")]), _vm._v(" "), _c('p', [_vm._v("Laila felt very embarrassed. As for Maryam, she came toward my mother, and took out of her pocket what was left of the nobleman money with her. She said after a long silence, “This money is yours, madam, in exchange for our staying here, and we will give you a sum every month for our residence here. Zaina will supervise it.”")]), _vm._v(" "), _c('p', [_vm._v("Salma withdrew the money and said, “It is a small amount, but it is okay. As for the issue of the monthly fee, my mother will supervise it herself. I am pregnant and I cannot come by myself; my mother will come every month to collect the amount, and to take our share from selling vegetables. You have to thank God that we will allow you to stay in our dear house.”")]), _vm._v(" "), _c('p', [_vm._v("Salma’s way of talking infuriated me, so I said angrily addressing my mother, “Then give me my share of the nobleman’s money which he gave you in exchange for Reem, your daughter, whom you sold for money.”")]), _vm._v(" "), _c('p', [_vm._v("My mother answered me coldly, “I have nothing for you, and I will come every month and take my share of the rent and the land.”")]), _vm._v(" "), _c('p', [_vm._v("They left coldly, I couldn’t cry, I didn’t want to speak; I didn’t even know what to say! They embarrassed me and insulted me in front of my two friends. They live in a beautiful house, and they bought a small shop for Salma’s husband by the rest of the money they took from the nobleman. Salma lives like a lady, unlike me; she does not walk in the heat or cold, and the basket is over her head. She is not afraid of being hurt by weather factors. She has never experienced remaining without food or drink. She has the most beautiful clothes and shoes, I have a brown dress, an apron and old shoes; I am afraid to walk with on the mud on rainy days so that the shoes will be torn. I am afraid that my vegetables will expose to drying or a flood, and when I am exposed to such situations, I eat one-day food in three days. They stole my money and my smile; they insulted me and my two friends. It’s okay I won’t cry, I’ll work and become rich and marry the nobleman!")]), _vm._v(" "), _c('p', [_vm._v("I turned to Laila sadly. She smiled and said, “It’s okay, Zaina, God bears witness that what you have done to both of us is not done by a sister or a mother…”")]), _vm._v(" "), _c('p', [_vm._v("I went to Maryam and asked her, “How could you speak?”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me and smiled, and answered painfully, “How not, my dear, thank you for having me in your house. She patted on my shoulder and went up to her room.”")]), _vm._v(" "), _c('p', [_vm._v("The next morning, we woke up and found Maryam turned the house upside down. She decorated it, arranged it, and made it beautiful with the simplest tools. Laila and I were amazed at the view of the house. What we saw made us very happy. She prepared a delicious breakfast for us. I sat around the dining table; I may have forgotten that I already have a table in the living room! But this table was not like ours, it was decorated, neat and clean. The room that day was warm. The table was full of food. I sat on the chair and I was fascinated and confused what to eat? Do I eat cheese or jam or drink milk? And maybe I’ll have a red apple when I’m done…I’ll take the apple and start my day with it; I told to myself.")]), _vm._v(" "), _c('p', [_vm._v("As soon as I touched the apple, Laila cried, “Wait a minute!”")]), _vm._v(" "), _c('p', [_vm._v("She turned to Maryam and asked her, “What is it, where did you get the food from?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam, with a smile of victory, said, “I bought it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What, where does the money come from? You gave everything you had to Zaina’s mother!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I woke up in the morning, decided to clean the house and organize everything. Yesterday, I decided to start a new life and go back to work. We have to move on with our lives and forget what happened.”")]), _vm._v(" "), _c('p', [_vm._v("While I was cleaning the place, I was thinking how we would gain money for rent and food and for the two little girls, and how I would bring goods and sell them. I got dressed and went to the merchant. I begged him to give me goods to sell and I pay the price at the end of the month. Of course, he refused sharply, and he told me that he did not want me to work with him anymore. I was so sad. I went to Salma’s house, yes, do not be surprised, I went to your sister’s house, Zaina! I wanted to beg her to cancel the rent.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Of course, she will not agree, but she will expel you immediately after the last day of the month.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Thank God, I did not meet her. Rather, I met Faris, Salma’s husband, who was standing in front of the door of the house. He asked me, ‘Who are you and what do you want?’”")]), _vm._v(" "), _c('p', [_vm._v("He was carrying a bracelet, and the money I gave to your mother yesterday. I had a strange feeling that he was a thief; stealing their things and selling them. I looked at him shrewdly and asked him, “You are the one who stole my money!”")]), _vm._v(" "), _c('p', [_vm._v("He replied surprisingly, “What money?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “My money is in the brown bag you are carrying now, and also Salma’s bracelet. I came to retrieve them because I changed my mind. After I asked her to bring me goods, I found another merchant. I will call her to find out that you are a thief.” I started screaming, “Salma!”")]), _vm._v(" "), _c('p', [_vm._v("He put his hand over my mouth and said, “Shut up, you madwoman, you will cause us a scandal. Come with me and we will make a deal.”")]), _vm._v(" "), _c('p', [_vm._v("We went to his small shop, which collects all kinds of preserves, cheeses and sweets!")]), _vm._v(" "), _c('p', [_vm._v("“What do we agree on?” I asked him quietly.")]), _vm._v(" "), _c('p', [_vm._v("He answered me with a smile, “I will return your money and then you should leave as if you did not see me and I do not know you, okay?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, I will take my money, and enough food for me and my daughter for a week, and you have not seen me and I do not know you!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “First, how do I know that this money is yours?”")]), _vm._v(" "), _c('p', [_vm._v("I told him the amount in the bag; he gave it to me and filled me a box with all kinds of food and fruits. Before I left, he asked me, “At least tell me your name!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “You’re going to sell the bracelet in this neighborhood? Or you are going to give it to your girlfriend. If you want to give it to your sweetheart, ask her to avoid putting it in front of Salma.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed out loud and said, “I will not sell it here and I don’t have a girlfriend, thanks for the advice. Won’t you tell me your name?”")]), _vm._v(" "), _c('p', [_vm._v("I turned to him with a smile that was full of femininity.")]), _vm._v(" "), _c('p', [_vm._v("“When I run out of eggs, I will come to you and tell you my name.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed again and said, “I wish it would run out now, but you will pay for it next time!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him hurriedly, (I want to go out for fear that Salma or your mother will come), “I doubt that.”")]), _vm._v(" "), _c('p', [_vm._v("I ran out, the sound of his laughter filling the place.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well done, well done! The money came back with food.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “I didn’t know you two are so evil; can I eat the apple now?”")]), _vm._v(" "), _c('p', [_vm._v("We all laughed. It was one of the most beautiful breakfast we had ever had, as if the fate was taking revenge on Salma quietly and without any interference from me.")]), _vm._v(" "), _c('p', [_vm._v("We all decided to work. Laila would work one day and stay at home one day; Maryam would do likewise. We have two children that we should not leave alone at home. On days when the weather is nice, we take them with us and work the three of us, but I will work every day, and so we started a new phase of our lives.")]), _vm._v(" "), _c('p', [_vm._v("I was so sad because of my appearance in front of Salma, I couldn’t forget her image wearing the most beautiful dress, and shiny new shoes. I looked in the mirror after I had collected vegetables and prepared my baskets. I was never disturbed by my life or my appearance as I am today. I left my baskets with Maryam and Laila, and then left. I went to the market of the neighboring city. I did not tell them where I was going, but I sped off, passed the house and took out a large part of the money I had saved for the dress that I would wear when I would met the nobleman .")]), _vm._v(" "), _c('p', [_vm._v("I never felt as embarrassed as I am today. I ran fast and entered the first store I passed by. The saleswoman did not receive me properly; perhaps she thought I was a beggar!")]), _vm._v(" "), _c('p', [_vm._v("I said, “Excuse me, I had an accident, and I want to buy new clothes, I lost my bags.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled, perhaps not believing me, or rather assured that I would pay for the clothes I was going to buy.")]), _vm._v(" "), _c('p', [_vm._v("She gave me two dresses with their shoes to try. They both were fitting me. I kept wearing the second one with its shoes. I looked at myself in the mirror, I saw a new woman. I saw a woman wearing a real dress; not a torn old one; a piece of shabby cloth to cover her body. How long I neglected myself. Some simple things will change us completely; despite of the fact that the dress was not so expensive, and wouldn’t show me as a noblewoman, it turned me to a real woman. I came out of the fitting room happy. I told the girl that I would not take it off, and the shoes. She did not mind.")]), _vm._v(" "), _c('p', [_vm._v("She asked me calmly, “Do you want nightwear dresses, my lady? We have beautiful things.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her in astonishment after I heard my lady’s word, for the first time someone respects me and called me my lady. All I hear all day long is: “How much do vegetables cost today, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her with some vanity and said, “Yes, my dear, I’ll see what you have; for after I’ve lost my bag I must need it.” I smiled inside me, now she totally believes me; why not!")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to buy two nightgowns, I only have two, and they are old and outworn.”")]), _vm._v(" "), _c('p', [_vm._v("I chose two nightgowns, now I have two of everything, two dresses, two shoes and two nightgowns, and I’m going to buy a scarf for the cold too…yes, the prices are very reasonable.")]), _vm._v(" "), _c('p', [_vm._v("She put my things in a bag, and said, “I hope to see you soon.”")]), _vm._v(" "), _c('p', [_vm._v("I thanked her with a smile on my face. I paid the money; I bought all these beautiful things, and I still have some money. I know I took out most of my savings, but it’s okay, I’ll work hard and save and save again for the clothes I will buy for meeting the nobleman.")]), _vm._v(" "), _c('p', [_vm._v("I was happy and at the same time very annoyed for neglecting myself for long time.")]), _vm._v(" "), _c('p', [_vm._v("I looked opposite of the store I bought the clothes from, I saw a wonderful hat shop. I headed towards it. I saw marvelous hats with different colors and shapes. I was fascinated by a white hat with a very beautiful pink ribbon. I imagined it on my head while I shook the hand of the nobleman, and introducing myself to him as I am Lady Zaina. The wonderful scene was interrupted in my head by the voice of a little girl; she was a month old girl, in a basket on the ground.")]), _vm._v(" "), _c('p', [_vm._v("I did not notice who had put it at my feet and when…")]), _vm._v(" "), _c('p', [_vm._v("I was looking at her while the shop owner shouted, “Take your daughter and stop her from crying!”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him in astonishment and asked, “Are you talking to me?”")]), _vm._v(" "), _c('p', [_vm._v("He shouted, “Yes, madam, have mercy on her and carry her, her heart will stop from crying!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with the same intensity, “But I don’t know this girl, she is not my daughter!”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me angrily and said, “You wanted to leave her here and escape like they always do, but thank God I caught you before you ran away, I’ll call the police.”")]), _vm._v(" "), _c('p', [_vm._v("I swore to him over and over again and again that the baby girl was not my daughter, and that I did not know her parents. He grabbed me tightly by my hand and called the police. People gathered around me while I was crying and screaming that she was not my child.")]), _vm._v(" "), _c('p', [_vm._v("The police came quickly and took me to the station. I repeatedly tried to convince them that she was not my daughter. The officer was very calm. He tried to calm me down and convince me that I should take care of my daughter. After more than half an hour, he stood up saying, “Be quiet, you have exhausted me. Take the girl and leave, or I will throw you in prison.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him with anger and tears filled my eyes. “I told you she’s not my daughter, why don’t you believe me?”")]), _vm._v(" "), _c('p', [_vm._v("He hit the table with his fist, making a sound that startled me. “You are all like this, you deny your children, why should I believe you? Everyone said that the baby is your daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I calmed down and answered him, “I have never been married in my life, I am a virgin girl, if you want, bring a doctor, and he will assure you that she is not my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("He was astonished at my answer and burst out laughing, and answered me sarcastically, “It’s okay, you get that.”")]), _vm._v(" "), _c('p', [_vm._v("He called his guard and ordered him to bring the doctor, but the guard answered him eagerly, “There is a woman who claims to have seen the girl’s mother.”")]), _vm._v(" "), _c('p', [_vm._v("He asked him to enter her quickly. It was the girl who sold me the clothes. I smiled when I saw her, as she is the best witness that I am not her mother. The officer told her firmly, “What do you have?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “This lady passed by me, and bought clothes from me. There was no one with her, no child, no one, she was alone, sir. Then she went to the opposite store.”")]), _vm._v(" "), _c('p', [_vm._v("She finished her sentence and looked at me and said, “God forgive you, why did you go there? I have hats that are prettier and cheaper than his.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “When we leave here, we go together and buy from you.”")]), _vm._v(" "), _c('p', [_vm._v("The officer looked at us and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“What else, do you have children’s clothes?”")]), _vm._v(" "), _c('p', [_vm._v("The girl was confused she looked at the officer and said, “Do you really want children’s clothes?”")]), _vm._v(" "), _c('p', [_vm._v("He shouted at her, “What else?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl innocently:")]), _vm._v(" “Shoes and bags…”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “What happened after she went out to the hat shop?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “Yes sir, I am sorry. While this lady was watching the hats, a young man, working as a salesman in one of the shops, passed by, and he put the basket in front of this young woman and ran quickly. I looked at him from afar; he talked to a lady putting a blue hat on her head. She gave him money and left quickly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Do you know the boy’s name?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “Yes, and I know where he works.”")]), _vm._v(" "), _c('p', [_vm._v("He gave her a paper and a pen, she wrote the address and the boy’s name on the paper. He gave the paper to the guard and asked him to bring the boy, and asked the girl to stay until the boy came; lest she be a liar.")]), _vm._v(" "), _c('p', [_vm._v("The baby girl started to cry, she kept crying and screaming. I was very sad; I wanted to hold her and feed her, but I can’t. The officer got a headache from the girl’s voice, he shouted at us, “Please carry her; I almost go crazy from her screams!”")]), _vm._v(" "), _c('p', [_vm._v("I looked sadly at the girl, but I couldn’t get close to her, I was stuck in my place, holding my bag of clothes tightly. I was afraid that someone would take it from me; I was so nervous.")]), _vm._v(" "), _c('p', [_vm._v("The other woman got up and took the little baby in her arms. She found a bottle of milk next to her. She gave her the nipple of the bottle, and shook her tenderly until she fell asleep, then she put her back in the basket.")]), _vm._v(" "), _c('p', [_vm._v("The guard brought the boy quickly. They entered the room. The officer asked the boy cleverly, “Why did you leave your daughter and departed? Take her with you and go. It’s okay we all make mistakes.”")]), _vm._v(" "), _c('p', [_vm._v("The boy flinched at the officer’s words and said, “But she is not my daughter, sir; she is the daughter of the lady who has the white car! Every week, she comes and buys many things from us, but today she came and asked me to put this basket in front of the hat shop. She said that there were hats she wanted to return.”")]), _vm._v(" "), _c('p', [_vm._v("He spoke spontaneously and quickly, the officer laughed at the spontaneity of the boy and asked him, “Didn’t you know there was a baby in the basket?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The boy:")]), _vm._v(" “No, sir, Mrs. Wedad did not tell me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Is Mrs. Wedad here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The boy:")]), _vm._v(" “She’s at her house; I just came from her house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Do you know her house?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The boy:")]), _vm._v(" “Of course, sir.”")]), _vm._v(" "), _c('p', [_vm._v("The officer asked the boy to go with the policeman and bring Mrs. Wedad. The officer looked at me and said, “If what the boy says is true, you will go home safely.”")]), _vm._v(" "), _c('p', [_vm._v("The saleswoman asked the officer, “Can I leave, sir?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at her and said sarcastically, “No, of course you can’t!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “Why, sir?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “And who will take care of the girl if she cries again, you will not leave before we see the woman called Wedad.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on my cheek; if Salma hadn’t come and insulted me in my house, I wouldn’t be here now. It was all her fault. I wish I hadn’t come, I started crying; the girl approached me and put her hand on my shoulder and said, “It’s okay, my dear, the lady is coming and explain everything and then you will go home.”")]), _vm._v(" "), _c('p', [_vm._v("The officer smiled and said, “Did you see your benefit? If the little girl cries or the adult one, you take care of them!”")]), _vm._v(" "), _c('p', [_vm._v("The officer’s words made me laugh; I looked at him and said, “I swear she’s not my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me calmly and replied, “I know, Virgin lady.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at the ground ashamed of his words. How did I have the audacity to utter such words? Sometimes we say things we don’t know if they are true or not, but the situation is what necessitates us to say them, we remember them after days and we are surprised by our boldness, then they become a memory that may make us cry or maybe we laugh!")]), _vm._v(" "), _c('p', [_vm._v("After about an hour of waiting and tension, the guard entered with Wedad and the boy. The officer looked at Wedad (a forty-year-old woman, dressed in luxurious clothes and a blue hat, she appeared to be cunning) angrily and asked her, “Who is this child for? How dare you leave her in front of the hat shop?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Wedad:")]), _vm._v(" “She’s the hatter’s daughter; he brought her to me in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("The officer after hitting the table again with his fist, said, “You liar, everyone knows the integrity of the hat-shop owner! Take your child and leave, or else I imprisoned you!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Wedad:")]), _vm._v(" “Well, sir, I’ll take her and go.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Officer:")]), _vm._v(" “Wait, you have to apologize to this girl first, or I’ll file a case against you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “No, I want to go. (Wedad was a tough woman and I didn’t want to fight with her.) God forgive her, I added, for perhaps she could not afford the baby, so she put her in front of the hat shop.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Wedad:")]), _vm._v(" “I’m richer than him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Then why do you deny the child and accuse the storeowner? You will not leave, woman, until I understand everything, or I will imprison you, and you will tell me to whom this child belongs.”")]), _vm._v(" "), _c('p', [_vm._v("The officer looked at me very attentively and said, “You can leave, Miss Zaina, you can leave with your friend, but you, young man, do not take anything from anyone without looking inside.”")]), _vm._v(" "), _c('p', [_vm._v("I went out sad from the police station. The daylight began to fade and the sun to disappear. The girl looked at me and said, “I’m Rasha.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her and said, “I don’t know how to thank you; you saved me from the disaster.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “I didn’t save you. I told him the fact. Listen, you’re going to come with me to my store and eat; you must be very hungry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “It’s okay, my dear, I have to go home, the sun is starting to set.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Come quickly, we won’t be late, I’ve got some delicious food in the shop, you’ll see, and if you’re late, I’ll drive you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “I think it is enough for you today. You wasted your time with me. I live in the neighboring town; I will go and you have to rest.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Come on, dear.”")]), _vm._v(" "), _c('p', [_vm._v("We walked towards the store. She started talking about her life. Rasha’s house is the store itself. She did not have any family; she left her family two years ago, and moved to work to help herself; after her father died and her mother married another man, she felt alone and outcast from her stepfather’s family. She suffered to find a place for her, until she met the owner of her store; an old man who took pity on her, he afforded her to work and sleep in the store for a tiny amount of money. She kept talking all the way about herself. We finally got to the store, she tried hard to get me in; she invited me to have dinner with her but I refused. I was late and I still had a long distance to walk to arrive to my home.")]), _vm._v(" "), _c('p', [_vm._v("I entered her store and picked out a white hat, which I wanted to buy in gratitude for what she had done with me.")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “My dear, it is a gift from me to you, please accept it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “No, Rasha, thank you for everything you’ve done. I have to leave now.”")]), _vm._v(" "), _c('p', [_vm._v("I put the price of the hat on the table. I wrote her my address on a small piece of paper, and invited her to visit me.")]), _vm._v(" "), _c('p', [_vm._v("I walked out of her store with heavy steps, I was very sad of what happened. The night began to fall little by little. There were many questions in my head; who is Wedad? Why did she leave her child? Is she really her child, and why did the storeowner say, “All of you are doing this?” All of you! So Wedad was not the first lady to leave her child on the road; what a city!")]), _vm._v(" "), _c('p', [_vm._v("It became so late; I started to speed up. There was a car walking slowly behind me; I was terrified very much. I turned behind. The car stopped when I turned, and the Officer got out of it. He headed towards me smiling.")]), _vm._v(" "), _c('p', [_vm._v("“Where do you live, Virgin lady?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him angrily and said, “Please stop calling me like that.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Well, what was your name?”")]), _vm._v(" "), _c('p', [_vm._v("“My name is Zaina.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Yes, Zaina, a beautiful name, and now where do you live?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “In the next town, I’ll be arriving soon.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Officer:")]), _vm._v(" “Well, come and ride with us. I’ll take you before I take the baby to the orphanage; it is on our way. Don’t be afraid; the guard is also in the car.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Why?”")]), _vm._v(" "), _c('p', [_vm._v("I almost passed out when I heard the word orphanage!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Because the road is full of bandits at night and you are a girl. I will take you home safely; this is the job of the police.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Why do you want to take the baby to the orphanage?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Get in the car and I’ll tell you, she’ll wake up and cry and no one can stop her.”")]), _vm._v(" "), _c('p', [_vm._v("I got into the car and the little girl was sleeping, I sat next to her and said, “Oh poor girl, where is Wedad? Didn’t she say she’d take her?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “That liar, she is now in prison, until we know for whom she works. During my conversation with her, her tongue slipped, and she said that she was not the first child she threw on the road, so there must be a secret behind her, and she will not leave prison until she confesses where she brings the children from.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “What is this cruelty? Whoever was not able to raise children, he shouldn’t bring them to life and leaves them to suffer from the bitterness of losing parents and safety. He should not expose them to pain.”")]), _vm._v(" "), _c('p', [_vm._v("The officer looked at me and said, “You’re right.”")]), _vm._v(" "), _c('p', [_vm._v("I held the child in my arms; I looked at her for a long time while she was sleeping helplessly. I held her to my chest and kissed her on the cheek. I stroked her cheek with my finger, and whispered in her ear, “What’s your name beautiful?”")]), _vm._v(" "), _c('p', [_vm._v("The officer answered, “Children like her have no name, no identity, no address, and even when they are taken to orphanage, their names are just numbers.”")]), _vm._v(" "), _c('p', [_vm._v("The child remained in my hands until we reached the house. At the door of the house, Maryam and Laila were standing waiting for me. They were very worried about me. I didn’t know how they would receive me. They surely would say Zaina is a mad woman because I was the one who left her baskets, and went running with a worn dress and torn shoes to reach the neighboring city, and return at night with a new dress, new shoes, a hat, in a police car And carrying in my hands a miserable child.")]), _vm._v(" "), _c('p', [_vm._v("They walked towards the car, shouting, “What’s wrong? Are you okay?”")]), _vm._v(" "), _c('p', [_vm._v("The officer got out of the car and hurried to the two girls and said, “She’s fine, please; she’s been through a lot today.”")]), _vm._v(" "), _c('p', [_vm._v("They were silent and looked at me from head to toe, not uttering a word; Maryam was the best who spoke in such situations.")]), _vm._v(" "), _c('p', [_vm._v("“We worried about you so much.”")]), _vm._v(" "), _c('p', [_vm._v("I added cleverly, “I went shopping and was late.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “It’s okay, madam.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “You are safe now with your sisters. Please give the child to the guard and go to have a rest.”")]), _vm._v(" "), _c('p', [_vm._v("As soon as the guard took the girl, she started screaming; the officer put his hand on his head and said, “Oh, my God, not again.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam approached the officer and asked him to give her the child, saying, “I will feed her, change her clothes, and bring her back to you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “We can’t, madam. We’ll be late for the orphanage.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila in astonishment:")]), _vm._v(" “Orphanage! Oh my God!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Please calm down, we have enough headaches from the morning, then we have neither clothes nor food for the baby.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam carried the child and said while cuddling her, “We have everything.” She looked at the girl and kissed her on the forehead, saying, “Do not be afraid, my dear, we have everything, food, clothes, a warm hug, a bed, and everything you need.”")]), _vm._v(" "), _c('p', [_vm._v("I approached the officer, with a calm smile and a childish look from my charming eyes, and looked directly at his eyes and said, “Please be our guest. I’ll make for you and your guard something to eat and drink while they take care of the baby.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at my eyes in amazement and said, “Well, only for half an hour.”")]), _vm._v(" "), _c('p', [_vm._v("Laila took the girl from Maryam. She took her to her room, and brought for her clothes from little Zaina’s clothes, while Maryam went to the kitchen and prepared a dinner worthy of our guests.")]), _vm._v(" "), _c('p', [_vm._v("The officer sat on the sofa quietly. He was contemplating my eyes and my smile all the time as if he was wandering in them. He forgot the world, and the heavy day that passed by. In my eyes, he found his sanctuary. Thank God I was dressed, but no, I will never think about him; my heart is outside my body, my heart is with Karim, the nobleman and master of the city!")]), _vm._v(" "), _c('p', [_vm._v("We all had dinner except Maryam; the one who took the child from Laila and sat with her the whole time contemplating her. Silence fell on everyone, and then the officer broke the silence, addressing his words to Laila. “Where is your husband, madam? I don’t see men in this house!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and replied instead of Laila, “No men here, only a group of ladies.”")]), _vm._v(" "), _c('p', [_vm._v("The officer, overwhelmed with joy, because I was the one who answered, “Why?”")]), _vm._v(" "), _c('p', [_vm._v("“First of all, we are friends. I am Zaina, as you know, and Laila is my best friend. Unfortunately, her husband left her when she was in the last month of pregnancy. She went to live with her brother, the husband of Maryam, who was carrying the child. Unfortunately, he died after their house fell on him. Maryam has a daughter. I have two sisters and a mother; they left me. I became alone, so God sent me two sisters and two nieces, and I formed a bigger and more beautiful family.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Why did your sister and mother leave?”")]), _vm._v(" "), _c('p', [_vm._v("“As for the elder, she married by the money of the younger one, whom the noble Karim chose to take care of her, so my mother left with the elder because her house is better than this.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Thank God they left the house; otherwise we would have stayed on the street.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Who is this Karim, and why does he choose girls, what is this nonsense?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Nonsense! Why?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “It’s okay; we have to leave now, thanks for the food and caring of the baby.”")]), _vm._v(" "), _c('p', [_vm._v("He got up annoyed. He was very upset by mentioning the name of the nobleman Karim. He looked at Maryam and said, “Thank you, madam. Please give the child to the guard.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Please don’t take her from me, I’ll take care of her and look after her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Yes, I have a child at her age; we will raise them together as sisters.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “I beg you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “I can’t, it’s not allowed, the girl should go to the shelter and take a number, and then you can adopt her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Adopt her! What does that mean?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Adopting her means taking her as your daughter in a regular and legal way, a good idea.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “The little girl will not sleep far from me; not even for one day.”")]), _vm._v(" "), _c('p', [_vm._v("The officer looked at me and said, “Has your friend gone crazy? Since you’re the smartest, and you know the meaning of adoption and the law, tell her to give the baby to the guard so we can leave.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand tenderly and looked with my charming eyes straight to his eyes. He looked at me in astonishment.")]), _vm._v(" "), _c('p', [_vm._v("I said quietly, “You don’t know who the child’s mother is; let’s suppose she is her mother. An hour ago, you asked me to take her and leave as she is my daughter. You didn’t care then for papers and proofs. Let her give her a name and identity, let her live in a warm house; don’t let her be as an unknown number, please!”")]), _vm._v(" "), _c('p', [_vm._v("The officer while his eyes were fixing on me. “It’s different now, there’s something hidden going on, and she will be a key to solve the case.”")]), _vm._v(" "), _c('p', [_vm._v("“A key to solve the case, and a lock for the happiness of the child. After God sent her three mothers, instead of one mother, you want to take her. Please let her enjoy a bed after her bed was the street!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Hours ago, you neglected her and now you want her!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Not me who want her, but Maryam, and I do not like to see her broken-hearted again, after she lost her husband. Then when I denied her I was defending my dignity and honor.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Right. ‘The Virgin.’”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand hard and said, “I told you not to repeat it; now I will stay two days to answer their questions.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Well, Zaina, I’ll leave the girl for her own good, but someone will come to take your data to make it legal. Thanks again for dinner.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Thank you for accepting having dinner in my humble home, and thank you for delivering me safe to my home, and thank you for leaving us Lynn.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Who’s Lynn?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “The little girl, I decided to give her the name Lynn.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Very beautiful.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Good choice.”")]), _vm._v(" "), _c('p', [_vm._v("He took out a card from his pocket with his name and phone number on it and handed it to me and said, “This is my number and address. If you need anything, do not hesitate to call, especially if it is about Lynn, I must leave before I become like you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")])]), _vm._v(" "), _c('p', [_vm._v("“How are we?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “You are a mixture of lonely women, who are full of tenderness and madness.”")]), _vm._v(" "), _c('p', [_vm._v("I read the card and said, “Is your name Amjad?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Prettier than the name Lynn, but Zaina is more beautiful, Zaina, oh…”")]), _vm._v(" "), _c('p', [_vm._v("He walked out of the house smiling; I know he wanted to say ‘Virgin.’")]), _vm._v(" "), _c('p', [_vm._v("At the door, he met Jawad; he was crying and saying, “Where have you been, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him sadly, “Oh, my God, I forgot about you today, come and sleep in my house, my little boy.”")]), _vm._v(" "), _c('p', [_vm._v("Amjad looked at me and said, “And who is this?”")]), _vm._v(" "), _c('p', [_vm._v("“My assistant at work, I did not work today so he did not take his wages; I forgot to tell Laila to give him money. Oh my God if he came back without money, he had to sleep outside his house; how cruel his mother is!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “It is different today. The nobleman Karim passed by the market and distributed the money to the children. I was not among them, so my mother got angry.”")]), _vm._v(" "), _c('p', [_vm._v("Amjad was listening to him interestingly. He said, “Why weren’t you there?”")]), _vm._v(" "), _c('p', [_vm._v("I said to Jawad, surprised, “Kareem passed by today!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Amjad:")]), _vm._v(" “Do you care?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Thank God I wasn’t there; I’m afraid he will think that I am one of the poor people and offer me something.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “He gave a lot today, but we picked up our baskets and walked away when he got close.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Good what you did.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Amjad:")]), _vm._v(" “Who is Karim, and what does he do?”")]), _vm._v(" "), _c('p', [_vm._v("The way he asked about Karim did not make me comfortable, and he will definitely look for him and know everything. I do not want Karim to know that Amjad is in our lives now. I think Amjad liked me, but I would never care about him. I will find a solution to this issue soon.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Amjad:")]), _vm._v(" “You adopt a child, you shelter your assistant at night for fear of his mother, you open your house to your friends, who are you, woman, and what is your heart made of?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “A vegetable seller, I own a small land on which I live. I am like the girls of the city. I love science, reading, and writing poetry. This is me; Zaina is a girl working in the City Centre.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Amjad:")]), _vm._v(" “Good bye, city girl; I will read your poetry someday. Take care of the baby please.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “She became our daughter! Bye.”")]), _vm._v(" "), _c('p', [_vm._v("She became our daughter, my God! Will we be able to spend on her? It’s okay. We will work hard and collect the money.")]), _vm._v(" "), _c('p', [_vm._v("I entered the house exhausted and tired. A hundred issues occupied my mind: my miserable day, the arrival of a new person in the family, the house, Salma, my meeting with the nobleman… When will I meet him?")]), _vm._v(" "), _c('p', [_vm._v("I closed the door and looked in front of me. Maryam was carrying the child with the tenderness of a mother, and Sarah was next to her. As for Laila, she carried the little Zaina and looked at me. I know she wanted to ask me about my day, who is this child, and where I was all the day? She was staring at me with curiosity from my head to toe, wanting to ask me about my new clothes, but I was tired and would not answer any of her questions, and in order to stop her, I turned to Jawad and asked him, “Are you hungry?”")]), _vm._v(" "), _c('p', [_vm._v("He replied with a sad look, “Yes, very.”")]), _vm._v(" "), _c('p', [_vm._v("I put him a little food with a glass of juice. He sat on the ground and began to eat very greedily, as if he had not eaten in decades. I let him enjoy his food and asked the two girls to sit down.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Won’t you tell us about your day?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Not now, we now have to talk about how we will work.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam interrupts with unusual sharpness, “I won’t work anymore!”")]), _vm._v(" "), _c('p', [_vm._v("“What?” Laila and I said it in amazement.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We have three girls, how are we going to feed them?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Hear me please, I will sit every day with the girls, and you go to the market to work. I will prepare my basket and help you in preparing your baskets. You go, and I stay at home. I clean the house and take care of the three girls.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Fair enough, but who will help us in carrying the baskets. Jawad will not be able to carry them alone, because I will definitely double my baskets.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I thought about that too. My brother Hazem has an old cart, he brings my goods from a merchant from the neighboring city every month; I will ask him to come and work with you, for a small wage and some food.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “So we can all double the baskets.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “The expense has become too huge.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “It’s okay, I am good at making sweets and desserts; I will make some kinds. Take them with you. If you can sell them, we will expand in making them. So we will work with more than one product.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Good idea, we will increase products and baskets.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “But sweets need materials.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Don’t worry; I’ll get them from Faris, Salma’s husband. I can convince him to pay for it in installments.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “How will you make sweets while you are busy with the girls?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I’ll wake up at dawn; I will prepare sweets while you two take care of the girls, we’ll cooperate, don’t worry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Where is Hazem now?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Poor Hazem, he sleeps in his cart every night, after my husband deceived him, and persuaded him to sell him his house at the cheapest price. He bought that cart and it became his home and the reason for his livelihood. How cruel my husband was!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “It’s okay, my dear, God punished him and the house fell on him. He is dead now; no need to mention him.”")]), _vm._v(" "), _c('p', [_vm._v("The two looked at me and burst out laughing… Laila said while laughing, “He was butchered.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at them resolutely, wanting them to believe the idea, and said in a stern tone, “He just died! Come on, Maryam, prepare the room next to the kitchen, and call Hazem, this will be his home from today.”")]), _vm._v(" "), _c('p', [_vm._v("She couldn’t believe what she heard. She jumped up to me and kissed me on the cheek. She opened the door and called out loud, “Come on, Hazem!”")]), _vm._v(" "), _c('p', [_vm._v("He was sleeping behind the house, that poor man, when I was leaving for work, he would come and say hello to his sister and check on her. I never noticed him, maybe because I didn’t know at that time that he was here. For a long time, he was helping us and then I no longer saw him. A strong and handsome young man, but fatigue, homelessness, and sleeping in the cart made him lose a lot of his personality and beauty, yet he enjoyed the beauty of a soul that no one in the world had ever carried. He is very kind and generous; he may dedicate himself to us indifferent to anything, he may give us his life in return for a smile of our satisfaction!")]), _vm._v(" "), _c('p', [_vm._v("Hazem entered the house in disbelief that he would live in a house with a family; with his only sister and her beautiful child. In his shabby clothes, he looked good and naïve, just as his sister had said, and her husband must have taken advantage of his kindness and naivety. I welcomed him warmly as if he was a brother.")]), _vm._v(" "), _c('p', [_vm._v("He thanked me and said, “From today, I will be your servant.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him shyly, and told him, “You’ll be our guard, you’re our only man, and we’ll all be naughty sisters.”")]), _vm._v(" "), _c('p', [_vm._v("He liked to be our only man! He cheerfully said, “I will protect you, don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam couldn’t believe what happened, she didn’t say anything, but her eyes said a thousand things! She thanked me with her eyes and a smile that was emerging from the heart.")]), _vm._v(" "), _c('p', [_vm._v("I prepared the bathroom and a room for him in half an hour, and Laila made dinner for him. Despite all that we went through in that day, we stayed up for the morning, it was one of the most beautiful nights we spent together; we talked and laughed. Hazem was very consistent with Laila, she spoke and he commented on her words; they have been friends for a long time.")]), _vm._v(" "), _c('p', [_vm._v("I decided to give him my father’s old clothes that never left my closet. How much I loved my father, and how much I wished he would stay with me! He left me sad for me, dissatisfied with the injustice of my mother and Salma. Perhaps his tiredness and need for money is what prevented him from defending me. I am sure that my mother controlled him completely, and she was the one who convinced him to oblige me to appear in front of the nobleman; if it was up to him, he would have wanted me by his side for life!")]), _vm._v(" "), _c('p', [_vm._v("We own my father’s eyes, Reem and I! He was affectionate and loved us, he was the one who taught me farming and caring for the land. I cried for long nights when he died. My mother left me only his old clothes; she took all his valuable things and sold them. He had a small wooden box that included old pictures of us; she took it and deprived me even from his pictures. She knew that I loved him more than her, and that he was my only friend in life!")]), _vm._v(" "), _c('p', [_vm._v("I took out the clothes from the box, which I was sure would fit Hazem, because my father was also tall and broad-shouldered. I grabbed the clothes in my hand; my father’s scent spread throughout the room! The smell of the place took me back for many years. I remembered when I was running to him when he was getting back to home; he used to carry me and hugged me to his chest. That smell, the smell of earth and fatigue mixed with love!")]), _vm._v(" "), _c('p', [_vm._v("I don’t know how I dared to dispense with my father’s clothes! Perhaps what saddened me the most was Hazem’s appearance. Perhaps I wanted to commemorate my father through him. Perhaps I wanted my father to come back. Hazem’s smile and eagerness for us reminded me of my father, may God have mercy on him.")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room, exhausted and weak. I put on the new nightgown that I had bought from Rasha’s shop, I looked in the mirror and found a beautiful girl after a long adventure, I smiled and told myself how beautiful I am! I lay on my bed, thank God, despite the harshness of the day, but it ended with goodness, love, and happiness. The child did not become a number, but rather a girl with a name, a mother, and a house! Hazem will not sleep in his cart in the middle of the road after today.")]), _vm._v(" "), _c('p', [_vm._v("Then I fell asleep; I only woke up at a knock on the door, because of Laila’s screaming, “Come on, lazy girl, it’s noon, if you don’t get up and gather your vegetables, you won’t come home at night.”")]), _vm._v(" "), _c('p', [_vm._v("I opened the door, my hair agitated, I shouted, “Since when did you come back mom to live with me?”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me sarcastically and whispered, “I didn’t mean to erupt your memories, but my dear children are hungry and the earth is thirsty, come on, my beauty.”")]), _vm._v(" "), _c('p', [_vm._v("I calmed down and went back to my bed, she looked at me and said calmly and sarcastically, “It’s okay, go back to sleep, I’ll collect the vegetables.”")]), _vm._v(" "), _c('p', [_vm._v("She knew I wouldn’t let her touch my vegetables! I quickly got up, got dressed, went to the ground, and gathered my vegetables.")]), _vm._v(" "), _c('p', [_vm._v("While I was leaving, Maryam called me in a soft voice, “Come and have breakfast then go.”")]), _vm._v(" "), _c('p', [_vm._v("I had a delicious breakfast. Maryam prepared us eggs, cheese, milk, and fresh bread. After we finished, Hazem picked up the baskets and put them in the cart. Laila and I followed him, while Maryam waited at home to take care of the children.")]), _vm._v(" "), _c('p', [_vm._v("I tried hard to ignore Laila all the way, her eyes were full of doubt and questions; she wanted to know everything. She started talking after a long silence.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I’m waiting for you to tell me what happened with you yesterday, come on, you naughty.”")]), _vm._v(" "), _c('p', [_vm._v("I wanted to finish her doubts and inquiries, I told her what happened in detail, she smiled and said, “Thank God that Salma came and teased you with her appearance to take care of yourself a little. You must appear in beautiful clothes in front of people, perhaps you will marry a good man.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her sarcastically and replied, “I did not do this to get married, but because I insulted myself so much by neglecting her, I must compensate her, and then my clothes are no longer suitable even to clean the house, so I decided to go to Rasha every month and buy myself a dress.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, my dear, next time, if we have too much money, we will go and buy some clothes for the two little girls.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “To Sarah too, and to you and Maryam.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We have enough now, but the little girls will grow up quickly, and they will always need new things.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “As you wish, we arrive the market now, let’s start working.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We are too late; our customers usually come in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s okay; we sit for only two hours. We will come early tomorrow to compensate.”")]), _vm._v(" "), _c('p', [_vm._v("We waited half an hour, but not a single customer came. After a few moments, an elegant lady came with her maid. She looked at my vegetables and said, “These vegetables are very good, my dear, I’ll take them all, and tomorrow morning I want the double if you can.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her in amazement and said, “As you want, madam.”")]), _vm._v(" "), _c('p', [_vm._v("She answered me calmly and softly, “If your vegetables remain like this, I will pass by you every day and buy them all.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “They are always like that.”")]), _vm._v(" "), _c('p', [_vm._v("She gave me a bag of money. Laila wanted to take advantage of the situation, and this is her right of course.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Won’t you look at my embroideries?”")]), _vm._v(" "), _c('p', [_vm._v("The lady turned to her and said, “Do you make them yourself?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Yes, they are unparalleled.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The lady:")]), _vm._v(" “Well, I’ll take them all. If I like them and found them fitting my house, I will buy more.”")]), _vm._v(" "), _c('p', [_vm._v("She gave Laila a bag of money, then turned to Maryam’s baskets, and said, “Where did this cloth come from?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “From nearby villages.”")]), _vm._v(" "), _c('p', [_vm._v("She took a piece in her hand, but unfortunately, she did not like the quality of the cloth. She smiled and said, “That’s enough for today, see you tomorrow young lady, and make sure your vegetables are ready in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Thank you, madam. They will be ready, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("We did not believe what was happening with us, perhaps God has honored us because we saved Lynn and took care of her. Despite our delay in work, we sold our baskets. All the girls in the market looked at us in astonishment. We had not been there for an hour, and we had sold what we had. They were sitting from the morning, and they did not sell half of what we sold… We will not care about them, we went through similar circumstances; how many times I gave Laila money, because she did not sell anything from her basket.")]), _vm._v(" "), _c('p', [_vm._v("We came back happy; our pockets were full and our baskets were empty. We brought a lot of cooking utensils and food with us. We also bought some essentials stuff for the children. I bought a beautiful doll and a dress for Sarah.")]), _vm._v(" "), _c('p', [_vm._v("Maryam was a little sad, because nothing was sold from her goods, but at the same time, she was happy that we came back with so much money. What was the most important for me is to secure a decent life for a group of girls and two nice guys.")]), _vm._v(" "), _c('p', [_vm._v("We had a delicious dinner that evening. Laila’s cooking was great and Maryam’s way of arranging everything was charming. For the first time, we felt that we are ladies because we had a good amount of money. We sat around our table; we talked about that lady. Despite all the happiness that I had, I was worried, even afraid, that I could not provide enough vegetables for that lady, but no, I’ll get up early and work hard to plant more.")]), _vm._v(" "), _c('p', [_vm._v("I woke up early the next morning and filled my baskets; I went to the market with Laila. The lady came as she promised us, and bought all the vegetables, but she did not buy anything from Laila’s goods. Laila expected that so she was not sad. Laila stayed in the market, but I went back to work on the land. I don’t know if what I have will cover the lady’s need for the rest of the days; I have to expand my cultivation, but how? My land is so small.")]), _vm._v(" "), _c('p', [_vm._v("Laila returned after she sold half her basket, and also sold a little of Maryam’s basket; there are no occasions these days, so there is little demand for such things.")]), _vm._v(" "), _c('p', [_vm._v("Maryam made dinner, we all gathered around the table, the food smelled so delicious, the house hadn’t been so warm since my father passed away.")]), _vm._v(" "), _c('p', [_vm._v("“Since we depend mainly on vegetables for our livelihood, we have to expand our work.”")]), _vm._v(" "), _c('p', [_vm._v("This is how Maryam began the conversation. I looked at her in astonishment, and commented, “It’s like you’re reading my thoughts.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Yes, my dear, we are now a big family; we must expand our business. I spent the day thinking about a solution. People could dispense with everything, except for food and drink, so we should expand in agriculture.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I will not dispense with embroideries, because I do not know anything about agriculture.”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “The land is too small and it is not enough for all of us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I know, so we’ll buy the neighboring land and plant it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Do you think the money we got in the past two days is enough? Did you forget that we have to pay the house rent every month? Then we don’t know if that lady will come every day and buy vegetables. I agree with you; we have to expand the vegetable trade, because after Zaina had left today, lot of people asked about her; they wanted vegetables. But it is important to remember that we have a lot of obligations.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (angrily):")]), _vm._v(" “Calm down and let me finish what I want to say.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Let’s hear her and see what she has.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I will sell my house, and with the price, we buy the land.”")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “Is there a buyer?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You won’t find a buyer for a house that has fallen for months, my dear.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Well, Zaina goes to the owner of the land tomorrow, and looks at him in the same way that she looked at the officer, and convinces him to sell us the land at a comfortable installment.”")]), _vm._v(" "), _c('p', [_vm._v("I was so upset by her rudeness; I got up in anger and asked her, “What look are you talking about, or rather what do you mean?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Do not be sad, my dear, I did not mean to offend you, but before your beautiful eyes, men cannot refuse.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Sorry, I’m not of that kind, I wouldn’t use my eyes to seduce anyone, and if I did it with the officer, it’s only for you, and I’m remorseful from now on.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What a fool you are, Maryam! You think and get tired, then with unbalanced words, you fall into problems. She really did not mean to insult you. Zaina; she only wanted a solution to the problem. Generally, it is okay, I will go to him, and perhaps I will convince him with a dry smile.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Well, do whatever you want. I’m tired and I’m going to sleep.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (sadly):")]), _vm._v(" “Good night, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I know she regretted what she said, maybe she didn’t mean it. She should know that I’m not that kind of woman. It was my fault from the beginning that I sympathized with her in order to get Lynn, or maybe I did it for Lynn herself.")]), _vm._v(" "), _c('p', [_vm._v("The next day, I went alone to the market. Jawad helped me in carrying the baskets. They knew that I was sad. The lady came and bought the vegetables. I came back to home and filled another basket and sold it to the women of the market. I didn’t want to lose my customers; I didn’t know who that lady was , and I didn’t know if she would keep buying Vegetables from me. Four baskets must be prepared daily, how is this? My land cannot bear all this, so the land must be expanded.")]), _vm._v(" "), _c('p', [_vm._v("I came home tired and hungry, Maryam was preparing the food, she greeted me with a kind smile, and said, “The food is ready, wash your hands and come, we prepared something wonderful for you.”")]), _vm._v(" "), _c('p', [_vm._v("I thanked her. I went to the bathroom, and then came back to eat. She prepared the most delicious food, she wanted to apologize in a classy way, I never talked about anything. While eating my food, Laila entered the house screaming, “You eat without me, can’t you wait? This is betrayal!”")]), _vm._v(" "), _c('p', [_vm._v("Maryam replied cheerfully, “We just sat down, come on, the food is still hot.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, it looks delicious. How are you, Zaina? Hazem blames you for not going with him today.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “It’s okay, I was in a hurry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, he was awake and asked you to wait for him, but you ignored him.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s okay, I’ll talk to him later.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “As you wish, dear. My ladies, look what I have, the contract of the land.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “What?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “As I told you, I used my dry smile and he agreed at once.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Tell me the truth, there’s no time for jokes.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What is wrong with you, dear? He found it an opportunity to find someone to buy this land from him. He did not even argue with me for the price. He sold it to me at a cheap price and in convenient installments. For him, it is worn out land of no use.”")]), _vm._v(" "), _c('p', [_vm._v("He said to me, “I was praying to God that someone would buy this land.”")]), _vm._v(" "), _c('p', [_vm._v("I answered, stunned, “I can’t believe it, thank God!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Who will be the owner of the land?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “The owner will be the daughter of the master of this house. The eldest one who has the charming blue eyes.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her angrily, “Enough, it becomes silly. I’m sick out of this!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I’m not lying dear. He told me that your father used to take you with him when you were little to his house. He loved you very much. He used to give you sweets and some gifts. He asked your father to bring you from time to time, because you were a very beautiful and adorable child. He wants you to visit him tomorrow, to sign the contract. He gave it to me today to read it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Praise is to God, Zaina and her eyes are the reason for the end of my misery in life.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Well, you know I have a good heart; I’ll go to him tomorrow and finish it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You will have land and you will be a noble lady. I will go with you tomorrow. Don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("Her words ‘Noble Lady’ delighted my ear, that’s right; the land will be the first step. After I plant it and sell its crop, I will have a lot of money, and I will become a noble lady.")]), _vm._v(" "), _c('p', [_vm._v("We went the next day to the man who owns the land. He greeted me very warmly, and started talking about my father. I was very pleased to meet someone knew my father. He offered us tea and biscuits. After an hour of talking and laughing, we signed the land contract; the land became completely mine. A large land. It will take a lot of work and diligence, but it will definitely bring us a lot of money. I thanked him and got up to leave with Laila. Laila greeted him and left. As soon as I approached him to say goodbye, he grabbed my hand and approached me and whispered in my ear:")]), _vm._v(" "), _c('p', [_vm._v("“Come tomorrow, I want you in an important matter, but please don’t bring anyone with you.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him in amazement and said, “Is there anything wrong?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me, “Don’t ask, come tomorrow and I’ll tell you.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t know what he wanted but I was very happy that I became the owner of such a large land.")]), _vm._v(" "), _c('p', [_vm._v("We came back running to our house. I knew the land needed a lot of work, and it also needed money to buy the basic materials for it. It’s okay, we will use the money that we gained from the lady in the past days, and I will take out all my savings. If Maryam can sell her house, we will also use the money to cultivate the land.")]), _vm._v(" "), _c('p', [_vm._v("We held a small party because of the land. Maryam prepared a table full of food and sweets. We stayed up and laughed and agreed to start working hard in the morning. We also agreed to buy only the things necessary for the house, until the land gave us of its bounties and we became rich.")]), _vm._v(" "), _c('p', [_vm._v("We got up early; I went straight to the land to collect fresh vegetables. I took with me for the first time Jawad. I taught him how to work in the land; he will become my assistant.")]), _vm._v(" "), _c('p', [_vm._v("Hazem was watching me carefully while I was teaching Jawad. I felt that he liked the idea and wanted to work with us. I went towards him and pulled him from his hand and said, “Do not be shy; come closer, we are all partners in this land. Oh my God, how quick he was in learning! In a few days, he will become a professional farmer. He loved the earth and it loved him; actually, whoever loves something he becomes creative with it. He is very ashamed of me, and all he wants was to please me; since he entered my house and his concern in the world was to please me.”")]), _vm._v(" "), _c('p', [_vm._v("I went to the market and sold all my vegetables. I came back before Laila; I didn’t tell her where I was going. I gave the empty baskets to Jawad to put them in the house, and I headed straight to the house of the owner of the land. I rang the bell of the house, and I waited a good while before he opened the door. He invited me to enter, but I refused under the pretext I’m in a hurry.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “It’s okay, my daughter, I know you’re afraid to enter the house of a man who lives alone.” He added, “Come in, the maid is inside, don’t be afraid, you are like my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I entered, but I was very confused; yesterday Laila was with me, and Maryam knew our destination, but today I am alone, and no one knows where I am. I sat on the sofa closest to the door. The maid offered us tea, but I did not drink it. He looked at me with a look full of tenderness and kindness and he began:")]), _vm._v(" "), _c('p', [_vm._v("Listen, my little girl, the land is yours now, and I don’t want any penny for it.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him in amazement, and said, “No, sir, I will pay you the price of it.”")]), _vm._v(" "), _c('p', [_vm._v("He interrupted me and said, “Please keep listening till I finish my words, and do not interrupt me. The land is yours, it belonged to your father; may God have mercy on him. He came to me one day and asked me to keep the land as a trust, until you grow up and be able to take care of it. He knew that your mother would abandon you, and that you would be alone, he also knew that if your sisters need you, you will not abandon them.”")]), _vm._v(" "), _c('p', [_vm._v("I started crying, I asked him sadly, “Oh, my God, was he upset with me? Please tell me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Absolutely not, my little girl, he never wanted you to go with the nobleman, but he was afraid of your mother’s anger and hatred. In fact, he loved you more than anything else in the world. Don’t cry please. By the way, he left you a box; I will give it to you today.”")]), _vm._v(" "), _c('p', [_vm._v("He added quietly, “You should know, my dear, that I was the one who inspired your friend to expand the land, in order to give you back what is yours.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you inspire her?”")]), _vm._v(" "), _c('p', [_vm._v("“I was passing by your house, while she was standing looking at the small land, holding a child in her hand.”")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “What is bothering you?”")]), _vm._v(" "), _c('p', [_vm._v("She replied, “The family is growing, and the expenses are increasing; there must be a solution. Unfortunately, the land is very small.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “The land must be expanded; there is an abandoned land near you, so buy it.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me happily and said, “Thank you, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Your father told me to keep this a secret, do not reveal it to anyone, not even to your friends. I am leaving today to my home in a city a little far from here. I left my address for you in the box, keep it. If you want anything at any time come to me, and I will help you. You are as my daughter; don’t ever hesitate to call me.”")]), _vm._v(" "), _c('p', [_vm._v("I took the box and thanked him. I went home immediately. I entered the house with the box in my hand; thank God I did not meet anyone. I headed towards my room. I wouldn’t let anyone touch it .I’ll also bring the money that hidden in the land; I’ll put everything in my room. Everyone will work in the farm, so it’s better to keep all my things in my room. I left it under the bed. I should go back to the farm. I decided to come back early from the farm and open the box to see what my father had left for me.")]), _vm._v(" "), _c('p', [_vm._v("I hurried back to the farm. Hazem and Jawad were waiting for me. I did not see Maryam while Sarah was playing and running in front of the house. We started working hard. I taught them everything; they were very obedient. After about three hours, Maryam called us from afar, “Come on everyone, the food is ready.”")]), _vm._v(" "), _c('p', [_vm._v("We never felt how the time passed. I didn’t even know when Laila come back. We entered the house, tired and exhausted. I asked Maryam curiously, “Where have you been? I didn’t see you when I entered the house.”")]), _vm._v(" "), _c('p', [_vm._v("She answered me calmly, “I took the two girls to the city doctor, I wanted to check on them and find out about the vaccinations they should have.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Well done.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Laila and asked her about her day. She answered me sadly, “I have only sold a little, perhaps I will work with you on the land, and I will not waste all the time waiting for a customer or two.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Well you do, wait, and see how much the earth will give us, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("Sarah asked me in a childish innocent way, “Can I work with you?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “You must learn reading first.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Oh really! How?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “There is a school in the neighboring city, not far away, we will send her to it; Hazem will arrive her in the morning and get her back at noon.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Oh really!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Really, true and yes.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone laughed at Hazem’s spontaneous reaction; how faithful he was, he loved us all and was ready to give us his soul and life. He believed that he was the man of the house, and that his responsibility was to protect us. He never refused any request for any of us. He was the last to sleep after making sure that everyone was safe. He carries the most passionate heart in the universe. He loved Jawad very much, and considered him his little brother.")]), _vm._v(" "), _c('p', [_vm._v("The days passed; we worked hard on the land. Everyone learned agriculture, except Maryam. She took care of the house and the children. We did not lack anything in the house. She made sure to arrange it and prepare food every day. She respected my privacy and did not approach my room, but Laila and her great curiosity did not stop her. When she asked me why my room was closed, I ignored her questions; I would not answer her until I open my father’s chest.")]), _vm._v(" "), _c('p', [_vm._v("At the first day of the month, Salma and my mother came to take the money of the rent, and what I owed from the crop of the land. As usual, Salma came with the most beautiful dress, and shiny new shoes. My mother looked at me with her usual cruelty, and asked me, “Did you really buy a land, where did you get the money from?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam replied calmly, “No, aunt, I rented it not Zaina, but Zaina is the one who taught us how to farm, she added sarcastically how could she buy it and she had nothing.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Are you able to pay the rent?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “My husband left me a good amount; I paid the rent of the land for a year.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Year! Wouldn’t it be better if you bought a house rather than living on rent?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (maliciously):")]), _vm._v(" “My dear, when the land produces, it enables us to buy houses.”")]), _vm._v(" "), _c('p', [_vm._v("Salma did not like Maryam’s words at all. Laila gave Salma the money. They left immediately angrily; disappointment appeared on their faces.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, Laila and I went to work, while Hazem remained to work on the farm. Two hours after we left, Maryam left the girls with Hazem and went to Faris directly. She entered his shop with a sad face.")]), _vm._v(" "), _c('p', [_vm._v("He smiled when he saw her. He was very happy to see her again.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “What is wrong with you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Would you accept what happened with me; would you accept that Salma came and took my money?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Sit down, my dear, I saw her while she was coming back from your house. She told me that she takes the rent of her house from you, so it is her right.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Do you know how I get the money! My husband has left me homeless and without money, and your wife comes and takes what I earn every month.”")]), _vm._v(" "), _c('p', [_vm._v("She started crying.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Don’t cry, please, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed her hand and looked directly into her eyes. She put her other hand above his hand. She was able to capture his heart with her looks. He said to her, “Do not worry, my dear, do not worry, I will return the money to you immediately. Come every month and get your money back, and come every Saturday and take everything your house needs from my shop for free.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Oh really! Will you help me; will you help my two orphaned daughters?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Yes, but Salma said that you rented a land?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “False! Where do I get the money from? My merchandise could no longer find a customer; I told her so to leave Laila alone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “What about Laila?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “She is the one who sold her bracelet and rented the land. Anyway, this is a long story to explain, and it is not right to talk inside the shop. Customers may enter the shop in any minute, so it is not good to see me here.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Well, go now, and I’ll send you your money with all your necessities, and I’ll hear the whole story tomorrow.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Well, we will meet tomorrow in a small café out of sight, but please do not send things with anyone; I will send my brother Hazem to take the money and things.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at him with a look full of love and said, “Do not forget the eggs, my dear!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Eggs, cheese, and everything. Don’t forget our meeting tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("She came home very quickly. As soon as she arrived, she sent Hazem to the Faris shop. He took his cart and headed to him. He returned after less than an hour. The cart contained different kinds of food; cheese, chicken and meat. He also gave her the same bag of money that she gave to Salma yesterday!")]), _vm._v(" "), _c('p', [_vm._v("Faris’s work was very good; he gained lot of money from nobleman’s guards and their wives who bought a lot from him. Despite this, he didn’t leave any money in Salma’s hands, but she forced him to buy her all the clothes and jewelry she needed.")]), _vm._v(" "), _c('p', [_vm._v("I came home in the afternoon after I sold all my goods; Laila came back with me. We found many things lying on the ground, while Maryam was busy in arranging and packing. I heard Lynn crying, so I went to Maryam and said, “Please go to Lynn, and I’ll take care of the arrangement.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “No, my dear, this is my job. Have a rest and Laila will take care of Lynn.”")]), _vm._v(" "), _c('p', [_vm._v("This is what really happened. Laila carried Lynn and took care of her.")]), _vm._v(" "), _c('p', [_vm._v("I asked Maryam curiously, “Where do all these things come from? Have we not agreed to buy what is necessary until we cultivate the land?”")]), _vm._v(" "), _c('p', [_vm._v("She turned to me with a smile and said, “Don’t worry, my dear, I didn’t pay for anything; Faris sent them as a gift; Salma’s husband.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her in amazement, “Why does he send you a gift?”")]), _vm._v(" "), _c('p', [_vm._v("Laila replied, “You brought the money?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam replied in the same tone of voice, “Yes, and we will no longer pay for groceries, he will send us everything we need every Saturday?”")]), _vm._v(" "), _c('p', [_vm._v("I asked her angrily, “And why would he do that?”")]), _vm._v(" "), _c('p', [_vm._v("Laila came with the baby in her hand.")]), _vm._v(" "), _c('p', [_vm._v("“He might like her.”")]), _vm._v(" "), _c('p', [_vm._v("She said it very coldly. It seemed to me that they had agreed on everything. Maryam looked at Laila coldly and said, “Yes, my dear, he likes me and we will meet tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("I asked her innocently and spontaneously, “Does Salma know?”")]), _vm._v(" "), _c('p', [_vm._v("The two laughed loudly; Laila added, “That idiot takes our money; do you think we will leave her?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, Maryam, go and meet him; I will sit at home tomorrow and take care of the children.”")]), _vm._v(" "), _c('p', [_vm._v("I said angrily, “I see you two arranging everything… Beware of Salma; what you don’t know that she is as evil as you are, and she will not leave you, and her revenge will be great.”")]), _vm._v(" "), _c('p', [_vm._v("Laila replied sarcastically, “We are ready to that arrogant.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I warned you. Now I will see what Hazem did today, and then I will go to the neighboring city.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Hazem did nothing today.”")]), _vm._v(" "), _c('p', [_vm._v("“Why?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “He was helping me.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Oh, my God, if we stay like this, we will not end for years!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Go now, I will finish my work and help him, I promise you will find everything finished when you return.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s okay, my dear, just do what you can, I’ll come back and finish.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Don’t bring us new kids, just come back alone!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and headed to the neighboring city. I decided to go to Rasha’s shop; I wanted to see her and buy new clothes. Every time I saw Salma in new clothes, I remembered how neglectful I was to myself. I would not let her look better than me.")]), _vm._v(" "), _c('p', [_vm._v("I started thinking about Salma’s revenge on Maryam, if she knew about her relationship with her husband. How stupid Maryam was; she does not know how much Salma would hate her, and she would take revenge on her harshly, rather she would take revenge on all of us.")]), _vm._v(" "), _c('p', [_vm._v("I arrived at Rasha’s shop while I was exhausted from thinking about Maryam and Salma. Rasha welcomed me warmly. I had brought her a cake with me as a gratitude for what she did with me last time. I also brought her a basket of my fresh vegetables.")]), _vm._v(" "), _c('p', [_vm._v("“How are you doing?” She began the conversation with eagerness and a wide smile. She had two clients; I did not want to distract her from her work. I put the basket for her on the floor, and the cake on the table.")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Fine, I’ll see what you have, while you’re done.”")]), _vm._v(" "), _c('p', [_vm._v("I began by choosing dresses for everyone; I was choosing and carrying, until I could no longer carry any more. She came to me in a hurry, carried them from me and put them on the table.")]), _vm._v(" "), _c('p', [_vm._v("She asked me in astonishment, “Are you going to buy all of this?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “I haven’t finished yet.”")]), _vm._v(" "), _c('p', [_vm._v("She laughed and said, “No discounts, no installment sales!”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “Whoever said I wanted a discount, I would buy it and pay immediately.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “So, choose as you wish, perhaps you have inherited money or found a treasure.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I work day and night, and I have the right to take care of myself.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Choose whatever you need while I make tea. Since you’ll take half the goods, I’ll shut the door. We’ll have your sweets with tea, and then tell me your stories.”")]), _vm._v(" "), _c('p', [_vm._v("She closed the door of the shop, while I chose clothes for everyone. I found things that fit Hazem and Jawad too. Her shop was not big, but it contained everything.")]), _vm._v(" "), _c('p', [_vm._v("I chose a pink dress with a blue scarf for myself, and I brought other clothes that fit the work and the land. I chose beautiful things for the two girls and Sarah. Of course I did not forget Maryam and Laila, so I bought them beautiful dresses and nightgowns.")]), _vm._v(" "), _c('p', [_vm._v("I finished the selection and paid for everything. Rasha was very happy and I was also happy. She made tea and presented with it dessert and asked me, “How are you going to carry these things by your own?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, my dear, Hazem will come and take me, I gave him your address and he has a carriage.”")]), _vm._v(" "), _c('p', [_vm._v("“Who is Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("“My friend’s brother, he’s as my brother.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha (jokes)")]), _vm._v(": “Is he handsome?”")]), _vm._v(" "), _c('p', [_vm._v("“I told you as my brother.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “I heard you, but he’s not my brother.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed and said, “A very cool young man, when he comes, you will see him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Well, tell me about your situation and your work.”")]), _vm._v(" "), _c('p', [_vm._v("We sat chatting; we did not feel how the hour had passed. Rasha is a cheerful and helpful girl. Hazem knocked on the door; Rasha eagerly opened for him, and greeted him with a wide smile:")]), _vm._v(" "), _c('p', [_vm._v("“Welcome, Zaina’s brother, Hazem, please come in.”")]), _vm._v(" "), _c('p', [_vm._v("He did not like to call him Zaina’s brother. He didn’t say anything, he didn’t even say hello. He blushed and said, “Are you ready, Zaina?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “You won’t leave until you drink tea, please come in.”")]), _vm._v(" "), _c('p', [_vm._v("She pulled him by the hand, and brought him a cup of tea, and a piece of cake. She liked how he looked, and she liked his shyness even more.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “No, thanks. We have to go. We have a lot of work to do.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “We won’t die if we don’t finish work today, at least drink a little tea.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “It’s okay, Hazem, sit down for a while, we won’t be late.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Well, Zaina, as you wish.”")]), _vm._v(" "), _c('p', [_vm._v("He sat confused and shy, not knowing what to say, for the first time a woman had treated him in this way.")]), _vm._v(" "), _c('p', [_vm._v("While I was waiting for Hazem to finish his cup, which he was drinking very slowly and ashamed; as if he would not finish it in a year! Rasha was looking at him with interest, studying his details and engraving his image in her mind. Suddenly the owner of the hat store entered the shop. I couldn’t look at his face.")]), _vm._v(" "), _c('p', [_vm._v("I said angrily, “Come on, Hazem, we have to leave now.”")]), _vm._v(" "), _c('p', [_vm._v("The man smiled and said, “It’s okay, son, finish your cup, please.” He looked at me and said, “Madam, I want to talk to you for one minute.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with meanness and malice, “Did someone throw a child at your door today and you want to get me involved in it?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “No, madam, I came to apologize to you. How long I waited for you to come. Please forgive me. I have wronged you. Believe me, I have not slept since that day, and I pray to God to meet you to forgive me, you are like my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I felt in his words a tone of regret and sadness, I did not see a look as sincere as his, I replied with a smile, “No problem, sir, I forgive you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “Thank you, my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("He offered me a bag he was carrying and said, “Please accept this gift from me.”")]), _vm._v(" "), _c('p', [_vm._v("“No thanks, I don’t want, there’s no need for that.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “Please take it.”")]), _vm._v(" "), _c('p', [_vm._v("Rasha pulled the bag from his hand and opened it; she got out a beautiful and very expensive hat. Rasha put it on my head, and said, “She accepted it. Look, and put it directly on her head.”")]), _vm._v(" "), _c('p', [_vm._v("The man thanked Rasha and left. I took the hat off my head and put it in the bag. I was really afraid that it would get dirty. I thanked Rasha and invited her to visit me. She whispered in my ear, “I’ll come soon and I’ll see Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and thanked her again. Hazem put things in the cart while I kept carrying the hat bag. It was surely the hat I would put on my head in front of the nobleman.")]), _vm._v(" "), _c('p', [_vm._v("We rode the carriage. Hazem set out; he looked very annoyed, I don’t know why. I didn’t asked him at the beginning because Maryam’s reckless behavior preoccupied me. Even when I was choosing clothes, I chose them with my mind confused with them; I chose beautiful things, but I really forgot what I chose. Salma would not let her take her husband from her. It was very exhausted to think about their immature behaviors; I am no longer able to think about them more. I turned to Hazem and asked him, “What’s wrong with you, my friend?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me angrily and said, “Oh really! Now I am your friend? And you were just calling me your brother in front of that nasty girl!”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t know what to say, I preferred silence than to say something that bothers him, or provokes his anger. He started to speed up the cart. I held his hand and begged him to reduce his speed; the road was bumpy. I tightened his hand until I hurt him. He stopped finally; I felt very dizzy, so I got out of the cart and started vomiting.")]), _vm._v(" "), _c('p', [_vm._v("He was so frightened; he started screaming, “I’m sorry, wait for me; I’ll get a doctor right away.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand after I finished and asked him to take me home. I didn’t feel anything after that, I fainted from exhaustion. He carried me and put me in the cart calmly and tenderly. He put the scarf over me. The last thing I remember seeing is his eyes full of tears.")]), _vm._v(" "), _c('p', [_vm._v("I opened my eyes while I was in his arms, taking me to my room. I saw the same scene; his eyes were full of tears.")]), _vm._v(" "), _c('p', [_vm._v("Laila was very afraid for me and asked Hazem to bring the doctor. I prevented them and told them that I was fine; there was no need for a doctor.")]), _vm._v(" "), _c('p', [_vm._v("I slept for two hours, and then woke up to Maryam whispers; she woke me up very gently saying, “Come on, my dear, wake up, get up and eat the soup.”")]), _vm._v(" "), _c('p', [_vm._v("I got up, grabbed her hand, and whispered in her own way, “Please stay away from Salma; if she finds out about your relationship with her husband, she will destroy you, rather she will destroy us all.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (calmly):")]), _vm._v(" “Well, Zaina, I promise that I will not approach her after today. Now, eat your food, and come show us what you bought. Since Hazem left you, he put the things next to him, and prevented anyone from approaching them until you wake up.”")]), _vm._v(" "), _c('p', [_vm._v("I repeated, “Don’t come close to Faris, please.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I promised you and we’re done, forget about it.”")]), _vm._v(" "), _c('p', [_vm._v("Laila entered to confirm Maryam’s words:")]), _vm._v(" "), _c('p', [_vm._v("“We agreed not to approach Salma and her husband. Oh dear, Get up, Sarah will go crazy to see her things.”")]), _vm._v(" "), _c('p', [_vm._v("I did not feel comfortable with them, they will certainly not stay away from Faris, but I will ignore them for the time being and I will believe their promise temporarily"), _c('strong', [_vm._v(".")])]), _vm._v(" "), _c('p', [_vm._v("I went downstairs; when Hazem saw me, he ran out of the house without saying a word.")]), _vm._v(" "), _c('p', [_vm._v("I handed each of them her things; they were all happy, as if it was a feast day. I went outside carrying Hazem’s things. I called him, but he did not answer. I went towards his cart and found him lying on the cart with his hands on his face soaked with tears. I raised his hands from his eyes with the tenderness of a mother.")]), _vm._v(" "), _c('p', [_vm._v("He said sadly, “I was afraid you would die.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and grabbed his hand and said, “No, my dear, I still have a lot to do. Come on, get up, take a shower, put on your new clothes, and come to have dinner with us. We won’t start eating until our man comes.”")]), _vm._v(" "), _c('p', [_vm._v("He jumped off the wagon and said, “Don’t call me your brother again.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I will say my best friend.”")]), _vm._v(" "), _c('p', [_vm._v("His heart was full of love for me, but unfortunately, even if I don’t love the nobleman, I would never accept to take him as my lover. Despite all the feelings I had for him, he doesn’t suit me. I love him very much and I cannot live without him as a brother only. He is a real man who we depend on even though he looks simple and naïve.")]), _vm._v(" "), _c('p', [_vm._v("I decided to be sympathetic to him, and to treat him as a little child; if he made a mistake, I would reprimand him calmly, and if he did something good I would reward him and strengthen his confidence inside himself. What I most desired was that he turns away from the evil thoughts of Maryam, which might cast him into the abyss.")]), _vm._v(" "), _c('p', [_vm._v("I woke up the next morning exhausted and emaciated. What happened yesterday affected me badly. I ate my breakfast and drank a cup of coffee. I didn’t talk to anyone. I went out to the farm and filled my baskets. Hazem ran towards me immediately; he took the baskets from me and put them in the cart. We walked together to the market. We sold everything and came back; he didn’t leave me for a moment. He noticed how tired I was; he took over all the selling and talking to customers. We went straight back to work on the farm. He brought me a chair and called Jawad to help him.")]), _vm._v(" "), _c('p', [_vm._v("He made me a cup of tea and said, “Don’t worry, I will do everything.”")]), _vm._v(" "), _c('p', [_vm._v("I guided him; he was skillful and hard working.")]), _vm._v(" "), _c('p', [_vm._v("We stayed like this for days. I didn’t see Laila and Mariam much anymore; all my interest was in the land and work.")]), _vm._v(" "), _c('p', [_vm._v("Salma and my mother kept coming every month to take the rent. I was not safe from their tongues at all. Once, Salma came with a beautiful baby in her hand. My mother smiled and said, “I don’t think I will see your children, Zaina, because you have grown up to that!”")]), _vm._v(" "), _c('p', [_vm._v("I did not grow up, but the girls in our city marry in early age. I loved the child, in the end he is my nephew. I wished to hold him with my hands and kiss him, but I know that if I approached him, they would scold me and accuse me of jealousy, and perhaps they would accuse me that I want to harm the child. Maryam was annoyed when she saw the child in her hand, which raised my suspicions that she is still in a relationship with Faris. I sent Jawad behind her the next day watching her; she must have wanted to get the rent back from Salma. Jawad came back and told me that she had met him, and on that day, the house was filled with groceries from his shop as usual. The next day Maryam came out early too, so I sent Jawad after her, and when he came back, he told me that she had met Faris in a café outside.")]), _vm._v(" "), _c('p', [_vm._v("We stayed like this for a whole year. Jawad became like Maryam’s shadow; he was watching her wherever she went. I didn’t want to interfere with her private life, but I was afraid of the calamity that would befall us if Salma knew.")]), _vm._v(" "), _c('p', [_vm._v("The land prospered and yielded and we became famous in all the neighboring villages for the quality of our merchandise. I thank God for the abundant good that comes to us from the land. We are no longer filling two or three baskets; we were preparing dozens of baskets a day. The work was hard and exhausting on me, I don’t deny Laila’s help and perseverance. I missed her so much; I missed our conversations despite spending most of our day together.")]), _vm._v(" "), _c('p', [_vm._v("We rarely sat and talked, I was not convinced by her recent behavior with Maryam. She missed me a lot too; her eyes carried great sadness and reproach. She did not know that Maryam recklessness and support would bring a disaster upon us. She tried hard to restore the family atmosphere, but the land was the most important for me.")]), _vm._v(" "), _c('p', [_vm._v("A year and another passed, the little girls grew up and started to cause us an obstacle on the farm; all they wanted was to play. Maryam was the main responsible for them, but with their clutter, who could control them. Sarah also grew up and mastered reading and became a beautiful and nice girl. I loved little Zaina very much. Whenever she saw me, she ran towards me, kissed me, and asked for her sweets that she used to take from me every day. Laila considered her a strong link between me and her. She used to argue with her to see me, so she would come to me complaining about her, or tell me how much the girl loves me, and that she will not sleep before I kiss her! She used sleep on my bed and sit on my knees at mealtimes and I would feed her with my hand.")]), _vm._v(" "), _c('p', [_vm._v("The days went by in such routine. Rasha did not leave us; she visited us from time to time. When we wanted new things, Hazem went to her and bring things. She used to come with him and spent the day with us. We chose what we wanted and then Hazem returned her in the evening. She tried to get close to him a lot but in vain; he did not even like to look at her until she gave up on him, and she completely forgot about him.")]), _vm._v(" "), _c('p', [_vm._v("I was so pleased with the progress of the land; we became famous, that even the gentlemen bought from us.")]), _vm._v(" "), _c('p', [_vm._v("Two years of prosperity and abundant sustenance, and things are among the best. The winter came, I didn’t like rainy days that kept me away from work. Hazem never allowed me to be exposed to rain or extreme heat; he took care of everything so that I wouldn’t get tired.")]), _vm._v(" "), _c('p', [_vm._v("On a rainy day, I sat in my room with no desire to talk to anyone. I stood in front of my window, and began to contemplate the raindrops that were knocking on my window. From afar, I saw a car standing in front of the door of the house. A man came out of it; I heard the sound of the doorbell, I went down quickly. Who is visiting us with this late time? I opened the door and saw the officer Amjad in front of me, I was surprised to see him; I had not seen him since that incident. I welcomed him and asked him to enter.")]), _vm._v(" "), _c('p', [_vm._v("“How are you doing?” he started the conversation.")]), _vm._v(" "), _c('p', [_vm._v("“Fine, we haven’t seen you since that day!”")]), _vm._v(" "), _c('p', [_vm._v("“I’m on an official mission, Zaina, please call everyone, I don’t want to be late; I’m afraid the weather will get worse.”")]), _vm._v(" "), _c('p', [_vm._v("His tone was serious and harsh.")]), _vm._v(" "), _c('p', [_vm._v("“Come in, I’ll make you a cup of tea, while everyone comes,” I said quietly.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, quickly please.”")]), _vm._v(" "), _c('p', [_vm._v("His visit never pleased me. I sent Sarah to her mother’s room and Laila’s also to tell them to come down. She answered me calmly, “But my mother is not here.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her in amazement and said, “Where did she go?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “I don’t know, every evening she goes out for two hours and then comes back.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, call Laila and your uncle quickly.”")]), _vm._v(" "), _c('p', [_vm._v("She laughed and said, “Who is my uncle?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and remembered that she had never called him an uncle, but only Hazem. I grabbed her hand, and in a firm tone ordered her:")]), _vm._v(" "), _c('p', [_vm._v("Call Laila and Hazem, and tell them the officer wants them right away.")]), _vm._v(" "), _c('p', [_vm._v("She ran upstairs, Hazem came immediately, and Laila came down after a few minutes. I grabbed Laila by her hand tightly and asked her, “Where’s Maryam?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “In her room, I’ll bring her.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her hand tightly and asked, “Where’s Maryam? She is not in her room!”")]), _vm._v(" "), _c('p', [_vm._v("She was surprised; she seemed very sincere.")]), _vm._v(" "), _c('p', [_vm._v("“You hurt me, I swear I don’t know!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Well, let’s go to the guest.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem brought tea and presented it to the guest. Laila welcomed the guest and asked him about his health. He smiled at her and said, “Fine, where’s your friend?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She went to the doctor. Tell us, sir, what is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("He asked cautiously, “Who is this who brought me tea?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “It’s her brother, please, officer. What’s the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Where’s the little girl?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “She’s sleeping in her room.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Please bring her.”")]), _vm._v(" "), _c('p', [_vm._v("At that moment, Maryam entered. She seemed to come back running; she was wet. She was surprised when she saw Amjad. She went straight to him and said, “Welcome, how are you? We haven’t seen you in a long time.”")]), _vm._v(" "), _c('p', [_vm._v("He didn’t like the way she spoke, so she turned to me and said in a loud voice, “Where’s the little girl?”")]), _vm._v(" "), _c('p', [_vm._v("He turned to Maryam and said firmly, “Sit down and calm down, I will tell you everything. There have been many cases similar to Lynn in the city. Every two or three months, we find a girl in front of a store. I arrested many of those who left children, but unfortunately, none of them revealed anything. All the children were female. Unfortunately, one of the girls died, and we discovered after a while, after making tests on them, that some of them are sisters. I think they are from the same father, not all of them, and also, unfortunately, some girls suffer from diseases. I want to take Lynn to do some tests for her, and see if she was a sister to one of them. I want also to check if she had any disease.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “No, sir, she is fine and in full health. She does not suffer from anything. I take her to the health center, and conduct periodic examinations for her. As I am telling you, she is fine; there is no need to take her with you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “I must take her; she will be in the shelter for several months, and then I will return her to you, so bring her quickly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Several months! No, sir, I can’t live without her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Officer:")]), _vm._v(" “Bring the girl, it is necessary, I must take her with me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (calmly): “")]), _vm._v("What do you think if I go with you, sir, we make the tests for her and then I get her back with me?”")]), _vm._v(" "), _c('p', [_vm._v("The officer, starting to lose his patience.")]), _vm._v(" "), _c('p', [_vm._v("“No, I must take her, it may carry new evidence on the father or mother. You do not know how serious the matter is. There may be a gang that trades in girls. When the girls give birth, they kill them and throw the baby girls away. I have been working on this case for two years. They only leave the baby girls in the streets; we have never found a boy, so please bring the girl quickly.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam looked at him with contempt.")]), _vm._v(" "), _c('p', [_vm._v("“Which girl are you talking about?”")]), _vm._v(" "), _c('p', [_vm._v("Amjad smiled sarcastically and said, “Bring the girl quickly, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Okay, I will bring her immediately.” I headed to her room.")]), _vm._v(" "), _c('p', [_vm._v("He looked to Maryam and added, “Do you know that I can imprison you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What charge?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Amjad:")]), _vm._v(" “Bring the girl quickly. I wanted to be friendly with you, so I didn’t bring the guard, I know she means a lot to you, but this is my job, bring her quickly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (obstinately):")]), _vm._v(" “You are threatening us in our house. There is no girl here.”")]), _vm._v(" "), _c('p', [_vm._v("I quickly got down and Lynn was between my hands.")]), _vm._v(" "), _c('p', [_vm._v("I looked to Maryam and said, “Enough, he’s doing his job and he’ll bring her back to you.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam looked at me angrily.")]), _vm._v(" "), _c('p', [_vm._v("“Why did you bring my daughter, Zaina? She is not the girl he brought, this is my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("Amjad pulled Lynn from my hands. She started crying.")]), _vm._v(" "), _c('p', [_vm._v("He said calmly, “I will forgive you for what you did, just because you consider her your daughter.” Then he headed towards the door.")]), _vm._v(" "), _c('p', [_vm._v("Maryam ran to the kitchen with great anger, she brought a knife and stabbed him in his side. Before he fell to the ground, Laila took Lynn.")]), _vm._v(" "), _c('p', [_vm._v("He turned to me, writhing in pain, trying to get his gun out. He said painfully while he was bleeding, “What did I do to kill me?”")]), _vm._v(" "), _c('p', [_vm._v("Before he could finish his words, she had stabbed him in the heart for the second time. He fell on the ground, a lifeless body.")]), _vm._v(" "), _c('p', [_vm._v("His look was painful; he was asking and reproaching me by his look, “Why did you allow them to kill me, why didn’t you stop her after the first stab, I’m bleeding, and you are watching me, what did I do to you?”")]), _vm._v(" "), _c('p', [_vm._v("I stuck in my place, a horrific scene. How did Maryam get the audacity?")]), _vm._v(" "), _c('p', [_vm._v("I forgot that whoever kills once kills a thousand.")]), _vm._v(" "), _c('p', [_vm._v("I fell on the ground. Hazem immediately picked me up, took me to my room, and put me on my bed quietly.")]), _vm._v(" "), _c('p', [_vm._v("His sister ordered him to take Amjad’s body and threw it into a far river; outside the city.")]), _vm._v(" "), _c('p', [_vm._v("I had a strong fever. Laila brought me the city doctor. She stayed up beside me for four nights; four nights of fever and I rambled and said, “What did I do to you?” Four nights and silence fell on the whole house. Maryam locked herself in her room. She carried Lynn in her arms; kissing her and telling her, “I will not allow anyone to take you from me.” Four nights and Hazem was beside my room praying God for healing me. Four nights, and the land was neglected and the girls were dazed.")]), _vm._v(" "), _c('p', [_vm._v("I regained consciousness and recovered from the fever on the morning of the fifth day. As soon as I opened my eyes, I saw Maryam and Laila above my head with an innocent smile saying, “Thank God, you’re back.”")]), _vm._v(" "), _c('p', [_vm._v("I got up angrily and shouted in Maryam’s face, “What are you doing here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I check on you; we worried a lot about you, five nights ago I entered your room and found you lying on the floor.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “You liar!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What’s the matter, my dear? She was so worried about you. She brought you the doctor in the middle of the night, and that’s how you thank her.”")]), _vm._v(" "), _c('p', [_vm._v("I asked them, “What happened to Amjad?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Who is Amjad?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “She killed him, I saw her stabbing him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Who is Amjad? My God, the fever has eaten up your mind, stab whom, if I can’t kill an ant!”")]), _vm._v(" "), _c('p', [_vm._v("Laila took my hand and said, “Calm down, my dear, you have a high fever, you may have seen him in your dream.”")]), _vm._v(" "), _c('p', [_vm._v("I answered with confidence, “I’m not crazy; I saw her killing Officer Amjad with a kitchen knife!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Calm down, my dear, now I remember who Amjad is. You were delirious, believe me. I will bring you some food; the doctor told us that you should eat well in order to recover.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want, get out; I don’t want to see anyone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You should eat.”")]), _vm._v(" "), _c('p', [_vm._v("She was very worried about me. I know that she loves me, but she is covering up for that killer; perhaps because Maryam covered her up when she killed her brother. Perhaps Laila was afraid of Maryam if she disclosed her secret, she would expose her too. I was saddened by Laila’s condition and the state of tension and fear in which she was living. She is always the good and friendly friend. No one ever complained about her behavior, and everyone knew that she was a good woman. She hated violence and fighting, and always avoided arguing with anyone. Her personality has changed a lot since Maryam entered her life. She may not have been affected by killing Amjad, and the matter does not mean to her. I know that what I saw was true and that she killed him. I know that they hid everything related to the crime, but I will reveal that when I recover, and then I will expel her from the house. Basically, she has become a danger to all of us, perhaps someone will anger her and she will kill him!")]), _vm._v(" "), _c('p', [_vm._v("They went out, Laila was worried and disappointed. After half an hour, Hazem brought me food, and said, “I prepared food for you myself; you should eat. The doctor said if you do not eat, you will die, and I do not want anything bad to happen to you.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him to leave the food on the table and go. I spoke to him in a nicer tone because he is the one who will tell me later what happened and that I was not delirious.")]), _vm._v(" "), _c('p', [_vm._v("I locked myself in my room; whenever any of them opened the door, I kicked her out. Maryam never came in anymore. As for Laila, she used to come to me in the morning and evening, reassuring that I am okay and leaving. Hazem used to bring me food and drink. His kindness to me reminded me of my father, when I was sick when I was young, he would bring me food and feed me with his hands. I wish he was there, yes he is inside me. The memories of my father reminded me of the box that Malik gave me. Oh my God. I forgot the box completely. I wish it were the same box that my mother took from me, that contained many pictures of me with my father.")]), _vm._v(" "), _c('p', [_vm._v("I pulled the box from under the bed. I was so glad I remembered it, how stupid I am, it’s been two years and more since it’s been under my bed, how careless I am! I cleaned it from the dust. I opened it quietly, after I had locked the door of my room from the inside, so that no one would suddenly enter my room. Malik had recommended me that I should open it by myself.")]), _vm._v(" "), _c('p', [_vm._v("I took out the paper that Malik had left me on which he wrote his address. I put the paper aside; I don’t know if I’ll ever go to him, but I’ll keep the paper, I might need it one day.")]), _vm._v(" "), _c('p', [_vm._v("The first thing I found was a letter. It was addressed to me as written on its envelope: ‘A letter to dear Zaina, from your loving father.’ I started to cry as soon as I read the phrase. My father, I miss his kindness and tenderness, and the touch of his hand on my cheek when I was crying, he was wiping away my tears. How I wish if he was here today. I was very eager to know the content of the letter. I opened it while my heart was beating fast and the blood inside me was boiling. What I needed most in these difficult days was my father. I was very late to open the box, but I did not need to open it like I need today. I wanted to forget what Maryam did. I wanted to go away from reality; I wanted to travel to another time. Perhaps traveling to my life with my father is the perfect time.")]), _vm._v(" "), _c('p', [_vm._v("I held the paper in my trembling hands; I do not want the letter to contain a new pain to be added to my painful life. I want this letter to be a joy. I want to forget Amjad’s blood and his look at me when he said, “What did I do to you…” I want to fly away, I want to visit my father and enjoy his touch. I want to forget the injustice of my mother and Salma.")]), _vm._v(" "), _c('p', [_vm._v("“My dear Zaina.” This is how he began his words, how beautiful his words are, and how beautiful my name is because it was manuscript on the paper with his fingertips!")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("My dear Zaina, my dear little daughter, I suppose you are now a mature lady. I know that life has been very harsh with you, but I also know that you are strong, tough, and able to face it. I have left you a wide land, I know, my dear, that you will be surprised. Why did I leave the land for you alone? I did that because you are able to take care of it, and because you will not wrong your sisters and your mother. If one of them needs you, you will take care of her neglecting how bad she will be with you. Take care of the land; as you give the land of your time and efforts, it will give you. Take care of your sisters; be like a second mother to them. Take care of yourself, my beautiful angel. I left you a bracelet. I bought it for you; keep it to yourself, my dear. It will be your guide one day. Be as I always wanted you to be a strong, solid, and tender woman.")]), _vm._v(" "), _c('p', [_vm._v("Note: Keep Laila’s friendship, she has no one but you. I wish you, my little girl, to have a happy life full of love and success.")]), _vm._v(" "), _c('p', [_vm._v("Your loving father.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("His words traveled inside my whole being, I grabbed the message and contemplated it while tears filled my eyes. It surrounded me with warmth that I had forgotten for a time. It kindled inside me feelings of nostalgia for my father and my days with him. His words were engraved inside my head; I will take care of the farm, my sisters, and Laila. I will be strong and achieve my dreams. I will not skimp on anyone with my big heart and my beautiful feelings.")]), _vm._v(" "), _c('p', [_vm._v("His message woke me up from my slumber; I will not stay in my room, I will ignore Maryam, and pretend that I believed her story about Amjad’s death. I will renew my old friendship with Laila. My father loved Laila very much. When her father died, he took care for her a lot; she was like his daughter. He surrounded her with his tenderness and warmth. When her mother died, he didn’t leave her until his death. After he died, my mother mistreated her so she rarely visited me. The market became the place for meeting. She learned the art of embroidery from her mother, and we spent most of our time together. When she got married, I was a good helper and a good friend. Laila was also a wonderful friend, but time and the evil Maryam began to change her; I will work hard to wake her up to restore herself.")]), _vm._v(" "), _c('p', [_vm._v("I found the beautiful bracelet and put it right around my wrist; it was so bright and shiny. It contained green, red and blue, and colored stones. It seemed to be expensive and precious. I would not tell anyone that it was precious; if Laila asked me, I would tell her that it was a cheap bracelet that I bought from a street vendor. What did my father mean with proof? Why is the bracelet a proof? Maybe proof of his love for me!")]), _vm._v(" "), _c('p', [_vm._v("I also found the papers of the land and it was registered under my name. I found an old picture of me and my father. I remembered this picture very well. When we were working on our small land, one of the photographers passed by and he was screaming and calling, “Who wants an instant picture?”")]), _vm._v(" "), _c('p', [_vm._v("I was wearing a pink dress and a brown apron over it. I put on my head a straw hat to protect me from the heat of the sun. My eyes were shining like the sky. I grabbed my father by his hand and jumped while saying, “Please, let us take a picture, please, Dad.” He would not refuse me a request; he called for the man immediately.")]), _vm._v(" "), _c('p', [_vm._v("He carried me with his hands, and said, “Picture of the little beauty.”")]), _vm._v(" "), _c('p', [_vm._v("The man smiled and said, “Lift the hat so that the beauty of your eyes appears.” I held the hat and raised it high, and put my other hand on my father’s neck. The man gave us the picture; my father smiled and said, “I will keep it. For you.” I thank God that the photo is still there to remind me of my father.")]), _vm._v(" "), _c('p', [_vm._v("The last thing in the box was a very beautiful doll. It had the color of my eyes. I found a sticker on the doll’s hand; it was written on it: ‘This is for you baby, I always wanted to get you one.’ I burst into tears. I hugged the doll as if it was my daughter. I couldn’t believe what I saw; he always promised to bring me a doll when he was leaving us, and when he came back with his hands empty, he was saying to me painfully, “I’ll bring you the doll next time.” He kept his promise after his death, oh my God, he didn’t forget the doll one day, and now I have one. What a doll! It was a very beautiful doll, in a white dress and a pink hat. She had also blue eyes; she looked a lot like me. I think it was made especially for me.")]), _vm._v(" "), _c('p', [_vm._v("I put all the things back into the box, and put it under the bed. I wished to sleep with my doll, but I was afraid that any child would enter and possessed it. I will leave it now protected from their clutches, until I bring them dolls.")]), _vm._v(" "), _c('p', [_vm._v("I could not sleep after that, my father’s box brought me back all the old memories with him, and also ignited inside me the feelings of nostalgia to meet him and sit with him. His message urged me to rearrange my affairs and priorities. I will go to the land early tomorrow. I will reestablish my relationship with Laila, but Maryam must be completely ignored. Laila knocked on the door and woke me up from the overwhelming torrent of memories in which I was drowning in.")]), _vm._v(" "), _c('p', [_vm._v("I shouted, “Who?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “It’s me, Laila. I brought you some food. Can I take it in and I’ll get out at once?”")]), _vm._v(" "), _c('p', [_vm._v("I went to the door and opened it for her, asking her to come in.")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “How are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("Laila carefully, calmly, and surprised.")]), _vm._v(" "), _c('p', [_vm._v("“Fine, I won’t bother you, but you must eat, my dear. I made the food myself.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, sit down. Let us eat together.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (eagerly and with great joy):")]), _vm._v(" “Oh really!”")]), _vm._v(" "), _c('p', [_vm._v("Her mind could not believe what her ears heard, she was good, but she must be awakened from her slumber.")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Yes, I have missed our sessions together.”")]), _vm._v(" "), _c('p', [_vm._v("Laila put the food on the table, approached me, hugged me, and started crying.")]), _vm._v(" "), _c('p', [_vm._v("“Me too, you don’t know how much I miss you; I don’t have anyone but you in this world.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, I was tired, and you know working on the land, installments and debts are all burdens that exhausted me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “It’s okay, my dear, thank God, the farm today produces and offers us a lot of money. You must use all your efforts to get the goal.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you’re right.”")]), _vm._v(" "), _c('p', [_vm._v("While we were having a conversation and laughing, Maryam entered us, embarrassed and confused.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “How are you, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her calmly and sweetly, ignoring everything that had happened, “Fine, sit down and eat with us.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam sat in a state of astonishment; we ate and then we all went down to the hall. We started chatting about the coming days. Eid is coming and Laila’s work starts now. They agreed to make a large amount of embroidery, but I will return to my work on the land with great vigor.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, Hazem came to us. When he saw me, he smiled and said, “Thank God you are back.” He had a bag in his hand. He gave me the bag and said, “This is for you.”")]), _vm._v(" "), _c('p', [_vm._v("I was so happy; I opened it, and found a blue silk scarf.")]), _vm._v(" "), _c('p', [_vm._v("I said happily, “Oh my God, it’s expensive!”")]), _vm._v(" "), _c('p', [_vm._v("I felt like a child who had received a gift from her father, who had been waiting for him for hours; as if he had brought me the doll that I had been waiting for so long. He had spent a fortune on the scarf. He might have spent all he had. Why would he do that?")]), _vm._v(" "), _c('p', [_vm._v("I put the scarf around my neck; it was so beautiful and gorgeous. It reflected the color of my eyes. I looked so beautiful. I asked him innocently and childishly, “Why would you buy such a precious gift? Maybe you spent a lot of money on it?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me joyfully because I liked the scarf, “You deserve everything I have.”")]), _vm._v(" "), _c('p', [_vm._v("I jumped towards him and with a spontaneous movement, I kissed him on the cheek. He blushed and put his hand on his cheek; on the place of the kiss. He didn’t expect what I did, not even me. I was jumping towards my father and expressing my love to him in the same way, he was carrying me and lifting me high, and then calmly bringing me back to the ground. As for Hazem, he froze in his place. He didn’t expect what happened to him, he never imagined to get a kiss from Zaina; his beautiful girl who is creative in giving him orders and notes. That kiss will remain the most beautiful thing he ever got, that kiss will remain in his memory as long as he lives.")]), _vm._v(" "), _c('p', [_vm._v("Maryam interrupted his moment of joy and love and said, “Where is my scarf, dear brother?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at her, sighed, and took out two small bags from his pocket.")]), _vm._v(" "), _c('p', [_vm._v("“These are two scarfs one for you and the other for Laila.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam began jokingly shouting, “You brought the precious one, in a valuable bag for Zaina, and ours; you took them out of your pocket.”")]), _vm._v(" "), _c('p', [_vm._v("Laila pulled the two scarfs, chose one, and put it around her neck. She laughed and said, “It’s okay; the point is that he did not forget us, then who we are in front of Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("Laila made us a delicious cake. We spent a wonderful evening full of laughter. We restored friendliness to the house which had suffered from long and hard nights. I would hide my feelings towards Maryam until I knew what had happened to Officer Amjad, who I was sure had died with her knife.")]), _vm._v(" "), _c('p', [_vm._v("The days of hard work passed quickly. Laila, with Maryam’s help, made a large number of wonderful colorful embroideries. They used all colors; they made beautiful paintings on fabrics of all kinds. I liked one of them; the one that had a lake and a white swan inside. I asked Laila to keep it for me. She presented it to me and whispered in my ear, “Put it on your pillow on your wedding day.” I smiled and thanked her. I took it and put it inside my wooden box. It would have been the most beautiful memory from my best friend!")]), _vm._v(" "), _c('p', [_vm._v("I put in the box the scarf that Hazem gave me; I don’t know why I put it! I wanted to wear it so badly, but I felt like… I don’t know what I felt, but I was sure it was very precious and had to be kept, like my father’s bracelet and the doll.")]), _vm._v(" "), _c('p', [_vm._v("I decided to invite Rasha to spend the Eid days with us. She is alone and has no friends or relatives. Maryam and Laila accepted the idea happily despite Hazem’s resentment. He does not want to see her. He hated her attempts to attract him. Hazem did not and will not see a girl other than me. He closed his eyes to all women; I was the only one who controls his being and his soul. Since he lived with us and he did not sleep before he was assured that I was asleep. He did not eat food before me. How many times he kept fasting while I was tired, and how many nights he spent awake when I forgot to turn off the light in my room. Once I found him sitting in front of my room, I asked him, “Why aren’t you in your room, on your bed?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me scared, “I heard the dogs barking outside, so I was afraid that you might be afraid of them, so I decided to stay by your door if you needed anything.”")]), _vm._v(" "), _c('p', [_vm._v("That night, the police were chasing a thief. They, in cooperation with the nobleman, released dogs all over the city to find him. Before sunrise, they arrested him.")]), _vm._v(" "), _c('p', [_vm._v("He surrounded me with tenderness and love. I wished that his heart were inside the body of the nobleman, and I get that attention from a Karim! He compensated me by the purity of his heart and his love for the affection of my father.")]), _vm._v(" "), _c('p', [_vm._v("I went a few days before Eid to invite Rasha, I wanted to see her, not just to invite her, but I really wanted to ask her about the officer Amjad; surely his family and the police are looking for him. I was sure that Rasha knew many things about him; news like this spread quickly among the people of the city.")]), _vm._v(" "), _c('p', [_vm._v("I woke up very early and decided to go for a walk; I wanted to go alone. I was no longer worried about picking the crop early and taking it to the market; Jawad became very good at this work with Hazem’s great help. They took care of selling vegetables and looking after the land. Although I watched them closely, they are trustworthy.")]), _vm._v(" "), _c('p', [_vm._v("I stepped out of the house in a hurry; I did not want to meet Laila on my way. If she saw me, her questions would rain down on me. “Where are you going, and when are you coming back?” And other questions. No matter how early I wake up, there is always someone outstripped me, as if he hears my steps. I met Hazem at the door. He offered to take me in a carriage, but I refused. With great difficulty, I convinced him that the weather was fine, and that I would like to walk and enjoy the morning breeze. He reluctantly agreed after I told him to come at noon and bring me back home.")]), _vm._v(" "), _c('p', [_vm._v("I started my walk with the cool morning breeze, I was anxious to see Rasha a lot. I wasn’t fast paced nor slow either. I’ll be there in a reasonable time and I won’t panic her.")]), _vm._v(" "), _c('p', [_vm._v("On my way, I saw a little girl holding her father’s hand in fear. Perhaps she was afraid of him. Perhaps he was the nervous type with his girl. After a few moments, the girl left his hand, rubbed it with her other hand, and almost burst out crying. I rushed to her quickly and asked her, “What’s wrong with you, little girl?”")]), _vm._v(" "), _c('p', [_vm._v("She did not speak, but showed me her red hand. Her father was holding her hand so tightly which caused her harsh pain. He looked at me in astonishment and said, “It isn’t your business, woman!”")]), _vm._v(" "), _c('p', [_vm._v("Then he suddenly fell silent. At first, I felt that I would receive a slap from him for interfering with his affairs, but he smiled and said, “If I left her hand, she would run down the street and run away. She is a very quarrelsome child.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily, “Is it possible that your fist causes her pain?”")]), _vm._v(" "), _c('p', [_vm._v("He held the little girl in his hands and kissed her. She smiled immediately as if she was accustomed to such behavior; she looks quarrelsome. They reminded me of my father. When I was going with my father to the neighboring city, he held my hand, and when I got tired, he carried me and kissed me. His fist did not cause me any pain. On the contrary, he was so compassionate and kind!")]), _vm._v(" "), _c('p', [_vm._v("The man said calmly, “How are you, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him in astonishment.")]), _vm._v(" "), _c('p', [_vm._v("“Who are you, and how did you know my name?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “I came to your village several times and asked about you, but unfortunately, I could never find your house.”")]), _vm._v(" "), _c('p', [_vm._v("I replied in an angry tone, “Who are you, and why are you asking and looking for me?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled while fear filled my heart. Nothing occurred to my mind but Amjad. Perhaps he is one of his friends or an officer like him. Surely, he would ask me about him.")]), _vm._v(" "), _c('p', [_vm._v("He asked me friendly, “Don’t you remember that wounded man to whom you lent money?”")]), _vm._v(" "), _c('p', [_vm._v("“Which wounded, and what money?”")]), _vm._v(" "), _c('p', [_vm._v("“You have right to be surprised, you have the right to forget; years have passed since we met. I was that wounded person whom you gave your money, the one from whom his horse was stolen. You bandaged my wound and lent me money. I promised you that I would return, and honestly, I came back many times and did not find you. Since then, the money never left my pocket, I pray to meet you and return it to you.”")]), _vm._v(" "), _c('p', [_vm._v("He took out of his pocket a bundle of money wrapped in the same bandage with which I had bandaged his hand. It was not the same amount; it was double or more.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him shyly and said, “I don’t want it, thank you, thank God you’re fine, and then I don’t remember lending you that much money.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “Please, this money is your right.”")]), _vm._v(" "), _c('p', [_vm._v("“I am very well known in the city, it is strange that you did not find me.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, I was asking about Zaina downtown.”")]), _vm._v(" "), _c('p', [_vm._v("“Downtown! What do you mean downtown?”")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t you tell me at that time that your name was Zaina and you said downtown, I went downtown and asked about you?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I work in the city center, but I am better known in the market, where I sell my vegetables. I also have land in the city center. Anyway, if you want to ask about a person in our city, you should ask in the name of the family, because there is more than one girl called Zaina lives in our neighborhood.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, anyway thanks for your help, please take your money.”")]), _vm._v(" "), _c('p', [_vm._v("“Buy a doll for your little girl with money; I am not the one who takes money from the needy.”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me madam, I am not in need, I am a doctor and I earn a lot from my work, the child has a lot of dolls. Please accept the money from me.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I didn’t mean to offend you, but you were in need at that time. I’ll only take what I lent you.”")]), _vm._v(" "), _c('p', [_vm._v("I opened the bag after he told me how much I lent him at the time. I took my money and returned the rest to him. I was happy to be treated like a lady who had her business and her money. He smiled and said, “Please, if you know someone who needs the money, give him what’s left.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him curiously and said, “Did you think I need it?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said in confusion, “No, never, forgive my ignorance.”")]), _vm._v(" "), _c('p', [_vm._v("I put the money in the bag and added, “A great idea, I will combine my money with yours and give it to a poor family.”")]), _vm._v(" "), _c('p', [_vm._v("He thanked me and gave me a piece of paper with his name and address written on it. His name was Ashraf. I put the paper and money in my handbag. I greeted him then I continued walking towards Rasha’s shop.")]), _vm._v(" "), _c('p', [_vm._v("I know he is right if he thinks I am poor; on the day I saw him, I was in my old dress and my worn-out shoes. My appearance gave the impression of misery and poverty.")]), _vm._v(" "), _c('p', [_vm._v("I arrived so early that the shop was closed. I knocked on the door. After two minutes, Rasha opened the door. She seemed tired and exhausted. She was very happy to see me, but at the same time, she was surprised that I was so early at her door.")]), _vm._v(" "), _c('p', [_vm._v("She began jokingly, “You see the shopping in your dreams. You are the first customer who comes so early.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, you are the one who I saw her in my dreams,” I answered her in the same way.")]), _vm._v(" "), _c('p', [_vm._v("“Come in, I’ll make you a cup of coffee.”")]), _vm._v(" "), _c('p', [_vm._v("I entered. The shop was not what it was before: tidy, elegant, and full of merchandise, the place was in a mess.")]), _vm._v(" "), _c('p', [_vm._v("I asked her curiously, “What is the matter? Why is this mess?”")]), _vm._v(" "), _c('p', [_vm._v("She answered me with a sigh, “I’ll make coffee first and then we’ll talk.”")]), _vm._v(" "), _c('p', [_vm._v("I started flipping through the existing clothes and choosing things for the little girls.")]), _vm._v(" "), _c('p', [_vm._v("She came back with coffee. She smiled and said, “Can you choose in this mess?”")]), _vm._v(" "), _c('p', [_vm._v("“I still like your goods, but what’s going on with you?” I asked her quietly.")]), _vm._v(" "), _c('p', [_vm._v("“The last season was very bad. After the death of the owner of the shop, his children wanted the money of the rent. They threatened me if I did not pay within a month, they would throw me on the street, or they would complain to the judiciary. I returned a lot of goods to the merchants I was dealing with, but unfortunately they discounted a lot from their price. What was left, the owners did not agree to recover them. I still did not collect a quarter of the amount that I owed.”")]), _vm._v(" "), _c('p', [_vm._v("I was so sad when I heard from her, I asked her, “Why didn’t you tell me before?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to add a burden to your worries, and then I know that you don’t have enough money to help me.”")]), _vm._v(" "), _c('p', [_vm._v("I took out of my bag the money that Ashraf gave me, with all the money I was carrying, and I gave it to her and I asked her if it was enough.")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “You have come to me from heaven, but unfortunately, it is still not enough.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, I came to invite you to spend the days of Eid with us, and then we will see how much you lack and complete the amount for you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha (sadly")]), _vm._v("): “Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("While she was talking, a man came to us with a little girl, it’s Ashraf. Seeing me surprised him. He looked angrily at Rasha. The little girl jumped on me and said, “That’s you again!”")]), _vm._v(" "), _c('p', [_vm._v("He asked me softly after he pulled the girl to him, “What are you doing here?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “It’s not your business.”")]), _vm._v(" "), _c('p', [_vm._v("He was surprised by my answer. I did not like the way he entered the store, or the way he dealt with the little girl.")]), _vm._v(" "), _c('p', [_vm._v("Rasha looked at him with hatred and said, “What do you want? I still have time.”")]), _vm._v(" "), _c('p', [_vm._v("He sat on the chair and sighed.")]), _vm._v(" "), _c('p', [_vm._v("“I know, but you must empty the shop today. We desperately need it.”")]), _vm._v(" "), _c('p', [_vm._v("I interrupted him. “Why the hurry?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “It is not your business?”")]), _vm._v(" "), _c('p', [_vm._v("His answer did not bother me; it was only a reaction to my previous answer. I smiled and continued, “She is my partner.”")]), _vm._v(" "), _c('p', [_vm._v("He rose from the chair and said, “But she didn’t tell me that she had a partner!”")]), _vm._v(" "), _c('p', [_vm._v("“Sit!” I ordered him firmly.")]), _vm._v(" "), _c('p', [_vm._v("I added, “Sit down and let’s talk, the poor girl is trying to collect money for you; she even lost a lot from the price of her goods.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “It’s okay, give me only what she collected, and I forgive her of the rest, but should hand me the shop empty today.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha (stunned)")]), _vm._v(": “Where do I live, and what do I do?”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her hand and asked her to calm down, and then I turned to him and asked him, “Will you write us a paper that you give up the rest of the money?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Sure, the important thing is that I take the shop empty today.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Come back in the evening and you’ll take your shop.”")]), _vm._v(" "), _c('p', [_vm._v("He greeted me politely. While he was leaving with the girl, she turned towards me and said, “I want to stay with you; I don’t want to go with Ashraf.”")]), _vm._v(" "), _c('p', [_vm._v("He got so angry at her. He picked her up hard and left. I followed him, full of anger at him. I stopped him and said, “Why do you treat her like that? I’ve never seen a father treating his little girl this way!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “First, she is not my daughter; second, please go back to the shop to help your friend. I know that you are not her partner and that you will give her money, it’s okay.”")]), _vm._v(" "), _c('p', [_vm._v("Despair and frustration appeared on his features; as if he had a big problem.")]), _vm._v(" "), _c('p', [_vm._v("I asked him quietly, “What’s the matter, what makes you sad?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “My father passed away and left me this child from his second wife. I do not know how to take care of her, and my brother did not want to raise her with his children. I am a single man and I do not know how to take care of the girl, and I have a lot of work to do. Her mother left her easily. I promised my father that I would take care of her; my biggest fear was that I would mistreat her and oppress her. Besides, she is very troublesome which I can’t bear.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “It’s okay, take it easy. Send her to school. If she goes to school, you will spend half your day free.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Well done! School, how did I not think of it? Thank you, see you in the evening.”")]), _vm._v(" "), _c('p', [_vm._v("He left quickly with the girl. I think school is the best solution for the poor girl!")]), _vm._v(" "), _c('p', [_vm._v("I went back to Rasha’s shop and found her crying and nagging.")]), _vm._v(" "), _c('p', [_vm._v("“Where shall I go, where shall I live, and what shall I do?”")]), _vm._v(" "), _c('p', [_vm._v("She was crying and repeating those questions.")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her hand and said, “You will live in my house, and you will work with us. Believe me, dear, we are a group of women who do not master anything in life as we master work!”")]), _vm._v(" "), _c('p', [_vm._v("We started putting the goods in cardboard boxes; her face was overwhelmed with sadness and sorrow. I told her to be patient. I tried to convince her of the beautiful life that she would spend with us.")]), _vm._v(" "), _c('p', [_vm._v("We worked hard for more than hour without saying a word. Suddenly, I felt tired. I was about to fall down, so I sat on a chair.")]), _vm._v(" "), _c('p', [_vm._v("She looked at me sadly and said, “I’m sorry about what’s going on. Please don’t move; I’ll work alone. You should know that your existence here today comforts me.”")]), _vm._v(" "), _c('p', [_vm._v("“Who told you that I am upset or that I will leave you? But I haven’t eaten before I come to you, so let’s take a short break, have our breakfast, and tell me the news of your neighborhood.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Good idea, but why do you want to know our news?”")]), _vm._v(" "), _c('p', [_vm._v("I meant the news of Amjad. I did not forget the main purpose of my visit to her.")]), _vm._v(" "), _c('p', [_vm._v("I answered her calmly and sarcastically, “I just wanted to speak about new subject except arranging things and moving with me. Come on, tell me, what is the news?”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said excitedly, “Yes, there is a lot. I will quickly prepare breakfast and tell you the story of Officer Amjad.”")]), _vm._v(" "), _c('p', [_vm._v("I felt that my heart would stop beating because of fear. Thank God she did not notice me because she immediately went to the small inner room, which is her home to get food. I tried hard to be normal when she came back; I held myself and regained my composure.")]), _vm._v(" "), _c('p', [_vm._v("But my face was so pale.")]), _vm._v(" "), _c('p', [_vm._v("She looked at me intently and said, “Oh, my God, I must have tired you so much! I wish you had told me from the beginning that you hadn’t eaten your breakfast.”")]), _vm._v(" "), _c('p', [_vm._v("I thank God that she explained my paleness due to hunger. I smiled and thanked her for the food. I ate a piece of bread covered with cheese with a cup of hot tea.")]), _vm._v(" "), _c('p', [_vm._v("After a few moments, I asked her, “What’s the officer’s story? What is his name?”")]), _vm._v(" "), _c('p', [_vm._v("She answered in amazement, “You forgot his name! It’s that Officer Amjad who almost detained you because of the child. How poor the Officer is! He was found dead!”")]), _vm._v(" "), _c('p', [_vm._v("When she said it, my hands started to tremble until the cup of tea was almost fallen.")]), _vm._v(" "), _c('p', [_vm._v("She took the cup from my hand and said, “It’s okay, my dear, we were all shocked. How aggrieved"), _c('strong'), _vm._v("that young man was. He was trying to reach the gang that throws girls in the street, but as it is said that he exposed them, so they killed him and threw his body in a river outside the city. Everyone mourned him, as well as his mother and his young wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Was he married?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, about two years ago, and he has a baby.”")]), _vm._v(" "), _c('p', [_vm._v("I started crying; I was sure that what I saw was true and was not a dream. I knew that I was right and that they lied to me. I must stay friendly with them because of Maryam’s evil nature, and I do not want also to attract attention to my family. How much it would be a big scandal if people knew that I harbored a murderer in my house.")]), _vm._v(" "), _c('p', [_vm._v("Rasha did not understand the reason for my tears. She did not realize that those words will engrave in my heart before my mind! How can I forget that image of Amjad when he looked at me in his last moments and asked me, “What did I do to you?”")]), _vm._v(" "), _c('p', [_vm._v("Rasha grabbed my hand tenderly and said, “Do not be sad, Zaina, we are all doomed to die, I did not know that you are very sensitive.”")]), _vm._v(" "), _c('p', [_vm._v("She tried hard and in various ways to console me. I was able to stop my tears from flowing so that she would not doubt me, but who will stop the remorse that will haunt me for life.")]), _vm._v(" "), _c('p', [_vm._v("When Laila killed her brother, I did not care, but I was happy that she was fine. Her brother was evil; she was defending herself and the crime did not happen in my house. I did not see him being killed. Now an officer is doing his job and he was killed unjustly. How I hate the inertness that hit me, I wish I jumped towards her and stopped her or screamed to warn him. Sometimes we are unable to move, and this exposes us to situations that we will regret for the rest of our lives.")]), _vm._v(" "), _c('p', [_vm._v("We went back to work with vigor and activity, I wanted to occupy myself in arranging things for Rasha so that I might forget about Amjad. Another hour of diligent work passed. Hazem entered the shop. I knew that he would come at any moment to take me. He was surprised by the mess.")]), _vm._v(" "), _c('p', [_vm._v("He said in astonishment, “What are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("I answered firmly, “Don’t ask, come on, take those boxes to the cart, take them home, and come back to help us!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Did you buy all the goods?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “No, I’m going to move from here and stay in your house. Tell the ladies so they won’t be surprised.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to her in annoyance and said, “Why should they surprise; you’re going to stay in my house, not theirs.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem supported me. “Yes, it is Zaina’s house, and she has the right to invite whoever she wants.”")]), _vm._v(" "), _c('p', [_vm._v("I thanked him through my eyes. He understood me very well; he understood when I want to thank him and when I want to scold him. He never embarrassed me in front of anyone. No matter what I say and whatever I do, he stands by me.")]), _vm._v(" "), _c('p', [_vm._v("I asked him to be fast as possible as he can because time is running out and we have a lot to do. He alone moved all the boxes with great vigor and activity. Rasha was astonished by how the work was going well. He left after his cart was full of boxes. Hazem came back an hour later with Jawad to help us. Jawad whispered to me in my ear, “Why does she want to live with us?”")]), _vm._v(" "), _c('p', [_vm._v("I told him in the same way, “We’ll talk about this later.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad helped us a lot by putting things inside and closing the boxes, they moved another cart to the house. When they came back, they had lost a little of their activity, so I asked them to have a rest. Jawad sat on the chair while Hazem refused to sit down; he looked at me and said, “As long as you work, I work, and if you want to rest, I will work instead of you.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Let’s finish the work quickly; there is not much left until evening.”")]), _vm._v(" "), _c('p', [_vm._v("Rasha and I didn’t anticipate how much goods she had, when we started we thought we’d only use ten boxes, but we’re over thirty and we still need more.")]), _vm._v(" "), _c('p', [_vm._v("We were tired, so we decided to sit down for a while and have a cup of coffee. As for Hazem, as he promised, I rest and he completes the work. He accomplished a lot; if he did not come, we would have needed another day. We closed the last box. Hazem put it in the cart and said, “Will you come with me?”")]), _vm._v(" "), _c('p', [_vm._v("I asked him to go home to unload the cart, and then come back to pick us up. As soon as Hazem left, Ashraf came with another young man.")]), _vm._v(" "), _c('p', [_vm._v("Ashraf entered smiling in a completely different form from what we saw in the morning. I asked him about the little girl.")]), _vm._v(" "), _c('p', [_vm._v("He answered me cheerfully, “I don’t know how to thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“Why?”")]), _vm._v(" "), _c('p', [_vm._v("“I put her in a boarding school, thank God, there is someone will take care of her day and night.”")]), _vm._v(" "), _c('p', [_vm._v("The other man added, “Yeah, that was a great idea! How had we not thought of it before; putting her in a school was the suitable solution.” The other man was very tall and handsome, and very self-confident.")]), _vm._v(" "), _c('p', [_vm._v("I asked him curiously, “Who are you?”")]), _vm._v(" "), _c('p', [_vm._v("Rasha replied wryly, “He’s his brother, Nader.”")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t take my eyes off him, and at the same time, I didn’t want him to notice me. I immediately remembered my dear, noble Karim, so that I would never think of Nader.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Are you ready to hand over the shop?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “Yes, your shop is ready.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("Then he looked at the shop from all directions and said, “We must buy the shops around it.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him in amazement, “Why?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me firmly and noticed the beauty of my eyes. He stared at me for a moment and added, “I will build a factory.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him after my cheeks blushed from his looks, “I wish you all the best!”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("Then he looked at Rasha and said, “I am sorry for your loss, but I asked my brother to not take a penny from you. Keep the money to start a new business with your friend.”")]), _vm._v(" "), _c('p', [_vm._v("I felt that he had touched my pride by his words, so I interrupted him angrily.")]), _vm._v(" "), _c('p', [_vm._v("“She will open her project alone, and I will be a good help to her. As for me, sir, I have my vast land, my own business, and my home.”")]), _vm._v(" "), _c('p', [_vm._v("I was afraid that Rasha would be saddened by my words, but on the contrary, she turned to me cheerfully and said, “Oh really! Will you help me to establish my own project?”")]), _vm._v(" "), _c('p', [_vm._v("Her words pleased me and I began to feel that I had become a noble lady; she told Nader that I would help her.")]), _vm._v(" "), _c('p', [_vm._v("Nader was a nobleman, rich and handsome; I liked his character very much.")]), _vm._v(" "), _c('p', [_vm._v("Was I wrong in thinking of Noble Karim, and ignoring the remaining nobles in the city? Maybe because I had nothing and never saw a nobleman except him, but no, I love Karim, how can I think of someone else? But, I’m getting older and Karim has never noticed me. I don’t know if Nader married or not; he might admire the beauty of my eyes? While Karim, I am sure that he never married and the whole world knows that he is a single man. What a fool I am to think of anyone else, I will ignore that I met Nader one day!")]), _vm._v(" "), _c('p', [_vm._v("I looked at Nader and said tenderly, “I am honored to meet you both. Now we have to leave; excuse us.”")]), _vm._v(" "), _c('p', [_vm._v("I wanted to leave before Hazem returned. I did not want Ashraf and Nader to see me riding Hazem’s old cart. I didn’t want them to have a bad idea about me; I should stay a noble lady in their eyes. Rasha was astonished that I went out in a hurry, while Nader offered me to drive us in his car. I looked at him and thanked him. He insisted on us, and said, “We may visit you one day; let us drive you and know where you live.”")]), _vm._v(" "), _c('p', [_vm._v("Ashraf said, “Yeah, right, I’ve always looked for your house.”")]), _vm._v(" "), _c('p', [_vm._v("Rasha said, “Well, Zaina, come on, we are tired.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t want to accept their invitation to drive me home, but they insisted. Oh my God, I must invite them to enter my house; my furnishings are not luxurious, although from the outside the house is beautiful! It’s okay I’ll pretend I want to change the furniture. That’s what I’ll really do, since my visitors become noble, the house must be renovated. I actually got into the car with them, ignoring the poor man Hazem and started to gossip about the house, and how I will soon buy new furniture! The car was very beautiful and comfortable unlike the wagon that vibrates all the way, we even got home, and I didn’t feel the distance.")]), _vm._v(" "), _c('p', [_vm._v("For the first time I rode a car other than the police car I had with Amjad. Nader must be a rich man. I thanked them for their generosity with Rasha and invited them to come in. Nader got out of the car and said, “This is your house?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it is old and in need of renovation, but it is very strong and solid.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “We don’t care about houses, but about inhabitants.”")]), _vm._v(" "), _c('p', [_vm._v("He extended his hand to shake my hand and said, “Now I have to go.”")]), _vm._v(" "), _c('p', [_vm._v("I shook hands with him, ashamed, and added, “Why don’t you get in and have a cup of coffee with us, I have who can make it well.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Excuse us, we’re really in a hurry, but I promise in another visit, I will enter your house and drink your delicious coffee. You have the most beautiful blue eyes I have ever seen.”")]), _vm._v(" "), _c('p', [_vm._v("He left and took with him a part of my soul, and his words kept playing on the strings of my heart. I never loved my eyes as I loved them today. I stood waving goodbye till the car left and moved away in the horizon. My hand was very hot; I put it on my chest immediately to transfer the feeling to my heart. What happened? Suddenly I forgot Karim and the world. I also forgot the hat and dress with which I will wear when I meet Karim. I even forgot Rasha who was standing in front of me, waiting for me to invite her to enter the house. I forgot my poems that I was writing for Karim. Is it possible for me to forget a love that lasted for years because of words and looks? Maybe it wasn’t love in the first place, but it was a motive to change a life.")]), _vm._v(" "), _c('p', [_vm._v("Hazem’s voice woke me up saying, “You are here and I am looking for you!”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him calmly and said, “I’m sorry, but we were so tired we couldn’t wait, let’s all go home.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem looked at me angrily.")]), _vm._v(" "), _c('p', [_vm._v("“How did you get here?”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand and said, “The shop owner donated to drive us by his car because Rasha was tired.”")]), _vm._v(" "), _c('p', [_vm._v("He calmed down at once as if I had transferred my warmth to him, but I firmly remarked to him, “Please do not yell at me again.”")]), _vm._v(" "), _c('p', [_vm._v("That poor young man; he went, and came back looking for us. He did not even complain of fatigue, but his complaint was full of concern for me. He apologized deeply.")]), _vm._v(" "), _c('p', [_vm._v("I grabbed Rasha by the hand and enter the home, repeating, “You’re welcome, from this moment on, our house is yours!”")]), _vm._v(" "), _c('p', [_vm._v("Mariam and Laila gave us the best reception, and they had prepared a dinner worthy of a guest. Laila also prepared a room for Rasha.")]), _vm._v(" "), _c('p', [_vm._v("We sat around the table; Laila started, as usual, to chat and ask questions to Rasha. She wanted to know the reason for what happened to her. Rasha told her the full story. There was an atmosphere of intimacy and friendliness between everyone; no one felt that Rasha was strange; even Maryam was cooperative. Perhaps they remembered their situation when they came to my home the first time; sad, homeless and depressed.")]), _vm._v(" "), _c('p', [_vm._v("While we were eating the sweets that Laila had prepared for the guest, I deliberately started talking about the officer Amjad. I did not want to disturb them, but I meant to end this issue from the family’s life completely.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Maryam on purpose and said, “Did you know what happened to Officer Amjad?”")]), _vm._v(" "), _c('p', [_vm._v("She answered me with an unpredictable coldness and ignorance, “Who is Officer Amjad?”")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Oh how cold she is")]), _vm._v("! However, Hazem, in his usual simplicity, said, “The one who brought baby Lynn.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Well done, Maryam claims she forgot him.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam, with the same coldness and denial said, “I didn’t know his name was Amjad.”")]), _vm._v(" "), _c('p', [_vm._v("Laila interrupted, she was afraid that Hazem might say anything about what happened.")]), _vm._v(" "), _c('p', [_vm._v("“What happened to the Officer?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “He was killed, he was found dead. Come on, Rasha, tell them what happened.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Yes, the poor man was found dead, killed by the gang that kidnapped children.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Poor fellow.”")]), _vm._v(" "), _c('p', [_vm._v("I replied to Laila, “Really, poor man. May patience and solace rest in the heart of his mother, his wife, and his only child.”")]), _vm._v(" "), _c('p', [_vm._v("As for Maryam, she was steady as nothing happened. She said forcefully, “Will we mourn for someone we met once? Every day, many die.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You are right.”")]), _vm._v(" "), _c('p', [_vm._v("I ignored them and said, “Let’s go to bed now, and let’s take Rasha to her new room.”")]), _vm._v(" "), _c('p', [_vm._v("I pretended to believe what happened, I don’t want any fight with Maryam.")]), _vm._v(" "), _c('p', [_vm._v("Everyone went to sleep. Hazem stayed outside the house; he never entered the house that night. I stood watching him from the window of my room. He always liked to sit under my room window; he stayed there for more than an hour. I was so worried about his situation very much. I put my scarf on my shoulder and went to him to assure him.")]), _vm._v(" "), _c('p', [_vm._v("I approached to him and said, “What is wrong with you today?”")]), _vm._v(" "), _c('p', [_vm._v("When he heard my voice, he wiped his eyes with his hands, as if he was crying. I came closer to him and asked again, “What is wrong with you; why didn’t you go to sleep. Does the presence of Rasha in the house bother you?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me with tears in his eyes, “No, poor girl; she is homeless.”")]), _vm._v(" "), _c('p', [_vm._v("“Then why are you crying?”")]), _vm._v(" "), _c('p', [_vm._v("“Sad for the Officer Amjad.”")]), _vm._v(" "), _c('p', [_vm._v("He was feeling remorse and regret, I wanted him to tell me everything, I put my hand on his hand and said, “It’s okay, my dear, this is the life of officers, they are always at risk.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “No, we are responsible for his death. Maryam was the one who killed him and I was the one who threw him into the river. We were the reason of your fever.”")]), _vm._v(" "), _c('p', [_vm._v("I knew I wasn’t delirious, and that it was Maryam who killed him. I put my hand on his mouth and said, “Shut up, do you want to expose your sister and imprison all of us? Hear me well; do not tell Maryam about what you said to me. Never tell anyone, or else she may kill me too.”")]), _vm._v(" "), _c('p', [_vm._v("He got angry at my words and said, “If someone touches you, I will kill him. Don’t worry, my little girl, Maryam loves you very much and will never hurt you.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed at his childish appearance; I grabbed his hand and told him that he was my only man in this world. He was so happy as if he had not been crying for a few seconds. I kissed him on the forehead, and asked him to go to sleep, because we have a lot to do with the advent of Eid.")]), _vm._v(" "), _c('p', [_vm._v("I did not sleep that night. Thoughts began to welter inside my head; a heinous crime happened before my eyes, a new girl entered the family, Nader and his looks. I will not give up the dream of marrying the nobleman. If I thought of Nader, I would have to leave the city to live with him, and then I would neglect my land and abandon it. I will leave my house and my family. But if I married the nobleman, he will harness his followers to take care of my work.")]), _vm._v(" "), _c('p', [_vm._v("I tried hard to sleep until I gave up; I decided to go out for walking after the threads of the sun began to creep into my room. I was walking among my trees at a cheerful pace; I was happy with their colors and beautiful shapes. I did not know where my feet would take me; I walked and walked until I reached near the house of Mr. Malik. I noticed movement around the house, so I got closer and closer until I found myself in front of the door. The door was open, for the first time, the door was open after he left.")]), _vm._v(" "), _c('p', [_vm._v("I heard a voice from inside calling, “Come, come in, my girl, come, and don’t be afraid.”")]), _vm._v(" "), _c('p', [_vm._v("It was the voice of Mr. Malik; I entered. I was happy to see him. He was carrying a cup of tea in one hand and a newspaper in the other.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Get in and have tea with me.”")]), _vm._v(" "), _c('p', [_vm._v("His maid came in and said, “Hello my daughter, how are you?”")]), _vm._v(" "), _c('p', [_vm._v("He asked her to bring me a cup and a plate of biscuits quickly.")]), _vm._v(" "), _c('p', [_vm._v("I approached him and said, “How are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("The maid returned with the cup in her hand, murmuring, “He keeps reminding you, day and night, why don’t you come to live with us?”")]), _vm._v(" "), _c('p', [_vm._v("I was very surprised by her question, but Malik interrupted her and said, “Get the box I brought her yesterday, come on quickly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The maid:")]), _vm._v(" “I knew it’s for her.”")]), _vm._v(" "), _c('p', [_vm._v("He sighed and turned to me.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it is for you, my beautiful daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “How happy I am to see you, I thought I would never see you again.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What brings you here?”")]), _vm._v(" "), _c('p', [_vm._v("“I couldn’t sleep, so I said to myself why don’t I walk. I arrived here and found the door open. I was afraid that someone was trying to break into your house, so I came close to check. I relaxed when I heard your voice. Thank God, it was not a thief.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and said, “I came to see my daughter, but unfortunately she could not come. You came instead of her, as if God had compensated me for her.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have a daughter, sir?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Please don’t call me sir, but father, at least in front of the maid; I don’t want her to know that my waiting was in vain.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my father.”")]), _vm._v(" "), _c('p', [_vm._v("“My daughter has your name. When you were a little girl, your father came to me and you were in his hands. How much I loved you that day, and I told him that my wife would give birth soon, and if the baby was a girl, I would call her Zaina. I hoped to be beautiful like you and her eyes carried the color of your eyes. Unfortunately, two years after her birth, my wife left me and took the girl with her. I only see her in intermittent long periods.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, Dad.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, my daughter, it’s okay. I am afraid I may die before I see her!”")]), _vm._v(" "), _c('p', [_vm._v("“Please don’t be sad, you will live to see her and see your grandchildren too.”")]), _vm._v(" "), _c('p', [_vm._v("The maid entered with a large white box in her hand. It was a gift box with a pink ribbon on it. She said, “Come on, Zaina, look what your father brought you!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Open it, my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I took the box and opened it. I knew that it was for his daughter and that he gave it to me instead of her, because she did not and will not come. I never knew that he loved me, and that he called his daughter in my name. I grieved for him very much, and I wanted to treat him as his daughter.")]), _vm._v(" "), _c('p', [_vm._v("I pulled out of the box a pink dress. There were also shoes and hat that suit the dress.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, so beautiful!”")]), _vm._v(" "), _c('p', [_vm._v("I cried with joy. "), _c('em', [_vm._v("I will wear it in front of the noble when I see him")]), _vm._v(", I said to myself, but the maid interrupted my thoughts:")]), _vm._v(" "), _c('p', [_vm._v("“Come on, my dear; let’s try it on you, to see if the size is right.”")]), _vm._v(" "), _c('p', [_vm._v("She grabbed my hand and took me into a very beautiful room. Perhaps it was Malik’s daughter room. I looked at the maid shyly and asked her to leave me alone to put it on.")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “I’ll help you, don’t be afraid, you have to get used to me.”")]), _vm._v(" "), _c('p', [_vm._v("She really helped me wear it. I felt like a noble lady. The size of the dress was great, as if it was made for me; even the shoes were very suitable.")]), _vm._v(" "), _c('p', [_vm._v("I went out happily, Malik was so sad, so I decided to make him happy.")]), _vm._v(" "), _c('p', [_vm._v("I said, “What do you think, Dad, am not I the most beautiful girl in the universe?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled, took my hand, and said, “The most beautiful princesses of the universe.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone was happy, the maid asked me again, “What do you think if you go with us?”")]), _vm._v(" "), _c('p', [_vm._v("Mr. Malik interrupted her, “Who will take care of the house and the land in our absence?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The maid:")]), _vm._v(" “Well then, you forgot that we’ll never come back here.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Yes, my little girl, I will give you the key to the house.” Then he looked at the maid and asked her to go to prepare breakfast. She immediately carried out the order and came out as if he wanted her to leave us alone.")]), _vm._v(" "), _c('p', [_vm._v("He held my hand and said whispering, “I will give you the key to the house, please take care of it in my absence. If my daughter comes here, give it to her; I know she will never come. If you want to sit in the house, it is okay; it is your house. My dear, there is in the room in which you wore the dress, a closet full with new clothes, shoes, and hats; take them all. My address is with you, if you need anything, come to me.” Then he took out a bundle of money from his pocket and said, “This is yours, perhaps you need it. You are very beautiful so be wary of men’s treachery.”")]), _vm._v(" "), _c('p', [_vm._v("I shook my head, not understanding what was going on, perhaps because I hadn’t slept since yesterday, or perhaps because I was sad for the man, that he was going to leave, or perhaps because of the small fortune I had just acquired.")]), _vm._v(" "), _c('p', [_vm._v("I spent the middle of the day with him. When he wanted to leave, he broke my heart. He will leave with tears in his eyes and a broken heart for not seeing his daughter. The maid brought a camera for instant pictures, and suggested that we take a picture together. He was very happy with the idea and asked her to take it twice so that he would keep a copy and I would keep the other.")]), _vm._v(" "), _c('p', [_vm._v("I entered the house after saying goodbye to him. I took off the beautiful dress and put my clothes on. I was curious about the closet full of clothes; I opened it and looked inside it. It was full of very beautiful clothes. The different colors began to make me dizzy; I realized that I should go home and sleep and I will come back next day to enjoy seeing my new closet. I took out a beautiful small bag from the elegant bags section; bags of various colors and shapes, I put money inside it. I will take the dress with me; I will wear it on Eid, since I have many more. Before I closed the closet, I noticed an old bag. I took it and opened it; it was full of messages. I was not able to examine it and read it, so I decided to take it home with me. I went home quickly, as I was exhausted by sleepiness, fatigue, and sadness for Malik’s condition.")]), _vm._v(" "), _c('p', [_vm._v("I got home; everyone was waiting for me at the door. I ignored them all, including Rasha and went up to my room. I closed the door and lay on the bed. Without any resistance, I fell into a deep sleep.")]), _vm._v(" "), _c('p', [_vm._v("I woke up early the next morning. I had slept sufficiently and comfortably; no one bothered me. I put all the important things inside my wooden box and decided to hide it in Malik’s house. Hazem was not around; one of our customers asked him to deliver him a large amount of fresh vegetables very early. I was happy that he was not there; I did not want anyone to see me. I took the box and the bag of papers and ran to Malik’s house. I put the box inside one of the small safes that had a lock, and locked it. I sat on a large comfortable wooden chair, and began reading Malik’s letters to his daughter which were in the bag. All the letters he had written were returned to the sender. His daughter never received a letter from him.")]), _vm._v(" "), _c('p', [_vm._v("All the letters expressed Malik’s longing for his daughter and that he wanted to see her. I opened them all. I did not get tired of reading them all. They contained longing and love for his daughter. I wished that those letters were addressed to me. The last two letters caught my attention a lot. The first was telling her that his disease has become dangerous and that he would not live long. He did not seem tired; he might want her to sympathize with him to return to him. The second message was his will; he will leave all his possessions to her if she returns to him. He mentioned to her everything he owned; he owned a lot of lands, houses, and factories.")]), _vm._v(" "), _c('p', [_vm._v("I envied her for what her father would leave for her. How I wished if my father were alive. I put the bag of letters inside the box and locked it.")]), _vm._v(" "), _c('p', [_vm._v("I went back to my house, after I had checked the wardrobe. I secretly prayed that Malik’s daughter would never come back, perhaps one day I would take all the dresses and put them in my closet.")]), _vm._v(" "), _c('p', [_vm._v("I arrived home and found Nader at the door. It was surprised to see him. What does he want? Thank God I was elegant and beautiful, although I wouldn’t think of him but I would like him to see me elegant as a lady.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “How are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“Fine, you’re welcome, come and have tea with us.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m in a hurry, I came to work.”")]), _vm._v(" "), _c('p', [_vm._v("“What work?”")]), _vm._v(" "), _c('p', [_vm._v("“I want to make a deal with you.”")]), _vm._v(" "), _c('p', [_vm._v("I was very happy in my secret, but I will not show him how happy I am.")]), _vm._v(" "), _c('p', [_vm._v("“Why don’t you enter so we could talk?”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("We sat in the guest room and began to speak.")]), _vm._v(" "), _c('p', [_vm._v("“I am building a factory and I have a lot of workers; I want you to supply me with fresh vegetables every morning to prepare healthy meals for them. This will continue for two consecutive months, what do you think?”")]), _vm._v(" "), _c('p', [_vm._v("“Agree, I will send you Hazem every morning with your request, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("“How would you like me to pay you?”")]), _vm._v(" "), _c('p', [_vm._v("“Every week.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you send me your bill every Thursday morning, and in the evening I come and give you the money.”")]), _vm._v(" "), _c('p', [_vm._v("He did not tell me that he would send the money with Hazem, but that he would come himself. I do not want to lose the deal, so I told him, “You got it.”")]), _vm._v(" "), _c('p', [_vm._v("He shook my hand, looked at me and said, “See you soon.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem entered us suddenly and saw Nader holding my hand. His face turned red in anger. He shouted, “Who is this, and what does he want?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him calmly and indifferently and said, “It’s Mr. Nader; he came to make a deal with us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We don’t have vegetables.”")]), _vm._v(" "), _c('p', [_vm._v("Nader annoyed and said, “But I see your land is full.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem (angrily)")]), _vm._v(": “Yes, I sold it all today!”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him curiously and said, “How do you act without my permission?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Since when do we take permission from women?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “It’s okay, when you become the owner, we will talk.”")]), _vm._v(" "), _c('p', [_vm._v("He ran out furiously, I tried to catch up with him, but Hazem grabbed my hand and shut the door.")]), _vm._v(" "), _c('p', [_vm._v("Nader got into his car and drove away in anger. Perhaps he thought that Hazem was my husband and that I was lying to him about my ownership of the land. Hazem made me lose a big deal.")]), _vm._v(" "), _c('p', [_vm._v("I yelled at him and said, “Get out of my house and never come back here again.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam hurried down with Laila. They were wondering.")]), _vm._v(" "), _c('p', [_vm._v("“What is happening?”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Maryam and said, “Your brother has made us lose a very big deal by his stupidity, and insulted me in front of the man. What have I done to him to do this to me? Aren’t we all beneficiaries of money?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was very angry at her brother and shouted at him, “You idiot, what have you done?”")]), _vm._v(" "), _c('p', [_vm._v("Laila added, “Why have you done that? It is not your business.”")]), _vm._v(" "), _c('p', [_vm._v("He was very angry and irritable, which frightened me greatly.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Do deals take place by holding hands?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam said, “It is not your business, you idiot, perhaps he loved her and wanted her as a wife. The girl is free; let her enjoy her life. Isn’t enough what she got through?”")]), _vm._v(" "), _c('p', [_vm._v("He got angry, threw the chair towards the window, and broke it. I was so afraid of him that I didn’t speak. He said with a loud shriek, “No one will marry her as long as she lives, either me or no one.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “It’s okay.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me calmly and said, “Do you accept my brother as a husband?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her and I was so terrified.")]), _vm._v(" "), _c('p', [_vm._v("“No, I will not marry anyone, neither he nor anyone else. I will go up to my room to sleep. When I wake up, he will be gone. You, fix the window.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem suddenly calmed down.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll fix the window and go, but you won’t marry anyone.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “You have nothing to do with my life, just leave.”")]), _vm._v(" "), _c('p', [_vm._v("He came out sad and broken-hearted. Maryam followed him and said, “Where are you going?”")]), _vm._v(" "), _c('p', [_vm._v("“Do not worry,” he answered her, and then added, “I will not leave you alone. I will sit in my cart behind the house. I am afraid that something bad will happen to Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room angry. Hazem’s behavior in front of Nader annoyed me and made me lose the deal, and then I never wanted anyone to tell me that he loved me. Although I was sure that he loved me, I never wanted to hear it from anyone.")]), _vm._v(" "), _c('p', [_vm._v("Laila followed me and began to console me.")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, my dear, don’t worry, I’ll go early in the morning to the man and tell him the truth and arrange the deal.”")]), _vm._v(" "), _c('p', [_vm._v("“What are we going to do with Hazem? He loves me and wants to marry me, what is this nonsense?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, we will teach him manners; he will understand that you are the mistress of the house, and that he works for you.”")]), _vm._v(" "), _c('p', [_vm._v("“How will you persuade Nader to return? The deal will give us a lot of money; he may tell his city merchants and businessmen about the quality of our goods and we will have a lot of customers.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry, depend on me.”")]), _vm._v(" "), _c('p', [_vm._v("“If you can convince him, you have a share of the profits.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want anything; I just want my friend back.”")]), _vm._v(" "), _c('p', [_vm._v("“You are not my friend; you know you are my soulmate.”")]), _vm._v(" "), _c('p', [_vm._v("Laila, after she embraced me with joy because of what she heard.")]), _vm._v(" "), _c('p', [_vm._v("“How much is my share of the profits?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her while I was laughing, “Haven’t you just refused? But I knew you would not spare your share; twenty percent is good?”")]), _vm._v(" "), _c('p', [_vm._v("“Excellent! Now the hard work begins.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her worriedly and said, “Hazem is very violent.”")]), _vm._v(" "), _c('p', [_vm._v("“How not, and he saw the man holding your hand; he loves you very much. He is jealous for you. Do not worry, it is impossible to hurt you one day; who loves does not hurt.”")]), _vm._v(" "), _c('p', [_vm._v("“He broke the window, made me lose the deal and terrified me, and you say harmless. I’m afraid he will take his sister’s knife and stab me with it!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (firmly):")]), _vm._v(" “Trust me that she will never carry her knife except in the face of those who harm you. As for Hazem, he will never carry a knife except to defend you. My dear, Maryam loves you very much and won’t forget that you helped her.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope that.”")]), _vm._v(" "), _c('p', [_vm._v("The next morning, Laila went to Nader and met him. She was very clever in persuasion and evasion. She told him that Hazem was as a little child; he considered me as his sister who raised him and took care of him. She convinced him that Hazem was naïve and did not behave well, and he always embarrassed us in front of everyone…")]), _vm._v(" "), _c('p', [_vm._v("Nader was convinced and told her that the deal would be completed. He will send a man to receive the goods; he does not want to see Hazem.")]), _vm._v(" "), _c('p', [_vm._v("Laila told him that I was the lady of the house, or else I wouldn’t have tolerated someone like Hazem.")]), _vm._v(" "), _c('p', [_vm._v("He answered in amazement, “She is truly a woman who deserves recognition. He also told her that work with him will start after the holidays because his workers are on vacation.”")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile, Hazem was collecting vegetables with Jawad; they sold a large amount.")]), _vm._v(" "), _c('p', [_vm._v("I did not expect him to return to work on the land, but his magnanimity refused to allow me to collect vegetables and go to the market. The one who we consider naïve has a mind greater than all of us. Despite his attitude towards Nader, he knows that the interest requires selling vegetables and collecting money for the big family… I fired him, but His big heart refused to make me enter the land and work on it.")]), _vm._v(" "), _c('p', [_vm._v("Maryam went out as usual and came back at noon; she prepared delicious food for everyone. Maryam did not enter my room for fear of asking her about Hazem, so she sent Rasha to wake me up. Rasha calmly and politely knocked on the door of my room, I asked her to enter; she was very shy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha:")]), _vm._v(" “Maryam has prepared the food.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, how are you, are you comfortable with us?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, very much.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry for being so busy, but you saw how life is with constant work.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, I want to work too.”")]), _vm._v(" "), _c('p', [_vm._v("“Do not rush, when the feast is over we will find what suits you. Now let’s eat, Maryam’s food is very delicious.”")]), _vm._v(" "), _c('p', [_vm._v("I was very sad from Hazem. At the same time, I was very sad for him, he does not own anyone in the universe but us. He is very kind with me, but the idea of marrying him is very difficult, even Nader; despite all his handsomeness, education, nobility and money, I will not marry him; my goal is to marry Noble Karim whatever it takes.")]), _vm._v(" "), _c('p', [_vm._v("There is not much left for me to achieve my dream; I will expand the land and try to buy the whole house from Salma, and I will establish a company to distribute and transport vegetables. Two years at most and I will become the noble Lady Zaina.")]), _vm._v(" "), _c('p', [_vm._v("We all sat around the table. Laila was very happy with her achievement. Of course, what she is most happy about is that she will take a percentage of the profits. She started talking about her dialogue with Nader and how she persuaded him. Maryam began to eat while tears filled her eyes, I could not stand her tears. I asked her, “Did you give food to Jawad?”")]), _vm._v(" "), _c('p', [_vm._v("She replied shyly, “Yes.”")]), _vm._v(" "), _c('p', [_vm._v("Then I added, “And Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me in astonishment.")]), _vm._v(" "), _c('p', [_vm._v("“Can I send him food?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her angrily, “Of course! He has not eaten yet. How silly you are! Do you think I will forbid him from eating if we fight? Hurry up, get him water and food. I know he won’t leave the house. Tell him if he needs something, send Jawad to take it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Oh, you have the kindest heart ever! I promise he won’t bother you after today.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Yes, he must learn how to deal with me in front of people, and he must get the idea that he loves me out of his head.”")]), _vm._v(" "), _c('p', [_vm._v("We spent the day quietly; I never saw him that day. In the evening, Salma came with my mother. I welcomed my mother warmly. I was wearing a beautiful dress with its shoes. As usual, Salma entered in the most beautiful outfit. For the first time, I did not feel there was any difference between her and me. Salma looked at me with jealousy and malice, and said, “You look good.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank God, I’m working hard.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “How is the land?”")]), _vm._v(" "), _c('p', [_vm._v("She did not ask me how you are, how cruel woman she was!")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “It is very good; it offers us a lot, but unfortunately its monthly rent is also very large. After it started producing, its owner raised the rent and asked for a share of the profits.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Good, now give me the rent, I’m in a hurry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Reem invited us to visit her; we will spend the Eid days with her, so we have to pack our bags.”")]), _vm._v(" "), _c('p', [_vm._v("I was really surprised; would the nobleman allow the girls to invite their families? All I know is that when he took a girl, she forgets her family completely and never sees them again. He only brings her back to her family, when she behaves badly. This is unbelievable. How weird why didn’t Reem invite me? I was the one who took care of her; not them.")]), _vm._v(" "), _c('p', [_vm._v("I asked my mother curiously, “How was she able to invite you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “I heard that she is very close to the nobleman, and became one of the ladies in his palace.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “She definitely won’t invite you!”")]), _vm._v(" "), _c('p', [_vm._v("“Why definitely, Mama? I am the one who raised her?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “She doesn’t want anyone to be more beautiful than her.”")]), _vm._v(" "), _c('p', [_vm._v("She said that word and fell silent immediately, as if she regretted that she had taken it out of her mouth.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma (angrily)")]), _vm._v(": “Who said that Zaina is more beautiful than Reem or is as beautiful as her?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Silence, give us the money quickly.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam offered Salma the money; her heart was full of hatred towards her. She smiled and said sarcastically, “This is the money, beauty.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “How are you, Maryam? I no longer see you in the market!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “None of your business!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Enough, you took your money, Salma. I think you should leave so that you are not late for your appointment.”")]), _vm._v(" "), _c('p', [_vm._v("My mother yelled at Laila, “You kick her out of her house? In the morning, you and your friend should leave; we won’t rent the house after today!”")]), _vm._v(" "), _c('p', [_vm._v("I interrupted my mother, “As if you own the whole house. No one will leave; they work with me on the land.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “They will leave.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I didn’t mean to fire her; I just wanted to end the argument.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “There was no argument.”")]), _vm._v(" "), _c('p', [_vm._v("We were surprised by Maryam’s cold reaction.")]), _vm._v(" "), _c('p', [_vm._v("She added coldly, “She asked me how I am, maybe she loves me and I don’t know.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “I hate you, and in the morning, you will leave.”")]), _vm._v(" "), _c('p', [_vm._v("I answered firmly, “Nobody will leave!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Are you disobeying my orders? Your share is very small.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Then I’ll buy your shares from you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Oh really! Where did you get the money from?”")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow I will bring an expert to appraise the house and I will buy it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “I will not sell.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “You will sell and I will buy, otherwise I will tell the nobleman that you deprived me of Reem’s money. I will go to Reem and tell her that I am the most beautiful, and put you both in a bad situation. I will go to the judge and tell him that I am the one who works and you are stealing my money; I will cause a scandal you have never expected, and I have witnesses to all of this.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “What a bad girl you are!”")]), _vm._v(" "), _c('p', [_vm._v("I asked her sadly, “Since when have you been a kind mother? I got nothing but cruelty and hatred from you as if I were not your daughter! Anyway, tomorrow the expert will come and we will finish it, and then pack your bags for Reem’s visit.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “I will accuse you of lying.”")]), _vm._v(" "), _c('p', [_vm._v("“I have many witnesses. Take the price of the house and use it, and then we will not bother each other.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “That’s a good idea, and then we won’t have to see you.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Me neither!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “As for me, it is always a pleasure to see you.”")]), _vm._v(" "), _c('p', [_vm._v("Salma looked at Maryam in very vicious way. I did not like her look at all, as if she was telling me that she had hidden something very evil inside of her, as if she was telling her we will meet and I will revenge you. As if something inside her told her that Maryam was betraying her with her husband, and that she would repay her treachery.")]), _vm._v(" "), _c('p', [_vm._v("They went out after my mother promised me that she would come the next day at noon. We would finish the paper of the house. I always wished that the whole house be mine, but not in this way; I did not want my relationship with my mother to be so bad.")]), _vm._v(" "), _c('p', [_vm._v("After they left, Laila approached me, remorse and tears in her eyes:")]), _vm._v(" "), _c('p', [_vm._v("“Where will you get the money from?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her tenderly and said, “It’s okay, there is no need to cry; I will borrow it from Mr. Malik. I may mortgage him the house; the important thing is to be free from them.” I looked at Mariam and said, “I hope Salma doesn’t know what you’re doing with her husband, or else she will destroy us all, you don’t know her.”")]), _vm._v(" "), _c('p', [_vm._v("The next morning, I woke up very early. I went to Malik’s house and brought all the money that I had collected. I went to the expert and asked him how much the house was worth. Unfortunately, the amount was not enough and I needed almost double my money. I went back to Malik’s house and searched the house; I might find any money. I entered all the rooms and searched well, I did not find any money. After I gave up, I sat on the ground and broke down in tears, what did I get myself involved in, how much will they gloat about me? I went searched the house again. I entered Malik’s room for the third time; I must find something of value. After a long search, I entered his daughter’s room and opened the wardrobe and decided to sell her clothes. They are mine; Malik told me to take them all. I was very sad when I put them in the bag, I did not even try them on me. A very beautiful blue dress caught my attention, so I decided to wear it even for a few minutes. When I put it on my body, I felt something storing me.")]), _vm._v(" "), _c('p', [_vm._v("I took it off me and turned it over. I found a necklace hanging on it from the inside; it was definitely expensive. He bought her with every dress a wonderful necklace of gold and diamonds. I took all the clothes out of the bag, and I turned them all over. In fact, with every dress there was a matching necklace, and with every hat a ring. I took them all out and put them in front of me. They surely formed a great fortune. Who would have thought?")]), _vm._v(" "), _c('p', [_vm._v("I gathered all that I found and put them in my chest. I took enough to buy the house and went out of town to sell them. I was sure when Malik wanted me to take the clothes; he wanted me to have the jewels with them.")]), _vm._v(" "), _c('p', [_vm._v("I was very happy, the joy almost killed me. In moments, I became rich. I should check the dress that he gave me, but I did not feel a prick when I put it on. Perhaps it has an inner pocket – like some dresses – and its necklace is inside it.")]), _vm._v(" "), _c('p', [_vm._v("I sold the gold to the first jewelry store I came across. I knew that they did not give me the right price, but unfortunately, I did not have enough time. I have to be at home before they arrived, the search for money stole all the time.")]), _vm._v(" "), _c('p', [_vm._v("I returned with the money. I was so confused; I wanted to finish the house deal, and go back to Malik’s house to arrange the mess. I met Hazem at the door, I didn’t want to argue with him; I looked at him indifferently, I was about to enter when He gently grabbed me by the hand and said, “I’m sorry, I promise I will not interfere with your affairs again.” And then he took out a bag of money from his pocket and gave it to me.")]), _vm._v(" "), _c('p', [_vm._v("“This is all I have, please take it and get rid of the two ugly ones.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“My mother is not ugly.”")]), _vm._v(" "), _c('p', [_vm._v("My eyes did not believe what they saw. Is there such loyalty? Oh my God, he gives me everything he has. I put my hand on his cheek and said, “You must be an angel sent by God to me, but don’t worry I have money. Save your money for other times.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled as if my touch had taken him to another world.")]), _vm._v(" "), _c('p', [_vm._v("“Keep money with you, you are better than me in managing things.”")]), _vm._v(" "), _c('p', [_vm._v("How sweet he was, though I kicked him out. How I regretted that he spent the night in his cart.")]), _vm._v(" "), _c('p', [_vm._v("I took the money and entered the house happily. No one will take my house from me after today; it will all be my own. I will not see Salma after today. I am sad for my mother, but it’s okay, time will change everything; it will heal wounds and end conflicts.")]), _vm._v(" "), _c('p', [_vm._v("They came on time. Faris, Salma’s husband, and the lawyer came with them. The expert came and told them the price of the house. The lawyer supported him and did not argue with him.")]), _vm._v(" "), _c('p', [_vm._v("The lawyer took out the papers and told me to read them before I sign. I read the paper well. There is a waiver from Salma and my mother about the house for me. I turned to the lawyer and asked him, “But we have a fourth partner; she is our sister, Reem.”")]), _vm._v(" "), _c('p', [_vm._v("Salma laughed and took out a piece of paper from her bag.")]), _vm._v(" "), _c('p', [_vm._v("“I forgot; this is Reem’s waiver of her share to me.”")]), _vm._v(" "), _c('p', [_vm._v("I was shocked by Reem’s behavior, shouldn’t she concede to me? Didn’t I the one who spend her savings on her to look the most beautiful girl in front of the nobleman? There is definitely a secret behind all of this.")]), _vm._v(" "), _c('p', [_vm._v("We signed the papers; Salma took the money. My mother looked at me and said, “How did you get this money?”")]), _vm._v(" "), _c('p', [_vm._v("“I work day and night, and everyone in this house works as well.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “But it’s a big amount. Does really the land give all this?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Who told you that we work only on the land, we have our own trade, in clothes and jewelry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Diligent workers, but how do you pay the rent for the land? Your business must be very big.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Take your money and leave; you have nothing to do with us after today.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Oh really! Worst place, how burden to see you.”")]), _vm._v(" "), _c('p', [_vm._v("Faris was staring at Maryam; he seemed like a lover and lost himself inside her eyes.")]), _vm._v(" "), _c('p', [_vm._v("Salma turned to him and said, “Let’s go, my dear, but he didn’t answer her.” She noticed how he was looking at Maryam, who in turn was exchanging him his admiration. Salma pricked him and said, “I said let’s go!”")]), _vm._v(" "), _c('p', [_vm._v("He got up and said, “Okay dear, let’s get out of this dreary house.”")]), _vm._v(" "), _c('p', [_vm._v("Salma looked at Maryam and said, “What a woman you are, we’ll meet soon!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Of course, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Salma was burning from inside; her heart was full of hatred and grudge while Maryam was so cold and calm as if she had done nothing.")]), _vm._v(" "), _c('p', [_vm._v("Salma got out angrily after she slammed the door angrily. Everyone with her left except my mother.")]), _vm._v(" "), _c('p', [_vm._v("She looked at me cunningly and said, “Where did you get the money from?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her coldly, “If I told you, would you rest, why does this concern you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “I am afraid that you are doing something disgraceful which will dishonor the family.”")]), _vm._v(" "), _c('p', [_vm._v("I was shocked by her dirty mind; I answered her angrily, “How horrible you are! How could you say that; you are accusing me! Are you really a mother? I have borrowed most of it. Have you rested now? Go before you cause me a heart attack. I will never forgive you. I will pray God to punish you for that.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me with astonishment she did not expect me to pray on her. She didn’t know how much she insulted me and belittled me in front of everyone!")]), _vm._v(" "), _c('p', [_vm._v("Salma entered and asked her to hurry up.")]), _vm._v(" "), _c('p', [_vm._v("Then Salma grabbed her hand and dragged her outside while she was saying, “I did not mean that.”")]), _vm._v(" "), _c('p', [_vm._v("Really didn’t she mean? Did her conscience really wake up?")]), _vm._v(" "), _c('p', [_vm._v("I went to my room without saying a word. She ruined my happiness in owning the house. I sat on the bed, my blue wooden bed which my father made for me with his own hands; it was old but sturdy and strong. I was so sad and frustrated; what a woman, how can she accuse me of that. Didn’t she know that I work hard? Didn’t she know how pure and respected her daughter is?")]), _vm._v(" "), _c('p', [_vm._v("I tried to sleep a lot that night but I couldn’t. Her words were engraved inside my heart. I thought to go to Malik’s house but it is impossible, I don’t want to draw their attention to my secrets in that house. I wanted so much to open my box and hug my picture with my father, so I get a little love. If he didn’t leave the land for me I would now be on the side of the road begging people to give me money. I won’t think about it much. I lay on my bed for the tenth time trying to sleep; suddenly, I remembered the image of the jewelry I found in Malik’s house. I quickly jumped to my closet and opened it. What distinguished it was the dress that Malik gave me!")]), _vm._v(" "), _c('p', [_vm._v("I pulled it out of the closet. I turned it over, and started searching every inch of it. I didn’t find anything. Perhaps he gave me this particular dress because it didn’t contain anything. I threw it hard on the bed; something fell on the floor. I rushed to it and found a diamond ring containing a jewel which had the color of the dress. I immediately put it on my finger. It was completely appropriate as if I was the real daughter of Malik; perhaps Malik did not have a daughter, and I was the one who thought her his daughter. I don’t think so, he must have a daughter, the messages and things in the house all refer that he has a daughter. Maybe she was dead and he does not know, or he knows and does not want to believe. It’s okay as long as she is not here so I have the right to take everything. He gave me the key of the house and told me to choose what clothes I want.")]), _vm._v(" "), _c('p', [_vm._v("I fell into a deep sleep after my new ring made me forget my mother’s words. I fell asleep with the ring around my finger, as if I were a princess and my pillow was filled of feathers!")]), _vm._v(" "), _c('p', [_vm._v("The next morning, I woke up to a knock on the door from all the hands in the house. They called out with one voice, including Hazem, “Wake up, lazy one; it is Eid day.”")]), _vm._v(" "), _c('p', [_vm._v("I woke up and said, “Well… I am coming.”")]), _vm._v(" "), _c('p', [_vm._v("Then the door opened and the little girls jumped up, shouting, “Come on, Zaina, wake up.”")]), _vm._v(" "), _c('p', [_vm._v("They sat on my bed. Sarah looked at me and said, “Where are the gifts?”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her hand and pulled her to me. I kissed her on the cheek and whispered in her ear, “Under the bed there are bags, each bag has its owner’s name written on it. Please my beautiful angel, take them out and distribute them.”")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina looked at me innocently and beautifully and said, “And me?”")]), _vm._v(" "), _c('p', [_vm._v("I drew her to me, I kissed her too, and told her to go and help Sarah. Lynn was the strongest, so she jumped alone and followed them.")]), _vm._v(" "), _c('p', [_vm._v("Maryam and Laila approached me and sat around me. Laila looked at me like a tender mother. She gave me a bag and said, “This is for you, my dear. Happy Eid.”")]), _vm._v(" "), _c('p', [_vm._v("I hugged her and kissed her on her forehead. I told her that she was the best thing I had in this life. Maryam was trying to get close to me by various means, but she was always afraid that I would stop her. I was adapted to the policy of calmness and claiming love to her! I drew her to me, and said to her, “Happy Eid, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam gave me a bag containing a bottle of perfume as an Eid gift. Sarah distributed the bags to everyone; when she read Hazem’s name on the bag, she approached me and said, “Why don’t you give it to him?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem stood in front of the door, ashamed to enter in while I was lying on my bed.")]), _vm._v(" "), _c('p', [_vm._v("Laila noticed the ring on my hand, so she said, “Where did you get this?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her mischievously and asked, “Pretty?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Very much.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Yesterday when I was borrowing money from Malik, a fake jewelry seller passed in front of his house. I was sad and tears filled my eyes. He called him and bought it for me. I wish I had brought you the same, but it’s okay. The man promised me that he would return with new goods and then each one would choose what she wanted.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “It looks real!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “That’s the best thing about it!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “How are we going to return the money to the man?”")]), _vm._v(" "), _c('p', [_vm._v("I reassure her, “It’s okay, my dear, he gave me a deadline. If we don’t return the money on time, the house will be his and we will rent it from him; he promised me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I’m sorry Zaina, I’m afraid you will lose your home.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not lose anything; you are the most beautiful family, and this is very important to me.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem was still waiting at the door. I got up from my bed. While the girls were busy opening gifts, I took Hazem’s bag and headed towards him. I presented it to him and said, “This is for you, I hope you like it.”")]), _vm._v(" "), _c('p', [_vm._v("I was drawn by his elegant appearance and handsomeness on that day, so I said with a laugh, “Who is this noble man?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and gave me his gift in return. It was the most beautiful thing I had that day. He gave me a beautiful golden necklace. Oh my God, how beautiful and so elegant it was, he must have spent a fortune on it.")]), _vm._v(" "), _c('p', [_vm._v("How weird the relationship between Hazem and me was. Since we were children, we were quarreling. I always screamed and asked him to leave, the next day he came back as if nothing had happened. One day, I was going to the market carrying heavy baskets; he followed me and carried one of them. The second fell from my hand on the ground. At that time, I grieved a lot, so I told him, “Leave, you ruined my day, how can I gain money now? Who is going to buy old vegetables?” He left me. When I went on my way home, I met him and said, “What do you want, didn’t I ask you to leave?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me angrily, “Shut up now, little girl.” He gave me money. The amount was equivalent to the price of the vegetables I lost. Even though I was the one who dropped the basket! I took the money from him at that time for fear of my mother. I knew that I had taken his day’s sustenance. Since we were kids, he was a reliable man.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Shall I help you with wearing the necklace?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, you will all leave my room to let me change my clothes, and I will put it on myself.”")]), _vm._v(" "), _c('p', [_vm._v("Rasha was standing away watching us.")]), _vm._v(" "), _c('p', [_vm._v("Oh my God! I called her, “Why are you there? Come take your gift and enjoy with us.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and approached shyly.")]), _vm._v(" "), _c('p', [_vm._v("“But I didn’t bring anyone anything.”")]), _vm._v(" "), _c('p', [_vm._v("Laila jumped out of the bed, followed by Maryam.")]), _vm._v(" "), _c('p', [_vm._v("She approached Rasha and said, “It’s okay, come on, you’re still new.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone left the room, I stayed alone. I put the necklace that Hazem brought me around my neck. It was very beautiful and elegant despite its simplicity. He always gave me everything he had. He put the watch I brought him around his wrist immediately and never took it off.")]), _vm._v(" "), _c('p', [_vm._v("I did not like how Rasha was looking at me; I will not think of her today, but we must be careful. We had spent a beautiful day. Laila prepared many delicious dishes, while Maryam arranged the house in the best way ever. The girls played all day and had fun. We went out to the field; the photographer passes in front of us. He usually visits Villages on the days of Eid; they are the reason for abundant livelihood for him; everyone wants to take a picture with his loved ones, and of course, in his new clothes. Hazem called for him and we took many beautiful pictures, which will remain a memory for life!")]), _vm._v(" "), _c('p', [_vm._v("I did not see Jawad, so I was very worried about him. We decided in the evening to go to his house and check on him. I took his gift and everyone in the house bought him one except Rasha of course. Laila took him a lot of sweets and foods that she had prepared. He opened the door for us, while he was crying.")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong with you my little friend?” I asked him anxiously.")]), _vm._v(" "), _c('p', [_vm._v("He answered me, “I’m not little anymore.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “You will always be my little boy.”")]), _vm._v(" "), _c('p', [_vm._v("We all entered his house. His mother was crying. I sat next to her, while Laila went to the kitchen to put the food in, and Maryam took the children to give them some sweets.")]), _vm._v(" "), _c('p', [_vm._v("The house was very old. There were only two rooms. I did not know that they are living like this; the furniture was very old and the lighting was very faint. The smell of dampness wafted in every corner of it.")]), _vm._v(" "), _c('p', [_vm._v("I used to think that I lived in an old house, but it is very solid, and the sun enters from everywhere, while in this worn-out house the sun is afraid to visit it for not wearing out! Oh my God, maybe they don’t get warmth even on the hottest days, I don’t know why its owner clings to it so much?")]), _vm._v(" "), _c('p', [_vm._v("I asked Jawad’s mother gently, “What’s the matter, madam?”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me sadly and said, “My husband left me after he sold the house, and we have to leave the house in a week… Where shall I live with an army of children?”")]), _vm._v(" "), _c('p', [_vm._v("Indeed, Jawad had a brother and a sister from his parents, and three younger half-brothers from his mother, whom she bore from her new husband.")]), _vm._v(" "), _c('p', [_vm._v("How brave Jawad was, he never told me about his stepfather and his suffering.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and asked, “Why didn’t you tell me that?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me sadly.")]), _vm._v(" "), _c('p', [_vm._v("“I wish she hadn’t married him, everyone told her he was a bad man but she didn’t listen.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “It’s okay, dear. The important thing now is to find a solution. Oh my God, even if the owner of the house does not ask you to leave, the house is basically not suitable for living!”")]), _vm._v(" "), _c('p', [_vm._v("I was so confused, what is the solution? I certainly wouldn’t invite her to live in my house; I have an army of women too.")]), _vm._v(" "), _c('p', [_vm._v("“What is the solution?” I said out loud.")]), _vm._v(" "), _c('p', [_vm._v("Hazem looked at me sadly and said, “We build her a room opposite the land; she lives there and works with us.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him with joy and said, “How noble you are, what a wonderful idea, but, who will build the room in a week?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Jawad and I, it won’t take a week.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad looked at him and said, “Indeed, if it was a room, it wouldn’t take a week, what a man!”")]), _vm._v(" "), _c('p', [_vm._v("I added, “He’s the family man.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “And I will arrange the house; I we will also teach the girls how to embroider.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I’m hungry. Let’s eat. We have a lot of work.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone laughed because of Laila’s spontaneous reaction. Jawad’s mother’s smiled sadly. I approached her and kissed her on the forehead and said, “Don’t worry; there is a solution to everything.”")]), _vm._v(" "), _c('p', [_vm._v("She didn’t know how to thank us, we spent the whole night laughing, chatting and eating. It was a beautiful night, even though it was full of hidden pain. And again, I didn’t like Rasha’s way of looking at us.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, we all awoke to the sound of nails and hammers. I looked out the window; I saw Hazem and Jawad working briskly. How I wished I’d stayed in my bed another hour.")]), _vm._v(" "), _c('p', [_vm._v("Maryam shouted at them, “We are still in vacation, you idiot.”")]), _vm._v(" "), _c('p', [_vm._v("And Laila from her window said, “Were you dreaming of building?”")]), _vm._v(" "), _c('p', [_vm._v("No one cares, Hazem was like a deaf! He was working vigorously. He looked so brave and active.")]), _vm._v(" "), _c('p', [_vm._v("Hazem turned to them and said, “Make breakfast.”")]), _vm._v(" "), _c('p', [_vm._v("Laila gave up, and despaired of going back to her bed, she said, “Well then, it’s a must, I’ll make breakfast.” Then she said in a loud voice, “Come on girls, I won’t work alone.”")]), _vm._v(" "), _c('p', [_vm._v("She first went into the kitchen, and then Maryam and I followed them.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I want to sleep.”")]), _vm._v(" "), _c('p', [_vm._v("I said to her, “Me too.”")]), _vm._v(" "), _c('p', [_vm._v("Laila had regained her activity quickly.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll make you coffee to wake up.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Thank you, where is Rasha? Didn’t all this noise wake her up?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Perhaps she is used to sleeping in such conditions.”")]), _vm._v(" "), _c('p', [_vm._v("In fact, she did not get out of her room before noon.")]), _vm._v(" "), _c('p', [_vm._v("We prepared breakfast and invited men to come in. Hazem took a shower and came in with new clothes. He wanted to impress me in any way and actually, he looked very handsome. When he was working while his sweat was dripping from him, he looked a perfect man.")]), _vm._v(" "), _c('p', [_vm._v("Maryam looked at him and said, “If you’re going to wash at every meal, I’ll spend my day washing your clothes.”")]), _vm._v(" "), _c('p', [_vm._v("He blushed and said, “What is your task then?”")]), _vm._v(" "), _c('p', [_vm._v("Laila and I laughed at his answer to his sister.")]), _vm._v(" "), _c('p', [_vm._v("Maryam said angrily, “I’m not going to wash anything. Clean your clothes by yourself.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and said, “Don’t listen to her; she cannot see a single piece without washing. If she refuses to wash them, I wash them myself; enjoy your new clothes.”")]), _vm._v(" "), _c('p', [_vm._v("He thanked me with his shy eyes and smiled as if he was the king of the world that I was satisfied with him. As for Jawad, he only washed his hands. He ate his food in a hurry and returned to work quickly.")]), _vm._v(" "), _c('p', [_vm._v("He was gloomy, as if he was carrying the world’s worries on his shoulders.")]), _vm._v(" "), _c('p', [_vm._v("Everyone worked hard for four hours. Then, Maryam prepared more food for everyone. Maryam and Laila took turns taking care of the girls, while I stayed by the side of the young men. I did not leave them for a moment. I helped them as much as I could. Hazem was very careful not to carry anything heavy, and whenever he felt that I was in a dangerous place, he commanded me to go away. He feared for me more than for himself or for anyone else; he always surrounded me with unparalleled care and concern.")]), _vm._v(" "), _c('p', [_vm._v("At noon, I asked everyone to take a break for at least an hour. Hazem started to sweat and the sun was getting a little scorching.")]), _vm._v(" "), _c('p', [_vm._v("We all entered the house. Laila prepared tea and cake for everyone. Rasha came out of her room, not caring about anything that was happening.")]), _vm._v(" "), _c('p', [_vm._v("Laila asked her, “How are you, did you sleep well?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam smiled mockingly and added, “As if you, my dear, do not hear well.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rasha (carelessly):")]), _vm._v(" “I hear very well; when Hazem began to move the first plank of wood, I woke up and put cotton in my ear to go back to sleep. I actually fell asleep quickly.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Have your breakfast, my dear. You have nothing to do with everything that happens. You are our guest, and we must honor you.”")]), _vm._v(" "), _c('p', [_vm._v("Laila smiled and realized that I would not keep Rasha with us for much. As for Maryam, her heart was leaping with joy; she knew that I did not care about Rasha much, and in return, she knew that I cared about her and her two daughters because I never told her that she was a guest, but that she was one of the family.")]), _vm._v(" "), _c('p', [_vm._v("Despite what Maryam did, she was always trying to help us; even when she went to Faris, all she wanted at the time was to return our money. However, her biggest mistake was when she killed Amjad.")]), _vm._v(" "), _c('p', [_vm._v("After everyone rested, we decided to go back to work. Suddenly, guests knocked on our door, Hazem opened the door and found Nader and his brother Ashraf in front of him.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Welcome, welcome, please come in.”")]), _vm._v(" "), _c('p', [_vm._v("He greeted them warmly for satisfying me. We welcomed them and invited them to enter.")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled and looked at me passionately and said, “How are you, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("Thank God, I was well dressed. When I decided to take a break, I went to my room, showered, and put on nice clothes.")]), _vm._v(" "), _c('p', [_vm._v("I replied shyly, “How nice of you to visit us!”")]), _vm._v(" "), _c('p', [_vm._v("He was holding a gift for me in his hand. He also brought a set of beautiful toys for girls and some boxes of candy. I looked at him shyly and said, “There was no need to bother yourself.”")]), _vm._v(" "), _c('p', [_vm._v("He looked very elegant and handsome. As for Ashraf, he headed to Laila.")]), _vm._v(" "), _c('p', [_vm._v("He said, “How are you, Madam?”")]), _vm._v(" "), _c('p', [_vm._v("We were all astonished by the way Ashraf was looking at Laila. He seemed like he liked her. Where did he saw her? I asked myself. He might see her when she went to the factory to convince Nader to work with us. I couldn’t stop myself from asking him, “Have you met before?”")]), _vm._v(" "), _c('p', [_vm._v("Laila smiled and said, “Yes, I met him when I went to the factory.”")]), _vm._v(" "), _c('p', [_vm._v("Just as I expected.")]), _vm._v(" "), _c('p', [_vm._v("Maryam said, “Okay everyone, would you please sit down, I’ll make you some coffee and sweets.”")]), _vm._v(" "), _c('p', [_vm._v("Nader thanked her politely, then looked at me and said, “I noticed that you’re building something outside.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem replied quietly, ignoring Nader’s looks at me, “Yes, sir, Lady Zaina, with her merciful heart, decided to build a room to help Jawad’s family.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem dazzled me with his answer, what a man, he gave me the position I wanted from the beginning in front of Nader, Lady Zaina; this is what I wanted from the beginning.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him gratefully and said, “Indeed, but that noble idea originally came from Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem added, “But it is your land, and we would not have done that without your consent.”")]), _vm._v(" "), _c('p', [_vm._v("My heart melted with his words.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Do you know how rooms are built? They need to be designed and arranged to be habitable.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem said innocently, “Four walls and a roof then it became a room.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader (smiling):")]), _vm._v(" “With the first gust of wind the roof falls.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Never enter the room, Zaina; I am afraid that it will fall on your head and you will die.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone smiled; Nader looked at me and said, “He’s so afraid for you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Yes, how not!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “He is afraid for everyone; he has a very big and tender heart.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “He is a man in every sense of the word. No one can take care of this many women and fear for them unless he is a real man.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem felt proud of himself. He said, “But we all receive care from lady. Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled, realizing how much Hazem loves me, at the same time, he was certain that Hazem has no hope to be my husband one day !")]), _vm._v(" "), _c('p', [_vm._v("He said, “I will send you a group of workers with the expert and we will finish the work soon.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (interrupted):")]), _vm._v(" “How much will it cost us?”")]), _vm._v(" "), _c('p', [_vm._v("As if she’s the bookkeeper at home, but I knew her goal was to figure out how much it would cost to know if we could afford it.")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled and said, “Nothing, we are not less noble than Lady Zaina. We love goodness and help other as she does. I will pay the entire construction expenses.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said softly, “I insist on paying, they are under my care; I am the only one who is responsible about them.”")]), _vm._v(" "), _c('p', [_vm._v("Laila almost cut my tongue out of my throat, but she smiled resentfully, and said, “Zaina is right, they are our responsibility.”")]), _vm._v(" "), _c('p', [_vm._v("Nader vehemently refused.")]), _vm._v(" "), _c('p', [_vm._v("“Please do not deprive me of participating in the good work; I promise you, the work will be completed within two days.”")]), _vm._v(" "), _c('p', [_vm._v("Laila thanked him quickly and added, “We will not deprive you of doing well; you can do what you like and make you feel comfortable.”")]), _vm._v(" "), _c('p', [_vm._v("Nader thanked her and said, “We must leave; it was a beautiful time we spent together.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “It is less than an hour.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “It is an Eid visit which must be short and happy. You know where to find me if you need anything.”")]), _vm._v(" "), _c('p', [_vm._v("He extended his hand to shake mine and said, “See you soon.”")]), _vm._v(" "), _c('p', [_vm._v("He didn’t take his eyes off mine, which made me blush! As for Laila, she was surprised by Ashraf, who did not take his eyes off hers.")]), _vm._v(" "), _c('p', [_vm._v("They went out as quietly as they entered; it was a pleasant visit full of affection and love. I looked at Hazem to see his reaction. He was very calm, as if he had never seen anything. He looked at me calmly and said, “We continue the work or what?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him, frightened to hurt his feelings, and said, “Are you convinced of his words?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Yes, he is right. There must be an expert. I will wait for the expert to arrive, and then I’ll go back to work.”")]), _vm._v(" "), _c('p', [_vm._v("He came out quietly; I felt the sadness in his voice. I was never convinced that I would love Nader because I was in love with Noble Karim, so it occurred to me to make him rest from the whole situation.")]), _vm._v(" "), _c('p', [_vm._v("He sat as usual on the wooden chair under the window of my room. As if he derives tenderness and love from it. As if the window was sending him my whispers and words. I followed him after I prepared him a cup of tea with pieces of very delicious sweets; it was from one of the boxes that Nader brought.")]), _vm._v(" "), _c('p', [_vm._v("I sat next to him after I was putting the necklace he gave me around my neck. I said, “Take the tray from my hand, it will fall down.”")]), _vm._v(" "), _c('p', [_vm._v("He quickly sprang from the chair and picked up the tray. He put it between us.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him happily and said, “It is nice to sit here, isn’t it? We should bring a small table and put it in front of the chair; so if we want to eat something we put it on the table and not beside us.”")]), _vm._v(" "), _c('p', [_vm._v("I then looked at him tenderly and said, “Didn’t you notice my new necklace?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said innocently, “Isn’t it the one I brought; do you like it?”")]), _vm._v(" "), _c('p', [_vm._v("I laughed and said, “Yes, how sweet your heart is! The necklace is very beautiful.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Yes, because you’re wearing it.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him, “Am I really so beautiful?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “The most beautiful lady in the universe!”")]), _vm._v(" "), _c('p', [_vm._v("“Am I really a lady?”")]), _vm._v(" "), _c('p', [_vm._v("“Is there a lady other than you?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me lovingly and added, “Nader is a nobleman, and you certainly love nobles.”")]), _vm._v(" "), _c('p', [_vm._v("“Nobles, of course, but not Nader.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and his eyes sparkled out of happiness.")]), _vm._v(" "), _c('p', [_vm._v("“You don’t love Nader!”")]), _vm._v(" "), _c('p', [_vm._v("“Neither Nader nor anybody else; I love the land, the house, and my crazy family.”")]), _vm._v(" "), _c('p', [_vm._v("He jumped from the chair, which dropped the cup of tea on the ground, and then he bent down and took out a bag from under the chair. He opened it and took out a book and presented it to me, and said, “Teach me reading!”")]), _vm._v(" "), _c('p', [_vm._v("He surprised me a lot. I stood happily and said, “Oh my God, really?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I beg you.”")]), _vm._v(" "), _c('p', [_vm._v("“Why?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I want to be a gentleman, please.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on his cheek and said, “You are the noblest man in the world. I will teach you; every day we will sit here and read.”")]), _vm._v(" "), _c('p', [_vm._v("He jumped with joy like a small child who received his first doll he had been waiting for it for a long time. I turned to the right happily, Rasha was watching us from afar; she was staring at us so evilly. Oh my God, as if I had brought an enemy into my house; her looks worried me very much.")]), _vm._v(" "), _c('p', [_vm._v("I turned back toward the chair to collect the glass of the cup that had fallen. I was afraid that one of the girls would sit and injure herself. Hazem did not allow me to touch it, but he asked me to go home and he will clean everything. I asked him to collect the pieces carefully for not injuring himself.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Do you think I am a girl?”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Only girls cut their hands and start screaming like children.”")]), _vm._v(" "), _c('p', [_vm._v("I threw the plate on the ground and said, “Well then, collect them all.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “This is also a childish behavior.”")]), _vm._v(" "), _c('p', [_vm._v("He started to collect it while laughing. I looked at him and said, “I am a child so I cannot teach reading!”")]), _vm._v(" "), _c('p', [_vm._v("He laughed out loud and said, “Only children threaten and quickly change their minds.”")]), _vm._v(" "), _c('p', [_vm._v("I hit him on his shoulder and whispered in his ear, “This is also a childish behavior.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Go to your house, you’re late for bed, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I told him, surprised, “Little girl! Oh my God my father came back from heaven! No one called me little girl except my father.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and whispered, “I love you, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("His word fell in my ear like soul music, it did not bother me or disturb my heart; it was like nourishment for my tired heart. As if I heard it from my father not from Hazem. I completely ignored him as if he did not say it. I claimed that I did not hear it even though it was settled inside me; it surrounded my heart with warmth and tenderness. I ignored his feelings; I do not want him to wish something that I cannot give him. I wish he was a nobleman. I wish he was Karim himself. I wish I could find someone who loves me like him one day. He knew for sure that I am not his; he knew I loved him as a brother, but he was patient and persevering.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and said stupidly, “What did you whisper?”")]), _vm._v(" "), _c('p', [_vm._v("He said with greater stupidly, “Go, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, see you at dinner.”")]), _vm._v(" "), _c('p', [_vm._v("The next day, we woke up to the sounds of wood. Laila shouted at Hazem from her window, “Can’t you wait until we wake up?”")]), _vm._v(" "), _c('p', [_vm._v("Another voice answered, “Excuse me, madam, but I understood that you are in a hurry.”")]), _vm._v(" "), _c('p', [_vm._v("I jumped towards my window to see who was talking. I saw Nader and his team. I immediately changed my clothes and went down. Everyone had woken up in displeasure. I asked Maryam to make coffee and said to Laila, “Stop yelling, tidy up the hall, and make breakfast for everyone.”")]), _vm._v(" "), _c('p', [_vm._v("Laila grabbed my hand tightly and said resentfully, “Other orders, my lady?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her tenderly and said, “You are my lady. Please let’s finish this.”")]), _vm._v(" "), _c('p', [_vm._v("She liked my words because what she hates most is to feel that she is someone’s servant!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, we’ll finish, you brat girl.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was very obedient; she also wanted us to finish quickly.")]), _vm._v(" "), _c('p', [_vm._v("I ran outside and greeted Nader warmly. I invited him in. He approached me and whispered:")]), _vm._v(" "), _c('p', [_vm._v("Do not go out of the house again until the work is done, do you not see all those workers? If they see you they’ll be so preoccupied with your beauty and stop working. Hurry back inside, and tell all the girls not to go out. If we need something we’ll send Jawad, go quickly.")]), _vm._v(" "), _c('p', [_vm._v("I returned with my head bowed to the ground. I had never received orders from anyone before now, then who has been working on the land all these years! But he’s right, there are a lot of men and we are all women. He might also think I’m a noble lady and treat me like that.")]), _vm._v(" "), _c('p', [_vm._v("Sarah approached and wanted to go out. I grabbed her hand and brought her in. Maryam looked at me and said, “It’s okay, she want to watch how they are building the house.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “No, my dear, going out is forbidden until work is done.”")]), _vm._v(" "), _c('p', [_vm._v("Laila cried, “What?”")]), _vm._v(" "), _c('p', [_vm._v("No one judged Laila; she was strong and solid and could stand among a hundred men and beat them with her wit.")]), _vm._v(" "), _c('p', [_vm._v("I looked at her calmly and said, “These are the orders of Mr. Nader. He says that women are not allowed to go out. He is afraid of workers, because we are beautiful. They might leave working and keep staring at us.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam laughed and said, “I wish he had seen us when we were working in the market with baskets on our head.”")]), _vm._v(" "), _c('p', [_vm._v("Laila added, “You remember buying goods from merchants, it was the worst. Whenever you enter a merchant’s shop, he looks at you maliciously and says, ‘Where is your husband, madam?’ Isn’t he supposed to come with you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Sorry, I’m a widow, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("The two laughed. I interrupted them by saying, “Don’t you like being treated like two ladies at all?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, Lady Zaina, the coffee is ready. Please, Lady Maryam, call Jawad to carry it to the gentlemen outside.”")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t stop myself from laughing with them. They are absolutely right, but things have changed now, and they should act like ladies.")]), _vm._v(" "), _c('p', [_vm._v("Nader never left the workers, and Hazem was quietly doing everything he asked. By evening, the work was completely finished. Nader dismissed the workers and invited us to see the new construction. I went out quietly while everyone went quickly. Nader looked at me and said, “Sorry, I was so rude to you, but believe me, I was afraid of the workers. Honestly, you looked so beautiful in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him shyly and said, “No one ever spoke to me in this way, but it’s okay. Thank you very much; if you didn’t come and finish the work, we will build a worn room for the lady. We must go home after I watch the construction and pay you everything you paid for the workers.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand and said, “Excuse me, madam; you have no right to enjoy doing well alone. I won’t take a penny, and if you talk about money again you won’t see me again.”")]), _vm._v(" "), _c('p', [_vm._v("I angrily withdrew my hand and said, “Do not threaten me, you will take your money and if you want to see us, you are welcome, but if you do not want to, it is up to you.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed out loud and said, “My Lady, I won’t take the money.”")]), _vm._v(" "), _c('p', [_vm._v("“You should take your money, that’s your right.”")]), _vm._v(" "), _c('p', [_vm._v("“Enough, you stubborn girl, I won’t take the money and I won’t hear a single word about this anymore. Let us go now to see the new house. You have to check it before we bring the furniture.”")]), _vm._v(" "), _c('p', [_vm._v("We went together to the new house.")]), _vm._v(" "), _c('p', [_vm._v("It was wonderful, consisting of two small rooms, between them a door; there are a small bathroom and a very small kitchen. It was a complete house. I know it is small for the family that will live in it, but it was new and the sun enters it from all sides.")]), _vm._v(" "), _c('p', [_vm._v("Well, we will bring beds for the lady and children, a small table and some chairs. We will also bring her kitchen tools. I don’t think she needs more. We are very close to her, we will check on her from time to time. The land will provide her with vegetables. She will definitely work with us after she feels stable.")]), _vm._v(" "), _c('p', [_vm._v("I looked to Nader gratefully and thanked him.")]), _vm._v(" "), _c('p', [_vm._v("“It’s perfect for the family. We wouldn’t have done it like this without you; I really can’t thank you enough.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Write a list of the things you want to put in the house; I will send everything tomorrow with the workers. The lady will come to her new house tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not accept anything entering the house until I have paid for it.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Believe me, I will not pay for anything, I have a lot of furniture in my old house that I do not want. I will send it to you, choose what suits the place, and return the rest.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I’ll take care of the house, I’m good at it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Well, madam; God bless you. I have to go now.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him, “Won’t you have dinner with us? Laila has prepared delicious food; you can leave after eating dinner with us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “No please, I have to go. I have a lot of work tomorrow. I must have a rest, it was a long day.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, thank you again.”")]), _vm._v(" "), _c('p', [_vm._v("“I promise we’ll eat together soon.”")]), _vm._v(" "), _c('p', [_vm._v("“We will be waiting for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Good bye, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Nader went out in a hurry towards his car. Rasha was standing in front of the car waiting for him. We didn’t see her all day until she had her lunch. Now she is standing with Nader. What does she want from him? I was so worried. He spoke to her for a while, then he raised his hand and said goodbye to me. He got into his car and drove off. I went towards her and asked her, “What is there?”")]), _vm._v(" "), _c('p', [_vm._v("She looked at me and said, “Nothing.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t like the way she was looking at me, she smiled and went back to her room.")]), _vm._v(" "), _c('p', [_vm._v("The next day, Nader sent a large car full of furniture. Maryam chose the appropriate things for Jawad’s house. Nader was right behind them in his car. He called me from afar. I headed towards him.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me firmly and said, “I want you on a very important matter.”")]), _vm._v(" "), _c('p', [_vm._v("We walked together and began to speak.")]), _vm._v(" "), _c('p', [_vm._v("“Tell me, Zaina, did you really promise Hazem to marry him?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Hazem, who told you that?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("“")]), _vm._v("Rasha.”")]), _vm._v(" "), _c('p', [_vm._v("“Rasha? Why is she telling you that?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, please tell me the truth.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you interested?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay; I won’t force you to talk. I may have made a mistake in interfering with your affairs.”")]), _vm._v(" "), _c('p', [_vm._v("“Hazem is like a brother to me. He is afraid of any stranger for us. This does not mean that I will marry him. Yes, he is interested in me, but not only me. He took care of all the girls in the house. As for marriage, it is impossible to marry him. You should know that Hazem, despite his manhood, is a simple man. He does not know how to behave; I make decisions at home. I am responsible for everything.”")]), _vm._v(" "), _c('p', [_vm._v("“I knew that Zaina did not think of anyone, and that Hazem was just a brother to her. Please beware of Rasha, as I noticed, she is very jealous of you! Be careful, I don’t think she loves you.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for asking me first and you didn’t believe what she said.”")]), _vm._v(" "), _c('p', [_vm._v("“I like to make sure of the same person, I hate making random judgments according to what people say.”")]), _vm._v(" "), _c('p', [_vm._v("(I respected him, he is indeed a very gentleman, and worthy of respect and admiration.)")]), _vm._v(" "), _c('p', [_vm._v("He added, “The car will stay parked until you choose whatever you want. If you like anything, take it to your home, please.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with pride, “We don’t need anything; if we want we’ll buy it!”")]), _vm._v(" "), _c('p', [_vm._v("Nader laughed.")]), _vm._v(" "), _c('p', [_vm._v("“I mean no offense, you arrogant lady. I know that this house is for girls, and you are with them to look after them. I know that you have more beautiful house.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, this house is mine but I really dedicated it for those ladies. I tell Laila and Maryam to check if they need anything from the furniture.”")]), _vm._v(" "), _c('p', [_vm._v("He greeted me wonderfully and left.")]), _vm._v(" "), _c('p', [_vm._v("I went home worried and nervous from Rasha. Why would she do that to me?")]), _vm._v(" "), _c('p', [_vm._v("Laila noticed my distraction, so she approached me and asked, “What’s wrong, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“Nader said we can take everything we need for our home too.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, are there beautiful things?”")]), _vm._v(" "), _c('p', [_vm._v("“Are you kidding? Wonderful! But really what’s wrong with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Very briefly? Let’s beware of Rasha!”")]), _vm._v(" "), _c('p', [_vm._v("“Okay, we will warn her, why don’t we expel her?”")]), _vm._v(" "), _c('p', [_vm._v("“Not now.”")]), _vm._v(" "), _c('p', [_vm._v("“You so anxious; now is better.”")]), _vm._v(" "), _c('p', [_vm._v("“Later please, let’s finish what we are in now.”")]), _vm._v(" "), _c('p', [_vm._v("Laila and fear fills her heart for me.")]), _vm._v(" "), _c('p', [_vm._v("“Well, now come and choose with us.”")]), _vm._v(" "), _c('p', [_vm._v("“No, choose what you like, I’m tired; I’m going to my room to have a rest.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room confused and sad. I thought a lot about what Nader said. I think he was absolutely right. A while ago, I didn’t like the way she was looking at me. I looked out the window. Everyone was busy moving things between our house and the house of Jawad family. Rasha was standing from afar and looking at everyone with her usual suspicious looks. God, what have I brought for myself? I wish I hadn’t brought her home, perhaps Laila’s words are true; we must expel her and end our anxiety.")]), _vm._v(" "), _c('p', [_vm._v("I lay on my bed and fell into a deep sleep. I may have escaped from my thoughts so I fell asleep quickly. I woke up, two hours later, to a knock on the door. It was Laila, I asked her to come in. I was still under the cover and I was very sleepy.")]), _vm._v(" "), _c('p', [_vm._v("Laila approached the bed and gently like a tender mother touched my hair with her hand and said, “Wake up, my dear; you have received a message from Reem.”")]), _vm._v(" "), _c('p', [_vm._v("I got up forte and said, “From Reem!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that’s what was written on the envelope.” She gave me the letter and said, “I will make you a cup of coffee so that you can read your letter while you are aware of what you are reading.”")]), _vm._v(" "), _c('p', [_vm._v("I thanked her for her kindness; I took the envelope in my hand and read:")]), _vm._v(" "), _c('p', [_vm._v("From your younger sister, Reem.")]), _vm._v(" "), _c('p', [_vm._v("My eyes couldn’t believe what they saw, Reem! Maybe it was an emergency; maybe she needed me, so I quickly opened the envelope and began to read:")]), _vm._v(" "), _c('p', [_vm._v("Dear Zaina,")]), _vm._v(" "), _c('p', [_vm._v("I will marry the Nobleman Karim next week. He loves me very much. What he loves most of all are my blue eyes. Moreover, he loves the letters of poetry you wrote.")]), _vm._v(" "), _c('p', [_vm._v("Do not be surprised, your letters were my way to trap him. I noticed once when I was offering him a cup of tea that he was very interested in your letters, so I started watching his mail very closely, thus, when you put a letter I would steal it and present it to him with my hand as if it was from me. I convinced him that I was fond of him and I was using someone to write poetry letters to him. Then, I became able to write myself. I told your story, my sister, as if it was my story.")]), _vm._v(" "), _c('p', [_vm._v("Do not ever come close or reveal the secret. The nobleman loves me very much and may do anything to please me. Believe me; if you come close I will burn your land and your house!")]), _vm._v(" "), _c('p', [_vm._v("Your younger sister,")]), _vm._v(" "), _c('p', [_vm._v("Reem.")]), _vm._v(" "), _c('p', [_vm._v("I could not believe what I read. Perhaps it was a dream. Yes, I was still in bed. I would read it again; I read it more than twenty times until I realized that I was awake. She destroyed my heart and burned my soul. She killed years of waiting and hard work. She stole my dreams. She planted knives of oppression in my heart and chest.")]), _vm._v(" "), _c('p', [_vm._v("She crushed what I planned. I hid the letter under the edge of the mattress. I didn’t leave my room for a week. Everyone was marveled at my lying down. They all tried to talk to me but I couldn’t speak. I lived a week in astonishment and denials. How did she know that I loved him? Not only love, but a life goal and a wish! Maybe she was watching all my actions, how smart she was and I didn’t notice it!")]), _vm._v(" "), _c('p', [_vm._v("Hazem was so worried about me; he stayed near my door for the whole week. He slept on the floor beside my room’s door. Maryam and Laila did not leave me; they tried hard to make me eat or leave my room, but I did not respond. The young girls were surprised by my condition. No one knew about the letter except Laila; she knew that the reason for what I was in was the letter, but she did not tell anyone about it.")]), _vm._v(" "), _c('p', [_vm._v("The day of the big wedding came. The whole city was so busy with it. The nobleman distributed food and money for everyone. No one attended the wedding from my family except Rasha. She left the house every day from morning to evening.")]), _vm._v(" "), _c('p', [_vm._v("I started to get out of my room to check on the planting and returned back immediately to my room. I didn’t know how I will live with something like this; as if an earthquake hit my head. Nader didn’t appear in that period; I haven’t seen him since the day he sent the furniture. I was surprised by his disappearance, but at the same time, I didn’t want him to see me in such situation.")]), _vm._v(" "), _c('p', [_vm._v("The painful days of the wedding passed; everyone talked about the beauty of the bride and her sparkling eyes. I did not comment and I will not comment. I am today a lonely girl to a man who gave me everything he owned as if he already knew the ugliness of my sisters. He left the land for me alone because he knew how evil my mother and sisters were. I wish he would come now and talk to me, I wish I would fall on his chest and cry and take out all what is inside me of groans and sorrows!")]), _vm._v(" "), _c('p', [_vm._v("A month has passed since on my silence. Everyone is fed up with me, Hazem tried in every way to make me speak and get me out of this state.")]), _vm._v(" "), _c('p', [_vm._v("On the morning of the thirty-first day, to my silence, I awoke up to Laila’s screams.")]), _vm._v(" "), _c('p', [_vm._v("I ran to her, she was shivering, wet from head to toe. I grabbed her tightly and shook her.")]), _vm._v(" "), _c('p', [_vm._v("“What is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“The land!” she answered me.")]), _vm._v(" "), _c('p', [_vm._v("“What’s up, what happened to the land?”")]), _vm._v(" "), _c('p', [_vm._v("“The land was drowned, as if a flood had swept it away.”")]), _vm._v(" "), _c('p', [_vm._v("I left Laila and ran down to the land. It had no features; the water overwhelmed it from all sides. It turned into a pool of water.")]), _vm._v(" "), _c('p', [_vm._v("I walked through the water stunned and confused, I didn’t know where or on what I was treading. I reached the middle of the land while the water reached my knees. I sat on the ground and soaked in the water. I mixed with mud and dead plants; what is this disaster, how did this happen, what is this calamity? What a misfortune! Oh my God.")]), _vm._v(" "), _c('p', [_vm._v("I fainted in the middle of the water and I almost lost my life with the land. Hazem was right behind me, he carried me from the midst of the flood and brought me back to my room, wet, filthy, worn from inside and outside! He put me on my bed in the state I was in. I was unconscious for an hour. I woke up and found everyone around my bed; I asked them to leave me alone.")]), _vm._v(" "), _c('p', [_vm._v("Laila objected.")]), _vm._v(" "), _c('p', [_vm._v("“But you are tired and someone should stay with you, I’m afraid you’ll faint again, then you will hurt yourself.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her angrily, “Please go out and take everyone with you.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem said sadly, “Leave her alone, I’ll stay at the door if she needs anything, I’ll know don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("I looked around and saw nothing but wetness and mud filling the place. It saddened me very much. I went into a state of hysterical crying. The sound of my crying rose to cover the whole house. I became like a bereave who lost her baby! Hazem entered the room frightened. He hugged me despite my dirty clothes and body. I cried on his chest like a lost child looking for her mother in the heavy crowd. “It’s okay, my dear,” he began to console me, after he embraced me, like a kind father, “we will repair the land, I promise we will return it as it was and better!” He kept talking and promising me until I fell asleep. He put me on my bed and put my cover on me. He left me quietly and went out to sit in front of my room door as usual.")]), _vm._v(" "), _c('p', [_vm._v("I woke up in the morning to Laila’s voice.")]), _vm._v(" "), _c('p', [_vm._v("“Wake up, lazy one, you slept a lot.”")]), _vm._v(" "), _c('p', [_vm._v("I opened my eyes and asked, “How did the land sink?”")]), _vm._v(" "), _c('p', [_vm._v("“That’s what I’d like to talk about, but first let’s clean you and your room. It doesn’t make sense for you to stay like this for another day.”")]), _vm._v(" "), _c('p', [_vm._v("I got up from bed and immediately headed to the bathroom. I stayed for more than an hour washing my body and my head from the mud with hot water. I was not only washing my body, but also my concerns!")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile, Laila arranged the room perfectly. When I came out, she was putting the sheet on the bed, and this was the last thing left for her.")]), _vm._v(" "), _c('p', [_vm._v("I rushed toward the bed and quickly took out Reem’s message. She noticed my eagerness for the letter, but she did not and will never ask. She knew for sure that the letter contained something very disturbing, and she also knew if I wanted to talk about the subject, I would speak.")]), _vm._v(" "), _c('p', [_vm._v("I tore the letter after I drowned its letters in water; I drowned the nobleman, Reem and all my family with it. Today I am alone; I have neither sisters nor a mother! I had a father who will stay always in my heart and I have friends whom I love very much. I got dressed, everything was clean and tidy, and on the small table, there was a delicious breakfast she had prepared for me, I sat down on the chair and ate. I asked her, “How did the earth sink?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Someone opened the water on it all night and emptied the water tanks on it.”")]), _vm._v(" "), _c('p', [_vm._v("“Good analysis.”")]), _vm._v(" "), _c('p', [_vm._v("“Not an analysis, that’s what happened.”")]), _vm._v(" "), _c('p', [_vm._v("“I see you are very sure!”")]), _vm._v(" "), _c('p', [_vm._v("“Rasha has done that, she was the one who flooded the land. She escaped. Oh, if I found her, I would cut her off with the knife I planted in my brother’s heart.”")]), _vm._v(" "), _c('p', [_vm._v("She shocked me; who could believe that. I almost choked with food in my mouth out of shock. Laila rushed to me with a glass of water and added, “Jawad’s sister saw her doing this, but she is a child and could not save the situation.”")]), _vm._v(" "), _c('p', [_vm._v("I stayed in my room that day. I stood in front of my window contemplating the ruined land then went back to my bed. I almost went crazy because of thinking; why did she do that to us and we only helped her? But I am the one who should be blamed; Nader warned me about her and Laila asked me to expel her. I ignored their warnings, I acted stupidly, and today I am reaping the result of my stupidity and kindness of my heart.")]), _vm._v(" "), _c('p', [_vm._v("My crisis of the land did not make me forget what Reem had done; two catastrophes at the same time. I don’t know how my heart and mind will accommodate with these misfortunes. How will we fix the land, how will it recover? The arable soil was washed away; it was back to zero. We lost years of hard work. In the beginning, all I wanted was to be a noble lady having a land and a house, things changed, my main goal was to own the land to attract the attention of the nobleman. But then, I realized the importance of the land after it started to give us a lot of money, during the past few years, the land was the reason for the livelihood of this large family that was under my responsibility. It gave me a very great value among people; I became Lady Zaina, after I was a poor girl carrying her basket and seeking for her livelihood with an old dress and worn out shoes.")]), _vm._v(" "), _c('p', [_vm._v("I will not go back to that period of my life, I will stay Lady Zaina , not for anyone this time but myself and my family; those broken ladies have no one but me.")]), _vm._v(" "), _c('p', [_vm._v("We stayed in deep grief for our lost for a week. Finally, Maryam gave up; she entered my room even though she was afraid to talk to me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Hazem tried hard to save the land, but in vain, all his attempts failed.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I know.”")]), _vm._v(" "), _c('p', [_vm._v("“How about you come downstairs? Let’s talk, maybe we can find a solution.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going down, just give me five minutes and I’ll catch up with you.”")]), _vm._v(" "), _c('p', [_vm._v("I went down and saw them sitting around the table, Laila had made a pot of coffee and some sweets.")]), _vm._v(" "), _c('p', [_vm._v("I started talking and tears filled my eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Well, our loss was very big; I have a little amount of money that will suffice us for the next three months.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We’ll go back to our previous jobs, don’t worry, as we were.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “No! You will never go back to carry the baskets.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We will not go to the market, but we will send the men with the goods after making them; we will also make some foods.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s okay, Jawad and his brothers will take care of the sale, and Hazem will cultivate the small piece of land, my old land; thank God the water did not drown it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “My dear Zaina, you should have a rest from all of this.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “I will return the land as it was and better; we will become richer.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “How will we repair the land? Good soil has been washed away.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “We’ll recreate it. Listen; tomorrow morning I will travel to Mr. Malik’s house in the neighboring town. Surely, he knows how to fix the land.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “If he asks you about our debts, how will you return the money to him?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “It’s okay, I will write papers for him and I will mortgage everything I own to him; when the land recovers, we will return his money to him. Do not worry, he was my father’s friend; he would not demand anything from me. Then I will tell him about my calamity, he will definitely sympathize with me. He is very rich; his life will not stop if I didn’t give him the money.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I’ll go with you.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I’ll go alone, you are the man of the house; you must stay with the ladies. You have also a lot of work to do; I may be away for a week.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at Maryam firmly and added, “You are a very strong woman; I rely on you to keep our family safe. If you see Rasha or catch a glimpse of her, you know how to behave.”")]), _vm._v(" "), _c('p', [_vm._v("She was so overjoyed because I was counting on her.")]), _vm._v(" "), _c('p', [_vm._v("She said, “Don’t worry; I’ll take care of everything.”")]), _vm._v(" "), _c('p', [_vm._v("I headed to Laila and said, “You are the tender mother, take care of everyone especially Hazem please. He does not eat if I am absent.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Don’t worry, dear.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem smiled when he realized my concern for him, he was really humble, and he does not eat until he sees me eating. I felt as if I would leave my little child behind, but there must be a solution. We must have the courage to manage our affairs, otherwise we will return to poverty and fatigue.")]), _vm._v(" "), _c('p', [_vm._v("I went out very early in the morning; I passed by Malik’s house and checked my things. I put on an elegant dress with its hat and shoes. I took the address paper and locked the house well. No one came home since I left it because everything was just as I left it.")]), _vm._v(" "), _c('p', [_vm._v("It occurred to me to sell more jewelry, but how? Who will believe that I have all these jewelry? If Malik comes back, checks his jewelry, and finds something missing, he will accuse me of stealing them and I will get into bigger problems. I don’t want to lose his trust and respect. The man deserves my love and respect. He helped me a lot and gave me a lot of money. He allowed me to wear the dresses in his daughter’s room. He never expected that I would reach the rest of the rooms and find what I found! He gave a beautiful dress with a very precious diamond ring. I will never make him sad or angry.")]), _vm._v(" "), _c('p', [_vm._v("Honestly, I will never tell the girls about the money he gave me; it is better to think that the money is a debt. I started to lose my trust in all people; what Rasha and Reem have done broke me and broke my trust with those around me.")]), _vm._v(" "), _c('p', [_vm._v("I decided first to go to visit Nader, a long time passed since he came to us; I was afraid that something bad happened to him.")]), _vm._v(" "), _c('p', [_vm._v("I arrived early; he was standing in front of his factory door and ordering his workers to take out the goods. He turned and saw me standing behind him. He looked at me with great admiration, but his look was full of blame, as if he was waiting for my arrival. I was very beautiful in a black embroidered dress, a handbag and a white hat; my appearance indicated that I belonged to a prestigious family.")]), _vm._v(" "), _c('p', [_vm._v("He asked me tenderly, “How are you?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him shyly, “Well, you have been absent for a long time. As I’m out of town today, I decided to come to see you and ask how you are.”")]), _vm._v(" "), _c('p', [_vm._v("He answered in astonishment, “I sent you a letter telling you the reason for my absence, but unfortunately you probably did not pay attention to it.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly and firmly, “I didn’t get any message, I came on my own.”")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “How come? I sent the worker to you and he said he handed you the letter.”")]), _vm._v(" "), _c('p', [_vm._v("“He did not come and I will not repeat it.”")]), _vm._v(" "), _c('p', [_vm._v("He called the worker who came quickly, answering his angry master, “Yes, sir, what do you want?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Haven’t you delivered Lady Zaina the letter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The worker:")]), _vm._v(" “Yes, sir, I gave her the letter with her own hand.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly, “But I haven’t seen you before now.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The worker:")]), _vm._v(" “No, madam; Lady Zaina, not you.”")]), _vm._v(" "), _c('p', [_vm._v("“But I am Zaina. Would you please describe the other one for me?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The worker:")]), _vm._v(" “She is skinny, has reddish hair, and wears normal clothes.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “You idiot, didn’t I tell you the blue-eyed lady.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “It’s Rasha, do you expect her to hand me the letter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Screw her, leave now.”")]), _vm._v(" "), _c('p', [_vm._v("He approached me and said tenderly and regretfully, “I’m sorry, I had to travel to get new machines to the factory, and it took a month. I sent you a message; I explained everything with it and I was so upset to ignore it. Didn’t I ask you to warn about that girl?”")]), _vm._v(" "), _c('p', [_vm._v("I said sadly, “I wish I did! I have reaped my stupidity; I said those words and tears began to run down on my cheeks.”")]), _vm._v(" "), _c('p', [_vm._v("“Then, suppose I didn’t answer the letter, won’t you investigate?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll come next week; believe me.”")]), _vm._v(" "), _c('p', [_vm._v("He took out a small notebook from his pocket, opened his appointments page, and inside it was written, ‘Zaina visit is on Thursday.’")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Well, I wish I had waited.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “What is the matter? What is the reason for those tears?”")]), _vm._v(" "), _c('p', [_vm._v("“It is difficult to explain the subject and I am really in a hurry, I have to go to the neighboring city. I came here first because I really wanted to check on you, I was worried about your absence.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Are you going to your father, Mr. Malik, in the neighboring city?”")]), _vm._v(" "), _c('p', [_vm._v("He thought that Malik was my father, but how? I was so confused. I could not tell him that he was not my father, but just a man who was helping me. That was why he thought that I was a noble lady and that I had a house, but how did he come to that conclusion?")]), _vm._v(" "), _c('p', [_vm._v("I answered him with a little confusion, “Yes, I want to reassure him and discuss an important issue with him.”")]), _vm._v(" "), _c('p', [_vm._v("“But the road is long and you have no carriage; you already came here on foot.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed me by the hand and pulled me.")]), _vm._v(" "), _c('p', [_vm._v("“Come, we’ll have some food at a nearby café, talk, and then I’ll take you to your father.”")]), _vm._v(" "), _c('p', [_vm._v("“Quietly, I’m not used to running in shoes like that.”")]), _vm._v(" "), _c('p', [_vm._v("“Quickly, you lazy lady.”")]), _vm._v(" "), _c('p', [_vm._v("We got to the café, it wasn’t far but we were too fast, which made me tired.")]), _vm._v(" "), _c('p', [_vm._v("We sat near the door; the table was for two people and the atmosphere was wonderful inside the café. In the middle of the table was a cup with a red rose inside it. I was very shy, as it was the first time I entered a café.")]), _vm._v(" "), _c('p', [_vm._v("He asked me politely, “What are you eating?”")]), _vm._v(" "), _c('p', [_vm._v("I replied shyly, “I’ll just have a cup of coffee.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and called the waiter and said, “Bring us two cups of coffee, and then make us a good breakfast.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The waiter:")]), _vm._v(" “Okay, sir.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Tell me what’s the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“I want to know first how you knew that I am Malik’s daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“We have been dealing together for a while; he told us at that he had a daughter named Zaina. Once I was going to him, I saw you leaving his house which is next to yours. I knew that you were Zaina his daughter. I saw him about a year ago; he was at the hat shop next to us. He bought a set of hats. I went towards him and greeted him; he told me that he was buying hats for his precious daughter. The hat you are putting on your head today is one of them. Why don’t you live with him in the same house? I was always wondering!”")]), _vm._v(" "), _c('p', [_vm._v("“He loves me so much and brings me everything I wish. He knows how much I love the land, work and my friends, so he let me to practice my freedom in choosing where to live. He also wants me to be a strong girl who can rely on herself.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I asked him once, how is Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("He replied to me, “My daughter is perseverance and reliable.”")]), _vm._v(" "), _c('p', [_vm._v("Perhaps Malik was referring to me specifically. I do not know how I answered him in that way, as if Malik was my father, or perhaps I wished that he was my father. Despite my great love for my real father, but today I do not need anyone as much as I need Malik.")]), _vm._v(" "), _c('p', [_vm._v("We spent about an hour in the café. We talked about several things. He was very nice. I told him about the land and what Rasha did to us. I did not feel upset, I was talking calmly. Perhaps his way of speaking made me tell him everything or because he was interesting about my issues. At the same time, I was very keen to mention Malik with my talk from time to time, as if I liked the idea that he was my father and I wanted to stick to it so badly!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “You must tell the police about what Rasha has done with you; she must be punished.”")]), _vm._v(" "), _c('p', [_vm._v("“How will they punish her, make her, for example, dry the land, and bring it back to its original case?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me with a smile, “How cool you are. She will be put in prison for what she did.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him in astonishment, “Prison; I will not accept to prison any girl. Oh my God; she will spend her life in prison, I will never accept.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you so nice? She deserves to go to jail and rot in it!”")]), _vm._v(" "), _c('p', [_vm._v("“No way; she will never go to jail. Please, I just want to ask her why did she do this to us?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw her three days ago standing in front of the hat shop and talking to its owner. We will go to him and ask him about her. Maybe he knows where she is. Then we go to her and ask her, if that is your desire.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him gratefully, “Thank you. After talking to him, I will go straight to my father.”")]), _vm._v(" "), _c('p', [_vm._v("“We will go together. I will not leave you before I hand you to your father in the best case; I am afraid for you, you shouldn’t go alone.”")]), _vm._v(" "), _c('p', [_vm._v("I was very happy; perhaps God sent him to me as compensation for my lost, although I am a strong woman and I do not need anyone; this has become my principle in life, my life will not depend on anyone and I will not make myself a hostage of a man after today.")]), _vm._v(" "), _c('p', [_vm._v("We headed towards the hat shop owner. Nader had a close relationship with him, as if they had a business relationship and not just neighbors in the same neighborhood. Nader greeted him and shook hands. The shop owner looked at me and said, “Your hat is from my shop.”")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled and replied, “Yes, she is Mr. Malik’s daughter.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The shop owner:")]), _vm._v(" “Yes, he always talked about his beautiful daughter, and he used to buy for her a lot. How is he?”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “Fine, thank God.”")]), _vm._v(" "), _c('p', [_vm._v("I thank God that he did not recognize me and did not remember the incident of the little girl. But how could he remember; I was wearing a simple dress with no hat nor a suitable shoes.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The shop owner:")]), _vm._v(" “Come on, I’ll show you my new collection.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Choose one, my dear, while I’m talking to the man.”")]), _vm._v(" "), _c('p', [_vm._v("He had a wonderful set of hats. I chose a wonderful blue hat that reflected the color of my eyes.")]), _vm._v(" "), _c('p', [_vm._v("Nader looked at me and said, “Really beautiful; it fits you!”")]), _vm._v(" "), _c('p', [_vm._v("He took the hat from my hand and paid for it. It was a really precious hat; I didn’t speak but I would definitely pay him for it. The man gave Nader a paper.")]), _vm._v(" "), _c('p', [_vm._v("The man said to me while we were going out, “I send my greetings to Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("I replied gratefully, “Thank you, sir.”")]), _vm._v(" "), _c('p', [_vm._v("We got into the car. Nader sat beside me in the back seat and asked his driver to drive. He looked at me and said, “Do you know what is written inside this paper?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and replied, “Before the paper, I would not accept the hat without paying for it.”")]), _vm._v(" "), _c('p', [_vm._v("“Which hat?”")]), _vm._v(" "), _c('p', [_vm._v("“The one I bought from the hat shop.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t buy a hat, do you see any hat on my head.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed heartily. He added passionately, “Should I not give you a simple gift, and you are wonderful, Zaina!”")]), _vm._v(" "), _c('p', [_vm._v("I was so ashamed of what he said, so I changed the subject.")]), _vm._v(" "), _c('p', [_vm._v("“What does the paper contain?”")]), _vm._v(" "), _c('p', [_vm._v("“Rasha’s address. While you were watching the hats, I asked him about Rasha. He told me that she visited him two days ago; she was looking for work, so she left her address with him. He asked me why I asked about her. I answered him that you needed a maid. I claimed that Rasha told me before handing me the shop if I could help her by finding a job. My argument matched his words, so he gave me the address.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank God for finding her address. How idiot she was; she was honorable in my house. We offered her food and drinking; she had her own room, no one bothered her. We gave her everything free; we didn’t ask her to do anything or to pay any penny.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, but I’d rather we tell the police about her, and you have Jawad’s sister as a witness.”")]), _vm._v(" "), _c('p', [_vm._v("“No, please, we’re not going to talk about this issue again.”")]), _vm._v(" "), _c('p', [_vm._v("We went straight to her neighborhood it was a very old. The smell of damp mixed with old wood spread all over the place. There were some boys playing in the alley. The car couldn’t get into that narrow alley; we got out of the car and walked our way. Nader tried before we got inside to prevent me from entering; he feared for me from the bumpy, wet road.")]), _vm._v(" "), _c('p', [_vm._v("“How are you going to walk in such a place while this dress? You may fall.”")]), _vm._v(" "), _c('p', [_vm._v("He said that and grabbed my hand tightly.")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly, “If you are afraid of falling, you can wait for me here, and I will continue alone.”")]), _vm._v(" "), _c('p', [_vm._v("He doesn’t know that I used to pass a similar alley when I was selling vegetables and my shoes were worn out while I was carrying a basket or two in my hand.")]), _vm._v(" "), _c('p', [_vm._v("I’ve had this experience over and over again, but to be honest, I haven’t been wearing high heels.")]), _vm._v(" "), _c('p', [_vm._v("I did not find it difficult to walk inside the long, dirty alley. The shoes and the tail of the dress became dirty. Nader held my hand like a little girl, afraid of losing her. The alley began to widen at the end, until we reached a small square surrounded by houses on all sides. We stood in the middle and began to look at all the doors. He took out the paper on which the address was written and read,")]), _vm._v(" "), _c('p', [_vm._v("“The house number is fifty-nine. Thank God it’s numbered!”")]), _vm._v(" "), _c('p', [_vm._v("“But the numbers end here at fifty.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s right. We must cross the square and turn left, then the numbers start from fifty-one, and we will find our destination between them.”")]), _vm._v(" "), _c('p', [_vm._v("We crossed the square; at the first left there was a big commotion and people gathered. Nader asked me to stop immediately.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t go in, we’ll ask someone what’s going on.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with fear, “Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He called one of the boys and asked him, “What’s going on, my son?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The boy:")]), _vm._v(" “I won’t tell you until you give me some money.”")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled and took a ten pounds note out of his pocket.")]), _vm._v(" "), _c('p', [_vm._v("“Tell me and I will give you this.”")]), _vm._v(" "), _c('p', [_vm._v("The boy smiled and said, “The girl, Rasha, was found murdered in her home this morning. Perhaps her fiancé stabbed her yesterday, because they were fighting, but the police did not catch him yet.”")]), _vm._v(" "), _c('p', [_vm._v("He withdrew the money and ran fast. Nader looked at me and said, “What a lady, did you know she was even engaged?”")]), _vm._v(" "), _c('p', [_vm._v("I did not answer him. He was still holding my hand, which had turned into a piece of ice. He was afraid for my condition.")]), _vm._v(" "), _c('p', [_vm._v("He asked me, “What is wrong with you, Zaina, come; I will take you to your father.”")]), _vm._v(" "), _c('p', [_vm._v("I don’t know how I got back to the car. I felt the blood would freeze in my veins! She wasn’t engaged I’m sure. I was wondering who killed her.")]), _vm._v(" "), _c('p', [_vm._v("Is it possible to be Laila? She said that she wished to insert the knife in her heart that she had planted in her brother’s heart, but Laila did not leave me for a moment. It must be Maryam, she is used to, but who is the man who came? Certainly not Hazem, he did not leave my room door; perhaps someone she knew. She might betray him as she did to us and he killed her.")]), _vm._v(" "), _c('p', [_vm._v("Nader was very worried about me; I started crying hysterically in the car. He tried to console me by saying, “Oh my God, if she did to you what she did and you weep for her, what if she is dear to you?”")]), _vm._v(" "), _c('p', [_vm._v("I took out of my bag the paper with Malik’s address written on it and gave it to Nader.")]), _vm._v(" "), _c('p', [_vm._v("He asked in astonishment, “Why are you writing the address on a piece of paper? Do not you memorize the address?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with difficulty, in a sad weeping voice, “Of course I know it. Usually my dad sends the driver to pick me up. He is very afraid when I come alone, so he recommended that I write the address on a piece of paper even if I had any accident, the address is in the bag.”")]), _vm._v(" "), _c('p', [_vm._v("(I do not know where that idea came from. The mind has a great ability to innovate even in the most difficult situations. Despite the sadness and pain, but we must be aware and conscious of every detail, and this is one of the reasons for continuing in life.)")]), _vm._v(" "), _c('p', [_vm._v("He gave the paper to the driver, and ordered him to take us there. I put my head on his shoulder and cried until I fell asleep, he thanked God with his secret that I fell asleep. He was very careful to keep me in comfortable situation till we arrived.")]), _vm._v(" "), _c('p', [_vm._v("When we got to Malik’s door, he quietly woke me up.")]), _vm._v(" "), _c('p', [_vm._v("“Dear Zaina, we have arrived at your father’s house, let’s go.”")]), _vm._v(" "), _c('p', [_vm._v("I got out of the car; I was so fatigue. I wished for a moment that I would go home and ask Laila, “Who killed Rasha?”")]), _vm._v(" "), _c('p', [_vm._v("The maid, Dalal, opened the door for us. She gave me a very warm welcome. Malik was right behind her asking:")]), _vm._v(" "), _c('p', [_vm._v("“Who’s at the door?”")]), _vm._v(" "), _c('p', [_vm._v("I headed toward him and said, “It’s me, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("He opened his hands and hugged me while saying, “Hello, my beautiful daughter!”")]), _vm._v(" "), _c('p', [_vm._v("I started crying on his chest to remove the worry from my chest. He said sadly, “No matter how big the problem is, we will find a solution for it.”")]), _vm._v(" "), _c('p', [_vm._v("He welcomed Nader and asked him to come in.")]), _vm._v(" "), _c('p', [_vm._v("Nader replied, “No, sir, I’m in a hurry, I wanted Zaina to arrive safely.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “No, you will not leave, you will stay with us tonight, and tomorrow you will leave.”")]), _vm._v(" "), _c('p', [_vm._v("He asked the maid to prepare a room for the guest. He looked at me and added, “As for your room, my dear, every day is cleaned as you have commanded.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at Nader and said, “Please, Mr. Nader, consider you at home. I will take my child a little while you have a rest.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “No need to bother yourself sir, I’m leaving now and come back later.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “No, sir, you want him to be angry with you, come with me, I’ll make you a cup of coffee while they prepare your room.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Thanks.”")]), _vm._v(" "), _c('p', [_vm._v("Dalal took Nader to the guest room, while Malik pulled me into his office. He sat on a chair and ordered me to sit across from him.")]), _vm._v(" "), _c('p', [_vm._v("“What’s the matter?”")]), _vm._v(" "), _c('p', [_vm._v("Tears started to fill my eyes.")]), _vm._v(" "), _c('p', [_vm._v("“The land sank and Rasha died.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Because of the land?”")]), _vm._v(" "), _c('p', [_vm._v("“No, she is the one who drowned the farm and then ran away; I did nothing for her except that I helped her. I went to her house today to inquire why she did it but I found her dead.”")]), _vm._v(" "), _c('p', [_vm._v("“Sit in my house; it is your house now. Leave the land; I will be responsible for all your requirements.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t, I don’t live alone, and I have a tribe of women; who will take care of them? Then I will not leave my land and my house. I am in a big trouble so I came to you; help me I don’t want to lose the land.”")]), _vm._v(" "), _c('p', [_vm._v("“Who are these women? Are they your sisters?”")]), _vm._v(" "), _c('p', [_vm._v("“No, they are my friends and their daughters, as well as Jawad and his family.”")]), _vm._v(" "), _c('p', [_vm._v("“Why all this, my girl? Why do you hold yourself the responsibility of those people?”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t refuse anyone’s help.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, I will send someone tomorrow to take care of the land and save it from drowning, but you should know that it will take a long time to recover and return to its old situation.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him and hope began to flow into my heart, “Really, will it be back?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, but Rasha will not return; the dead don’t come back. You have to forget her; maybe she hurt someone and he killed her. Apparently, she’s a bad girl.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s exactly what Nader said.”")]), _vm._v(" "), _c('p', [_vm._v("“What is Nader’s story?”")]), _vm._v(" "), _c('p', [_vm._v("“Just a friend. He wanted to help me, thinking that I was your daughter. If you are not existed, he wouldn’t have looked at me.”")]), _vm._v(" "), _c('p', [_vm._v("“My dear daughter, what attracted him to you is you, and your dazzling beauty; certainly not me. He is a businessman and from a noble family. If he wants you as a wife, let him propose to me, am I not your father?”")]), _vm._v(" "), _c('p', [_vm._v("“Is there a better father in the universe than you?”")]), _vm._v(" "), _c('p', [_vm._v("“Do not forget that you own a house and a land; you are a rich woman. Who wants you is because you are Lady Zaina, not because you are the daughter of Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me in admiration and added, “I see that you like the dresses; they are very suitable on you; as if they were designed for you.”")]), _vm._v(" "), _c('p', [_vm._v("I was ashamed and said, “This is the first dress, I’m sorry, but believe me; I only go to your home to check that everything is fine.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “A little while ago, I asked you to settle in it. Take everything inside it, my dear. You are my daughter. Take all the dresses and shoes until my daughter appears. If she appears, I will buy her a new set, don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("I kissed him on the cheek and thanked him, he overwhelmed me with a great tenderness I had never felt before.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Go to your room and change your clothes and let’s have dinner together; we must not leave the guest alone for long. We will find a solution to everything.”")]), _vm._v(" "), _c('p', [_vm._v("“Change my clothes! But I didn’t bring alternative clothes with me, maybe I should go home.”")]), _vm._v(" "), _c('p', [_vm._v("“You won’t be back before a week, and then your room is full of clothes; come up and wear whatever you like.” He held my hand and added, “Don’t forget, call me dad in front of them. Beware of making any mistake.”")]), _vm._v(" "), _c('p', [_vm._v("I knew I was going to stay with him for a week, but the idea of bringing clothes had completely disappeared from my mind.")]), _vm._v(" "), _c('p', [_vm._v("He was adamant about the idea that I was his daughter, it didn’t bother me, quite the contrary, but why does he stick to that idea? I will know later, what is important now is to save the land.")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room with Dalal; she was very happy to be with me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Come on, my dear; change your clothes while I prepare the food you like.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Thanks.”")]), _vm._v(" "), _c('p', [_vm._v("I entered the room; it was so big and so beautiful. Everything was so luxurious; the big comfortable bed, the ornate wardrobe and the floral wallpaper.")]), _vm._v(" "), _c('p', [_vm._v("There are three tables in the room; there was vase full of flowers on each of them. I felt like in the springtime, flowers were in every part of the room; even the carpet had a big red rose in the middle of it!")]), _vm._v(" "), _c('p', [_vm._v("I opened the closet; it was full of beautiful colorful clothes. I can’t believe how his daughter leaves all this? I took out a white dress decorated with blue butterflies, which was very suitable for dinner.")]), _vm._v(" "), _c('p', [_vm._v("I put it on the bed and went into the bathroom; a large bathroom. I found all kinds of perfume and luxurious soap. I took a quick and warm bath, put on the dress, dried my hair, and put a little lipstick on my lips. I looked at myself in the mirror; a very beautiful girl, but her eyes are full of sadness, and her heart is almost broken.")]), _vm._v(" "), _c('p', [_vm._v("I ignored my eyes and my heart. I found inside the drawers all the girl’s hair accessories I needed. I pulled out a blue ribbon and raised my hair with it from the front, while I let my hair fall on my shoulder from the back. I put on white open shoes from the front. Then I went down the stairs. I was like a little princess. Dalal took me to the dining room. There was a group of servants who took their orders from Dalal. She told everyone in the house that I was the lady of the house and the daughter of its owner. I was keen to act like his daughter and treat the servants as if I am their lady, but of course kindly; I do not like to hurt anyone with a word or behavior.")]), _vm._v(" "), _c('p', [_vm._v("I entered the dining room. Malik and Nader were sitting around the table chatting. The table was full of all kinds of delicious food.")]), _vm._v(" "), _c('p', [_vm._v("The smell was very delicious, which made me hungry. I greeted the gentlemen and sat on my chair. Nader couldn’t take his eyes off me, which confused me so much; I didn’t even know what to eat. Dalal felt about my confusion so she filled me a plate of various kinds. Malik tried to distract him by talking so that I eat the food.")]), _vm._v(" "), _c('p', [_vm._v("It was a very nice evening, for the first time I feel that someone is responsible for me, not everyone is under my responsibility!")]), _vm._v(" "), _c('p', [_vm._v("We sat after dinner in the garden of the house. Malik felt sleepy; he was not used to sleep late. He asked us all to sleep and rest, it was a busy day. Nader went to his room while I went up with Malik to his room. I wanted to make him feel that I was his daughter. He lay on his bed and put his blanket on him. I kissed him on his forehead and wished him a good night. He was very happy that I was with him. I went back to my room and lay on my bed.")]), _vm._v(" "), _c('p', [_vm._v("How soft and comfortable the bed was; I wish it were in my house. I would buy a bed like it. I couldn’t sleep quickly, Rasha never left my mind; is it possible that she was dead. I didn’t even ask her why she did that!")]), _vm._v(" "), _c('p', [_vm._v("We woke up in the morning to Malik’s voice. I wished not to get out of bed, but I had to see Nader before he left. I wore a yellow dress with a black belt and put a yellow ribbon on my hair. We had breakfast and then we said goodbye to Nader.")]), _vm._v(" "), _c('p', [_vm._v("He asked me before he left, “When would you like me to come to take you home?”")]), _vm._v(" "), _c('p', [_vm._v("Malik replied, “Don’t worry, I’ll send her with my driver. You don’t have to come back.”")]), _vm._v(" "), _c('p', [_vm._v("Three days passed quickly at Malik house; they were full of friendliness and love. I was worried about the land, but life was quiet and everyone was at my service. I used to sit with Malik every afternoon in the garden of the house and read him some stories. He got used to my presence very quickly; he needed someone to console him with his loneliness. One evening, he called me; we sat in his office.")]), _vm._v(" "), _c('p', [_vm._v("He began with a strange, unexpected conversation.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What do you think about becoming my daughter officially?”")]), _vm._v(" "), _c('p', [_vm._v("I was stunned by what he said. It appeared on my face all gestures of surprising.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “I only need a personal photo of you to attach it to your file and you become Zaina Malik. You will stay with me; no need to return there. Here everything is available to you. Since you are good at reading, I will seek to get you into the university. I can bring you documents that you have finished your studies at school, and then you can enter the university in the Arabic language department. I have only one condition that you stay here, and sell your house and land.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him puzzled, “Where is your daughter, Mr. Malik?”")]), _vm._v(" "), _c('p', [_vm._v("He shouted out loud, “I told you call me my father; do not ever utter Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("He frightened me so much. I stood terrified and said, “Perhaps; I made a mistake in staying here; I will leave tomorrow at dawn.”")]), _vm._v(" "), _c('p', [_vm._v("He grieved and held my hand. I was trembling and so afraid.")]), _vm._v(" "), _c('p', [_vm._v("He said quietly, “I’m sorry, my dear, I may have scared you, please complete the week, think about my offer and take your time.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I will never leave my house and my land.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t be in a hurry; take your time to think. If you agree, I will make you the queen of this house.”")]), _vm._v(" "), _c('p', [_vm._v("I withdrew my hand and asked him a permission to leave to my room. I greeted him politely and wished him a good night. I left him sad, but his presentation was also confusing and suspicious. Why does he want me to be his daughter, and where is his daughter? Actually, I began to doubt. "), _c('em', [_vm._v("Does he really have a daughter? Or does he wish to have a daughter?")])]), _vm._v(" "), _c('p', [_vm._v("I woke up the next day as if nothing had happened. I treated him like the affectionate daughter. At noon, we sat in the garden; I read him some short stories. In the evening, a guest visited him. He introduced me to the guest as his daughter. This guest was the officer Kamal. The relationship between them was good. We all sat around the dinner table. I was very careful in my conversation with him. He began his conversation by asking me, “Why didn’t we see you before now? Your dad always talks about you which made us eager to see you, but you’re much beautiful than I expected.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly, “He wanted to make a strong woman who would run her own business.”")]), _vm._v(" "), _c('p', [_vm._v("Malik was very impressed with my answer, he smiled and said, “And here I am reaping the result of your absence from loneliness and longing.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on his hand and said, “Don’t worry, Dad, I’ll spend the first week of every month with you.”")]), _vm._v(" "), _c('p', [_vm._v("He said happily, “Rather, the first ten days of every month.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("Kamal talked about his heroism at work and his ability to detect criminals and thieves until he reached to his complex case.")]), _vm._v(" "), _c('p', [_vm._v("I asked him, “What is the issue that concerns you?”")]), _vm._v(" "), _c('p', [_vm._v("“Every now and then a while ago, we find a little girl thrown in the street; they are all girls, we never found a boy. We take them to the shelter. We must reveal who is behind those girls. Unfortunately, for this thorny case, one of our best officers died, Officer Amjad, may God have mercy on him.”")]), _vm._v(" "), _c('p', [_vm._v("“How did he die?” (As if I never knew him!)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “He was killed with a treacherous knife and thrown into the river.”")]), _vm._v(" "), _c('p', [_vm._v("Then suddenly, he changed the subject. “Haven’t you heard of the girl Rasha?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik (in amazement):")]), _vm._v(" “What’s her story?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “She died yesterday; she was stabbed by her fiancé. She is from a far city, according to his claim, she was engaged to him. She stole his money and came to work in the neighboring city. Then, she was fired from her work and disappeared for a while. Suddenly, she appeared and stayed in a very old house. He visited her and asked her to give him his money. He promised her to leave her alone if she returned him his money. She claimed that she has nothing. Thus, he searched the house and found a golden bracelet containing a red diamond. He asked her to give him the bracelet. They quarreled; she tried to stab him with a knife. He took the knife from her and stabbed her with it. He admitted of that when we arrested him.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Poor girl, is the bracelet worth dying for?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “No one deserves to be killed in this way, but he was defending himself; if he did not kill her, she would have killed him.”")]), _vm._v(" "), _c('p', [_vm._v("We stayed silent after his words for a while. Really, if he didn’t kill her, she would kill him. From the beginning, she was lying to me; she never told me that she was engaged. How did I trust her and put her in my house? How naïve I am. However, where did she get the bracelet? As if I know that bracelet.")]), _vm._v(" "), _c('p', [_vm._v("I remembered, as if Salma was wearing a bracelet with a red diamond in her last visit. Yes, she was trying to tease me with it. Oh my God, could she be the one who pushed Rasha to flood the land? What did I do to her to destroy my ground? Perhaps she also agreed with Reem to keep me away from the nobleman. What a weird family! It is not my fault if I am the most beautiful and the smartest. Oh my God I wish I wasn’t their sister!")]), _vm._v(" "), _c('p', [_vm._v("Well, I will no longer be their sister; I will accept Malik’s offer to be his daughter and I will leave them forever, but not now; he must be convinced that I will not leave my land. I will visit him every month and make him stick more to the idea that I am his daughter, and then I will carry his name on my terms!")]), _vm._v(" "), _c('p', [_vm._v("Kamal left right after dinner… He greeted me and whispered in my ear, “Your father has grown up and is tired, don’t leave him too much.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with the same way, “I won’t leave him for long; I will visit him often and may stay with him soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Great!”")]), _vm._v(" "), _c('p', [_vm._v("He answered me with a smile and left quietly.")]), _vm._v(" "), _c('p', [_vm._v("Malik looked at me sadly and said, “Are you really going to visit me every month?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him tenderly after putting my hand on his hand, “Yes, the first ten days of every month. You should sleep now, it is too late.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to his room with him. He lay on his bed; I covered him with his blanket.")]), _vm._v(" "), _c('p', [_vm._v("He thanked me and said, “Open the first drawer of the dresser.”")]), _vm._v(" "), _c('p', [_vm._v("The drawer was locked.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Oh my dear, I forgot!”")]), _vm._v(" "), _c('p', [_vm._v("He took the key out of his pocket and gave it to me. I opened the drawer, it was full of papers, and there were also bundles of money inside it.")]), _vm._v(" "), _c('p', [_vm._v("“Take a wad of money.”")]), _vm._v(" "), _c('p', [_vm._v("He asked me and almost fell asleep.")]), _vm._v(" "), _c('p', [_vm._v("“Why? I don’t need it now.”")]), _vm._v(" "), _c('p', [_vm._v("Malik was half asleep:")]), _vm._v(" "), _c('p', [_vm._v("“Don’t argue with me, take the money and return the key.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay, thank you,” I replied.")]), _vm._v(" "), _c('p', [_vm._v("I took the money and went to him to hand him the key, but he had fallen into a deep sleep, it was the first time he had slept so quickly.")]), _vm._v(" "), _c('p', [_vm._v("I was curious to read the papers in the drawer; I opened it quietly and looked through them all. It took about an hour. It contained all the papers of his daughter; her birth certificate and everything related to her. I could not find a picture of her. There was also an envelope containing the bonds of his belongings.")]), _vm._v(" "), _c('p', [_vm._v("I closed the drawer quietly, but unfortunately, the key and the money fell to the floor. He opened his eyes and said, “Who’s there?”")]), _vm._v(" "), _c('p', [_vm._v("I turned towards him as if he had not yet fallen asleep, kissed him on the forehead, put the key in his hand, and said, “Thank you; you are the most beautiful father in the universe!” He took the key and smiled. He put it in his pocket, and fell asleep immediately.")]), _vm._v(" "), _c('p', [_vm._v("I quickly went to my room. I couldn’t sleep quickly. I started pondering of his offer; if I become his daughter, I will be very rich. I would study and become a truly a noble lady, but I would not leave my land and my family. I would plan to that quietly and smartly.")]), _vm._v(" "), _c('p', [_vm._v("The week passed; I got ready to leave. He asked me to take everything I needed with me.")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Maybe I’ll just take the bed; I couldn’t find a bed as comfortable as it is.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Why don’t you sleep in my house there; all beds are like it.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to mess in your house.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s your home, my dear, don’t hesitate to stay there.” He hugged me and whispered in my ear, “Think of my offer.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("“Our date is the first of the month, as you promised.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t be late, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Thank God, I am your father. The car is waiting for you. I filled it with delicious foods and gifts for your friends.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, you never forget anything, God bless you.”")]), _vm._v(" "), _c('p', [_vm._v("His eyes were filled with tears, he said sadly, “Keep the promise.”")]), _vm._v(" "), _c('p', [_vm._v("“I will never forget it.”")]), _vm._v(" "), _c('p', [_vm._v("I said goodbye to him and to Dalal. I rode the car back to the drowned land, the worn-out bed, and the broken girls.")]), _vm._v(" "), _c('p', [_vm._v("I arrived after a long car trip. Perhaps the long journey was no longer suitable for Malik’s health, so he no longer came to visit his house.")]), _vm._v(" "), _c('p', [_vm._v("I got out of the car; everyone was out waiting for me. The girls ran towards me and gave me the warmest welcome. Laila was behind them. She jumped towards me and hugged me.")]), _vm._v(" "), _c('p', [_vm._v("She said sadly, “Don’t leave the house again please.”")]), _vm._v(" "), _c('p', [_vm._v("She grabbed my hand and dragged me towards the land. There were workers and Nader was their commander.")]), _vm._v(" "), _c('p', [_vm._v("Maryam said friendly, “You have been away for a long time. Look, the land is dry.”")]), _vm._v(" "), _c('p', [_vm._v("Nader turned to me and said, “Hello, how are you? Look, the earth is back dry, but it needs time to recover and regain its ability to give.”")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t believe what I saw.")]), _vm._v(" "), _c('p', [_vm._v("“How is that?”")]), _vm._v(" "), _c('p', [_vm._v("I asked him while tears were dropping on my face; so he wiped them off my cheek and held my hand and said, “Everything can be fixed, but the earth will need time to recover.” He called a man from afar. The man approached us.")]), _vm._v(" "), _c('p', [_vm._v("Nader introduced him to me, “This is an agricultural expert; he will tell you about the situation of the land.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “Madam, the good soil has not been completely washed away; it was greatly damaged, but it is returnable as it was. You will need fertilizers and nutrients, and within months it will recover, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("Then he added, “We will send experts every day to help you in restoring it as it used to be, and they will teach your workers how they should work in such situation; these are the orders of Mr. Nader.”")]), _vm._v(" "), _c('p', [_vm._v("I thanked him and thanked Nader and invited him into the house.")]), _vm._v(" "), _c('p', [_vm._v("Hazem never approached and did not greet me, which made me very sad. I expected him to be the first to approach the car and greet me. He was standing far away looking at me. I was wearing a dark blue dress, a white belt, and a hat that fits it perfectly. I know how beautiful I was in his eyes, and how much He was annoyed from Nader presence! But he promised me once that he would not interfere between Nader and me, and he always keeps his promise.")]), _vm._v(" "), _c('p', [_vm._v("The workers and the engineer left. Everyone entered the house; the driver had brought all the gifts into the house with the help of Jawad.")]), _vm._v(" "), _c('p', [_vm._v("Laila grabbed my hand and said, “Nice dress.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam followed her, and held my other hand and said, “The most beautiful is the hat!”")]), _vm._v(" "), _c('p', [_vm._v("I said laughing, “Well, leave me, I have a guest.”")]), _vm._v(" "), _c('p', [_vm._v("All the boxes were arranged perfectly; on each box written the name of its owner. Malik did not forget anyone. He was a very organized man. When I was telling him my stories he was listening carefully and memorizing the names. Each one picked up her box and opened it. They did not care about Nader and were not even ashamed of the horrible mess. I grabbed Nader’s hand and asked him to sit in the middle of this mess.")]), _vm._v(" "), _c('p', [_vm._v("He simply accepted it and said, “I’ll let you rest now and I’ll come back later.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “You won’t leave until you have a cup of coffee, and I’ll make it for you myself.”")]), _vm._v(" "), _c('p', [_vm._v("“No, please, it’s okay.”")]), _vm._v(" "), _c('p', [_vm._v("Laila jumped from afar after realizing her carelessness.")]), _vm._v(" "), _c('p', [_vm._v("“You will not leave, sir, and I will make the coffee, also, there is a delicious dessert that Zaina brought, we will all taste.”")]), _vm._v(" "), _c('p', [_vm._v("“No, please, it’s okay.”")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina took out a small box on which was written ‘Nader,’ and another one ‘Hazem;’ she approached me and said, “Here’s the master’s gift, and I will give Hazem his box.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “No, my beautiful girl, give me the boxes, I will give them to their owners. You can give Jawad his gift.”")]), _vm._v(" "), _c('p', [_vm._v("She kissed me on the cheek and said, “Well, I’ll give Jawad his gift.”")]), _vm._v(" "), _c('p', [_vm._v("I presented to Nader his gift shyly.")]), _vm._v(" "), _c('p', [_vm._v("He said, “Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“It was nothing. Open it up and say what you think of it.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll open it at home, thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ll open it now and tell me what you think of it.”")]), _vm._v(" "), _c('p', [_vm._v("In fact, I didn’t know what was in it, and I wanted to know if he’d like it or not, because he definitely expected me the one who bought it.")]), _vm._v(" "), _c('p', [_vm._v("He opened it while muttering, “What a baby girl you are!” Inside the box was a beautiful precious watch, which he liked and said, “Nice choice, thanks.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him to try it. He put it on immediately.")]), _vm._v(" "), _c('p', [_vm._v("He said, “Are you going to ask Hazem to open his gift and try if it suits him.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly, but I was filled with inner anger.")]), _vm._v(" "), _c('p', [_vm._v("“No, but in gratitude for his efforts, I will hand him his gift with my own hand.” Then I threw Hazem’s gift on the sofa and asked him to sit down.")]), _vm._v(" "), _c('p', [_vm._v("He said regretfully, “I’m sorry, I was jealous.”")]), _vm._v(" "), _c('p', [_vm._v("“From whom? Hazem? Please no! He’s poor and kind, he’s as my brother, then why are you jealous?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “You crook, where’s the coffee? I have to go.”")]), _vm._v(" "), _c('p', [_vm._v("Laila offered coffee and sweets. He quickly drank his coffee and was eager to leave. I don’t blame him, for the house was in a great mess and horrible noise.")]), _vm._v(" "), _c('p', [_vm._v("He held my hand and looked at my eyes and said, “Your land will heal soon. Your girls are so happy because you are with them, but you must also think about yourself and your future.” He kissed my hand and left.")]), _vm._v(" "), _c('p', [_vm._v("He stole my heart with his kiss, so that I stayed standing in front of the door for five minutes. Is it possible that God sent him to me in compensation for my losses? I looked afar, I saw Hazem staring at me sadly. His appearance broke my heart. How sad and miserable he looked as if someone stabbed his heart and threw it away in a deep sea of grief and pain. I wanted to hug him and console him as a mother who tries her best to make his child happy when his best friend abandoned him, but I was sad from him because he ignored me when I arrived. I entered the house and brought his gift. When he saw me approaching him, he ran away. I was very sad; I returned home disappointed.")]), _vm._v(" "), _c('p', [_vm._v("I entered the house; the place was still in chaos. Laila came out in a beautiful dress and hat, as well as Maryam. There were dresses and dolls for all the girls. I suddenly had a strong headache. I smiled courtesy; I did not want to spoil their joy. I asked tittle Zaina to call Jawad. She was quick in executing to what I asked her to do. She ran quickly and brought him with her.")]), _vm._v(" "), _c('p', [_vm._v("“How are you?” I asked him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Fine, thank God.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you like what I brought you?”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, but what do I do with the things you brought for my family?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him in amazement, “Give them their things.”")]), _vm._v(" "), _c('p', [_vm._v("He replied sadly, “They have gone.”")]), _vm._v(" "), _c('p', [_vm._v("“They have gone! What happened?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me in grief, “When the earth sank, my mother thought that you would not come back and save it. She took my sister to the nobleman and presented her to him to take care of her. Of course, Salma met her. Now, she is responsible for choosing the girls. My mother begged her lot to accept my sister. Salma accepted her because she is beautiful, but didn’t give my mother money as much as she gave to other families. My mother took the money and sent a letter to her husband telling him she had money now. He came back and took her with him under one condition that my brother and I must stay here.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with a deeper sadness than his, “It’s okay, my dear, the land will improve and you have a house here. Perhaps Hazem will also sleep with you in the house and become the house of men. You will take care of us and guard us. And I have enough money; we will not need anyone after today, and you will never feel poor either. Your mother chose her fate and she is free, as for you, you must go on with your life and convince your brother of that as well.”")]), _vm._v(" "), _c('p', [_vm._v("He shook his head sadly and went to his house. I never considered her a good mother; despite all what he did for her, she left him empty-handed, not even leaving him a penny!")]), _vm._v(" "), _c('p', [_vm._v("I ran up to my room, fleeing the noise. There was the sweet surprise; a new bed with the comfy mattress like which I slept in Malik’s house.")]), _vm._v(" "), _c('p', [_vm._v("I lay on it cheerfully, I really needed some rest. There was an envelope on the bed. I opened it and read the letter.")]), _vm._v(" "), _c('p', [_vm._v("My dear daughter Zaina,")]), _vm._v(" "), _c('p', [_vm._v("There is a small bag for you with the new bedding in red color, open it. From today, you will only sleep comfortably. Have a good night, my dear daughter. Don’t forget the promise; I’ll wait for you soon.")]), _vm._v(" "), _c('p', [_vm._v("Your loving father,")]), _vm._v(" "), _c('p', [_vm._v("Malik.")]), _vm._v(" "), _c('p', [_vm._v("I found the bag on the side of the bed, a little red bag. I opened it; there was a very beautiful bracelet, supplied with green jewels. I put it in my hand, and then I slept quickly; without even arranging my bags and hiding what needed to be hidden. I woke up in the evening to the sound of Laila saying, “Dinner is ready, come everyone.”")]), _vm._v(" "), _c('p', [_vm._v("I was the last to arrive in the dining room; everyone was waiting for me. I asked Maryam to call Jawad and his brother; Hazem as well.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We sent food for Jawad and his brother, we’d better keep separate; we have little girls here.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “You are right.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “Hazem has not appeared yet, do not worry, he will come soon.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope that.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Eat your food now; don’t think about anyone, no one will die of hunger.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “People die of stabbing, not of starvation.”")]), _vm._v(" "), _c('p', [_vm._v("Laila replied in amazement, “What is this, Zaina? Please we want to restore the land and live in peace.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and continued, “Rasha is dead.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila and Maryam together:")]), _vm._v(" “She died?”")]), _vm._v(" "), _c('p', [_vm._v("“Her fiancé killed her because she stole him. I heard that she had a bracelet with a red jewel; I think Salma gave it to her in exchange for flooding the land.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “She deserved what happened to her, she almost exposed us to hunger and poverty.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Lynn:")]), _vm._v(" “But God saved us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “Yes, I wish Salma would die too.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Lynn:")]), _vm._v(" “Do not worry, my dear, she will die, for this is the end of the wicked people.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed from my heart at their talk, they grew up and we didn’t notice it.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “How malicious Salma is!”")]), _vm._v(" "), _c('p', [_vm._v("“We must beware of her, and you are the most of us, Maryam!” I looked at Laila and completed, “Thank God she is not my sister and that I am Malik’s only daughter.”")]), _vm._v(" "), _c('p', [_vm._v("She understood me from a look! She continued as if I were really his daughter, “Yes, we thank God that you have no evil sisters like her and you are only daughter for a great father.”")]), _vm._v(" "), _c('p', [_vm._v("As for Maryam, she understood the issue, but she did not participate. She was definitely worried from Salma, whoever was able to flood the earth, could do greater things than that. Moreover, if Salma knew about her relationship with her husband Faris, she might kill her. Salma today is stronger because of her work with the nobleman.")]), _vm._v(" "), _c('p', [_vm._v("I went out after dinner and sat on the wooden chair under the window of my room, the one on which Hazem always sits and waits for me. I put his gift beside me.")]), _vm._v(" "), _c('p', [_vm._v("He appeared in front of me carrying a bouquet of flowers.")]), _vm._v(" "), _c('p', [_vm._v("He said quietly, “He kissed your hand!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “You’re too late!”")]), _vm._v(" "), _c('p', [_vm._v("I asked him to sit next to me.")]), _vm._v(" "), _c('p', [_vm._v("“I won’t sit down before you accept my flowers.”")]), _vm._v(" "), _c('p', [_vm._v("I took them and added, “Accept my present.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at the amazing flowers and said, “I will put flowers in my room so that no one else can touch them.”")]), _vm._v(" "), _c('p', [_vm._v("“Truly!”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed his gift and opened it; the gift was a woolen scarf.")]), _vm._v(" "), _c('p', [_vm._v("“Did you like the gift? When you put it around your neck, remember me.”")]), _vm._v(" "), _c('p', [_vm._v("He sat next to me and repeated his sentence, “He kissed your hand.”")]), _vm._v(" "), _c('p', [_vm._v("I answered firmly, “Didn’t you promise me not to interfere? You should know something important; I can’t live without you; so you must be my brother. If you are something else, we may not agree. If you are a lover, I may resent you and leave you. However, if you are a kind brother and we quarrel or fight we will forgive each other and talk again as if nothing had happened! Please understand me.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me sadly and said, “But I love you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you very much too. What I fear most in life is losing you, and what I wish for is a brother who loves me. You sometimes remind me of my father and this is what makes me very happy and feel safe. You are the most precious thing I have. Please be a brother who loves me and supports me.”")]), _vm._v(" "), _c('p', [_vm._v("“You will never leave me, won’t you?”")]), _vm._v(" "), _c('p', [_vm._v("“Never, I can’t, believe me. I will help you in finding a good wife and take care of your children.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not marry, but I will always be close to you, even if you get married.” He put the scarf around his neck and got up, saying, “I’m hungry.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him cheerfully, “We have a lot of delicious food. Come, let’s eat together.”")]), _vm._v(" "), _c('p', [_vm._v("I know he was not convinced, but at the same time, I was relieved that he agreed about what I said.")]), _vm._v(" "), _c('p', [_vm._v("He did not consider me – and he will not consider me – his sister; the feelings he has towards me can only be the feelings of a lover for his beloved. He agreed to suppress his feelings and put salt on his wounds in order to satisfy me.")]), _vm._v(" "), _c('p', [_vm._v("How much he got hurt when he saw Nader kissing my hand. It is very difficult for me to see him suffering. In fact, his pain hurts me, but we are very far from each other in thoughts and dreams; his dream of life is me, and my dream transcends space, I want to be a noble lady who has possessions and high value among people. He lived my misery and my pathetic life, but he was satisfied and convinced of what life gave him. We both wanted something valuable, we both struggled to get it, and we don’t know who will achieve his dream! I don’t think Hazem will achieve his dream.")]), _vm._v(" "), _c('p', [_vm._v("We had a beautiful evening; Rasha’s death was the main issue we talked about. Everyone was happy; they consider the way she died as a punishment of what she has done. Oh my God, I was against anyone’s death in such a way. I wish I had asked her why she did that.")]), _vm._v(" "), _c('p', [_vm._v("They all wanted to speak with me; I felt how much they missed me. I told them stories about Malik and his family, and how beautiful his house was. The only one who was sad was Jawad’s brother, Ghaith. He did not accept his mother leaving. Maryam was taking care of him as if she was his mother.")]), _vm._v(" "), _c('p', [_vm._v("She was so weird, she loves children very much, she wishes she had a hundred boys and girls and took care of them!")]), _vm._v(" "), _c('p', [_vm._v("The next day, the expert came with the workers. Nader also came with them. The land was an excuse for him to come and see me every day.")]), _vm._v(" "), _c('p', [_vm._v("I went out to meet them. Nader ran towards me and said, “You do not have to go out every day to receive them. Ask Hazem or Jawad to receive them; it is their responsibility.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily, “Why? I understand of the land affairs more than them.”")]), _vm._v(" "), _c('p', [_vm._v("“Hazem is an expert and learns quickly.”")]), _vm._v(" "), _c('p', [_vm._v("Then, you will not work in the land; you are going only to supervise on it. Look how many workers there are; how you got out with all your beauty and elegancy.")]), _vm._v(" "), _c('p', [_vm._v("He added mockingly, “Why don’t you invite them to enter and drink tea with you? Enter the house and I will follow you in a few moments.”")]), _vm._v(" "), _c('p', [_vm._v("His orders and the way he spoke to me annoyed me, I was not accustomed to receiving orders from anyone in such way. I entered the house without saying a word.")]), _vm._v(" "), _c('p', [_vm._v("Laila asked, “What’s the matter? You are like an erupting volcano!”")]), _vm._v(" "), _c('p', [_vm._v("“Nader asked me not to go out to see the workers; he did that in a provocative manner.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s right, you’re a lady now. My dear, you’re so pretty and the way they look at you is awful. I think, we ladies, should stay with the girls inside until they leave.”")]), _vm._v(" "), _c('p', [_vm._v("Laila was wise and I liked her opinion, but I also did not like Nader’s tone of talking to me. He entered after more than half an hour. I was sitting on the sofa, holding a book in my hand, completely ignoring his presence.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Won’t you make me a cup of coffee?”")]), _vm._v(" "), _c('p', [_vm._v("I put the book on the sofa and got up. I headed to the kitchen. He grabbed my hand and said, “I know you are angry with me, but the noble lady does not stand among the workers!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him calmly, “The noble lady runs her own business.”")]), _vm._v(" "), _c('p', [_vm._v("“If she has someone working on her behalf, why is she standing in the crowd? A beautiful lady like you should take good care of her and avoid trouble, you have a lot to learn.”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand from inside his hand in anger and called Laila, who came quickly.")]), _vm._v(" "), _c('p', [_vm._v("“What do you want, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Please make a cup of coffee for Mr. Nader, and a pot of tea for the men outside. Send it to them with Jawad or Ghaith. I am tired; I will go up to my room.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “No need for coffee, Mrs. Laila. I’ll stay with the workers for a while and leave.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me but I turned my face away from him. I went up to my room and stood at the window watching him from afar. He was right, there is a lot to be learned; I have never lived as a noble lady. He looked towards the window, smiled, and left quietly. He did not know that he insulted me when he accused me of ignorance, but I will learn everything fast, and who is faster than me in learning!")]), _vm._v(" "), _c('p', [_vm._v("Nader was absent for three days. I was sad because of his absence; I thought that he would never return, but he came on the fourth day carrying a small box in his hand. I was committed to stay in house and not standing among the workers outside. Hazem was doing everything.")]), _vm._v(" "), _c('p', [_vm._v("He entered the house, while I was still in my room. He asked Laila politely to call me. I came down quietly as if I wasn’t eager and happy to see him! I welcomed him as befits a noble lady.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “How is the work?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him coldly, “How could I know? Ask Hazem or Jawad; I haven’t left the house since you have been here.”")]), _vm._v(" "), _c('p', [_vm._v("He answered me, overjoyed, “Really, that is great! I’m sorry if I bothered you with my fear for you; I’m really afraid for you from them and all people. You are very beautiful and sensitive, forgive me.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him quietly, “Did you bring me a book to learn from it what I lack?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and replied, “You are the best who teaches morals and kindness; I did not mean to offend you, but you are passionate and enthusiastic about work. You forget who you are and who your father is.”")]), _vm._v(" "), _c('p', [_vm._v("Malik is responsible for what you are doing; he gave you the freedom to run your own business.")]), _vm._v(" "), _c('p', [_vm._v("I answered, “It’s okay, because I have no one else in life but him, he is afraid that one day he will pass away and leave me alone, I cannot face life.”")]), _vm._v(" "), _c('p', [_vm._v("“He might be right.”")]), _vm._v(" "), _c('p', [_vm._v("He presented the box to me and said, “This is for you, I hope you like it.”")]), _vm._v(" "), _c('p', [_vm._v("I took it, thanked him, and put it on the table.")]), _vm._v(" "), _c('p', [_vm._v("He yelled spontaneously, “Won’t you open it?”")]), _vm._v(" "), _c('p', [_vm._v("“No. I am going to open it later, surely a beautiful thing.”")]), _vm._v(" "), _c('p', [_vm._v("He carried it angrily and approached me.")]), _vm._v(" "), _c('p', [_vm._v("“You will open it now and tell me your opinion.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay. I opened it.”")]), _vm._v(" "), _c('p', [_vm._v("There was a very beautiful watch inside it.")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Do you always bring the same gifts given to you?”")]), _vm._v(" "), _c('p', [_vm._v("“I expected this answer from you. I liked it very much; I did not imagine it around anyone’s hand but yours. Let me put it around your wrist.”")]), _vm._v(" "), _c('p', [_vm._v("He put it around my wrist, which made me feel very ashamed. I pulled my hand and said, “I’ll make you coffee myself.”")]), _vm._v(" "), _c('p', [_vm._v("The beautiful days passed in such routine. Nader used to come every day and drank the coffee I made.")]), _vm._v(" "), _c('p', [_vm._v("On one day, we were having coffee together; Hazem came and addressed me eagerly, “Come with me, Zaina. I want you to decide what to do with the space in front of Jawad’s house.”")]), _vm._v(" "), _c('p', [_vm._v("I got up quickly; Nader grabbed my hand and said, “Why should you decide? The workers will decide.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at Hazem and added, “Can’t you act alone, how ignorant you are!”")]), _vm._v(" "), _c('p', [_vm._v("I withdrew my hand in exasperation and said, “Do not talk to him in that way; do not ever insult him again. Do not think that you are better than him, or that you fear for me more than him; no one fears for me like him.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem came out quietly.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Nader and said resentfully, “Are you satisfied now? You hurt him, he does not do anything without consulting me, he’s afraid that he will do any mistake that bothers me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I could swear, if I didn’t know who you are, I’d say you love the boy.”")]), _vm._v(" "), _c('p', [_vm._v("“He is like a brother; doesn’t a girl defend her brother; believe it or not, it is up to you. I don’t like to treat anyone as if I am better than him, all people are equal, and you must apologize to him, sir.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He went out, but unfortunately, Hazem had left the whole place. Hazem loves me but does not accept anyone insulting his dignity.")]), _vm._v(" "), _c('p', [_vm._v("I waited for him for a long time in the evening sitting on our chair. I waited until I fell asleep; I woke up in the morning on my bed while he was sitting under my window on the floor waiting for me to wake up.")]), _vm._v(" "), _c('p', [_vm._v("“Did you sleep in my room?” I asked him in amazement.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I sat the whole night under the window.”")]), _vm._v(" "), _c('p', [_vm._v("“Is this acceptable?”")]), _vm._v(" "), _c('p', [_vm._v("“You were lying on the wooden chair, I was afraid for you; it was so cold. I carried you and put you in your bed.”")]), _vm._v(" "), _c('p', [_vm._v("“You can go out now and I’ll follow you in a while. Wait for me on the chair.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("I followed him after half an hour. He was too ashamed of himself to spend the night in my room. He was sitting while I kept standing as a teacher and her naughty student.")]), _vm._v(" "), _c('p', [_vm._v("I said seriously, “First of all, it is forbidden to sleep in my room. If you see me in such state, you better wake me up.”")]), _vm._v(" "), _c('p', [_vm._v("“I tried, but you didn’t wake up.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you try, I didn’t feel you at all.”")]), _vm._v(" "), _c('p', [_vm._v("“I whispered in your ear several times, but you didn’t hear.”")]), _vm._v(" "), _c('p', [_vm._v("“Whispered! Well, again if I don’t hear, put me in my bed and leave quietly.”")]), _vm._v(" "), _c('p', [_vm._v("“I put your blanket on you so you don’t feel cold and then I will leave quietly.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“Well, secondly, Nader followed you and wanted to apologize, but he couldn’t find you.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want him to apologize, and I don’t want to see him again.”")]), _vm._v(" "), _c('p', [_vm._v("“He will come a lot and you’ll have to see him.”")]), _vm._v(" "), _c('p', [_vm._v("“No, he will not enter the house again.”")]), _vm._v(" "), _c('p', [_vm._v("“Who presumed that?”")]), _vm._v(" "), _c('p', [_vm._v("“Me, didn’t you say that I was the man of the house?”")]), _vm._v(" "), _c('p', [_vm._v("“Does the man of the house kick people out? Is this his job?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem (angrily):")]), _vm._v(" “He won’t enter, or I’ll leave!”")]), _vm._v(" "), _c('p', [_vm._v("“Then go away.”")]), _vm._v(" "), _c('p', [_vm._v("“You prefer him on me?”")]), _vm._v(" "), _c('p', [_vm._v("“I quarreled with him for you, and then you are threatening me to leave, I hate such a childish behavior.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t threaten you, either me or him?”")]), _vm._v(" "), _c('p', [_vm._v("“He; leave now and I don’t want to see you again.”")]), _vm._v(" "), _c('p', [_vm._v("I came back to my room sad and annoyed. I watched him through my window, he never left the chair; even Nader, on that day, did not visit us. I thanked God that he did not come; I do not want them to quarrel because of me.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, he took his carriage and left. Maryam came to my room and said, “He said he would work in the neighboring city.”")]), _vm._v(" "), _c('p', [_vm._v("I replied sadly, “He’ll be back, he can’t stand our parting.”")]), _vm._v(" "), _c('p', [_vm._v("After two hours, God knows how I spent them, he came back and sat on the chair; I went down to him immediately.")]), _vm._v(" "), _c('p', [_vm._v("“You’re back, why didn’t you leave?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me sarcastically.")]), _vm._v(" "), _c('p', [_vm._v("“Who said I left in the first place?”")]), _vm._v(" "), _c('p', [_vm._v("“Where have you been?”")]), _vm._v(" "), _c('p', [_vm._v("“None of your business.”")]), _vm._v(" "), _c('p', [_vm._v("“What, how dare you, tell me now where you’ve been.”")]), _vm._v(" "), _c('p', [_vm._v("“Go away, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not a little girl, and I’m the one who’s leaving.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed because he was able to provoke me; he never provoked me before today. He was very afraid for me, and he even hated provocation.")]), _vm._v(" "), _c('p', [_vm._v("“Sit down and I’ll tell you.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to know anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, you won’t see what I brought.”")]), _vm._v(" "), _c('p', [_vm._v("“I do not want.”")]), _vm._v(" "), _c('p', [_vm._v("“As you like.”")]), _vm._v(" "), _c('p', [_vm._v("I was about to leave, he carried me quietly and put me on the chair; I was laughing at his spontaneous behavior. I was strangely very happy because he returned; no home without Hazem. He pulled out of the carriage a cage with two very beautiful birds inside and said, “I bought them for you.”")]), _vm._v(" "), _c('p', [_vm._v("I almost went crazy when I saw them, my God, how beautiful they are. I looked at him cheerfully.")]), _vm._v(" "), _c('p', [_vm._v("“You are full of surprises.”")]), _vm._v(" "), _c('p', [_vm._v("“You know that I’m better than Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“Who said he is better than you? You are unique. God knows that I quarreled with him and scolded him severely for you. Please do not compare yourself with anyone.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not approach him; I kept salience for what he said only for you. I was able to answer sharply; you know that very well. You are free to choose whomever you want, but you will never be my sister. I promise I will never interfere.”")]), _vm._v(" "), _c('p', [_vm._v("“Come on; let’s go home, the little girls will go crazy when they see the birds.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was about to cry when she saw Hazem entering the house with me. I put the cage on the table; everyone gathered around it. Hazem kept staring at me all night; my eyes are his destination. He found in my eyes his safety and peace. I always preferred to ignore his looks, so that he would never think for a moment that I accept him as a lover.")]), _vm._v(" "), _c('p', [_vm._v("We started a new month and I had to keep the promise and visit Malik. I was excited to go there, I have a lot of questions and things to learn. Surely; I will consult him and learn everything.")]), _vm._v(" "), _c('p', [_vm._v("Malik’s car arrived exactly on time, as if he was counting the hours to see me. I asked Hazem and Jawad to take care of the land in my absence, and Laila to run the house well; while Maryam was the loving mother to everyone. They asked me not to worry; they will handle everything.")]), _vm._v(" "), _c('p', [_vm._v("Nader did not come to say goodbye, even though he had promised me that he would. I got into the car thinking of the house and the land; I was so afraid for my family. I am the only one who can manage everything. On the other hand, I was looking forward to visiting Malik; I wanted to have a break and relief from the noise in my house.")]), _vm._v(" "), _c('p', [_vm._v("When I arrived, Malik and Dalal were standing at the door waiting for me. I ran toward Malik and hugged him. Nader appeared from nowhere. Actually, he came to see me. I was very happy to see them as if I returned to my home.")]), _vm._v(" "), _c('p', [_vm._v("Nader spent the whole day with us; he wanted to leave in the evening, but Malik insisted on him to stay till the morning.")]), _vm._v(" "), _c('p', [_vm._v("I spent ten days like a dream, as beautiful as a magic. I was the lady of the house and the spoiled daughter. Malik taught me many things as a noble lady. On the last day, he was so sad because I would leave him.")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand tenderly and said, “Won’t you accept to be my daughter officially? I will not deprive you of land and friends, but I want you to spend the most part of the month with me. I do not want your reply now; if you agree, we will arrange it on your next visit.”")]), _vm._v(" "), _c('p', [_vm._v("As usual, they were all waiting for me in front of the house. Nader was also there carrying a bouquet of roses in his hand. Jawad carried all boxes I brought with the help of the driver and put them inside the house. I invited Nader to enter and have coffee with me. I missed him so much; that I had not seen him for about ten days. I thanked him for the flowers and asked him, “Why didn’t you come to visit me?”")]), _vm._v(" "), _c('p', [_vm._v("“How I would have liked to come every day, but unfortunately the working days were very hard. I must deliver the goods to their owners myself, and make sure that everything is according to demand.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I hope one day I’ll be more important to you than work!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said while looking straight into my eyes, “Who said that my work is more important than you? We must keep our promise to our clients. You know my dear, when you are here; I can come every day, while when you are at your father house it becomes very difficult. I don’t like to bother Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“Malik is not bothered by anything that makes me happy; do not use Malik as an excuse for your absence. Then you could call and reassured about me, don’t you have a phone?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you win, I have no excuse!”")]), _vm._v(" "), _c('p', [_vm._v("“So you didn’t miss me? It is okay!”")]), _vm._v(" "), _c('p', [_vm._v("“You naughty girl, where’s my coffee?”")]), _vm._v(" "), _c('p', [_vm._v("We stayed like this for six months. I stayed at Malik’s house for ten days a month. I was never late for him, and on every visit, he asked me to be his daughter officially.")]), _vm._v(" "), _c('p', [_vm._v("On my last visit, I asked him, “Is there any hope that your daughter will ever return?”")]), _vm._v(" "), _c('p', [_vm._v("He replied sadly, “I don’t think, my dear, I don’t know anything about her; she never answered my messages.”")]), _vm._v(" "), _c('p', [_vm._v("I was certain at the time that he did not have a daughter. She might just exist in his imagination. Perhaps he had one, but she died and he still believed that she existed.")]), _vm._v(" "), _c('p', [_vm._v("I promised him that on my next visit I would arrange all the papers that would prove I was his daughter.")]), _vm._v(" "), _c('p', [_vm._v("That night, I went up with him to his room. I helped him in lying on his bed. He took out the key and said, “There is a bundle of money for you, my dear, take it and give me back the key.”")]), _vm._v(" "), _c('p', [_vm._v("I opened the drawer and took the money. A piece of paper caught my attention, which I had never seen before. I quickly took it, put it in my pocket, and closed the drawer. I gave him the key. I kissed him on his forehead, wished him a good night, and went to my room.")]), _vm._v(" "), _c('p', [_vm._v("I sat on my bed after locked the door. I opened the letter and read it. It was addressed to Mr. Malik.")]), _vm._v(" "), _c('p', [_vm._v("Dear Mr. Malik,")]), _vm._v(" "), _c('p', [_vm._v("We would like to inform you that your daughter left our school about three years ago; unfortunately, she was not good at studying. Moreover, her behavior was very bad with all the girls. She hit one of her classmates and mutilated her face. So, we had to transfer her to a special school for troubled girls. Your daughter is no longer under our care; she is under the care and responsibility of the police. Her mother is supervising her now, so please direct your messages to her mother.")]), _vm._v(" "), _c('p', [_vm._v("School principal.")]), _vm._v(" "), _c('p', [_vm._v("Gosh! So he has a daughter, what if she comes back one day and knows that he put me in her place, no, I will not accept to be his daughter; thank God I did not agree so far.")]), _vm._v(" "), _c('p', [_vm._v("I said goodbye to him in the morning. I was very tired. He asked me, “What’s wrong, darling?”")]), _vm._v(" "), _c('p', [_vm._v("“I never slept yesterday, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“So go to bed now; you can leave tomorrow. Why are you hurrying?”")]), _vm._v(" "), _c('p', [_vm._v("“I have to go now, everyone is waiting for me. I also have a lot to do.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, don’t be late for me.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not be late.”")]), _vm._v(" "), _c('p', [_vm._v("I was very sad for him, at the same time, I was afraid of his daughter.")]), _vm._v(" "), _c('p', [_vm._v("I came home exhausted and distracted. I went to my room immediately and lay on my bed. Nader followed me; it was the first time he entered my room.")]), _vm._v(" "), _c('p', [_vm._v("He asked me, “Didn’t you notice me?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “I’m sorry, how stupid I am, I didn’t notice anyone!”")]), _vm._v(" "), _c('p', [_vm._v("He asked me resentfully, “Am I like anyone else?”")]), _vm._v(" "), _c('p', [_vm._v("I went towards him and grabbed his hand; he pulled me to him and surrounded me with his arms, and whispered in my ear, “I love you so much.”")]), _vm._v(" "), _c('p', [_vm._v("I quietly turned away from him and said, “I am so tired.”")]), _vm._v(" "), _c('p', [_vm._v("Before I finished my word, he said, “I’ll let you rest and see you in the evening.”")]), _vm._v(" "), _c('p', [_vm._v("How do I rest? Oh my God; he finally said it, but he thinks that I am the daughter of Malik. Yes, he is sure that I am Malik’s daughter. If he knows the truth, he will leave me and despise me. Oh my God, he loves me! Do I love him too? Perhaps, he is very suitable for my dreams. He is a nobleman and he has money. He is just like Karim, the nobleman of our city. So I must be Malik’s daughter, but what if his daughter comes back? Oh my God; what a confusion!")]), _vm._v(" "), _c('p', [_vm._v("I don’t think she will come back, and if she does, she is a troubled and liar girl.")]), _vm._v(" "), _c('p', [_vm._v("I took out the paper that I forgot to put back in the drawer and tore it up, if it stayed, it might be proof that I’m not his daughter.")]), _vm._v(" "), _c('p', [_vm._v("Maybe I will say that I am Malik’s daughter from another wife; yes that is the best solution. I will stay here for a week; I will return to Malik house and tell him that I am agreeing to be his daughter. I will be Nader’s wife; I will not lose him as I lost the Nobleman Karim. He loves me and suits me, but he should know that I will not leave my family and my land. What about Hazem? What will he do? Will he accept that? How tired I am! I have to sleep.")]), _vm._v(" "), _c('p', [_vm._v("Hazem entered my room. He was very sad and hurt. I have never seen him so sad like today. He said, “He entered your room? What was he doing here?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him angrily; I must end this forever.")]), _vm._v(" "), _c('p', [_vm._v("“None of your business.”")]), _vm._v(" "), _c('p', [_vm._v("“What was he doing? He’s a bad guy; whoever enters a girl’s room like this is bad. I have a bad feeling about him.”")]), _vm._v(" "), _c('p', [_vm._v("“And you, what are you doing here? How do you enter my room like that? Whoever enters a girl’s room like this is bad!”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not him; don’t ever compare me with anyone. How awful what you did! You let a strange man enter your room; I didn’t expect that from you!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily after he had provoked me, “Get out now, I don’t want to see you again!”")]), _vm._v(" "), _c('p', [_vm._v("“Who told you that I want to see you after today?”")]), _vm._v(" "), _c('p', [_vm._v("“So leave and don’t come back.”")]), _vm._v(" "), _c('p', [_vm._v("He gave me a look that I will never forget. He murmured before leaving, “He is too bad.”")]), _vm._v(" "), _c('p', [_vm._v("I was very tired, I had to sleep for a while; I will think of Hazem when I wake up.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, I woke up to Laila’s voice, as usual.")]), _vm._v(" "), _c('p', [_vm._v("“Come on, lazy one, dinner is ready; we are all waiting for you.”")]), _vm._v(" "), _c('p', [_vm._v("Nader did not come as he promised me; maybe he had something important to do. We all sat around the table; it was a delicious dinner. But I was distracted and absent-minded; I felt that something bad will happen. Hazem was sitting with us as if nothing had happened.")]), _vm._v(" "), _c('p', [_vm._v("Hazem began to speak, “Thank God, the land has fully recovered and we have begun to cultivate it.”")]), _vm._v(" "), _c('p', [_vm._v("I answered happily, “That’s great! It will come back as it was and we will benefit from it.”")]), _vm._v(" "), _c('p', [_vm._v("“Nader helped us a lot, and it’s all for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, but you’re the one working on it day and night.”")]), _vm._v(" "), _c('p', [_vm._v("“I did all this for you, too.”")]), _vm._v(" "), _c('p', [_vm._v("“For our sake; for all of us Hazem, we are all live from this land.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s for you, Zaina; I work on the land because it’s your land.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily, “If the land does not exist, then what will you do?”")]), _vm._v(" "), _c('p', [_vm._v("He was provoking me, I was never reassured; I was very afraid of him.")]), _vm._v(" "), _c('p', [_vm._v("Maryam felt that the tension between us was rising, so she cut off the conversation.")]), _vm._v(" "), _c('p', [_vm._v("“Zaina is right; we all eat from the bounties of the land. We work for all of us, but Zaina is working very hard, actually, she is working more than all of us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, this is enough. Calm down everyone. Hazem only meant to impress you, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“I said from the beginning that he is the best of us. Basically, without him, the land would never recover. It is enough. Please, I suffer from a severe headache.”")]), _vm._v(" "), _c('p', [_vm._v("The door was knocked; Sarah opened it; Nader and his brother Ashraf were at the door.")]), _vm._v(" "), _c('p', [_vm._v("Laila got up quickly and greeted Ashraf warmly; I felt that they were constantly meeting each other.")]), _vm._v(" "), _c('p', [_vm._v("I smiled, invited them to come in, and asked Maryam to prepare tea and some sweets for the guests.")]), _vm._v(" "), _c('p', [_vm._v("I was not dressed elegant clothes as usual; I was wearing a long white nightgown, and I put a dark blue scarf on my shoulder. My face looked tired and pale. Nader felt me; he asked me fearfully, “Are you okay, dear?”")]), _vm._v(" "), _c('p', [_vm._v("Before I could answer him, Maryam fell on the ground. Sarah cried aloud,-“Mom, what’s wrong with you?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem carried her and put her on the sofa. I was very afraid for her. Nader tried to calm me down.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry, Ashraf is a doctor, he’ll tell us what’s wrong with her right away.”")]), _vm._v(" "), _c('p', [_vm._v("Ashraf tried to check her but he couldn’t because we all were around her.")]), _vm._v(" "), _c('p', [_vm._v("“I can’t check her, please take the girls out; he addressed his words to Laila.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I’ll take them and we all go out, Laila stays by her side, come on girls, let’s go out, she’s fine, don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("We sat in the room next to the hall. I was waiting nervously. Something was hitting me in my heart; it is not good at all. Nader tried to talk to me a lot but I didn’t pay him any attention. My mind was confused and the headache almost pierced my mind.")]), _vm._v(" "), _c('p', [_vm._v("Ashraf came out smiling.")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, she’s fine, and it’s just pregnancy marks.”")]), _vm._v(" "), _c('p', [_vm._v("I shouted at him, “What pregnancy?”")]), _vm._v(" "), _c('p', [_vm._v("Nader looked at me and said, “Didn’t you tell me that her husband was dead?”")]), _vm._v(" "), _c('p', [_vm._v("Ashraf was surprised.")]), _vm._v(" "), _c('p', [_vm._v("“Dead! How do? She told me her husband would be happy to hear this news, she was so happy!”")]), _vm._v(" "), _c('p', [_vm._v("I said in astonishment, “Happy! And her husband! What is happening?”")]), _vm._v(" "), _c('p', [_vm._v("Nader was so angry; he drew me to him forcefully.")]), _vm._v(" "), _c('p', [_vm._v("“You don’t know what’s going on in your house? A pregnant woman and you don’t know. How stupid you are?”")]), _vm._v(" "), _c('p', [_vm._v("I pulled myself hard from his hands and shouted at him, “I am not stupid, and I have no right to interfere in her life. If she says she is married, then she is.”")]), _vm._v(" "), _c('p', [_vm._v("He was completed disgusted.")]), _vm._v(" "), _c('p', [_vm._v("“I doubt that.”")]), _vm._v(" "), _c('p', [_vm._v("I shouted at him, “Don’t ever think of her that way; get out of my house right now.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “You’re kicking me out! You are a stupid and naïve lady. You defend her; perhaps you are satisfied with her behavior!”")]), _vm._v(" "), _c('p', [_vm._v("“Get out now and never come back again.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam, after having regained some of her strength, replied to him, “I am married, sir, and I am a free lady; I take no commands from anyone.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at her with regret and left. Ashraf apologized for his brother’s wrath and left.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Maryam and asked her, “Are you really married?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Yes, I married Faris, but we got married in secret.”")]), _vm._v(" "), _c('p', [_vm._v("I said in astonishment, “Faris! Didn’t I tell you to stay away from him? You would ruin this house, and I lost Nader because of you. You wouldn’t lose anything if you told me before; I became a stranger in my house!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Please calm down, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I said in disgust, “You’re not married, too? I see that your relationship with Ashraf get stronger, what’s up?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Never, I swear to you. Sometimes we meet in a café, but there is nothing serious between us.”")]), _vm._v(" "), _c('p', [_vm._v("“How will Nader return? We become like whores in his eyes. How idiot I am!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I’m leaving, I promise, I’m leaving with my daughters tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("I said firmly, “No one will leave, don’t say that again. This is your home; you have no place but here. As for me, I will go tomorrow and sit with Malik to recover.” I turned to Hazem, who was unusually quiet. “I see you silent? You are strange.”")]), _vm._v(" "), _c('p', [_vm._v("He answered me coldly, “I told you that he is bad, and then he has nothing to do with my sister. I promised you in advance that I would not be angry in front of him, and I am fulfilling the promise, or I would cut off his tongue.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room with tears filling my eyes and pain hit my heart. I sat on my bed and started crying. My head almost exploded; I was already suffering from a headache, and now the pain began to spread throughout my whole body. Hazem followed me and sat next to me, he hugged me while I was collapsing.")]), _vm._v(" "), _c('p', [_vm._v("I said painfully, “By what Maryam did, the family will be destroyed.”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll leave in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t let you go. You want to leave me! Who will take care of the girls and the land? Then, what is the fault of her girls and Laila with what she has done? Oh my God. If Salma knew, she would ruin us.”")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t you fire me in the morning?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“Why did you enter my room, you crook, and you are hugging me too. How bad you are!”")]), _vm._v(" "), _c('p', [_vm._v("I kept talking until I fell asleep from the severity of the headache while I was still between his arms. He put me on my bed.")]), _vm._v(" "), _c('p', [_vm._v("In the morning, he knocked on the door. He came in with the breakfast tray in his hand. I was sitting on my bed. I was still suffering from a bad headache.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Eat your breakfast and take a sedative.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to Malik; please get me a taxi to take me there.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', [_vm._v("“Please, I’ll eat and get dressed, quickly, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, but you have a guest in the hall. Get dressed and follow me… I want to ask you a question, Zaina. Do you really love Nader?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and burst into tears.")]), _vm._v(" "), _c('p', [_vm._v("“I don’t think I like him, but he’s a nobleman.”")]), _vm._v(" "), _c('p', [_vm._v("“I was sure of that. I’ll wait for you downstairs, don’t be late.”")]), _vm._v(" "), _c('p', [_vm._v("I took a small piece of bread just to drink the sedative; I had no desire to eat.")]), _vm._v(" "), _c('p', [_vm._v("I got dressed and went downstairs. I called out to Hazem, “Is the car ready?”")]), _vm._v(" "), _c('p', [_vm._v("“He’ll come in a quarter of an hour.”")]), _vm._v(" "), _c('p', [_vm._v("“Good.”")]), _vm._v(" "), _c('p', [_vm._v("He called me from afar, “Come on, you have a guest here.”")]), _vm._v(" "), _c('p', [_vm._v("I entered the guest-room and the guest was Nader. I was very happy from inside to see him, but I showed him contempt and anger.")]), _vm._v(" "), _c('p', [_vm._v("“What is this man doing here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “He wants to talk to you; I’ll leave you alone and go outside to wait for the car.”")]), _vm._v(" "), _c('p', [_vm._v("Nader looked at me tenderly and said, “My name is Nader, not that man!”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want? I’m traveling and I don’t have time to talk, quickly, tell me what you have.”")]), _vm._v(" "), _c('p', [_vm._v("“Hazem visited me; he told me that his sister was married to a man called Faris in secret. And she hid that from you because his wife was one your friend who was jealous of you. You know the evil nature of your friend so you tried to stop that marriage. You were afraid that the spiteful wife would hurt Maryam and her little girls. He told me that she was the one who flooded the land in agreement with Rasha. I am sorry; I was so reckless. Please forgive me; I promise I will not bother you again. I did that because I love you and I don’t want you to be hurt. Please live with your father and leave them the house and the land. You can visit them every two or three months.”")]), _vm._v(" "), _c('p', [_vm._v("“Please leave.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me sadly and said, “Won’t you forgive me?”")]), _vm._v(" "), _c('p', [_vm._v("“Please leave.”")]), _vm._v(" "), _c('p', [_vm._v("“I was very cruel to you, and now you are reciprocating the same cruelty to me. I love you, Zaina, forgive my recklessness. I will leave now; take your time to calm down and we will talk later.”")]), _vm._v(" "), _c('p', [_vm._v("He left quietly. The car arrived; it was Malik’s car. When Hazem went to Nader, he asked him to call Malik to send me the car and take me there.")]), _vm._v(" "), _c('p', [_vm._v("I got into the car quickly without saying goodbye to anyone, and I didn’t even tell Laila what to do in my absence.")]), _vm._v(" "), _c('p', [_vm._v("I should have bid farewell to Hazem; for his attitude is unforgettable. Despite all the love he carries in his heart for me, he went to Nader and persuaded him of the marriage of his sister. He worked hard to make me happy; I will never forget his attitude.")]), _vm._v(" "), _c('p', [_vm._v("My God, how does Nader think that I can allow a girl to sleep with a man and get pregnant from him without being married him? Does he not know that I am an honest pure girl?")]), _vm._v(" "), _c('p', [_vm._v("He must be punished for what he had done. If he really loves me, he must be confident that I have morals and principles in my life. He said that he was reckless; what should I do. It is very exhausted; I am no longer able to distinguish right from wrong.")]), _vm._v(" "), _c('p', [_vm._v("It only happened on the day when he told me that he loved me; he loved me in the morning and scolded me in the evening. He must be disciplined; even if I will die in his absence, he must be punished.")]), _vm._v(" "), _c('p', [_vm._v("How sweet Hazem’s heart is. I hope if Hazem’s heart settled inside Nader’s body. Oh my God, is it possible for a heart like this to be mine alone and let it flow from my hands.")]), _vm._v(" "), _c('p', [_vm._v("I shouldn’t think like this; it is better to keep Hazem as my brother so I will never lose him. When the lover annoys you or hurts you, the idea of leaving him is existed. So, if Nader hurts me, I will easily leave him, while I can’t imagine life without Hazem.")]), _vm._v(" "), _c('p', [_vm._v("How beautiful a heart is when gives you everything even though it might suffer; Hazem gives me his heart and feelings and everything amazing in the world.")]), _vm._v(" "), _c('p', [_vm._v("Hazem bears the bitterness of my love for another man in order to make me happy. I wish I could carry his heart between my arms and fly him high away from the misery of the world.")]), _vm._v(" "), _c('p', [_vm._v("I arrived at Malik’s house, tired and dilapidated. He was waiting anxiously at the door, leaning on his crutch. His eyes were almost popping out of his head while he was looking at the car entering the gate towards him. I got out of the car and fell on his chest, crying and complaining of my severe headache.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “It’s okay, my dear, cry as you like. Cry and empty your heart from pain.”")]), _vm._v(" "), _c('p', [_vm._v("Nader’s car was right behind me. Nader got out of the car and ran towards me.")]), _vm._v(" "), _c('p', [_vm._v("As soon as I turned to him, I fell out of fatigue; Nader caught me in his arms and took me to my room.")]), _vm._v(" "), _c('p', [_vm._v("He put me in my bed; everyone was very worried about me. Malik called his doctor, Mr. Ahmed, immediately. I was delirious and chanting the name of Maryam and Salma. I knew that what Maryam had done would only bring us great disaster.")]), _vm._v(" "), _c('p', [_vm._v("I stayed in that fever for three days. Nader never left us. He stayed by the bed. He definitely felt guilty and that he was the reason for what happened to me. I opened my eyes and found Malik standing near my head.")]), _vm._v(" "), _c('p', [_vm._v("He said happily, “Finally, the little troublemaker regained her consciousness.”")]), _vm._v(" "), _c('p', [_vm._v("Nader was standing next to him, smiling; his smile was full of sadness. He said in a calm, sad voice, “We almost died of fear for you.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “How long have I been like this? Where is Hazem? I always saw him next to me when I open my eyes!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Three long, ugly, boring days and Hazem is at home, my dear.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Come on, my sweetheart; we will leave you with Dalal to help you in changing your clothes. Have a shower, while I ask the servants to prepare food. Today is a feast; my little girl woke up!”")]), _vm._v(" "), _c('p', [_vm._v("They left the room. With Dalal’s help, I got up from my bed, took a quick shower, and got dressed. I asked her, “How long has Nader been here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Since you came; he has not left you for a moment. He has been very worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("I went down to them; l looked so beautiful and elegance. Nader stood up when he saw me. He smiled but his smile was mixed with fear of my reaction to him.")]), _vm._v(" "), _c('p', [_vm._v("He thought that I would not talk to him or that I would expel him again, but I was very calm. I headed toward Malik and kissed him on the forehead and sat down on a chair next to him.")]), _vm._v(" "), _c('p', [_vm._v("I turned to Nader and said, “Thank you for staying by my side while I was sick. There was no need to bother you with me; my father is here and everyone here is taking care of me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Not at all, thank God you are fine.”")]), _vm._v(" "), _c('p', [_vm._v("“I thank you.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at Malik and said, “Did you know what Maryam has done?”")]), _vm._v(" "), _c('p', [_vm._v("She got married in secret and now she’s pregnant and hasn’t told anyone. (I meant to say this in front of Nader so he makes sure that I wasn’t aware of anything, and I was just as upset as him and more.)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “It’s okay, my dear; she is free. We have no authority on her.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “No, not accepted at all; as long as she lives in a respectable house, then she should respect its owners. She would have brought shame to the house. If her brother had not known about it, Mr. Nader would not have believed that we did not know about her marriage, and he would have thought that I had notorious ladies in my house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I know who you are, Zaina. I was just annoyed by her behavior and her indifference to you. She had to tell you before anybody else; if she has done that, no one would doubt her. She should think about all the ladies inside your house, and keep the bad reputation away from them.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Who knows me well never thinks badly about me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “You are absolutely right, but it’s okay to be wrong sometimes; we are not all angels, then mistakes and misunderstandings strengthen relationships.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him while I was looking at Nader, “Not that way, there are unforgivable mistakes.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I did not intend to make a mistake, but I was upset that you did not know who you entrusted with your house and land. I am telling you again, I was afraid that they would affect your reputation.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “I am a strong and wise woman; I know how to behave with people, especially with my girls.”")]), _vm._v(" "), _c('p', [_vm._v("He answered smiling, “No wise person describes himself as wise! As for me, I am a reckless person who has erred in using his wisdom because of his arrogance. Please forgive me.”")]), _vm._v(" "), _c('p', [_vm._v("Malik smiled and said, “Come on, my sage, how many times does he have to apologize to you?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him while my eyes were full of reproaches, and added, “Just for Malik, I’ll forgive you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “She calls me by my name like that when she is compelled to do what I want.”")]), _vm._v(" "), _c('p', [_vm._v("Nader said sadly, “It is okay if it is for you or for anyone, the most important thing is to forgive me, because I love her very much.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “He dares to say he loves you in front of me because he knows that I trust him and certain that he wouldn’t hurt you.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone smiled from his heart, Malik was good at softening the atmosphere.")]), _vm._v(" "), _c('p', [_vm._v("After the lunch, Nader asked permission to leave; he had to go back to work and check on his affairs. He bid us farewell after expressing his happiness with my recovery, and promised me that he would come to visit me very soon.")]), _vm._v(" "), _c('p', [_vm._v("Malik and I entered his office; he asked me to tell him what happened in detail and with the full truth. I told him everything.")]), _vm._v(" "), _c('p', [_vm._v("I told him how afraid I was of Salma’s revenge on Maryam. Malik was very upset about what happened and was very afraid for me.")]), _vm._v(" "), _c('p', [_vm._v("He said, “Why don’t you leave the house and the land to them and live here with me. Why do you care so much about them? I am afraid you will get hurt.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t, how I leave them and they are my family. You do not know how much I love them and fear for them. We have supported each other for many years. How I abandon them now when they need me most!”")]), _vm._v(" "), _c('p', [_vm._v("“What are you going to do now?”")]), _vm._v(" "), _c('p', [_vm._v("“I will stay here to rest from the shock, and I will think of a solution if Salma finds out about Maryam. We must be prepared for any reaction from Salma.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you thought about my offer? It is better for you now to change your last name. You must be conscious, if you become my daughter, no one will be able to touch you.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, but I will not abandon my girls, and I must stay with them for long periods.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay; we’ll finish the formal documents tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("He knew I didn’t want to sit there much anymore, and he also knew I agreed to be his daughter because of Nader.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, he prepared the paper that proved I am his daughter. Now I am Zaina Malik instead of Zaina Fouad.")]), _vm._v(" "), _c('p', [_vm._v("I threw away my lineage and my origin. I get rid of my miserable history and my painful past. I changed my name and I no longer have sisters. I became a noble lady, after I was a vegetable seller. I no longer had a mother; basically, I never considered her a mother to me, she was only Salma’s mother.")]), _vm._v(" "), _c('p', [_vm._v("What saddened me that I threw my father away from me; I didn’t belong to him anymore. I would have to burn his letter that he wrote to me, but I do not have to burn his picture and his memories inside me!")]), _vm._v(" "), _c('p', [_vm._v("I will never forget a time I spent to prove myself. The most beautiful thing is that there is no Salma in my life, that malevolent girl who takes any opportunity to destroy me. Only God knows what she is planning for us now.")]), _vm._v(" "), _c('p', [_vm._v("I spent a whole month with Malik. He told me everything about his life and work. He told me how I should preserve his wealth and property after him.")]), _vm._v(" "), _c('p', [_vm._v("He even told me that if I stayed with him, I would manage some of his companies myself. He also advised me to marry Nader. He insisted that he is an honest man and loves me very much, and he will protect my interests. Actually, I liked the idea of running things and companies.")]), _vm._v(" "), _c('p', [_vm._v("I missed everyone; I changed my name and my family, I changed my clothes and became the noble Zaina, but I will not change my friends and I will never dispense with Hazem, who harnessed himself to make me happy!")]), _vm._v(" "), _c('p', [_vm._v("I decided to go home with a lot of gifts for everyone. Malik did not stop me; on the contrary, he helped me and gave me money.")]), _vm._v(" "), _c('p', [_vm._v("I arrived there. They were all waiting in front of the house; it was a solemn reception. Three months passed and I had not seen them. Laila ran towards me and hugged me and started crying.")]), _vm._v(" "), _c('p', [_vm._v("“You fool, how dare you were to leave us for long period?”")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t stop my eyes from crying. I whispered in her ear, “I’ll tell you everything later.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam did not come near. She waved at me from a far; that was enough for me. The girls ran towards me; they were so happy to see me.")]), _vm._v(" "), _c('p', [_vm._v("Jawad approached me and said, “I won’t let you leave again until you write me your address.”")]), _vm._v(" "), _c('p', [_vm._v("He was absolutely right. I replied, “In the evening, I will write it for you on a piece of paper, but do not give it to anyone even Ghaith, do you promise?”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, I promise. I have a lot to tell you, but not right now.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, in the evening, come to my room, and we’ll talk alone.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem approached me shyly. I was happier when I saw him, how handsome and elegant he looked!")]), _vm._v(" "), _c('p', [_vm._v("He asked me, “How are you?”")]), _vm._v(" "), _c('p', [_vm._v("“Fine, thanks. I didn’t miss anyone like I missed you.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and held his hand and said, “I brought you a very beautiful gift; I hope you like it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “The important thing is that you are happy and well. Look at the land; it has fully recovered and will bloom soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, this is because of your will and your efforts. I will never forget what you have done for us as long as I live!”")]), _vm._v(" "), _c('p', [_vm._v("Laila grabbed my hand and led me towards the house, saying, “I will prepare for you delicious food. I used to enter your room every day and cry for your parting. Please do not leave me for long time again. I can’t imagine life without you.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I won’t be late again. Tell me now how you managed your affairs in my absence.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We ran out of money, but as usual, you are our savior. You sent the driver just on time.”")]), _vm._v(" "), _c('p', [_vm._v("He gave me the money, otherwise, I was about to go back to work in the market.")]), _vm._v(" "), _c('p', [_vm._v("“Thank God, you didn’t need anyone.”")]), _vm._v(" "), _c('p', [_vm._v("Listen, Laila; don’t make any food, the car is full of delicious food. Empty it and arrange everything.")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room happy because I found them safe. What did Jawad want from me? I will ask him in the evening, I will not bother myself now with anything.")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina came in and hugged me tightly and said, “There is something I want to tell you.”")]), _vm._v(" "), _c('p', [_vm._v("I felt that Laila, who was speaking and not Zaina. She looked like her mother in all her actions, as if she were an exact copy of her.")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “What is the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “My father came to visit us. He wanted to take me with him; he wanted to introduce me to the nobleman, but my mother refused that. A very big quarrel began between them. He slapped my mother on her face, then Hazem came and expelled him from the house.”")]), _vm._v(" "), _c('p', [_vm._v("The next morning, my mother and Maryam left and did not return until evening. My mother said, “Don’t worry, my dear, your father won’t come back here again. I convinced him not to come back.” My mother is so brave, isn’t she?")]), _vm._v(" "), _c('p', [_vm._v("I sat on the bed, shocked.")]), _vm._v(" "), _c('p', [_vm._v("I looked at her and said tenderly, “Yes, my dear, Laila is a very brave woman. How about you go and see what I brought you and send Laila to here.”")]), _vm._v(" "), _c('p', [_vm._v("She kissed me again on the cheek and called Laila, who came quickly, saying, “What is there? Maybe you’re hungry, just five minutes and everything will be ready.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her calmly and firmly, “Close the door and sit next to me!”")]), _vm._v(" "), _c('p', [_vm._v("She was scared by my tone.")]), _vm._v(" "), _c('p', [_vm._v("“What is there?” she asked me cautiously.")]), _vm._v(" "), _c('p', [_vm._v("“Tell me your husband’s story.”")]), _vm._v(" "), _c('p', [_vm._v("“What did little Zaina tell you?”")]), _vm._v(" "), _c('p', [_vm._v("“I want to hear from you.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I will not lie as Maryam did, you are the most important person in my life, but please accept it calmly.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll accept it, tell me what you have.”")]), _vm._v(" "), _c('p', [_vm._v("“He came after all those years of absence, he wanted his daughter, imagine that; he wanted to sell her to the nobleman too. If you were me, would you give him the girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not.”")]), _vm._v(" "), _c('p', [_vm._v("“So we agree. He hit me and insulted me in front of everyone, and then Hazem kicked him out forcefully. In the morning, I found a paper written on it: I will take the girl from you even if I have to steal her, and I will punish badly the man called Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was beside me when I was reading the paper. I burst in tears. He wanted to take my only daughter, my soul and life, what should I do?")]), _vm._v(" "), _c('p', [_vm._v("Maryam said, “It’s okay, there is a solution to your issue, but it is expensive.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “It’s okay. Your money arrived at the same rime. We took the money and went to one of Faris’s friends.”")]), _vm._v(" "), _c('p', [_vm._v("He said he could find him and stop him alone. I don’t know where to find my husband but he could find him and punish him.")]), _vm._v(" "), _c('p', [_vm._v("I described my husband to the man. He left us and came back two hours later. He said, “Please come with me.” We went with the man. Zaina’s father was in a bar with his friends, drinking wine in the middle of daylight.")]), _vm._v(" "), _c('p', [_vm._v("The man asked me, “Is this your husband, madam?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Yes, sir, he is.”")]), _vm._v(" "), _c('p', [_vm._v("He said, “Stand far away and never come close no matter what you hear.” He entered there and started a big fight with my husband. Then, two of his friends followed him and got into a fight. All the blows were directed at Zaina’s father until he fell on the ground. The police and ambulance came and took him to the hospital. Everyone in the bar testified that my husband was the one who started the fight.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, he passed away in the hospital. I have nothing to do with his death, believe me; I did not know that he had only this solution.")]), _vm._v(" "), _c('p', [_vm._v("I asked her angrily, “Why is death always your only solution?”")]), _vm._v(" "), _c('p', [_vm._v("She answered me with the same anger, “Why are we always put in such situations? Why did he come after all these years? Why did he wrong me and slap me? He almost kidnapped my daughter and sold her to a man who has no honor or dignity. Think well, why does the nobleman choose the most beautiful girls in the city? I am sure he’s messing with them!” She started crying and then added, “Please stop, my conscience still hurts me. I swear by God I did not know that he would kill him.”")]), _vm._v(" "), _c('p', [_vm._v("I hugged her and said, “It’s okay, he died now. What happened had happened. What is the story of Maryam? She became a professional criminal, should I worry from her?”")]), _vm._v(" "), _c('p', [_vm._v("“No, she loves you very much, and she will never forget your favor with her.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you give the guy all the money?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Where did you bring money for your outgoings?”")]), _vm._v(" "), _c('p', [_vm._v("“We sold the gifts you brought us.”")]), _vm._v(" "), _c('p', [_vm._v("I took a bundle of money out of my bag and gave it to her.")]), _vm._v(" "), _c('p', [_vm._v("“It’s for you. I don’t want you to sell anything again, and don’t kill anyone either.”")]), _vm._v(" "), _c('p', [_vm._v("“All of this? You got rich! Malik loves you very much.”")]), _vm._v(" "), _c('p', [_vm._v("“He’s my father now. We’ll talk later, but now I’m really hungry!”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll call you as soon as I’m done. Please don’t mention anything in front of girls.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t even mention it to myself, rest assured.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and went downstairs to make food, but she was devastated, having lost so much of her vitality after she had said all that was stuck inside her.")]), _vm._v(" "), _c('p', [_vm._v("Moments later, Sarah entered; I was afraid that she might have something stronger than what little Zaina had said. I felt how essential my presence in the house was! She jumped up to me and kissed me on the cheek and said, “I want to tell you something very important.”")]), _vm._v(" "), _c('p', [_vm._v("I told her with a sigh, “Have you conspired on me today?”")]), _vm._v(" "), _c('p', [_vm._v("“It is very necessary; do you want to listen or what?”")]), _vm._v(" "), _c('p', [_vm._v("She was as nervous as her aunt Laila; Maryam was more patient and quiet. I smiled from my heart and said, “Speak up, little girl.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “Note that I’m not little girl anymore. You know I love you very much.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I love you too.”")]), _vm._v(" "), _c('p', [_vm._v("“Truly?”")]), _vm._v(" "), _c('p', [_vm._v("I hugged her and said, “You, Zaina, and Lynn are just like my daughters.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “In general, I came to tell you an important matter. Ghaith and Jawad’s sister came to visit them. Jawad was very careful in talking to her, but she gave Ghaith some money. She sat with him for a long time and they talked a lot.”")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("His sister! How did the nobleman allow her to come to visit us? The girls, that the nobleman chooses, do not usually visit their families. Oh my God! Perhaps the nobleman did not see her; surely, Salma accepted her to work with her. Perhaps she sent her spying on us. Jawad would not tell her anything about us, I am sure of that, but Ghaith might tell her everything and easily. Thank God he is new here.")])]), _vm._v(" "), _c('p', [_vm._v("I grabbed her tightly and asked, “Why didn’t you hear what they said to each other?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah (cautiously):")]), _vm._v(" “Don’t be afraid, I heard everything and I told my mom too.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her angrily, “What did you hear? Tell me!”")]), _vm._v(" "), _c('p', [_vm._v("“First, she asked him about you. He told her that you are fine and working hard to restore the land as it was. He told her also that you are working abroad to earn money in order to repair the land.”")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Good, he didn’t mention Malik to her, maybe Jawad say nothing about Malik in front of him so he didn’t know him; that is good.")])]), _vm._v(" "), _c('p', [_vm._v("“What then?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “She asked him about Laila and my mother; he told her that he did not know anything about them. She asked him to pay close attention to everything going on in the house, and that she would come back soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Did he tell her about your mother’s pregnancy?”")]), _vm._v(" "), _c('p', [_vm._v("“No, but he asked me two days ago if my father came back? He observed that my mother is pregnant!”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “It’s none of your business.”")]), _vm._v(" "), _c('p', [_vm._v("“Well done, when is she coming back?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, but I can tell Ghaith everything you want to convey to Salma.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you find out about Salma?”")]), _vm._v(" "), _c('p', [_vm._v("“Ghaith asked her about her condition. She replied that she works for Salma and has never seen the nobleman.” ")]), _vm._v(" "), _c('p', [_vm._v("When I told my mother, she said, “Salma is evil and you all fear her.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my dear, we’ll think about it later, but now let’s go down and have breakfast. Open your eyes and watch everything for me.”")]), _vm._v(" "), _c('p', [_vm._v("As we were on the ladder, Lynn stopped us.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, do not go down, Zaina, I also want you with an important issue.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Come on, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("She quickly came up to me and grabbed my hand.")]), _vm._v(" "), _c('p', [_vm._v("“Come on to your room.”")]), _vm._v(" "), _c('p', [_vm._v("I was afraid of new crisis, as if everything had happened in my absence.")]), _vm._v(" "), _c('p', [_vm._v("We entered my room and sat on the bed. She put her tiny hands on mine and started talking.")]), _vm._v(" "), _c('p', [_vm._v("“My mother took my bracelet and promised me to bring me another one, but she did not.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Is that all you have to tell me?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t be sad, I’ll go tomorrow to the market and buy you a nicer necklace and a bracelet too; if you want.”")]), _vm._v(" "), _c('p', [_vm._v("“All right, necklace and bracelet.”")]), _vm._v(" "), _c('p', [_vm._v("She jumped out of joy and went down to tease Sarah and little Zaina. But of course they were sure I would buy them the same things.")]), _vm._v(" "), _c('p', [_vm._v("In the afternoon, I took the girls and Laila to the market. Maryam did not agree to go with us under the pretext of being tired, but she was very afraid of facing me. We spent two hours full of fun and love.")]), _vm._v(" "), _c('p', [_vm._v("I bought for the girls everything they wanted, for Laila as well. We did not forget Hazem, Jawad, and Ghaith. We even bought beautiful things for Maryam and the baby. I wish the baby gender be a boy, but if it is a girl, that will be fine. I bought a gift for Malik and Dalal.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, I sat on the chair under the window of my room, waiting for Hazem to return. He went to buy things for the land; I was waiting impatiently, I was eager to give him the things I had brought him. He appeared finally. He smiled as usual when he saw me. His smile was full of love and hope. He sat down next to me and said, “How are you, little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Won’t you stop calling me a little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“I will not stop, how is Nader? He usually waits for you, I didn’t see him today!”")]), _vm._v(" "), _c('p', [_vm._v("“He traveled for an important business.”")]), _vm._v(" "), _c('p', [_vm._v("“Surely, you meet him at Malik’s house!”")]), _vm._v(" "), _c('p', [_vm._v("“Not much, he’s been very busy lately.”")]), _vm._v(" "), _c('p', [_vm._v("“I am sure you miss him!”")]), _vm._v(" "), _c('p', [_vm._v("“I miss you more when I’m away from you.”")]), _vm._v(" "), _c('p', [_vm._v("“If you really miss me, you don’t stay there for long time.”")]), _vm._v(" "), _c('p', [_vm._v("“I am establishing a business that will benefit all of us. Now, tell me in details. What happened in my absence? Of course you had a difficult time.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing important happened; we got rid of Laila’s husband.”")]), _vm._v(" "), _c('p', [_vm._v("“And how’s that?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, he visited us and wanted to take his daughter. He quarreled a lot with Laila and hit her. Then I went in and pushed him to the ground. He and I fought. After that, Laila asked the girls to go up to their rooms. Mariam closed all the doors and windows and stabbed him with her knife.”")]), _vm._v(" "), _c('p', [_vm._v("“As I expected. Where did you throw his body this time?”")]), _vm._v(" "), _c('p', [_vm._v("“In the river, where shall I throw it?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, are you not afraid that someone will see you? Maryam will destroy you one day. You help them to kill; what’s wrong with you? Are you okay with this?”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t be sad, he deserves what happened to him.”")]), _vm._v(" "), _c('p', [_vm._v("“We are not the ones who decide the death of anyone. Tell me what happened else?”")]), _vm._v(" "), _c('p', [_vm._v("“Ghaith’s sister has come, Salma sent her to spy on us, but don’t be afraid; Maryam took care of her.”")]), _vm._v(" "), _c('p', [_vm._v("I rose angrily.")]), _vm._v(" "), _c('p', [_vm._v("“What did she do with her? Did she kill her too?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not; she didn’t attack her; why to kill her? Maryam only inserts her knife inside the hearts of those who attack her or her daughters.”")]), _vm._v(" "), _c('p', [_vm._v("“So what did she do with the girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t be angry, she wanted to ruin our lives.”")]), _vm._v(" "), _c('p', [_vm._v("“What happened to the girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Maryam locked her in my old room, and every day she sends her food and drink.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("I came home angry and upset. I called Maryam and Laila after I had sent the girls to their room. I addressed Laila first, “How long have you been lying to me? Aren’t we best friends?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What is it, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("She was nervous and confused. So I asked her my question that came down on her like a thunderbolt, “How did your husband die?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam from her place, quietly, said, “I killed him with my knife.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to her angrily.")]), _vm._v(" "), _c('p', [_vm._v("“Simply and quietly, as if you had butchered a chicken? How could you? You will wreck the house on our heads; you will destroy all that I have sought!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “He would have killed her and stole her daughter. If you were there, you would have done what I did.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will never kill anyone, and I’m not like you.”")]), _vm._v(" "), _c('p', [_vm._v("Laila, calmly and pent-up anger:")]), _vm._v(" "), _c('p', [_vm._v("“What now?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Nothing, release the girl.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “If I free her, she will go to Salma and tell her everything.”")]), _vm._v(" "), _c('p', [_vm._v("“Honor her and never be cruel with her. Tomorrow I will leave; I will go back to Malik’s house. I hope when I return, things will be fine.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You came today! Please don’t leave, stay for a few more days I really miss you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Please, Zaina, appreciate my situation. Well, I will stay in my room if seeing me bothers you.”")]), _vm._v(" "), _c('p', [_vm._v("I sympathized with them, of course they made a great mistake but they are my family and I love them so much. I should help them. In fact, they are miserable and helpless women.")]), _vm._v(" "), _c('p', [_vm._v("Although I was on the stairs heading to my room, I went back and asked Maryam to make coffee.")]), _vm._v(" "), _c('p', [_vm._v("Maryam brought coffee. We sat around the table.")]), _vm._v(" "), _c('p', [_vm._v("I started my speech with Maryam.")]), _vm._v(" "), _c('p', [_vm._v("“You won’t stay locked up in your room, but please stop killing people. Try to find solutions. Remove the idea of murdering from your head. Try to find a solution for the girl, and you must train Ghaith to keep your secrets.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “There are no secrets with him; he will not enter the house. His work is only outside; Jawad knows that and agrees.”")]), _vm._v(" "), _c('p', [_vm._v("I had completely forgotten about Jawad. I asked Laila to call Jawad while Maryam headed to the kitchen to make another cup of coffee.")]), _vm._v(" "), _c('p', [_vm._v("I knew how kind and powerless Laila was, and then she was a friend of my life. Even Maryam, what prompted her to do that was her defense of her girls.")]), _vm._v(" "), _c('p', [_vm._v("I wish things would go well; without any surprises. Who give the right to fathers to sell their girls? Mothers suffer and fathers care about nothing but money. Is there anyone defending the rights of these girls? Perhaps Maryam enacted a law to defend them.")]), _vm._v(" "), _c('p', [_vm._v("Jawad came to me eagerly.")]), _vm._v(" "), _c('p', [_vm._v("“How are you, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand and we headed to the guest room alone.")]), _vm._v(" "), _c('p', [_vm._v("I said quietly, “I am not fine, dear. Why did your sister spy on us?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “This is what I wanted to tell you; Salma is looking for her. I saw my mother yesterday; she asked me about her. In fact, she asked Gaith first but Ghaith does not know that she is here. Salma was able to communicate with my mother and asked her to look for my sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Take me to your sister now.”")]), _vm._v(" "), _c('p', [_vm._v("I was wearing a very elegant dress and expensive jewelry. I put my fancy hat on my head.")]), _vm._v(" "), _c('p', [_vm._v("We went to her. When she saw me, she said, “Look what they have done with me! I’ve been locked up here.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her quietly, “After all I’ve done for you, you’re spying on me for that evil girl.”")]), _vm._v(" "), _c('p', [_vm._v("“She is your sister!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and quietly continued, “I have no sisters; I am Zaina Malik, not Zaina Fouad. Salma’s sister died some time ago. I am the only daughter of the rich man; who he lived next to this house; I am managing all his properties.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “She said she’s your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, she has a sister named Zaina, but not me. I am the daughter of Mr. Malik. I bought the farm and the house from her sister before her death.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Jawad who understood me from a look.")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t you tell them who I am, my dear?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “I told my mother and Ghaith.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “Ghaith did not tell me.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “You know now. Look, I will free you. Moreover, I will find you a better job with a higher wage of course, but you have to leave working with Salma completely.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “She gave a lot of money to my mother; she threatened me if I did not tell her your news, she would get her money back. My mother, as soon as she took the money, she dispensed with all of us.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on her head gently and said, “You poor little girl, you will not return to her and I will solve the matter. You will not remain imprisoned after today. You will be like a daughter of Maryam and Laila. They will teach you the arts of embroidery and all beautiful things!”")]), _vm._v(" "), _c('p', [_vm._v("The girl jumped happily and said, “Truly! But what should we do with Mrs. Salma?”")]), _vm._v(" "), _c('p', [_vm._v("“Do not be afraid, my dear, I asked Jawad to bring your mother. I will discuss everything with her.”")]), _vm._v(" "), _c('p', [_vm._v("I took the girl and went home waiting Jawad’s mother. Laila was surprised to see her. I called Maryam. She appeared immediately. She looked at the girl stunned and asked me, “What are you going to do with her?”")]), _vm._v(" "), _c('p', [_vm._v("“Wouldn’t you like to have a beautiful daughter to teach her embroidery and beautiful things, and she helps you at home?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam loved that.")]), _vm._v(" "), _c('p', [_vm._v("“It would be better if I had a daughter her age, but no, Lady Zaina, she will tell Salma about our whole life.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “No, I will never go to her; Lady Zaina Malik will solve the issue with my mother.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “So you will not leave the house without my permission and you will do everything I ask you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “Well…everything you ask for.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I will prepare a room worthy of my daughter. Thank you, Lady Zaina Malik, for taking care of us.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad brought his mother, she was impulsive and angry. When she saw her daughter, she started screaming at her.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Shut up, woman, you will piss off the lady of the house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad’s mother:")]), _vm._v(" “Who? The vegetable seller!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “How ungrateful you are!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “The vegetable seller has passed away, my mother, and the lady here is Zaina Malik, she is the owner of the land and the house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad’s mother:")]), _vm._v(" “When did she die?”")]), _vm._v(" "), _c('p', [_vm._v("Laila, her heart almost stopped beating and tears started filling her eyes, as if it was true; as if I died.")]), _vm._v(" "), _c('p', [_vm._v("“My dear friend passed away a while ago.”")]), _vm._v(" "), _c('p', [_vm._v("I appeared after I changed my clothes. I put on a long oil luxurious dress; more expensive than I was wearing in front of her daughter, it was indicating that I am a noble lady. I put on my head a hat with a net to cover something from my eyes. I said arrogantly, “Who is yelling in my house?”")]), _vm._v(" "), _c('p', [_vm._v("Jawad, with a smile on his lips, said, “I’m sorry, my lady, she is sad for the good girl; the vegetable seller. The one that honored my mother in her ordeal.”")]), _vm._v(" "), _c('p', [_vm._v("The words came like a thunderbolt on his mother’s head.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The mother:")]), _vm._v(" “Yes, madam, I was very sad for her. She helped me, but how did she die?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “She could not bear what happened to the land, she was afflicted with a fever and died, and may God have mercy on her soul.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The mother:")]), _vm._v(" “May God have mercy on her soul. You asked to see me, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Yes, I knew you’ve been hovering around my house for a while… What’s the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The mother:")]), _vm._v(" “I want my daughter Samar, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“But she doesn’t want to go back to that wicked lady.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The mother:")]), _vm._v(" “But we owe her money.”")]), _vm._v(" "), _c('p', [_vm._v("I took out a bundle of money and gave it to Jawad.")]), _vm._v(" "), _c('p', [_vm._v("“Go to that lady and give her money, and tell her that your sister will not work with her anymore. If she asks you where the money comes from, tell her from the new owner of the house (Zaina Malik) and if she asks you about her sister, tell her that she died because of a fever.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The mother:")]), _vm._v(" “I have to hand her the money myself.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “No, but if you want to go with him, that’s fine.”")]), _vm._v(" "), _c('p', [_vm._v("They went to Salma, and as I expected, she asked them about me. Jawad replied, “She died of a fever.”")]), _vm._v(" "), _c('p', [_vm._v("Her shock was very great. I expected that she would come to the house to make sure of the news. She would also ask about the price of the house; she wanted to inherit me, but I had an answer for everything.")]), _vm._v(" "), _c('p', [_vm._v("I asked Maryam to stay in her room if Salma came.")]), _vm._v(" "), _c('p', [_vm._v("I adjusted my hat so that my eyes would not be visible.")]), _vm._v(" "), _c('p', [_vm._v("Laila prepared well to meet her, as she bears the hatred of the world towards her. I felt as if she would carry her knife and implant it in her heart! But of course she will not. Maryam went upstairs and convinced the girls that I had no sisters, and that my name was Zaina Malik. Of course, it was easy to convince them because they did not see any of my sisters, except when they were very little; surely, they did not remember them.")]), _vm._v(" "), _c('p', [_vm._v("Salma came and her eyes were full of grudge and hatred. My mother was with her. Laila greeted them coldly.")]), _vm._v(" "), _c('p', [_vm._v("“Hey, what do you want?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Where’s Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("Laila cried again, as if I had really died. She was never able to comprehend my death, what a woman! Or perhaps she felt that her friend Zaina had disappeared and a completely new Zaina would appear from today!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Did you not hear of her death?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “My daughter died?”")]), _vm._v(" "), _c('p', [_vm._v("I appeared from afar when I heard her voice; she did not recognize me at all. I answered her with a slight change in my tone of voice.")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, madam, she died of a fever.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Why didn’t anyone tell us?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Have you ever asked about her? Did she know an address for you? Even Reem did not invite her to her wedding.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Enough, the girl is dead now and you are at my house, what do you want?”")]), _vm._v(" "), _c('p', [_vm._v("My mother sat on the chair in shock, but Salma was only concerned with money.")]), _vm._v(" "), _c('p', [_vm._v("She said in a nasty way, “The house for my sister and we will inherit it, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “The house and the land are mine. When your sister bought the house, she borrowed money from me. Even the land, it was originally belonged to my father and she rented it from him. When the land sank, everything became mine. Actually, she mortgaged the house for the land. I have the paper that proves everything. You can ask the lawyer. Please do not come here again, and do not send spies on my life. I will sue you if I see any of your workers. Ask your nobleman who Mr. Malik is!”")]), _vm._v(" "), _c('p', [_vm._v("She was afraid of my words.")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t send anyone, the girl is a liar!”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Then return the money I sent you with Jawad.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “No, madam, I paid the girl’s mother to work for me, and now I have nothing to do with her or her mother.”")]), _vm._v(" "), _c('p', [_vm._v("She looked at Laila and asked her cunningly, “Where is Maryam?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She’s gone from here.”")]), _vm._v(" "), _c('p', [_vm._v("Salma smiled and said, “Well, fine, I’ll find her.”")]), _vm._v(" "), _c('p', [_vm._v("She turned to me and said, “Sorry, Lady Zaina, for disturbing you. I hope to see you soon.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to my mother and said, “I regret the death of your daughter, madam.”")]), _vm._v(" "), _c('p', [_vm._v("I left them and went up to my room.")]), _vm._v(" "), _c('p', [_vm._v("Laila addressed them resentfully, “The visit is over and the lady wants to have a rest.”")]), _vm._v(" "), _c('p', [_vm._v("Salma left as if she hadn’t lost her sister; she didn’t shed a tear nor pretended to be sad. Perhaps the best decision I made in my life was that I became the daughter of Malik, and abandoned my family that did not want me in the first place.")]), _vm._v(" "), _c('p', [_vm._v("My mother appearance broke my heart. I wanted to run towards her and embrace her, but she would never allow me to cuddle her; she was always cruel to me. I felt that my soul was going to flee from me!")]), _vm._v(" "), _c('p', [_vm._v("Laila came in and hugged me while crying.")]), _vm._v(" "), _c('p', [_vm._v("“You didn’t die, you wouldn’t leave me. You know, your mother said before she went out that she wanted to say goodbye to you before you died.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “First, I did not die and I will not leave you. Secondly, she did not and will not say anything. Perhaps she grieved a little, but no stronger reaction will come from her than that.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She said it, I swear!”")]), _vm._v(" "), _c('p', [_vm._v("I said with tears in my eyes, “It’s okay, let’s consider today a goodbye day.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam entered smiling. She said joyfully, “How wonderful you are, Zaina. I have three girls, and the one I carry inside me, if it is a girl, I will have four beautiful daughters.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed and said, “I swear if you have ten girls, you would be happier.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Ten, great idea, maybe someday I’ll have ten girls.”")]), _vm._v(" "), _c('p', [_vm._v("Laila laughed, she knew how much I am suffering, and my laugh was full of sad and pain.")]), _vm._v(" "), _c('p', [_vm._v("She said quietly, “I’m hungry.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Girls too, change your clothes Zaina and come to have a long dinner with us.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Wait, you have to find a solution for Ghaith, you have to take care of him, Maryam.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Don’t worry, we’ll find a solution for him.”")]), _vm._v(" "), _c('p', [_vm._v("They left me to change my clothes. I sat on the bed and started crying. I felt like I was suffocating. Hazem entered my room angry, but my situation calmed him down.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, you didn’t die, thank God!”")]), _vm._v(" "), _c('p', [_vm._v("Despite my distress, his reaction made me enter in hysterical laughter!")]), _vm._v(" "), _c('p', [_vm._v("He smiled in confusion and said, “What is the matter? I saw Jawad swearing to his mother that Zaina died of a fever. I came running. I was about to fall down many times because of you; I imagined that you were a dead body.”")]), _vm._v(" "), _c('p', [_vm._v("I stood in front of him and put my hand on his cheek and said, “Are you afraid for me?”")]), _vm._v(" "), _c('p', [_vm._v("“So much. Don’t you know how much I fear for you?”")]), _vm._v(" "), _c('p', [_vm._v("“Sit down and I’ll tell you everything.”")]), _vm._v(" "), _c('p', [_vm._v("I told him everything that happened. He answered me angrily, “Was your death necessary?”")]), _vm._v(" "), _c('p', [_vm._v("“Very, my dear, there is no need any longer for the presence of the vegetable seller’s Zaina. We should change our life.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Did you do that for Nader?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “Rather, for all of us. This family should live in honor and dignity. I do not know if Nader is suitable for me yet, but all I know that Malik has great wealth, and there is no one to inherit him. We are in a deplorable condition and he is the one who provides us with money. If I leave Malik, my dear, we will return as sellers. Time changes, and don’t forget the big vegetable stores in the country, we don’t have a big chance in the market. So, Zaina Fouad must die for all of us first, as for Nader, I don’t know anything about my feelings toward him yet.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “You did not die, and if anyone came near you, I would kill him. I am ready to die for you.”")]), _vm._v(" "), _c('p', [_vm._v("With a look full of love and tenderness, I said, “No one will die. I am responsible for you and I will take care of you as long as I live.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Believe me, there was no need to change you. You have your house and your land. A beautiful woman with a big heart,; why do you need all this? What a girl you are!”")]), _vm._v(" "), _c('p', [_vm._v("As usual, Laila’s voice interrupts any dialogue.")]), _vm._v(" "), _c('p', [_vm._v("“The food is ready.”")]), _vm._v(" "), _c('p', [_vm._v("I have always been afraid of the truth of Hazem’s words; many times, he says things and they become true. Who said that life does not teach wisdom more than books! Despite his ignorance and simplicity, he was immersed in life and knew how to face it.")]), _vm._v(" "), _c('p', [_vm._v("Samar enjoyed life with us and obeyed Maryam as if she were her mother. Ghaith couldn’t stay away from his mother any longer.")]), _vm._v(" "), _c('p', [_vm._v("Jawad went to her more than once to convince her to take Gaith to live with her, but her husband was completely against it.")]), _vm._v(" "), _c('p', [_vm._v("Ghaith was very sad and he stops eating food. He got ill; we brought him the city doctor. Maryam did not leave him until he recovered. What a lady! She had the most compassionate heart in the world toward kids despite all the cruelty against men. Perhaps she is really defending those who approach her and her girls. I no longer have anything against her in my heart; on the contrary, I respect her even though I am still against killing. She holds a heart of a mother, no one in the universe holds like it.")]), _vm._v(" "), _c('p', [_vm._v("Ghaith recovered after a week. He remained silent and did not speak for another week. With the help of Samar and Jawad, he recovered fully. Maryam was the closest to him.")]), _vm._v(" "), _c('p', [_vm._v("He depended on her in everything, and was telling her everything! But he used to sleep in his room with Jawad. The rules remain stable, the girls in our house and the boys in Jawad’s house. Even Jawad considered Maryam as his mother! But he was ashamed of her; he remained my little friend and my watchful eye for everything.")]), _vm._v(" "), _c('p', [_vm._v("I was late for Malik; I was late for him for about a week. He was very sad from me; I tried to please him in various ways until he forgave me. He was kind-hearted and loved me very much.")]), _vm._v(" "), _c('p', [_vm._v("He was very eager to hear from me everything that happened in my house. I feel relieved when I tell him my problems and concerns; he always finds solutions for me and advises me!")]), _vm._v(" "), _c('p', [_vm._v("He admired the strength of my friends, but I did not tell him anything about how Laila’s husband died. I will never tell him that my friends are killers. He wouldn’t understand that they are protecting their girls from their greedy fathers. Ghaith’s condition disturbed him and he recommended me to take care of him. He was very happy that Zaina Fouad had died, and there is now only one Zaina, who is his daughter.")]), _vm._v(" "), _c('p', [_vm._v("The next day, Nader came; he finally came back from his trip. I missed him so much, he brought gifts for me and Malik, and he also brought a gift for Dalal. We spent two amazing days like a dream!")]), _vm._v(" "), _c('p', [_vm._v("My visit to Malik ended quickly; I went back to my house. I was afraid of new surprises like the last visit, but, thankfully, there were no sad surprises. Everyone was fine and waiting for me. We also spent beautiful days.")]), _vm._v(" "), _c('p', [_vm._v("When I wanted to return to Malik, Laila asked me, “Your absence is tiring, how long are we going to stay like this?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “I don’t know, my dear, but I promised him that I would spend my month like this, half here and half there.”")]), _vm._v(" "), _c('p', [_vm._v("As I was getting into the car, a woman called me from afar, “Zaina, you are my daughter Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("Laila asked me to get in the car quickly and leave; she will take care of her. My heart was with the woman. I watched her while I was in the car, she was my mother. Unfortunately, I cannot beat back my death decision!")]), _vm._v(" "), _c('p', [_vm._v("She met Laila in front of the house. She asked her eagerly, “Isn’t that girl my daughter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “No, my dear, she is Lady Zaina Malik.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “But she’s my daughter.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I am sorry, your daughter is dead. I beg you to leave and not come back here again, otherwise you will anger Lady Zaina Malik, and she will expel us!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “I want to visit her grave.”")]), _vm._v(" "), _c('p', [_vm._v("Laila was not confused by her request; on the contrary, she was steadfast. She said, “Well, come tomorrow, and I’ll take you to her grave.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("My mother:")]), _vm._v(" “Well, I’ll come tomorrow, and you’ll take me to her grave.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Well, madam.”")]), _vm._v(" "), _c('p', [_vm._v("She left groggy and tired. She died in the evening of the same day. We do not know how and why. Is it possible that her conscience woke up and started to reprimand her because of the pain she caused me for so many years? She felt of how cruel and awful she was with me and couldn’t bear her guilt. I did not know of her death until I came back, that is, after fifteen days.")]), _vm._v(" "), _c('p', [_vm._v("Laila received me with a long hug and then told me what had happened…my mother definitely wanted to tell me something. Oh my God, she died without saying goodbye. I wish I had stopped the car, got off, hugged her, and talked to her.")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room sad. I sat on my bed and started crying. I stood in front of the window, I watched Hazem while he was working on the farm. How I wished if he would go up to my room and embrace me while I am crying on his chest. Oh my God, I cried for her, and she was the cruelest person on me. She definitely wanted to tell me that she regretted what she has done with me all her life.")]), _vm._v(" "), _c('p', [_vm._v("I wanted so badly to hear from her that she repented and she was sorry to ignore me and neglect my feelings and existence. I want to throw myself between her arms, but she died, neither she expressed her remorse, nor did I tell her that I forgave her, and I have nothing in my heart toward her!")]), _vm._v(" "), _c('p', [_vm._v("Laila escaped from taking her to the grave, but I would never escape from my mother’s appearance when she called me and I drove away from her.")]), _vm._v(" "), _c('p', [_vm._v("Hazem looked towards the room and found me standing. He stopped working for a few moments. He looked at me and then returned to work. What is wrong with him? Why did he not come to check on me?")]), _vm._v(" "), _c('p', [_vm._v("He is not satisfied with what is happening; I know that he is not satisfied with my going to Malik’s house and staying with him for long days. It’s okay; he will never understand what I am doing. Perhaps I am the one who lost me, my lineage and my mother’s farewell, and he is the only one aware of the grave mistake.")]), _vm._v(" "), _c('p', [_vm._v("The days of my sadness for my mother have passed. I may have pretended in front of everyone that my grief over her is over. Perhaps I was not sad for her death as much as I was sad for ignoring her when she called me. May be the mother instinct inside her distinguished me at that time; she knew that I was her daughter and that I had not died. Why did she return? And what did she want from me? I wish I got out of the car and heard her!")]), _vm._v(" "), _c('p', [_vm._v("During that period, I did not sit with Hazem, and I never confronted him. A day before I returned to Malik, he waited for me in the evening near the wooden chair.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him with great reproach and said, “You didn’t come to console me, did you?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem, ignoring my question, said, “There is a good fruit, but it is seasonal. I am thinking of planting it in the ground. If you agree, I will bring its seeds tomorrow, Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I said surprised, “Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem completely ignored me.")]), _vm._v(" "), _c('p', [_vm._v("“It needs time and some money, what do you think?”")]), _vm._v(" "), _c('p', [_vm._v("I got up from my seat (Is this the right time for him to treat me like that) and answered him in his own way:")]), _vm._v(" "), _c('p', [_vm._v("“Yes, do what is good for the land, sir. I will send you money with Jawad.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Fine.”")]), _vm._v(" "), _c('p', [_vm._v("He left me coldly and quietly. I got very angry, so I called him, “Hey. You. Listen to me!” He stopped and calmly turned around to me. I added, “I do not agree!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “A little while ago, you said you agreed, what’s the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“I changed my mind; I am free and can do whatever I want. When you want to talk to me, come close to see you; I don’t like any of my workers to talk to me in such a way.”")]), _vm._v(" "), _c('p', [_vm._v("He approached me coldly and carelessly.")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, Lady Zaina. Any other orders; it is a good fruit! It will give you a lot, and yet you have complete freedom to decide.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him angrily, but tears overcame me.")]), _vm._v(" "), _c('p', [_vm._v("“Plant it.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and walked while weeping; he followed me and held my hand.")]), _vm._v(" "), _c('p', [_vm._v("“I am sad for you, and very angry of you.”")]), _vm._v(" "), _c('p', [_vm._v("I turned away from him and said, “I hate you so much, I don’t want to see you when I get back, you understand, I’m serious.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “As you wish, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I said with suppressed voice, “Lady Zaina, don’t call me with anything else.”")]), _vm._v(" "), _c('p', [_vm._v("In the morning, he wasn’t there to say goodbye. I don’t know what happened to him, maybe he hates me; does he really hate me?")]), _vm._v(" "), _c('p', [_vm._v("I returned to Malik, and I had signs of sadness on my face. He asked me:")]), _vm._v(" "), _c('p', [_vm._v("“What’s the reason? What did the girls do this time?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “Zaina Fouad’s mother passed away.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t say my mother, but I said Zaina Fouad’s mother. When I said to Malik, Zaina Fouad’s mother, I knew that Zaina Fouad had died inside me and she disappeared from existence.")]), _vm._v(" "), _c('p', [_vm._v("She is in oblivion, or perhaps in the midst of death. Today, the vegetable seller has left this world completely! She left with her spontaneity and beauty, with her blue eyes, dreams, and ambition, with her shabby clothes and stale shoes, with Rasha dresses and Rasha herself.")]), _vm._v(" "), _c('p', [_vm._v("Zaina found left with her dream to marry the nobleman, with what Reem has done with her.")]), _vm._v(" "), _c('p', [_vm._v("She left and the hatred of Salma has gone too. There is basically no presence of Salma in the life of Zaina Malik. Zaina Malik will keep Zaina Fouad’s girls, Hazem, Jawad, and Ghaith in her heart and mind. The land no longer has that great position in Zaina Fouad’s life. There is no longer anything of Zaina Fouad’s, except her strength to face difficult situations; she will even nourish Zaina Malik with all the strength and patience.")]), _vm._v(" "), _c('p', [_vm._v("Malik hugged me and whispered in my ear, “Do not grieve over people from whom you have seen nothing but cruelty, and thank God that you have been freed from them.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him crying, “I just wanted to know why she came back.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Perhaps it is good that you did not know, perhaps she wanted to cause you pain!”")]), _vm._v(" "), _c('p', [_vm._v("He was absolutely right. She may have come to know the destiny of the house after me. Oh my God I’m going crazy if I keep thinking about her. I won’t think about her anymore and I won’t cause myself a headache that puts me in bed like last time. I didn’t think about her after that moment, and she will never occur to my mind any more.")]), _vm._v(" "), _c('p', [_vm._v("Malik entrusted me with many of his works. I became well known among almost all clients and businessmen. Nader did not want me to be involved in the labor market much.")]), _vm._v(" "), _c('p', [_vm._v("He was very afraid for me. Malik convinced him that I must be in the market in order to manage my property after him, and that his health was deteriorating so he was unable to follow everything.")]), _vm._v(" "), _c('p', [_vm._v("Nader was able to convince Malik of the necessity of having a trustworthy lawyer to help me run the business. The lawyer meets the men while I sit at home and supervises everything from my place. The point is that the beautiful woman remains at home.")]), _vm._v(" "), _c('p', [_vm._v("I agreed to have a lawyer to help me; I also need his help because I travel a lot, I don’t even like to meet many people!")]), _vm._v(" "), _c('p', [_vm._v("I was late in getting back to the girls. Maryam was about to give birth. We were eagerly waiting for the new baby. Laila received me, as usual, with great warmth and love.")]), _vm._v(" "), _c('p', [_vm._v("I asked Maryam, “When will you give birth?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “The midwife said overnight, and we are waiting.”")]), _vm._v(" "), _c('p', [_vm._v("At that evening, Maryam gave birth to her girl. We thought the baby was a boy. I stayed in my room until the midwife left. She left muttering: “Oh my God; as if the women of this house had only girls.”")]), _vm._v(" "), _c('p', [_vm._v("Laila dressed the baby with the most beautiful clothes. She was as beautiful as the sun of the day. Without thinking, I said, “Shams; we will call her Shams.” (Shams is an Arabic name means sun.)")]), _vm._v(" "), _c('p', [_vm._v("Maryam smiled and said, “So beautiful, I hope her life shines like the sun.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I wanted to denominate her, but it’s okay. Shams is very beautiful. Promise me, Zaina, I will name your daughter.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I might have a son, and then I’ll call him Hazem.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “If Shams was a boy, I would have called her Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “No one will take the name.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem came and said, “I want to hold the baby.”")]), _vm._v(" "), _c('p', [_vm._v("I held her in my hand and gave him the girl. He took the girl without looking at me. He didn’t leave, and he won’t leave, I asked him kindly, “You are still here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Who takes care of all these women, if you find someone to look after them, do not fire their man!”")]), _vm._v(" "), _c('p', [_vm._v("I ignored him because he was right.")]), _vm._v(" "), _c('p', [_vm._v("“What do you think of the girl?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Beautiful. We’ll call her Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “No my dear, her name is Shams.”")]), _vm._v(" "), _c('p', [_vm._v("Yesterday you hated me and today you want to call the girl Zaina.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Who said he hates the other? Then who called her Shams?”")]), _vm._v(" "), _c('p', [_vm._v("“I said it with my tongue, but you were saying it with your looks and actions towards me. I am the one who called her Shams; don’t you agree, isn’t it, beautiful?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I didn’t like it.”")]), _vm._v(" "), _c('p', [_vm._v("“So what? We won’t call her Zaina, we have little Zaina, how many Zainas will the house contain?”")]), _vm._v(" "), _c('p', [_vm._v("“We will call her Rahma; may God have mercy upon this house! (Rahma is an Arabic name means mercy.)”")]), _vm._v(" "), _c('p', [_vm._v("“I said Shams, so it is Shams. We will call your daughter Rahma.”")]), _vm._v(" "), _c('p', [_vm._v("He looked straight at my eyes and said, “Will I ever have a girl?”")]), _vm._v(" "), _c('p', [_vm._v("He meant would I marry one day? If I did not marry Zaina, I would not marry anyone.")]), _vm._v(" "), _c('p', [_vm._v("I completely ignored him.")]), _vm._v(" "), _c('p', [_vm._v("“Shams, come on agree, you are her uncle and the man of the house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Well, you stubborn one, her name is Shams.”")]), _vm._v(" "), _c('p', [_vm._v("I told them happily, “You see; if I had a child, I would call him Hazem. You know why now.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem smiled and said, “Oh really! And if Nader refused?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Let him go to hell if he refused, then maybe I won’t marry him. We don’t know our destiny yet. So far we haven’t talked about anything related to engagement and marriage.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem smiled and said, “The girl is very beautiful.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She looks like her mother.”")]), _vm._v(" "), _c('p', [_vm._v("It was a very beautiful night; a wonderful life entered our world!")]), _vm._v(" "), _c('p', [_vm._v("I have never seen anyone as happy with the girl as Samar; she helped Maryam a lot in taking care of her. Maryam encouraged her and taught her how to take care of babies.")]), _vm._v(" "), _c('p', [_vm._v("A week has passed since the birth of Shams. Nader visited us and brought many gifts for the girl and Maryam. He apologized to Maryam because he suspected her manners and for his mistreatment with her. When he was leaving, he stood in front of the door to say goodbye to me. He took my hand and said, “Don’t you wish to be a mother for beautiful kids like you?”")]), _vm._v(" "), _c('p', [_vm._v("“When I get married, I will have a child, and I will call him Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Why not? A very beautiful name, and when do you intend to marry me, my little girl, to fulfill the dream and give birth to Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("I withdrew my hand shyly and said, “I don’t know; will I marry you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Who else? Nobody, only Nader, or I’ll shoot him. Actually, I’ll talk to your dad, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("He confused me. He smiled and got into his car. Before he left, I opened the door and said, “Why do you always call me little girl? Don’t say it again.”")]), _vm._v(" "), _c('p', [_vm._v("I only like hearing it from Hazem, as if Nader heard it from him and started imitating him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “What if you ride with me and we go to Malik?”")]), _vm._v(" "), _c('p', [_vm._v("I closed the door and laughed at his suggestion.")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room and lay on my bed. I wasn’t very happy. My dream would come true, and I would marry a nobleman; I officially became a noble lady. Since I became Malik’s daughter I turned into a noble lady; why should I marry him?")]), _vm._v(" "), _c('p', [_vm._v("Am I really going to marry him? Why not, hasn’t that been my wish for so many years? But today I have a house and a land, and as Hazem said, “Whoever owns a land is treated like nobles; I don’t know. I will discuss the matter with Malik and decide afterwards.”")]), _vm._v(" "), _c('p', [_vm._v("Half an hour after his departure, I heard the sound of a car stopping in front of the house. I looked out my window and saw Nader’s car.")]), _vm._v(" "), _c('p', [_vm._v("I quickly went down and opened the door. Nader was at the door and his brother Ashraf was with him. Ashraf was carrying a very small girl.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I came across him on the road.”")]), _vm._v(" "), _c('p', [_vm._v("He was carrying the child and saying, “Take me to Zaina immediately!”")]), _vm._v(" "), _c('p', [_vm._v("I invited them to come in. I called Maryam and Laila. Laila came quickly and Maryam followed her.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “I found this child in front of the door of my building. I closed the clinic after a very busy day; I was on my way home. I heard the sound of a child crying, I went down quickly. In front of the door of my building, I found her. I didn’t know what to do. I didn’t think of anyone but you. I came walking to you; the road was very long. I didn’t know what I was doing; all I know is that I must reach you. Thank God Nader saw me!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I asked him what’s up.”")]), _vm._v(" "), _c('p', [_vm._v("He only said, “Take me to Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("Laila approached Ashraf and said, “Calm down, give me the baby.”")]), _vm._v(" "), _c('p', [_vm._v("She took the child from his hands quietly. Maryam approached her quickly and lifted the cover from her face; she was a beautiful girl. Maryam took her into her room and nursed her from her breast, changed her clothes, and began to rock her until she fell asleep.")]), _vm._v(" "), _c('p', [_vm._v("Ashraf sat down, after half an hour of shock, he calmed down.")]), _vm._v(" "), _c('p', [_vm._v("He said, “I should have taken her to the police station or the orphanage.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “No problem, perhaps God has decreed for the girl to be brought up in a family. So he led you to us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “We have to tell the police and find out who left it.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not know, my dear. Didn’t you hear what the officer Kamal said; every time they find a girl lying in the street, and they are still looking for the one who is throwing them. As Laila said, God wanted this girl to have a mother and a family, so Ashraf only thought of us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “You will be her mother.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Me? No, of course not, her new mother took her inside and will not hand her over to anyone. She will come soon calling her by her new name. You will forget that you have left a girl here, or else…”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Or what?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing dear.”")]), _vm._v(" "), _c('p', [_vm._v("I wanted to tell him you should forget the girl, or Maryam will insert her knife in your heart. But I will never say that.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I will be responsible about the girl; I am ready to spend every penny she needs.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “I will do that; I found her.”")]), _vm._v(" "), _c('p', [_vm._v("I interrupted them. “She is in my house and becomes one of my girls; Lady Zaina is able to take care of her alone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Is it okay to bring some gifts for the baby?”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (cheerfully):")]), _vm._v(" “We all accept gifts.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone laughed; Maryam came carrying the child in her hand. She was very beautiful as the moon. Hazem entered smiling. He completely ignored the presence of Nader. He looked at Ashraf and asked him, “How are you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf (in confusion):")]), _vm._v(" “Fine; I found a girl.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “How many girls will this house hold yet? I see you with every baby girl happy as if you don’t have girls!”")]), _vm._v(" "), _c('p', [_vm._v("Hazem approached me and said, “What are you going to call her, little girl?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Kamer, (an Arabic name means moon) she came and illuminated the house at night.”")]), _vm._v(" "), _c('p', [_vm._v("I will call her Kamer, and I will have Shams and Kamer to light my whole day.")]), _vm._v(" "), _c('p', [_vm._v("I told her, “No, we will not call her Kamer; we will call her Rahma as Hazem said, because it is a mercy from heaven sent by God to us.”")]), _vm._v(" "), _c('p', [_vm._v("Nader looked at me in astonishment and said, “Little girl and Rahma! I have to go, it’s getting late.”")]), _vm._v(" "), _c('p', [_vm._v("I gave the girl to Maryam and said to him, “Why don’t we make you food? Surely, Ashraf is tired from walking and long work.”")]), _vm._v(" "), _c('p', [_vm._v("Nader was very upset; he said resentfully, “No, I am late. If he wants to stay, that’s okay.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him coldly, “As you like.”")]), _vm._v(" "), _c('p', [_vm._v("Then the two men asked permission to leave. Ashraf thanked us warmly for welcoming the little girl.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I will have ten girls, I feel it, they become five and there are five left.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Five is enough. Good that she accepted to breastfeed, otherwise it would be a problem. I am going to sleep now; I have to travel tomorrow, Malik is waiting for me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Sit for another week.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I have a lot of work there, and I have to consult Malik on a lot of things.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, but we miss you so much.”")]), _vm._v(" "), _c('p', [_vm._v("“And so am I, I will leave you a sum of money. If you need anything necessary, send Jawad to Nader’s house and he will phone me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Don’t worry, we won’t need anything.”")]), _vm._v(" "), _c('p', [_vm._v("“I know you are here and meet all their needs, but do not forget that there are two new children. I will not allow you to perish for everyone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Bring us a phone here, Zaina, and we’ll talk to you right away.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I will tell Malik, and he will send someone to take care of it. Feed well, Maryam. You have two babies; both must be fed well, and you must be strong.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Thank you from the bottom of my heart, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“Good night, dears.”")]), _vm._v(" "), _c('p', [_vm._v("We became a very big family; the land is working but not as before. There are many vegetable merchants; I have to open a new project. Malik gives me money, but for how long? I know he can support us for many years, but there must be always an alternative.")]), _vm._v(" "), _c('p', [_vm._v("The girl was so beautiful, who is throwing those girls? This mystery must be solved!")]), _vm._v(" "), _c('p', [_vm._v("Nader would have taken the girl to the police if I had not prevented him and convinced him that here was her place. I did not fear for the girl as I feared for Nader from Maryam’s knife!")]), _vm._v(" "), _c('p', [_vm._v("Thank God he was convinced. What made Ashraf bring her here? He seemed very sincere. As Laila said, “God wanted the girl to live a decent life.”")]), _vm._v(" "), _c('p', [_vm._v("I went to visit Malik’s house before traveling. I wanted to check on my box, and dispose some old belongings, i.e. everything related to Zaina Fouad.")]), _vm._v(" "), _c('p', [_vm._v("I walked into the house and there was the surprise; a girl sitting on the sofa in the big hall and flipping my things in the box! I asked her angrily, “Who are you? Who gave you the permission to mess with my stuff?”")]), _vm._v(" "), _c('p', [_vm._v("She closed the box and pushed it under the sofa.")]), _vm._v(" "), _c('p', [_vm._v("Her appearance was suspicious; she was wearing pants and a brocade shirt. She was holding a tobacco roll in her hand and spewing smoke everywhere. She approached me in mockery and said, “Who are you, beauty?”")]), _vm._v(" "), _c('p', [_vm._v("I turned away from her at once and said, “I am the lady of this house, Zaina Malik.”")]), _vm._v(" "), _c('p', [_vm._v("She replied violently, “Who are you, fool?”")]), _vm._v(" "), _c('p', [_vm._v("I also replied angrily, “How impolite you are! I told you Zaina Malik!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “I am Zaina Malik, and I came to take money from my cruel father, but thank God he is not there. I found a wealth of gold and diamonds.”")]), _vm._v(" "), _c('p', [_vm._v("She found my jewelry box. For sure, she didn’t arrive today. She might have come two days ago, searched the house well and found everything. My God! How will I get rid of her? Even her appearance does not at all suggest that she is his daughter. Perhaps she is a liar. What shall I do now? What a misfortune.")]), _vm._v(" "), _c('p', [_vm._v("I firmly ordered her to go.")]), _vm._v(" "), _c('p', [_vm._v("“Get out of my house at once, or I’ll tell the police about you, you thief.”")]), _vm._v(" "), _c('p', [_vm._v("She was very nervous, she picked up the ashtray and threw it at me, and she almost hit me with it. She was not conscious; as if she had been drinking alcohol before I arrived.")]), _vm._v(" "), _c('p', [_vm._v("I yelled, “You almost hit me, you idiot!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The girl:")]), _vm._v(" “I will kill you, you liar.”")]), _vm._v(" "), _c('p', [_vm._v("I ran from her around the hall. She was throwing me with everything she saw in front of her. She almost hit me more than once, and I was trying hard to avoid her strikes. Oh my God, she was crazy and really wanted to kill me! I started throwing things at her to defend myself. I hit her with something that stopped her from throwing things at me.")]), _vm._v(" "), _c('p', [_vm._v("She stopped to see what had happened to her, so I hurried out of the room and closed the door on her. She started screaming and hitting the door.")]), _vm._v(" "), _c('p', [_vm._v("I did not notice the presence of Maryam in the house; I was terrified by her appearance and asked her, “What brings you here? How did you know I’m here?”")]), _vm._v(" "), _c('p', [_vm._v("“Moments after you left, Nader came. He told me that he wanted to take you to Malik. I followed you running and I could see you entering here. I heard your screaming with the girl; I tried to enter but there were things thrown outside, so I was afraid to be hit.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “What are we going to do with this crisis?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What does she want?”")]), _vm._v(" "), _c('p', [_vm._v("“She says she is Malik’s daughter. My God, if this is true, we will lose everything, and she is also very violent and trying to kill me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I will deal with her.”")]), _vm._v(" "), _c('p', [_vm._v("“Quietly, please.”")]), _vm._v(" "), _c('p', [_vm._v("The girl was knocking on the door violently, so Maryam opened it hard, pushed her and threw her to the ground. Maryam was much stronger than her.")]), _vm._v(" "), _c('p', [_vm._v("The girl jumped and took out a pistol from her bag, and started shooting. A bullet hit me; it pierced my hand.")]), _vm._v(" "), _c('p', [_vm._v("Blood started to flow from my arms. The girl smiled viciously and turned to shoot Maryam, but Maryam was faster than her; she hit her with a heavy vase on her head! The girl finally fell down.")]), _vm._v(" "), _c('p', [_vm._v("There was blood all over the place. Oh my God, Maryam killed the girl, and she was almost killed for me, what shall we do now?")]), _vm._v(" "), _c('p', [_vm._v("Maryam put a piece of cloth around my hand to stop the bleeding. I opened the girl’s bag; I found her personal ID; on it was written Zaina Malik. There were also a few messages from Malik. She is really his daughter; we killed the man’s daughter! “What shall we do now?” I asked Maryam.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We will bring Malik here and tell him that we found the girl in this condition, but not today; after two days or more, so that he will not suspect us. Take this bag and destroy it. Don’t be sad, my dear, she almost killed us. She didn’t even give us a chance to talk to her. Don’t worry, I will arrange everything. First, we’ll make it look like she fell and killed herself because of alcohol. As for you, I must treat your wound. Then, you have to change your clothes and return to Nader as if nothing had happened. Tomorrow you will travel to Malik. After few days, I will send Jawad to speak with Malik. He will inform him that he saw an intruder in his house.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, nervously, “Nader knows that I will travel today, otherwise he wouldn’t come.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “It’s okay; just take it easy, my dear. Calm down; you always say everything has a solution.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam treated my wound after she found a first-aid kit in the kitchen. The bullet did not settle inside my flesh or bones; it just caused a wound. She sterilized it and wrapped it with bandages.")]), _vm._v(" "), _c('p', [_vm._v("I was literally carrying out what Maryam asked me to do! I changed my clothes and came back smiling at Nader even though I was crying in pain for that girl. Perhaps I was crying for Malik; how much he wished to meet his daughter. My God, he would meet her now when she is a dead body. How would he accept that? How would be his reaction? He’s tired now and can’t stand a situation like this, but we have no other choice.")]), _vm._v(" "), _c('p', [_vm._v("Nader noticed my tension so he asked me, “What is the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Perhaps she misses her father. Since she woke up, she is talking about him. She told us that she saw him in a dream.”")]), _vm._v(" "), _c('p', [_vm._v("I shook my head and said in agreement, “Oh, how I wish I could see him now.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I came to take you there. I want to tell him about us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Very cool.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “What is wrong with us?”")]), _vm._v(" "), _c('p', [_vm._v("I was confused and completely lost focus!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Come on now, if you want to go to your father, bring your bag so that you won’t be late.”")]), _vm._v(" "), _c('p', [_vm._v("I whispered to her, “Didn’t you say tomorrow?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “It’s okay, Mr. Nader is here today and he will drive you. Today is like tomorrow, dear.”")]), _vm._v(" "), _c('p', [_vm._v("I addressed Nader, “Well, I’ll get my bag and come with you.”")]), _vm._v(" "), _c('p', [_vm._v("I headed directly to my room. I closed the door. I put the girl’s papers in the fireplace to burn. In a minute, they turned to ashes; even the ashes became invisible. I brought my bag and said goodbye to the girls. Maryam whispered in my ear, “Don’t worry; everything will go according to plan.”")]), _vm._v(" "), _c('p', [_vm._v("Laila said sadly, “I think you will be late this time; the bag is big.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Yes, my father is tired and I am worried about him.”")]), _vm._v(" "), _c('p', [_vm._v("As soon as we set off, I asked Nader to drop me off for a while in front of Malik’s house, under the pretext that he had asked me to bring him important documents from the house. He wanted to accompany me, but I asked him to wait for me in the car and I wouldn’t be late.")]), _vm._v(" "), _c('p', [_vm._v("I entered the house and was very afraid. I was afraid to find the girl is still alive and kill me.")]), _vm._v(" "), _c('p', [_vm._v("The girl was lying on the ground with her blood around her. I avoided approaching her at all because I didn’t want to be stained by her blood.")]), _vm._v(" "), _c('p', [_vm._v("I was able to pull out the box without touching anything else. I emptied all the jewelry into my bag. Surely, if Mariam comes to check on the girl, she will notice the box. So, l didn’t leave anything inside it. I was afraid also from Malik. When he comes to see his daughter corpse, he would find out about the box. I put my father’s bracelet, picture, and his letter inside my handbag.")]), _vm._v(" "), _c('p', [_vm._v("I don’t know where I got that strength and courage to go home and see that girl again lying on the ground, helpless. Maybe I wasn’t conscious, maybe I didn’t want to lose what I had after all this effort and trouble. After all the years of misery and toil, she came in a second and wanted to get everything. Why did she want to kill me? She should inquire me first, but she immediately attacked me.")]), _vm._v(" "), _c('p', [_vm._v("I got out quickly, locked the door, and got in the car. We got to Malik’s house at noon. He was waiting for me at the door. I ran towards him and hugged him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What’s wrong, darling?”")]), _vm._v(" "), _c('p', [_vm._v("“I saw you in my dream and I was very worried about you, so I came right away. I wish you’d see me every day and stay here!”")]), _vm._v(" "), _c('p', [_vm._v("“This time, I won’t come back early, I will stay by your side as long as things are stable there.”")]), _vm._v(" "), _c('p', [_vm._v("“Great, I’m throwing a party today, and Nader will stay to enjoy with us.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room. Dalal followed me with my bag.")]), _vm._v(" "), _c('p', [_vm._v("“It’s heavy, so you really want to stay for a long period?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Dalal, I will stay as long as things are calm.”")]), _vm._v(" "), _c('p', [_vm._v("I asked Dalal to leave me alone. She wanted to help me to empty the bag, but I refused. I asked her to leave me now and we will arrange it later. I closed the curtains and put the jewelry bag in a small closet in the wardrobe. I locked it and hid the key in a place where no one would reach it. I filled the bag with clothes from the closet.")]), _vm._v(" "), _c('p', [_vm._v("I changed my clothes quickly, and came down on the pretext that I was afraid for Malik, and I wanted to stay by his side. In fact, I was worried that Nader would tell Malik that I went to his house; they shouldn’t stay together alone.")]), _vm._v(" "), _c('p', [_vm._v("Malik was very pleased with my eagerness for him; we had a wonderful day full of affection and love. In the evening, Malik made us a royal dinner; I wore a red dress with a beautiful white belt.")]), _vm._v(" "), _c('p', [_vm._v("Nader was dazzled by my beauty.")]), _vm._v(" "), _c('p', [_vm._v("He turned to Malik and said, “Won’t you let me marry her?”")]), _vm._v(" "), _c('p', [_vm._v("Malik smiled and said, “If she agrees, I have no objection, but on one condition.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Whatever you ask!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “If you marry her, you both will live here with me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Kidding, right?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “I’m never joking, she’s my only daughter and she’ll only live with her father. The house is too big and there is a place for all of us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I have a very beautiful house, she can furnish it as she likes. Do you think it is possible for me to live in my wife’s house?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Don’t answer now; think about it well if you love her.”")]), _vm._v(" "), _c('p', [_vm._v("Nader looked at me sadly and said, “What’s your opinion? You live all the time in a house with your friends, and he doesn’t care, but he refused to live with me; it’s mockery!”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “He told you to think about it, and if you really love me, you will live with me anywhere.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Yes, I love you very much, but my dignity does not allow me to live here. We may come every month and sit here for days as you do now, but to live here and settle down, this is very difficult for me!”")]), _vm._v(" "), _c('p', [_vm._v("“By the way, I should go home, too, and you should get used to the idea of us staying there, in my own house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “We will only stay in my house after we get married. If you want to see them, we will visit them. Please Zaina, I love you, but after our marriage, we will live in my house, and I ask you to think about it.”")]), _vm._v(" "), _c('p', [_vm._v("“And if I don’t agree?”")]), _vm._v(" "), _c('p', [_vm._v("“I will leave you to think about it, do not rush to reply, and be aware that I love you very much.”")]), _vm._v(" "), _c('p', [_vm._v("He put on his coat and asked a permission to leave.")]), _vm._v(" "), _c('p', [_vm._v("Malik looked at me and said, “He really loves you and does not want to marry you for your money, he is a good man.”")]), _vm._v(" "), _c('p', [_vm._v("“So why did you impose on him the condition of staying here?”")]), _vm._v(" "), _c('p', [_vm._v("“I had to know if he was greedy or not.”")]), _vm._v(" "), _c('p', [_vm._v("“Like I own something! Old house and sick land which still unable to produce.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, you have a lot. We will wait till he comes back. If he agrees to our request, you marry him but stay warned about him. And if he returns and stays on his position, you marry him while you are comfortable.”")]), _vm._v(" "), _c('p', [_vm._v("“If he comes back!”")]), _vm._v(" "), _c('p', [_vm._v("“He will return. He loves you so much. Now go to sleep, it’s been a long day.”")]), _vm._v(" "), _c('p', [_vm._v("“It really is!”")]), _vm._v(" "), _c('p', [_vm._v("I kissed him on the cheek and wished him a good night. I lay on my bed thinking, "), _c('em', [_vm._v("Will Nader come back, or will he not come back? I am afraid he will take a negative attitude on Malik and leave me, but he said that he loves me very much.")])]), _vm._v(" "), _c('p', [_vm._v("Why didn’t his word penetrate my heart? I was happy that he asked me for marriage; no doubt about that, but he loves me? I don’t know why I didn’t believe it. How beautiful, I love you little girl from Hazem’s mouth, what is this nonsense?")]), _vm._v(" "), _c('p', [_vm._v("What will people say about me if I marry Hazem? They will say, “She married a worker in her ground.” How will they consider me a noble lady then?")]), _vm._v(" "), _c('p', [_vm._v("As for Nader, he has factories and companies and comes from a noble family. He must return. I was thinking about Nader as if I had completely forgotten about Malik’s daughter.")]), _vm._v(" "), _c('p', [_vm._v("How will Maryam manage things, what will she do? I’ll wait to see. The pain started running through my whole body. I wondered where that pain came from. Oh my God, from my hand, I remembered the wound on my hand. I went back to Malik’s room and woke him up.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What’s wrong with you, my daughter?”")]), _vm._v(" "), _c('p', [_vm._v("“I have a headache, do you have any painkillers?”")]), _vm._v(" "), _c('p', [_vm._v("“Should I bring the doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“No need, just a sedative will be enough.”")]), _vm._v(" "), _c('p', [_vm._v("He pulled out a box full of medicine from his locker and gave me a pill.")]), _vm._v(" "), _c('p', [_vm._v("“This is a powerful sedative, you will fall asleep immediately.”")]), _vm._v(" "), _c('p', [_vm._v("I took it without thinking, went back to my room and lay on my bed and fell into a deep sleep.")]), _vm._v(" "), _c('p', [_vm._v("Three days passed, Nader did not come, and Maryam did not call or send anyone. The tension began to kill me; if the body remained in the house, it would rot and released a bad smell. I was waiting for the phone to ring with great eagerness. Malik noticed my great tension.")]), _vm._v(" "), _c('p', [_vm._v("He lowered his glasses and looked at me.")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry, he’ll come. Don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not worried.”")]), _vm._v(" "), _c('p', [_vm._v("Then the phone rang, Malik picked up the headphone and answered. Although I was eager to answer, but he carried it and he answered.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Hello, who is the speaker? Well, what then? Okay, I’m coming.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him eagerly, “What is there?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing, I have to travel now.”")]), _vm._v(" "), _c('p', [_vm._v("“Where to?”")]), _vm._v(" "), _c('p', [_vm._v("“I have an important job.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go with you.”")]), _vm._v(" "), _c('p', [_vm._v("He said sharply, “No, I might come back in the evening, or maybe tomorrow, I don’t know.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on his hand.")]), _vm._v(" "), _c('p', [_vm._v("“Take me with you; I’ll take care of you.”")]), _vm._v(" "), _c('p', [_vm._v("“You will wait for me here and take care of yourself. Do not leave until I return, do not leave at all, Zaina, you understand? Wait for me.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, promise me you’ll take care of yourself for me.”")]), _vm._v(" "), _c('p', [_vm._v("“You too, promise me that you will take care of yourself for me and do not think about Nader too much. He will definitely come back, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("He got dressed and left quickly. I knew that the caller was someone sent by Maryam. I was very worried and wanted to know everything. I can’t go, I promised him to stay. Then if I went, my reaction might reveal everything!")]), _vm._v(" "), _c('p', [_vm._v("I waited in front of the phone, expecting Maryam to call at any moment and tell me what’s going on. After a long waiting, she finally called.")]), _vm._v(" "), _c('p', [_vm._v("I answered, “Hello, who’s calling?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m Maryam; everything was done as we wanted.”")]), _vm._v(" "), _c('p', [_vm._v("“Tell me, what happened.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t, but Malik went to you about half an hour ago. I think he will tell you everything. He asked me not to tell you anything, and he will tell you himself. He is very strong. Don’t worry about him. Bye now.”")]), _vm._v(" "), _c('p', [_vm._v("I waited impatiently for Malik. It was very late and everyone in the house was sleeping, but I couldn’t close my eyelids. I stood in front of the window overlooking the street. When I saw the car coming, I ran straight to the door and greeted him.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me with firmness and strong determination and said, “Why haven’t you slept yet?”")]), _vm._v(" "), _c('p', [_vm._v("“I was so worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“I told you I might not come back until tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“I was going to stay up until you came back.”")]), _vm._v(" "), _c('p', [_vm._v("“Come on, my dear, I’m tired, get me into the room, and go to bed at once.”")]), _vm._v(" "), _c('p', [_vm._v("“Aren’t you hungry? I’ll prepare you a quick dinner.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to; I want to lie on my bed and rest.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, dear, let’s go upstairs.”")]), _vm._v(" "), _c('p', [_vm._v("He looked tired and stressed, but he didn’t look sad or annoyed as if he was on a mission, he finished it and came back.")]), _vm._v(" "), _c('p', [_vm._v("I went up to his room with him. He lay on his bed. I put the blanket on him, kissed him on the forehead. He grabbed my hand and said, “Sit next to the bed until I fall asleep.”")]), _vm._v(" "), _c('p', [_vm._v("“As you wish, my dear, I won’t leave you until you sleep.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t feel that he was going to sleep despite his tiredness; he opened his eyes and started talking:")]), _vm._v(" "), _c('p', [_vm._v("“We buried Zaina Fouad today; we only have now Zaina Malik.”")]), _vm._v(" "), _c('p', [_vm._v("I pretended to be astonished and said, “What do you mean?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “When did you last visit my house?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Zaina:")]), _vm._v(" “Well?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “It doesn’t matter; the important thing is that you haven’t visited it recently. I went home today, and found my daughter lying on the ground with blood all around her. She preferred death to me. She died instead of visiting me. Imagine, I waited for her for years, and today when I see her, I find her lying on the ground, not moving. How much she hated me and kept away from me. Every day I wished to see her, to speak to her; I never thought that when I saw her I would find her dead. She committed suicide, or maybe she fell and hit her head by her carelessness. Imagine my dear, she was smoking and drinking alcohol, a stupid bad girl. She had everything she wished and was going to inherit all my properties.”")]), _vm._v(" "), _c('p', [_vm._v("“How did you know she was there?”")]), _vm._v(" "), _c('p', [_vm._v("“Jawad called to tell me that someone was in the house. He looked from the outside window of the house and found blood. I went to the house immediately and found her lying on the ground. Perhaps she had been dead for several days. It is good that Jawad watches the house and visits it from time to time.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know Jawad and does he work with you? He didn’t tell me!”")]), _vm._v(" "), _c('p', [_vm._v("“I asked him to keep our work a secret, and then what is the importance of this now?”")]), _vm._v(" "), _c('p', [_vm._v("“Surely he tells you all my news.”")]), _vm._v(" "), _c('p', [_vm._v("“You are my daughter, and I must know everything about you to be reassured. When you go there, you take my heart and my mind, so I must know everything. Who will help you if something bad happened to you? I should be acquainted of everything.”")]), _vm._v(" "), _c('p', [_vm._v("As if he was not sad about the death of his daughter, perhaps in his mind he was convinced that the one who died is Zaina Fouad, not Zaina Malik. He was afraid for me and sent someone to watch me, while he only sent letters to his daughter to check on her. How strange his reaction is; perhaps his daughter’s cruelty is the reason, or may be her mother had her deep influence on her and kept her away from him. Is it possible that Malik is a tough person? He did not shed a tear, nor do his features reflect any sadness. He just looked tired of traveling and sleepy.")]), _vm._v(" "), _c('p', [_vm._v("He thought that I did not know his agreement with Jawad. He did not know that Jawad obeyed my commands and told me everything. I raised that boy and it was impossible for him to do something without telling me about it. Jawad was only conveying to him what I wanted him to know.")]), _vm._v(" "), _c('p', [_vm._v("I asked him kindly, “What happened after that?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “With what?”")]), _vm._v(" "), _c('p', [_vm._v("“Did you tell the police about your daughter’s death?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I interrupted him spontaneously:")]), _vm._v(" "), _c('p', [_vm._v("“Why does everyone call me my little girl? Perhaps Nader heard it from you, not from Hazem, so he calls me my little girl!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “We buried her, Jawad and Hazem buried her in the courtyard of the house. We put a tombstone on which was written, here lays Zaina Fouad. Zaina Fouad has died forever and only my little girl Zaina Malik is left in life. Come on, now, you curious one, go to sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t you want to eat?”")]), _vm._v(" "), _c('p', [_vm._v("“Is Hazem calling you little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, since we were children, he used to help me in carrying baskets. Today he’s the man of the house. You know, I love it when Hazem says it, but it’s so ugly from Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you love it from me?”")]), _vm._v(" "), _c('p', [_vm._v("“Very much.”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t like the word, but you like the one who says it. Think about the idea of your marriage from Nader well.”")]), _vm._v(" "), _c('p', [_vm._v("Again I asked him, “Don’t you want to eat?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “To bed, Hazem’s little girl.”")]), _vm._v(" "), _c('p', [_vm._v("What? Oh my God, I’m Hazem’s little girl, what does he mean? I won’t think much about it, whoever said I don’t like Hazem, I consider him a brother to me, and so I’m his little girl.")]), _vm._v(" "), _c('p', [_vm._v("Malik knew that Hazem would tell me everything, so he told me what happened in detail. I never expected that things would go that simple; he went and buried her and came back as if nothing had happened. She came back to face her destiny, God testifies that I never wished her death! But she is the one who started the fight and who tried to kill me and Maryam.")]), _vm._v(" "), _c('p', [_vm._v("I went to my room and lay on my bed. As soon as I put my head on my pillow, I fell into a very deep sleep.")]), _vm._v(" "), _c('p', [_vm._v("A week after his absence, Nader came like a fighter. He knocked on the door strongly. I opened for him. He looked at me firmly and said, “Zaina Malik, won’t you marry me?”")]), _vm._v(" "), _c('p', [_vm._v("I asked him, “Did you agree to live here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I did not and will not agree, and you will agree to marry me.”")]), _vm._v(" "), _c('p', [_vm._v("Malik called him from afar, “Come and have coffee with me, and we’ll talk about it.”")]), _vm._v(" "), _c('p', [_vm._v("He entered the house angrily. Malik spoke to him cheerfully, “Do people in your town get engaged to girls that way?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Whoever wants to betroth Zaina invents this method.”")]), _vm._v(" "), _c('p', [_vm._v("Malik laughed and said, “Come on, I found a suitable solution.”")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled at last and said, “Really, please, I can’t sleep, have mercy on me.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and offered him a cup of coffee, he took it from my hand with his eyes fixed on my eyes, but his look was full of reproach!")]), _vm._v(" "), _c('p', [_vm._v("“I’m alone, my son. I couldn’t believe that Zaina came back to live with me, and you want take her away from me simply!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I told you I would bring her to visit you for a whole week every month.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Rather, let us make the month evenly between us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Well, what do you think if you come and live with us?”")]), _vm._v(" "), _c('p', [_vm._v("Malik laughed and said, “Will I agree to leave my house? You didn’t accept to leave your house and you are still young, would I, the old man who hasn’t much in life, accept that.”")]), _vm._v(" "), _c('p', [_vm._v("I jumped toward Malik and hugged him.")]), _vm._v(" "), _c('p', [_vm._v("“You will live long; you will live to see my children and my grandchildren too.”")]), _vm._v(" "), _c('p', [_vm._v("Nader said gently after he was touched by our strong love and said, “Well, we will divide the month between here and there.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Well, then give me a month, and then we’ll set the engagement date.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Why don’t we set it now and set the wedding date in a month?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “She is your fiancée from now and after a month, we will hold an engagement party for her. We will wait a little for the wedding; there is no need to rush. I have a lot of work now and I need a month to finish it. You can come whenever you want here and visit her and talk.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “After a month, we give you the final approval, and then we set the date of the engagement.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “What? Don’t you agree?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “I want to think well. I must also tell Hazem and my friends.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Why do you want to ask Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “He’s the man of the house.”")]), _vm._v(" "), _c('p', [_vm._v("“So who is Malik?”")]), _vm._v(" "), _c('p', [_vm._v("“My father.”")]), _vm._v(" "), _c('p', [_vm._v("“Why do you care about Hazem’s opinion? Perhaps you are his little girl, as he said, when he called you, little girl!”")]), _vm._v(" "), _c('p', [_vm._v("I said arrogantly, “Stop nonsense, I must tell him. I will be very busy; he will take my place. He will be responsible about the family.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Well then, when are you going to tell him?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, in time. Next week I’ll go home and tell the girls and I’ll be right back, and then I’ll make up my mind.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Do you depend in making your decision on their opinion?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t depend on anyone in making my decisions. Only my father helps me in any decision.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, as you wish, the important thing is that you agree to be my wife.”")]), _vm._v(" "), _c('p', [_vm._v("He took out a box containing a necklace from his pocket. He got up and tried to put it around my neck.")]), _vm._v(" "), _c('p', [_vm._v("I pulled it from his hand and told him I would put it by my own. Malik noticed Hazem’s necklace around my neck and said, “I see you only wearing this necklace, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I replied spontaneously, “Hazem brought it to me. I remembered he bought it for me with everything he owned.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader (angrily): “")]), _vm._v("Did you allow him to put it around your neck?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not, he is very shy.”")]), _vm._v(" "), _c('p', [_vm._v("He got up and said, “Perhaps she hates what you bring to her, Mr. Malik. I’m sure she has a lot of necklaces and more expensive than it, but she only wears Hazem’s necklace!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Well, that’s enough!”")]), _vm._v(" "), _c('p', [_vm._v("He turned to me and said, “Put on Nader’s necklace, it is very beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll try it later.”")]), _vm._v(" "), _c('p', [_vm._v("It was a very beautiful necklace, a chain with an oval turquoise stone, I loved it very much. Nader did not agree to stay and sleep in Malik’s house that night; he told us that he had a lot of work to do in the morning. He came out very upset but I didn’t care, I faced the situation coldly like Malik faced the death of his daughter.")]), _vm._v(" "), _c('p', [_vm._v("I was so amazed at Malik’s coldness towards the death of his daughter. How did he have this strong ability to withstand against her death?")]), _vm._v(" "), _c('p', [_vm._v("Did he really wish for her death, or did my presence in his life remove her from his mind and heart? Perhaps he considered me his main daughter so her death did not affect him. I thought about that every night. Although my heart was distracted by my engagement from Nader, I was always afraid that Malik would collapse at any moment due to the death of his daughter.")]), _vm._v(" "), _c('p', [_vm._v("By time, I realized that I was wrong, and that her death may have removed the burden of thinking about her from his heart! He no longer had to look for her and send messages and think whether she would come or not. I was also thinking of her mother. In fact, I wanted to ask him about her, but I am afraid that he would call her. Then she would appear and say where my daughter is and put me in problems that I cannot solve.")]), _vm._v(" "), _c('p', [_vm._v("A week later, I went to my house. I wasn’t too eager to tell them about my engagement. At the same time, I wanted to see Maryam to ask her about what happened between her and Malik, and how the girl was buried.")]), _vm._v(" "), _c('p', [_vm._v("I arrived at noon. Everyone was waiting for me as usual, but their faces were not, as usual, happy and cheerful. I immediately headed to Laila and asked her:")]), _vm._v(" "), _c('p', [_vm._v("“What is there?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Have a rest first, and then we’ll talk.”")]), _vm._v(" "), _c('p', [_vm._v("“What is the matter? Come on, my heart will almost stopped beating!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Ghaith’s mother came and took him.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, and what’s up with that, maybe he’s happy?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “No, she brought him back and he’s very miserable.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Let’s go in and talk inside, I am sure you are tired, dear.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not tired, but I’m afraid of the surprises of this house. Oh my God, I want to rest! I wish I hadn’t brought them here. Whenever we had sympathy for someone, he would turn against us. I am certain that she had taken him to ask him about all our affairs and then she brought him back.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “That’s right, he told her everything, but thank God he doesn’t know anything about my marriage to Faris, not even about your identity.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Good, but he has no place among us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What is his fault?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “He did not preserve the sanctity of our house. Jawad was younger than him when he worked with me in selling vegetables and he kept secrets like a man.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What are you going to do?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I will send him to work in Nader’s factory; he has a place for workers. He may make a man of him. Do not worry, I will not throw him; I will raise him and he will become a man.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Well, that’s great!”")]), _vm._v(" "), _c('p', [_vm._v("“Tell me, what did he tell his mother in detail?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “He told her that I gave birth to a girl. He also told her everything he knows about you, about you traveling and coming back, that you give us money and you bring us gifts, and about Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, that is enough. The important thing is that he did not tell her about you and Faris. How is Samar? I’m afraid the girl will be like her brother. Make sure you don’t say anything in front of her.” I turned to Laila and said, “I brought a lot of things for everyone, please ask the driver to enter them with the help of Jawad and Hazem. I will go up to my room, when Jawad finishes his work, send him to me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “As you wish, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Maryam and asked her to come with me to my room. She knew I wanted to ask her about her meeting with Malik. So she followed me quietly. I sat on the chair and she sat in front of me.")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “Tell me in detail.”")]), _vm._v(" "), _c('p', [_vm._v("She told me the same story that Malik narrated.")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “What was his reaction when he saw her?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “He didn’t influence, nothing appeared on his face, as if she wasn’t his daughter. He asked us to bury her immediately. After which, he began to mutter to himself, ‘Where are her things?’”")]), _vm._v(" "), _c('p', [_vm._v("There was a bag containing some clothes, a book and a bottle of alcohol. He opened the bag and asked Hazem to destroy everything.")]), _vm._v(" "), _c('p', [_vm._v("Then he asked me, “Isn’t supposed to each lady to carry a handbag containing her papers and her private things?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled stupidly and replied, “You mean like the ones Zaina is carrying?”")]), _vm._v(" "), _c('p', [_vm._v("As for me, I don’t use them.")]), _vm._v(" "), _c('p', [_vm._v("He replied resentfully, “But she came from a far place, how careless she is, who would recognize her if she died in the street.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s good that we took her bag and burned it, what next?”")]), _vm._v(" "), _c('p', [_vm._v("“He wrote two letters and gave them to Jawad to put in the mail, but I took them from Jawad. I did not send them; I waited for you to read them before sending them.”")]), _vm._v(" "), _c('p', [_vm._v("“Well done! Where are they?”")]), _vm._v(" "), _c('p', [_vm._v("She pulled out the letters from her pocket and handed them to me. The first was directed to the school, in which he wrote:")]), _vm._v(" "), _c('p', [_vm._v("“The girl who was studied at your school got married and traveled to a far place.”")]), _vm._v(" "), _c('p', [_vm._v("The second one was directed to her mother, in which he wrote:")]), _vm._v(" "), _c('p', [_vm._v("“Your daughter, whom you were the reason for her destruction and whom you kept away from me, has returned to me. I inform you that she will marry and leave. She asks you to stay away from her life completely, or else I would have told the police that you kidnapped her all these years, and she will testify against you and that you were the reason for her addiction and I have evidence. It is better for you to forget her presence in your life.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, the mother will never return, but perhaps if she reads that message, she will come to reassure her.”")]), _vm._v(" "), _c('p', [_vm._v("I must find a solution. She is a mother and the mother’s heart does not know how to wait. I am sure she loves her, not like my mother. Every mother loves her daughter, except my mother who never loved me! I think my mother didn’t even have a heart inside her chest.")]), _vm._v(" "), _c('p', [_vm._v("I wrote her a new message:")]), _vm._v(" "), _c('p', [_vm._v("My dear mother,")]), _vm._v(" "), _c('p', [_vm._v("I will marry soon and travel far away. I am fine, I would have liked to see you but I did not have enough time. I got a large sum of money from Malik. I am going with my husband for a honeymoon and will settle in that country. My warm kisses to you.")]), _vm._v(" "), _c('p', [_vm._v("I gave Jawad the two letters to send them by mail. I wrote my address so that I could receive the reply and know everything happening. I burned Malik’s letter which supposed to be sent to the mother.")]), _vm._v(" "), _c('p', [_vm._v("I didn’t tell the girls about my engagement, I don’t know why! Although I came to tell them, the house is overwhelmed with worries, how do I tell them?")]), _vm._v(" "), _c('p', [_vm._v("I know that Maryam was afraid of Salma more anyone else in the house. She knew that what she did might harm the whole family, but she didn’t talk. She kept her fear inside her heart but was clear in her eyes.")]), _vm._v(" "), _c('p', [_vm._v("Jawad put the letters in the post office and came back quickly. I asked him to tell me everything about his meeting with Malik and how he reacted toward his daughter death. I wanted to hear the story from him; maybe I get new details. I was also eager to know Malik’s recommendations.")]), _vm._v(" "), _c('p', [_vm._v("He didn’t give me any new information; he just said what Maryam said. Before Malik leaving, he gave him some money and asked him to pass on all my news to him. He told him, “She is my only daughter, and I want to check on her.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad was transferring to Malik what I just wanted him to know. I asked Jawad to take Ghaith to Nader’s factory and leave him there. I wanted to keep problems out of the house by any means.")]), _vm._v(" "), _c('p', [_vm._v("I became a strong lady, I’ve always been strong, and I even was born a strong girl! I was taking care of my mother and my sisters after the death of my father. I exposed to injustice and abuse but I stayed withstood. My mother left me after she stripped me of her tenderness and the love of sisters!")]), _vm._v(" "), _c('p', [_vm._v("I remained steadfast in the face of poverty, hunger, and fatigue. I was the best helper for my friends and their girls. And my strength was increasing more and more, I always dealt calmly with problems. Nobody could ever break or destroy my will. Today, it is necessary to confront the evil that is coming from Salma, and I must prepare for it with greater strength and determination. I am certain she won’t ever leave us.")]), _vm._v(" "), _c('p', [_vm._v("Salma had employed Jawad’s stepfather to watch us and transfer to her all our news. His main task was to watch over our house, and to watch over Maryam and Faris. Of course, his wife helped him. Salma gave them extra money for every new detail related to Maryam.")]), _vm._v(" "), _c('p', [_vm._v("After Ghaith left to work at Nader’s factory, Jawad’s mother began to get close to Samar. With her tricks, she was taking all the information about us from her. Actually, she is her mother and knows how to deal with her, but the girl did not know anything except what Maryam wanted her to know. Maryam was very aware of what is going on.")]), _vm._v(" "), _c('p', [_vm._v("I was so serious in dealing with Samar. When we wanted to discuss anything, we sit in my room; the only safe place in the house. No one enters my room without my permission, and in my absence, it remains closed.")]), _vm._v(" "), _c('p', [_vm._v("I was so confused and didn’t know how to tell them about my engagement. I must consult them. I went to Hazem, not to tell him, of course, I must hint to him about the situation and see his reaction. He was working on the land, directing the workers while he was carrying his pick. Although the number of workers is large, he helps them. How he looks handsome from afar; he is the lord of the land. He commands this and teaches that. He was a master in a very strange way, friendly and affectionate with the workers as if he were their father. Is the mastership by shouting, beating, and vanity? Everyone who works under him is calling him Mr. Hazem.")]), _vm._v(" "), _c('p', [_vm._v("He gestured to me when he saw me from afar, with his hand, stop where you are.")]), _vm._v(" "), _c('p', [_vm._v("Then he approached me quickly.")]), _vm._v(" "), _c('p', [_vm._v("He said firmly, “My lady, enter the house and I will follow you, there are too many workers.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God. Another Nader has appeared.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand tightly and said, “I am Hazem, not Nader.”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand after feeling of pain.")]), _vm._v(" "), _c('p', [_vm._v("“You hurt me; I was mistaken to come to see you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Sorry, I didn’t mean, when did you come back?”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t care anymore; my absence doesn’t mean anything to you anymore!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Shut up, please. Am I satisfied with your going there? But who can force you to do something, or who can convince you that everything you are doing is wrong?”")]), _vm._v(" "), _c('p', [_vm._v("I said painfully, “You become a preacher and give advices!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Who am I in front of you, Lady Zaina? Just a worker, working on your land!”")]), _vm._v(" "), _c('p', [_vm._v("“You are the lord of the land, I will enter now, and I have no desire to speak anymore.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Does your hand still hurt you?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Shall I bring you a doctor?”")]), _vm._v(" "), _c('p', [_vm._v("“No, thanks.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and entered the house. I was very disappointed, oh my God; he almost went crazy just by mentioning Nader’s name. What would he do if he knew that Nader wanted to marry me? I must tell them about the engagement from Nader, but whenever I wanted to talk about it, something stopped me. The week was almost over and I had to go back to Malik to tell him by my decision.")]), _vm._v(" "), _c('p', [_vm._v("Laila made us dinner and we all sat around the table. It was a quiet evening and the table was full of delicious food. The girls always fought over who was sitting next to me! The strongest among them was little Zaina. Perhaps the girl drew her strength from me, or she loves me so much that she fights to sit next to me.")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “What makes you always win and sit next to me?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “If I do not sit next to you, I will not eat. You know, if I do not sit next to you, I will punish them by not playing with them. My aunt Maryam always says to them, ‘Do not bother little Zaina, she is her mother’s only daughter and you are sisters.’”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “No, in fact, we are afraid of your screaming all day, so we move away.”")]), _vm._v(" "), _c('p', [_vm._v("We laughed wholeheartedly at them.")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina added, “If I had known that was the reason, I would have shouted from the start.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “From now on, no yelling, you’ll be little ladies and still act like children!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “I’m the eldest and they should respect me.”")]), _vm._v(" "), _c('p', [_vm._v("They were really growing up and becoming beautiful little ladies. Sarah was the eldest and the more she was getting older, I was afraid of her from the nobleman, but we would never allow our girls to go to the nobleman’s house. I did not need his money and I would never offer my girls to him.")]), _vm._v(" "), _c('p', [_vm._v("I said firmly, “Enough arguing now, I want to tell you something important.” I turned to Samar and asked her, “Do you want to stay with us?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Samar:")]), _vm._v(" “Of course I want, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“Then why do you tell your mother all our secrets, you know that your staying here depends on keeping the secrets of the house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Samar:")]), _vm._v(" “But my mother is the one who calls me whenever she sees me outside. She asks me about all of you and your news and conditions, especially Mrs. Maryam.”")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “What are you telling her?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Samar:")]), _vm._v(" “What I know, believe me; I don’t know how to lie to her!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said nothing. I won’t mention anything about my engagement!")]), _vm._v(" "), _c('p', [_vm._v("After dinner, I decided that there was no room for her between us. I went up to my room; Maryam and Laila followed me.")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Samar will return to her mother tomorrow, or she will return to Salma, she has no place here; her mother’s influence on her is great.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I agree.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila: “")]), _vm._v("Oh really! Don’t you consider her your daughter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “We have many, many serious secrets and big problems. It isn’t related only to my marriage from Faris, but also my young girls. I am afraid that we will make a mistake in a word in front of her and cause us woes. We will send her to her mother tomorrow, and she is free with her, but I am afraid that Jawad will be annoyed.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Don’t worry about Jawad, I’ll talk to him tomorrow and finish it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What is the so important thing that you wanted to tell us?”")]), _vm._v(" "), _c('p', [_vm._v("“Well…”")]), _vm._v(" "), _c('p', [_vm._v("Before I could finish my word, Hazem entered quickly and said, “Come and see, Zaina, come quickly, follow me.”")]), _vm._v(" "), _c('p', [_vm._v("I quickly followed him; the girls were behind me. He ran out of the house and I followed him.")]), _vm._v(" "), _c('p', [_vm._v("“What do you want? What is there? Slow down, I am not as fast as you.”")]), _vm._v(" "), _c('p', [_vm._v("He stopped in front of his house and we stopped while we were panting. He entered the house and lit the place. In front of his house, there is a very beautiful flower garden. He smiled and said, “What’s your opinion? I planted it for you, isn’t it beautiful?”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “It’s wonderful.” I looked at him and said again, “It’s wonderful, when and how?”")]), _vm._v(" "), _c('p', [_vm._v("I stood watching my flowers, white and red, a very beautiful sight. How much he loves me, I remember once, we were talking, and he asked me, “What do you wish to see now?”")]), _vm._v(" "), _c('p', [_vm._v("I replied him, “I wish I could stand in the middle of a circle of white and red flowers.” And here it is today, he achieved my dream.")]), _vm._v(" "), _c('p', [_vm._v("I did not and will not tell them about my engagement of Nader. I will not hurt Hazem. I even have to rethink about it.")]), _vm._v(" "), _c('p', [_vm._v("We put a set of wooden chairs and a table and stayed up till the morning in front of this beautiful garden. Jawad made tea for us and Maryam made dessert. The girls were laughing and playing.")]), _vm._v(" "), _c('p', [_vm._v("Samar approached me and said, “I promise I won’t tell my mother anything after today, so please don’t deprive me of this family.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her hand and said, “Well we’ll see, we love you very much, and if you want to be part of this family, you must keep its secrets.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam asked the girls to go to their rooms to sleep, it was too late. Everyone went, only Hazem and I remained. I looked at him and said, “All I wish from God is that your heart will be mine forever!”")]), _vm._v(" "), _c('p', [_vm._v("He answered me shyly, “It is yours as long as I live. How is your hand?”")]), _vm._v(" "), _c('p', [_vm._v("“How about we dance around the flowers?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know how, how’s your hand?”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand and said, “I’ll let you know, look, it’s fine, if you’re afraid of it, don’t hold it tightly again!”")]), _vm._v(" "), _c('p', [_vm._v("He was very ashamed.")]), _vm._v(" "), _c('p', [_vm._v("“No, Zaina, I will not learn dancing. I will not dance with you today because I know that if I want to, it will not be repeated, perhaps if you dance with Nader, it is better.”")]), _vm._v(" "), _c('p', [_vm._v("“Who told you that I will dance with him? It is okay, we will not dance, but I will not sleep now. I will sit in front of my flowers until the sun rises, will you sit with me?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I will sit with you until you fall asleep in your chair, and I will carry you to your room and put you on your bed.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “It won’t happen, you’ll sleep before me, you lazy one.”")]), _vm._v(" "), _c('p', [_vm._v("Laila brought us two cups of coffee, sat with us for an hour, and then asked permission to go to her room.")]), _vm._v(" "), _c('p', [_vm._v("As for me, as soon as the sun rose, I fell asleep. He picked me up and whispered to me, “Didn’t I tell you that, my little girl?” He put me on my bed, murmuring, “How much I love you, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I was half asleep and heard all his whispers.")]), _vm._v(" "), _c('p', [_vm._v("The next day, I was supposed to travel to Malik. I woke up late. I have no desire to travel to anywhere. I’ll stay for another day in front of my flowers, or maybe for two days or more.")]), _vm._v(" "), _c('p', [_vm._v("We decided to spend the evening in front of my flowers garden. Laila prepared a big chocolate cake for us, and Maryam made various kinds of juices. While they were preparing the table, Nader came from afar; he headed straight towards us. He saw my little flower garden; he smiled and said, “Very beautiful, why didn’t you go to Malik today?”")]), _vm._v(" "), _c('p', [_vm._v("“Not today, not tomorrow, maybe the day after tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“And our date? I see you forgot? Didn’t you come to tell the girls?”")]), _vm._v(" "), _c('p', [_vm._v("Before he could finish his sentence, I pulled him aside and said, “Not now, please, at least until I find the right time.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “What is the matter? Are there problems?”")]), _vm._v(" "), _c('p', [_vm._v("“Later, we’ll talk later, but now come and enjoy with us. Laila made a delicious chocolate cake; let’s celebrate my garden today, and later we’ll talk about everything.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I wish I had told Ashraf, he would have come and attended the party. Apparently, it looks a nice country party.”")]), _vm._v(" "), _c('p', [_vm._v("I told him after I noticed someone coming from afar, “Isn’t the one that coming from afar Ashraf?”")]), _vm._v(" "), _c('p', [_vm._v("He answered, “Oh my God, he knows about the party and he didn’t tell me! Even you didn’t invite me; it seems there’s no place for me here, so I’m leaving!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “You’re not leaving, come on, I didn’t even know about it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader (maliciously):")]), _vm._v(" “Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “Come on now!”")]), _vm._v(" "), _c('p', [_vm._v("“Well, just for you, I’ll stay.”")]), _vm._v(" "), _c('p', [_vm._v("Everything is ready; the table is full of food as well as very beautiful flowers. Maryam has arranged the chairs and invited us to sit down.")]), _vm._v(" "), _c('p', [_vm._v("Hazem stood at the front of the table as if he were the man of the house and said, “I am honored to invite Lady Zaina to cut the cake for her birthday.”")]), _vm._v(" "), _c('p', [_vm._v("I answered with amazement and joy, “Oh my God, really today?”")]), _vm._v(" "), _c('p', [_vm._v("Nader smiled and said, “It’s today, little girl, why am I here then?”")]), _vm._v(" "), _c('p', [_vm._v("“I totally forgot!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I was keen to have your garden ready for your birthday.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Did you like the garden?”")]), _vm._v(" "), _c('p', [_vm._v("“It is amazing, the most beautiful thing!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “He knows exactly what you like; I wish I had his talent in taking care of you.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “We grew up together, how does he not know?”")]), _vm._v(" "), _c('p', [_vm._v("Nader took out a small box from his pocket and presented it to me.")]), _vm._v(" "), _c('p', [_vm._v("“This is your gift, I hope you like it, and I know it’s not as good as that flower garden, but I hope you like it, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("He wanted to kiss me on the cheek, but I walked away… He felt of my coldness towards him, but he ignored it completely, he didn’t want to embarrass himself in front of everyone.")]), _vm._v(" "), _c('p', [_vm._v("They were all looking at us! I was very ashamed, as I was afraid that Hazem would get upset. At that moment, I did not want Hazem to be upset about anything, but he was all the time smiling, suppressing his jealousy and anger within him.")]), _vm._v(" "), _c('p', [_vm._v("I was sure that if Hazem could throw Nader into the river as he did with Amjad one day, he would do it immediately. I think he wished that it was his knife that stabbed Nader, not his sister’s knife, but he refused all that for my happiness, and a promise he gave to me one day!")]), _vm._v(" "), _c('p', [_vm._v("We had a very beautiful night; we danced and sang till the morning, Laila danced with Ashraf, it was obvious that there were harmony and love between them. I was very happy for her, and I was sure that they would marry soon.")]), _vm._v(" "), _c('p', [_vm._v("I danced with the girls, Nader did not try to invite me to dance with him, he was afraid that I would refuse him like I refused his kiss. Hazem remained sitting smiling, but his eyes did not leave me for one moment. He was very proud of his achievement. He was also so happy with my neglecting to Nader. It was the most beautiful night I spent in my whole life; I never had a birthday like this.")]), _vm._v(" "), _c('p', [_vm._v("The evening ended, everyone left. Nader bid me farewell and said, “Your next birthday will be at our house, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Maybe.”")]), _vm._v(" "), _c('p', [_vm._v("“It will be, bye, little girl, don’t stay up too long.”")]), _vm._v(" "), _c('p', [_vm._v("“The sun is about to rise.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “It’s an hour or two until sunrise. We must get you a phone here so I can check on you.”")]), _vm._v(" "), _c('p', [_vm._v("He came close to me and whispered in my ear, “Indeed the flower garden is wonderful, but that does not give him the right to surpass me, he never stopped looking at you, and I am very jealous for you.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and spoke to him in the same way, “Nobody beats Hazem!”")]), _vm._v(" "), _c('p', [_vm._v("He said angrily, “Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and said, “Definitely.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “Perhaps your new girl, Samar, likes him, because she was courting him.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("“I think she gave him food and drink more than once, it’s okay, I think she suits him.”")]), _vm._v(" "), _c('p', [_vm._v("“Perhaps, take care of yourself, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“See you soon, my little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand tightly and said, “Don’t call me ‘my little girl,’ and I think Samar is too young for him!”")]), _vm._v(" "), _c('p', [_vm._v("He answered me calmly, “Who is suitable for him?”")]), _vm._v(" "), _c('p', [_vm._v("“He decides.”")]), _vm._v(" "), _c('p', [_vm._v("“Who would suit you, noble lady; the daughter of Mr. Malik, who would suit her?”")]), _vm._v(" "), _c('p', [_vm._v("“I have not decided yet.”")]), _vm._v(" "), _c('p', [_vm._v("How provocateur he is, he always likes to provoke me. I was very upset about Samar’s issue, I felt of a great and strange jealousy.")]), _vm._v(" "), _c('p', [_vm._v("When Rasha was there, I had no objection to love Hazem and even to marry him. Today, I don’t think I will accept the idea of his marriage from anyone.")]), _vm._v(" "), _c('p', [_vm._v("He has the right to love and marry, but not that Samar. She must leave my house. When she said to me, “Do not deprive me of this family,” she definitely meant Hazem. I will not think of her now, I will not spoil my night!")]), _vm._v(" "), _c('p', [_vm._v("Everyone went to sleep after they cleaned the place well. Maryam could not go to sleep and the place was messy. I asked Laila to make coffee for me and Hazem like yesterday. She prepared it quickly and went up to her room. She was very happy that she was close to Ashraf. I was very happy with her happiness; she deserves to love and to live her life.")]), _vm._v(" "), _c('p', [_vm._v("We sat across from each other. The smell of coffee mixed with the fragrance of flowers filled the place. He asked me with his usual spontaneity, “Did you like the party?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him, looking straight into his eyes, “Very, whose idea was it?”")]), _vm._v(" "), _c('p', [_vm._v("“It was Lily’s idea.”")]), _vm._v(" "), _c('p', [_vm._v("“Lily’s idea?”")]), _vm._v(" "), _c('p', [_vm._v("“She loves you very much; you are the most valuable thing she owns!”")]), _vm._v(" "), _c('p', [_vm._v("“I wish she had never told Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“She told Ashraf and he told him.”")]), _vm._v(" "), _c('p', [_vm._v("“He came without an invitation. That’s what he meant when he said, ‘Why didn’t you invite me to the party! By the way, Samar thinks and cares about you.’”")]), _vm._v(" "), _c('p', [_vm._v("He got up from the chair and threw it on the ground, which frightened me. How much I hate his eruption. He looked at me angrily and said, “Do not say that again, I have not and will not think of anyone but you.”")]), _vm._v(" "), _c('p', [_vm._v("I adjusted the chair and asked him to sit while tears filled my eyes.")]), _vm._v(" "), _c('p', [_vm._v("He said sadly, “I’m sorry; you made me angry with your words about her.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t do that again, I’m so afraid of your anger.”")]), _vm._v(" "), _c('p', [_vm._v("He took my hand and said, “I learned to dance, let us dance now.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled immediately like a little girl and got up to dance with him. We danced for half an hour. He stepped on my feet more than once; he apologized for each time. He took me with his spontaneity and smile to another world!")]), _vm._v(" "), _c('p', [_vm._v("I imagined myself with him a beautiful bird, flying in the vast sky, trying to catch his beloved to hug her and making her feel safety and peace. That dance, with its naivety and chaos, was the most beautiful birthday gift I ever had; I did not want to stop dancing.")]), _vm._v(" "), _c('p', [_vm._v("He made me laugh with some of his moves, but he was the most wonderful dancer. We almost fell down because of enthusiasm, so we sat on our seats laughing because of our stupidity. As if I was originally a professional dancer, or that I am a really noble lady, who used to attend dance parties, I was only a beginner. Malik taught me some moves when he was preparing me to be a noble lady. I perfected doing them with him, and unleashed spontaneity with Hazem.")]), _vm._v(" "), _c('p', [_vm._v("After we had spent another half an hour in front of the flowers, he looked at me, and added, “You should rest.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “I don’t want to sleep; I’ll wait for the sunrise with my flowers, and then go up to my room.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ll fall asleep like yesterday and I’ll carry you and put you in your bed. You know. I’m hungry now, I’ll bring some sandwiches. Will you eat with me?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I might take one with you.”")]), _vm._v(" "), _c('p', [_vm._v("He went and came back with a plate full of sandwiches and two cups of tea.")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“For whom are all these? It’s like an eternity has passed since we last ate!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “For us, we’ll eat them all.”")]), _vm._v(" "), _c('p', [_vm._v("“You will eat them.”")]), _vm._v(" "), _c('p', [_vm._v("“Let’s see!”")]), _vm._v(" "), _c('p', [_vm._v("They looked delicious, and they were a variety of cheese, meat and chicken, perhaps Laila had prepared them for him in advance and put them there.")]), _vm._v(" "), _c('p', [_vm._v("He started speaking after he handed me one.")]), _vm._v(" "), _c('p', [_vm._v("“When will you get married to Nader?”")]), _vm._v(" "), _c('p', [_vm._v("“Who said I would marry him?”")]), _vm._v(" "), _c('p', [_vm._v("“He said your next birthday would be at his house!”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, everyone speaks for himself, but I won’t—”")]), _vm._v(" "), _c('p', [_vm._v("Hazem interrupted, “You have time to think.”")]), _vm._v(" "), _c('p', [_vm._v("I wanted to provoke his feelings.")]), _vm._v(" "), _c('p', [_vm._v("“What do you think about it?”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“You won’t marry him, I know! But who cares to my opinion?”")]), _vm._v(" "), _c('p', [_vm._v("His answer surprised me, where did he get those answers from? He probably knows me better than I know myself. He was talking and giving me sandwiches. I didn’t pay attention to what I was doing, I would take them from his hand and eat and talk, and he was eating too. Because we were busy in talking, we didn’t pay attention to what we ate!")]), _vm._v(" "), _c('p', [_vm._v("Less than half an hour later, the plate was empty. He smiled and said, “Shall I bring more?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at the plate and burst out of laughing.")]), _vm._v(" "), _c('p', [_vm._v("“My God! It’s completely empty; I don’t know what I ate! Don’t bring anything; I’ve never eaten like I did today!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “You always lose your bets with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Can I ask you something?”")]), _vm._v(" "), _c('p', [_vm._v("“Anything?”")]), _vm._v(" "), _c('p', [_vm._v("“I want another cup of coffee.”")]), _vm._v(" "), _c('p', [_vm._v("“Immediately.”")]), _vm._v(" "), _c('p', [_vm._v("He brought coffee and sat next to me, we watched the sunrise together.")]), _vm._v(" "), _c('p', [_vm._v("“Please, when we sit together, don’t talk about Nader.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Then don’t talk about any girl, I love you, and I won’t love anyone else.”")]), _vm._v(" "), _c('p', [_vm._v("While he was talking, I put my head on his shoulder and I was almost going to fall asleep. He grabbed my head in his hand. Then he carried me. He put me on my bed and whispered, as usual, I love you little girl.")]), _vm._v(" "), _c('p', [_vm._v("I answered him in a sleepy voice, “Me too but I am not a little girl.”")]), _vm._v(" "), _c('p', [_vm._v("He kissed me on my forehead and left.")]), _vm._v(" "), _c('p', [_vm._v("The sound of Malik’s car awakened me few hours later. My delay worried him. Laila came in, I was still in bed.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Come on, you lazy one.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Tell him I’m tired, let him go now and come tomorrow.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You’re late for him.”")]), _vm._v(" "), _c('p', [_vm._v("“Please, I don’t want to leave today.”")]), _vm._v(" "), _c('p', [_vm._v("I was very depressed, my whole heart was with Hazem, but my mind refused that. I must marry a noble man. I feel as if my heart was kidnapped from me and stuck inside his heart. I never felt that feeling towards anyone! Not even toward the nobleman Karim, whom I spent years of my life thinking of. Oh my God, how confused I am, should I follow my heart or my mind? How I dreamed of being a noble lady and today I have everything to achieve this, but my heart is very fond of Hazem! Nobody understands me as Hazem; he loves me very much. I never expected to fall into that confusion, or even to fall in love with him! How I wish he would hug me now and let me fall asleep on his chest, where did those agitated feelings come from. Perhaps they were already existed, but today they liberated. I know that Nader loves me and wants to please me, but Hazem is ready to offer his soul, his heart, and all his being to me.")]), _vm._v(" "), _c('p', [_vm._v("Will Malik accept the idea of his daughter marrying a man like Hazem? Definitely no, I won’t care and I won’t lose that heart and Samar should leave my house.")]), _vm._v(" "), _c('p', [_vm._v("I stayed that day in my room, I did not go down nor did I eat. Everyone worried about me, but I had to sit with myself to make a decision that I will not regret.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, Malik visited us. I was happy to see him I hugged him and started crying on his chest.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “It’s okay, my dear, let’s go home, we’ll spend a few days here, and then we’ll travel.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He wiped my tears with his handkerchief, and then said, “It is your birthday; I came to wish you a happy and beautiful year. We will celebrate in my house. I’ll wait for you downstairs while you get dressed.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for coming.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “I was so worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("As we were getting out of the house and getting into our car, I saw Maryam standing with Faris near the house. The first time he dared to approach the house. When she saw me, she commanded him to leave immediately and ran towards me. I grabbed her hand angrily and said, “How dare he come here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam panicked:")]), _vm._v(" “I don’t know, he’s stupid, I warned him a million times not to come near our house.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “My God! Surely, Salma is watching him; you will cause a crisis to the house.”")]), _vm._v(" "), _c('p', [_vm._v("Malik was so afraid for me; he dragged me from my hand and asked me to get into the car.")]), _vm._v(" "), _c('p', [_vm._v("I said to myself, "), _c('em', [_vm._v("There is a calamity coming, I feel it in my soul and heart")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("On the way, there was a girl writhing in pain, screaming, “Help me, Zaina, please.” Her voice penetrated my soul and broke my heart. She was Reem. I turned to Malik and begged him to order the driver to stop the car.")]), _vm._v(" "), _c('p', [_vm._v("He refused and said, “We’ll go home and then I will send someone to check on her.”")]), _vm._v(" "), _c('p', [_vm._v("I cried out, “Stop the car!”")]), _vm._v(" "), _c('p', [_vm._v("The driver stopped immediately because he was afraid that he would run over the girl. I got out of the car, she was really Reem; she looked at me and said, “Please help me.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem was right behind us, he was running behind the car to tell me what Faris wanted from Maryam, we were not far from the house. Hazem carried Reem and went back to my house. Malik almost died in fear for me, he followed me at once. We entered the house and I asked Hazem to put her in my room.")]), _vm._v(" "), _c('p', [_vm._v("Malik grabbed my hand firmly and said, “I will go to my house. Check on her and follow me immediately. Her husband will definitely look for her, I fear for you, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("He was so right; basically, that’s what I would do, because I don’t want her to find out that I’m still alive.")]), _vm._v(" "), _c('p', [_vm._v("Hazem put Reem on my bed, she was pregnant and she had to give birth immediately, otherwise she and the fetus would die together. I wanted to call the midwife to come and to take care of Reem but I was afraid of her. If she knew that Reem is the nobleman’s wife, she would go to him and tell him where she is.")]), _vm._v(" "), _c('p', [_vm._v("Laila shouted addressing Maryam, “Bring some hot water and some towels, I’ll do it myself!”")]), _vm._v(" "), _c('p', [_vm._v("I asked eagerly, “Do you know how?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Yes, I watched Maryam and helped her when she gave birth to Shams, I can easily.”")]), _vm._v(" "), _c('p', [_vm._v("Reem was screaming, while Maryam and Laila were helping her to give birth.")]), _vm._v(" "), _c('p', [_vm._v("Reem began to babble, “I must give birth to a boy. If I have a girl, Karim will throw her in the street. I’ve seen him do it with other girls; who gives birth to a girl he throws the baby in the street and then the mother becomes a maid. He’s an evil man. I must have a son. He doesn’t take girls to teach them, he takes them to sell them to rich men, men with no morals or dignity. The girls shouldn’t have children from these men. Those who become pregnant should desert their men. If she gives birth to a boy, she stays in the palace to raise the baby, and if she gives birth to a girl, the girl is thrown into the street and the mother becomes a maid. His maids are cheaper than the ladies. He trades in girls. Oh my God, if they have girls, he throws them away. Most of the baby girls are taken to the shelter. When he visits the shelter to give alms, he looks for the most beautiful of them and claims to be a benefactor and wants to adopt her, a vile man. Please Zaina, don’t let anyone take my child from me.”")]), _vm._v(" "), _c('p', [_vm._v("I was listening to her with interest, even though she repeated it more than once and engraved her words in my head. She was delirious, but she was telling the truth. She was frightened and trembling and began to bleed heavily. Her delirium was increasing.")]), _vm._v(" "), _c('p', [_vm._v("“My mother wanted to warn you from Malik.”")]), _vm._v(" "), _c('p', [_vm._v("She grabbed my hand while she was screaming. The baby was almost born.")]), _vm._v(" "), _c('p', [_vm._v("She said, “Beware of Malik, beware of Salma, she is evil and hates you. She has flooded your land and will take your girls. I knew you were alive, but I did not speak, beware of Malik. Please, take care of my child, boy or girl; I do not want him to return there.”")]), _vm._v(" "), _c('p', [_vm._v("Finally, the child came out and started crying. It was a beautiful boy. Maryam carried him and wanted to draw him close to her. She smiled and the last thing she said, “Zaina, take care of my child as you took care of me, and forgive me. Then she passed away.”")]), _vm._v(" "), _c('p', [_vm._v("“My God! No, please don’t die!” I started screaming and crying. “Don’t die, please.”")]), _vm._v(" "), _c('p', [_vm._v("She was silent, not moving, quiet, cold, oh my God, how is that? She died in my arms, I shook her even harder but she never responded to me, she didn’t respond. Oh my God what should I do?")]), _vm._v(" "), _c('p', [_vm._v("Laila grabbed me tightly and said, “Go away. Faris said they’re looking for her.”")]), _vm._v(" "), _c('p', [_vm._v("“He was here to warn us. Run, Zaina. If Salma comes with them, she will know that you are alive and will not have mercy on you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Go away, and we’ll take care of her.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “But they will hurt you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Don’t worry, we’ll give them the baby, we’ll tell them we found Reem on the road and rescued her; just as what happened.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “She asked me to take care of her baby.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I’ll take him back later; it’s in my family now. I promise if they take him now, I’ll take him back. Leave now!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I will not go out before I take the child with me, and then she warned me from Malik, how do I go to him now?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “She does not mean Mr. Malik your father.”")]), _vm._v(" "), _c('p', [_vm._v("“Who then?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Faris told me that Nader had something to do with Karim.”")]), _vm._v(" "), _c('p', [_vm._v("“Nader!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he always visits him as Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, how dare he?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We’ll talk later, please leave now. Hide in Malik’s house; no one dares to come near it.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “But Reem is dead, oh my God, my sister is dead.”")]), _vm._v(" "), _c('p', [_vm._v("Laila grabbed me tightly and shook me.")]), _vm._v(" "), _c('p', [_vm._v("“Wake up, you fool. Since when did she ask about you? She only came to you when she got involved, and she will entangle you with her and lead to your destruction. If they notice your beauty, they will take you to be a servant of the nobleman.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her in astonishment, “Maid!”")]), _vm._v(" "), _c('p', [_vm._v("Hazem came to us and said, “Come on, Zaina, come quickly, they’re coming!”")]), _vm._v(" "), _c('p', [_vm._v("We got out quickly of the house. I actually saw them approaching us on their horses; the nobleman and a group of men. Salma was with them on a horse as well.")]), _vm._v(" "), _c('p', [_vm._v("Karim was screaming.")]), _vm._v(" "), _c('p', [_vm._v("“Where is my wife? Who kidnapped Reem?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “She’s in that house, I’m sure; they’ve seen her going there.”")]), _vm._v(" "), _c('p', [_vm._v("He shrieked and said, “I would burn it if anything bad happened to her!”")]), _vm._v(" "), _c('p', [_vm._v("My heart almost stopped, Hazem was pulling me and trying to get me away; we were running very fast. A voice shouted at him from afar, “Stop, you and those with you.”")]), _vm._v(" "), _c('p', [_vm._v("He turned to them after he hid me behind his back, he was huge so I couldn’t be seen anymore.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “There is no one with me; I am alone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “Liar, she might be behind you.”")]), _vm._v(" "), _c('p', [_vm._v("Karim to his guards, “Approach them and bring the girl.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam called from afar to draw their attention, “Your girl is here.”")]), _vm._v(" "), _c('p', [_vm._v("Everyone turned to her. Hazem pushed me and said, “Hide behind that tree, never show up no matter what you see!”")]), _vm._v(" "), _c('p', [_vm._v("I was so scared; I stood behind the tree and never became clear to anyone.")]), _vm._v(" "), _c('p', [_vm._v("Karim headed to Maryam and said, “Where is my wife?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mariam:")]), _vm._v(" “She’s upstairs, sir. We found her lying on the ground near our house. She was bleeding. She gave birth to her baby and died.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “What? Is Reem dead, you idiot? My wife is dead!”")]), _vm._v(" "), _c('p', [_vm._v("Laila appeared with a child in her hand.")]), _vm._v(" "), _c('p', [_vm._v("“But sir, your child is fine, we saved him.”")]), _vm._v(" "), _c('p', [_vm._v("Salma interjected maliciously, “You may have killed her!”")]), _vm._v(" "), _c('p', [_vm._v("Hazem headed towards them. I was very afraid for him; I don’t know what happened to me. I wanted to catch up with him, but he warned me to stay hidden from their eyes.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We didn’t kill anyone, madam.”")]), _vm._v(" "), _c('p', [_vm._v("Karim entered the house and quickly went upstairs. He came out with Reem in his hand. He ordered the guard to take the child from Laila, and gave Reem to another man to take her to his house. He looked at Hazem and said, “Who are you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “The master of the house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim (mockingly):")]), _vm._v(" “How did this happen, sir?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem did not answer him, he was afraid for the girls; otherwise he would have thrown him off his horse and killed him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “If I knew that you had a hand in her death, I would burn all of you, and what is stopping me from you now is the owner of the house, the fiancée of Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("As Maryam said, Karim thinks that Nader is Malik, and that he is my fiancé!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “We’ll find out from the doctor, and then we’ll come back for revenge.”")]), _vm._v(" "), _c('p', [_vm._v("Faris came from afar to reassure, he approached the house screaming, “Sir, they helped her, believe me, it was this family who saved the child, sir.”")]), _vm._v(" "), _c('p', [_vm._v("Salma turned to him with hatred and said, “How do you know?”")]), _vm._v(" "), _c('p', [_vm._v("He did not notice her presence at first. Perhaps if he had noticed this, he would not have come to the defense of Maryam.")]), _vm._v(" "), _c('p', [_vm._v("Salma approached Maryam and whispered in her ear, “What is he doing here? How did he know you helped her?”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was quiet and deliberately teasing her:")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, ask him.”")]), _vm._v(" "), _c('p', [_vm._v("Salma slapped her on the face, and turned to Karim and said, “Sir, I think we might benefit from her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “You fool, don’t you see my wife is dead!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Salma:")]), _vm._v(" “She’s good at dealing with the dead, and her friend too.”")]), _vm._v(" "), _c('p', [_vm._v("He said after Salma convinced him, “Well, bring them with us.”")]), _vm._v(" "), _c('p', [_vm._v("“You won’t take anyone of my house,” Hazem cried out.")]), _vm._v(" "), _c('p', [_vm._v("Maryam was aware of the gravity of the situation. She said quietly, “It’s okay, my dear, we’ll go with them to take care of the dead girl, and then we’ll come back.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “No one will go!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Do you dare to talk to me like that?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem grabbed his horse’s tether and said, “You won’t take anyone, leave with your men quickly!”")]), _vm._v(" "), _c('p', [_vm._v("Karim smiled and said, “Take the girls and burn the ground, and I’ll deal with Malik later.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem shook the saddle, which almost knocked Karim to the ground. Karim hit him with his foot and pushed him away from him. Hazem tried to attack him. But Karim’s bullet that penetrated Hazem was faster! Hazem fell to the ground and my heart fell with him. Oh my God, he killed him!")]), _vm._v(" "), _c('p', [_vm._v("All the girls came out because of the sound of bullets. Karim looked at them and said, “Take them with their daughters, we will benefit from them all. Only Samar and the babies are left in the house.”")]), _vm._v(" "), _c('p', [_vm._v("I wanted to run towards him, but one hand was placed over my mouth and the other prevented me from moving. I was dumbfounded, amazed, dazzled and confused. Oh my God, he killed Hazem; oh my God I didn’t help him! I wish I had gone out, but Salma would have known that I was her sister and had caused us all to die.")]), _vm._v(" "), _c('p', [_vm._v("It was Jawad who prevented me from going, he whispered in my ear, “Go now to Malik’s house and I will take care of the rest.”")]), _vm._v(" "), _c('p', [_vm._v("I pushed him away and said, “I won’t leave until I see Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("The land was burning in front of my eyes, my girls were leaving and Hazem was lying on the ground… They killed Hazem; they killed my heart and my soul with him.")]), _vm._v(" "), _c('p', [_vm._v("They let the fire eat the ground. I ran towards Hazem, who was lying in front of the house, oh my God.")]), _vm._v(" "), _c('p', [_vm._v("I approached him and tried to wake him up in various ways.")]), _vm._v(" "), _c('p', [_vm._v("I screamed, “Please don’t go away, don’t leave me alone.” I wept on his chest and said, “I was going to marry you. Don’t die; don’t leave me alone, I swear by God, I was going to marry you. I love you.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad pulled me up and said, “Go, please, someone may come back to make sure everything is as they want. Go and I will take care of everything.”")]), _vm._v(" "), _c('p', [_vm._v("“Please find the little girls and your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“Do not worry.”")]), _vm._v(" "), _c('p', [_vm._v("“Bury him in front of my flower garden, take care of him, I will come back to visit him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Go to Malik and tell him what happened; we need to get the girls back.”")]), _vm._v(" "), _c('p', [_vm._v("“Can he?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Sure, go away now.”")]), _vm._v(" "), _c('p', [_vm._v("And as Jawad expected, one of Karim’s men returned to check on the situation! I was hiding behind the tree.")]), _vm._v(" "), _c('p', [_vm._v("The man asked Jawad, “Who are you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “A passerby, sir, I saw a fire and came to see what was happening.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “It’s none of your business, go away.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Okay, sir.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad pretended to leave. Then he came back to me and said, “Go to Malik quickly!”")]), _vm._v(" "), _c('p', [_vm._v("I went running to Malik while I was crying, and a view of Hazem lying on the ground almost killed me. Yesterday we were dancing; yesterday he told me that I was his lover.")]), _vm._v(" "), _c('p', [_vm._v("Oh my God, no Hazem anymore, I have to get the girls back, I’m afraid he’ll sell them to someone. Who is that monster I’ve been in love with for years? I have to get to Malik. I arrived at Malik’s house; he was standing in front of the door waiting for me, afraid for me. He hugged me while I was crying and saying, “They killed him; they killed Hazem and took the girls. My God, the little ones, I must go back to get them, they stayed in the house.”")]), _vm._v(" "), _c('p', [_vm._v("He pulled me into the house and said, “Calm down and tell me everything, I promise I will act.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t talk, Hazem died, Reem died, how is this? Maryam is the reason. I told her that if Salma knew about Faris, she would destroy the house.”")]), _vm._v(" "), _c('p', [_vm._v("He shouted at me, “Calm down and speak softly so that I can help now or else I can do nothing.”")]), _vm._v(" "), _c('p', [_vm._v("I got back to delirium and confusion.")]), _vm._v(" "), _c('p', [_vm._v("“They burned the land, and he killed Hazem. He took the girls and killed Hazem!”")]), _vm._v(" "), _c('p', [_vm._v("Malik asked Dalal to bring water. I drank water. My tears filled my heart and drown my eyes! Then I began with a calm, sober talk in order to get my girls back.")]), _vm._v(" "), _c('p', [_vm._v("“We took Reem home, we helped her to give birth to a child and then she died. I went out exhausted and sad. Karim came to take his child and his wife; he quarreled with Hazem and killed him. He burned the land and took the girls.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik (angrily):")]), _vm._v(" “It’s time to stop that lousy!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, take revenge from them and bring me my girls, please.”")]), _vm._v(" "), _c('p', [_vm._v("He put his hand on my cheek and said, “Please, my dear, calm down, my heart is about to break for you, I promise I will take them back and Karim will go to hell.”")]), _vm._v(" "), _c('p', [_vm._v("“He and Salma.”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down, I’ll go out and be back soon.”")]), _vm._v(" "), _c('p', [_vm._v("He asked Dalal to take me to my room.")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand and said, “Watch out for Nader, he goes to him as Malik and I’m his fiancée.”")]), _vm._v(" "), _c('p', [_vm._v("He said wrathfully, “That jerk! Listen, if he comes and I think he’s coming, don’t tell him, you haven’t seen anything.”")]), _vm._v(" "), _c('p', [_vm._v("“Karim is the one who throws the little girls in the street, Reem told me.”")]), _vm._v(" "), _c('p', [_vm._v("I was panting and crying, but I was conscious of telling him everything, because Malik is powerful and has a lot of acquaintances.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Go to your room and change your clothes. I will ask the officer Kamal to come, and we will eliminate the miscreant and everyone with him.”")]), _vm._v(" "), _c('p', [_vm._v("“He imprisons young women in his house and sells them to rich people.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, wait, I won’t be late.”")]), _vm._v(" "), _c('p', [_vm._v("Before he left, I grabbed his hand tightly and said, “He killed Hazem; he killed him with a bullet. Make sure to bury him by the flower garden.”")]), _vm._v(" "), _c('p', [_vm._v("He turned to Dalal and said, “Take her to her room. Don’t leave her until she sleeps.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room with her. The first time I slept in this house. I changed my dress which was full of Hazem’s blood, and lay on the bed. I cried for more than an hour. Dalal did not leave me until I fell asleep, I don’t know how long I slept.")]), _vm._v(" "), _c('p', [_vm._v("I woke up to the sound of a baby crying. I went downstairs quickly. It wasn’t night, when I slept it was dark, but now it is afternoon; the sun is shining in the middle of the sky. I may have slept for a long time.")]), _vm._v(" "), _c('p', [_vm._v("I found Samar in front of me with the two little girls. I hugged her and asked Dalal to take care of them with the help of the servants. I looked at Samar and asked her, “How did you come here?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Samar:")]), _vm._v(" “I was hiding in the house, when they left; I was afraid that they would come back, so I went to Hazem and Jawad’s house and hid there. I stayed there till the morning. I took care of the little ones. Then Jawad came with an old man and brought us here.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Good, didn’t you see anyone?”")]), _vm._v(" "), _c('p', [_vm._v("“I was so scared that I didn’t leave my place until Jawad came.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, did you see Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("“The last time I saw him, he was lying on the ground.”")]), _vm._v(" "), _c('p', [_vm._v("“They killed him, they took him from me!”")]), _vm._v(" "), _c('p', [_vm._v("Dalal asked Samar to come with her, she took her and fed her after she gave her clean clothes, and then she came back to me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Don’t you want to eat, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“The last thing I remember eating were those sandwiches Hazem gave me. No, I won’t eat; I don’t want to forget their taste!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “I’ll make you coffee.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want; the last cup I drank was made by Hazem. He made me coffee and we danced and ate and then he carried me to my bed. If I fall asleep next to my flowers, who will take me back to my bed? They killed him, they took him from me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Why don’t you go to your room and rest, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“Take care of Samar and the little girls, please. Where is my father?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “When he came back, my dear, he found you sleeping. He didn’t want to wake you. He asked me to tell you that he would bring your girls back and that he would punish Karim. Actually, he left early in the morning. After a while, the girl came with a young man called Jawad. Jawad left immediately.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, if he or Jawad comes, tell me at once. I want my girls, be sure to remind him. When I see Maryam I will slap her hard, but I will not expel her because she is Hazem’s sister.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room while I was delirious. I lay on my bed and went back to a deep sleep. Malik was entering my room and checking on me from time to time. He was so worried about me. I didn’t wake up until the next morning. When I woke up I found him beside the bed.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Finally, you woke up, my little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him crying, “He always called me, my little girl, but they took him. Did you bring the girls?”")]), _vm._v(" "), _c('p', [_vm._v("“We’ll get them. Don’t worry, very soon, but now you have to get up and eat something, and then I want you to meet Mr. Kamal.”")]), _vm._v(" "), _c('p', [_vm._v("“I ate sandwiches that Hazem made for me. If I eat anything, then the taste will be gone, I will forget it. I don’t want that. He bought me a scarf by everything he owns. Where is my box?”")]), _vm._v(" "), _c('p', [_vm._v("“If you don’t eat I won’t bring the girls. Please sweetheart, I can’t stand losing you, you must help us to catch Karim.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I want sandwiches like the ones I ate with Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He asked the servants to prepare the sandwiches. I put on a black dress and went down to the dining room. I looked pale and tired. I sat on the chair; the table was full of all kinds of sandwiches, but none like the ones I ate with Hazem. I had to eat; I must gather my strength to bring my friends back.")]), _vm._v(" "), _c('p', [_vm._v("In the afternoon, Kamal came and was so excited to catch up with Karim, I greeted him sadly.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “Sit down, my lady, and tell me what happened in details.”")]), _vm._v(" "), _c('p', [_vm._v("“He killed Hazem, and burned the ground. He killed Hazem and stole my girls. He killed Hazem and left in cold blood.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “Tell me the story since you met his wife.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I was heading home with my father, suddenly, I heard a woman’s scream. I got out of the car and Hazem was behind us. He came and helped me to take her home. I wish he had let her die in the street. His fault was that he took her home to save her life! He killed Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("Kamal was patient with me, I was conscious but at the same time I was delirious about Hazem. Anyway, I knew what to tell him!")]), _vm._v(" "), _c('p', [_vm._v("I was silent for a moment, and then I added, “Hazem was killed. His wife told me that he takes beautiful girls, not to teach them and give them the chance to marry nobles, but to trade them, and woe to who gives birth to a daughter; He threw the girl in the street. He kept the most beautiful for himself, for his cheap desires, for his miserable soul. The stupid man; every girl is equal to a tribe of men. Who was working and selling vegetables and tools to people? Aren’t the girls who do this? He is a rotten ignorant, who thinks himself a nobleman; the nobility should be in morals and giving! The important thing you should know sir is that he took my girls and you must return them to me. She also told me that he locked some girls in his house. She warned me of Nader, that he was impersonating my father in order to get close to him. He probably didn’t love me that liar, not like Hazem who truly loved me. He killed Hazem and you have to bring my girls back.”")]), _vm._v(" "), _c('p', [_vm._v("I left him without asking permission and proceeded to go up to my room crying and saying he killed Hazem! He would not have reproached me, for my condition made him shed tears from his eyes, even Malik, that steadfast man who did not shed a tear for his daughter, cried for me.")]), _vm._v(" "), _c('p', [_vm._v("When I was on the stairs, he called me, “Madam, please, if Nader comes, pretend that you don’t know anything. I have confirmed from my sources that they are friends, and that he goes to his house almost every day.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, don’t worry; I’m a very strong woman. He won’t notice, but I should know why he was lying. He should be punished for Hazem’s death, they killed him; the nobleman Hazem was killed.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he is noble with his morals and courage; he did not accept insulting us. He is noble; when the land sank, he kept working on it patiently until it bloomed again. He is noble when he was covering up his sister crimes. He is noble when he gave me my freedom to choose whom I love while I am his lover. It became clear to me that the noble is vile and the poor is noble.”")]), _vm._v(" "), _c('p', [_vm._v("I lay on my bed and fell asleep, I was running away from my sadness by sleeping. How could I wake up and everyone was absent. Laila always woke me up with her loud voice; it was annoying sometimes, but today I do not want to hear anyone but her.")]), _vm._v(" "), _c('p', [_vm._v("She stood in front of me, wearing a long white dress. She looked like a moon in a dark night. She was like an angel. Her blue beautiful eyes were shining as if they were a blue beautiful calm sea. I wanted to slap her or may be stabbing her but I couldn’t. She smiled childishly and said, “Are you going to take care of my kid as you took care of me?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her in amazement and said quietly, “Is he going to steal my life as you did? You stole my dreams, the nobleman, my poems, and finally you stole the love of my life, Hazem. You killed Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("She approached me and put her hand on my face and said, “If I didn’t steal the nobleman from you, you will be in my place today. You will be lost between earth and sky. If you were in my place, you wouldn’t have the chance to hug your kid. Take care of my son please. I didn’t kill Hazem, but I am sorry. I am so sorry for everything. Please forgive me and take care of my kid. You have the safest and the most beautiful heart. Promise me, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I started crying. “I promise…but I am so sad. I lost you and Hazem at the same day. How much I missed you. How much I wanted to ask you what I did for you to ruin my life. I spent all my savings to buy you a beautiful dress. I was your mother not just a sister. I will take care of your kid. I promise. I forgive you…. I forgive you and I will take care of your son.”")]), _vm._v(" "), _c('p', [_vm._v("I woke up crying and saying in a sad suffocated voice, “I promise.”")]), _vm._v(" "), _c('p', [_vm._v("In the morning, I decided to go to visit my garden; four days passed. Dalal tried to prevent me from going out, but in vain. Malik looked at me firmly and said, “Are you crazy, my daughter, I’m afraid someone will hurt you.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him tenderly and said, “You are a wonderful father! I won’t be late I promise, I’ll water the flowers and come back.”")]), _vm._v(" "), _c('p', [_vm._v("He could not refuse my request and at the same time, he sent two strong men behind me so that no one would attack me.")]), _vm._v(" "), _c('p', [_vm._v("I reached the land; I only saw ashes. My wonderful land turned to ashes; this is the second time that the land got destroyed. Thank God, the fire did not reach the house or the flower garden. Jawad’s house was almost destroyed. Oh my God, how could Samar sit in it, and where did she hide? Perhaps she hid behind it; not inside it. I entered my house; it was empty, ugly, and cold. It was full of girls and their laughter, and Laila screaming at them. I miss Laila, my God, I am afraid that something bad will happen to them. Malik and Kamal promised me that they would bring the girls back.")]), _vm._v(" "), _c('p', [_vm._v("I went to my garden and sat on the chair. I contemplated the flowers, I picked a white flower and scattered its leaves in the air, I picked another red one and scattered it as well. I remembered our random dance and sandwiches, his dance was funny, and I was funnier than him. The place was full of the smell of his coffee.")]), _vm._v(" "), _c('p', [_vm._v("I was afraid to fall asleep on the chair, there is no one to carry me and put me in my bed, even my bed is stained with Reem’s blood. Reem took everything from me. Maybe she was right when she told me in my dream, that if she didn’t marry Kareem, I would be in her place today. How confused and sad I am. How can I heal from what happened?")]), _vm._v(" "), _c('p', [_vm._v("I came home with slow steps. I wanted to stay in my house, but it was cold, empty, and harsh. The frost almost gnawed at my body, it almost ate my flesh; I wish I had put on a coat. As if the warmth comes in the form of people! I’ve always been cold, and Laila’s smile makes my ribs warm, and the laughter of girls creates a sun inside my heart. If Laila was here, I might stay, but she was not here! I met Jawad, I smiled; he was one of the inhabitants of the house.")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “How are you?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “They killed Hazem, how could I be?”")]), _vm._v(" "), _c('p', [_vm._v("He replied in a sad tone, “I wish he knew how much you love him!”")]), _vm._v(" "), _c('p', [_vm._v("“I whispered to him in his ear, but he was dead. He might have heard me, perhaps not. If only he had heard me, then my soul would rest. I was so mean with him when I thought I loved Nader. He was patient with me, and when I realized that I loved him, he left me!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Enough please, I’ll take you back to Malik’s house, I’ve been with him; he’s very worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going there, I’d like to stay in my house but it’s cold and empty. It was always full, but today it’s empty!”")]), _vm._v(" "), _c('p', [_vm._v("Sadness ran through my body, as if my limbs were dying. His death, the scorched earth, and the imprisoned girls; which mind can bear all these misfortunes? Life is not ours, the more we advance we return. Is it reasonable that a lady like Salma lives and enjoy, and we who strive for life live the lives of the dead? Why is my mind frozen today? Perhaps it will leave; it will take my heart and my soul and fly away. Perhaps I will follow Reem, so that I may understand why she put me in such situation. I have never abused anyone and I have never dared to take what is not mine. Whenever I own something, it flows from my hands as water flows through fingers!")]), _vm._v(" "), _c('p', [_vm._v("How can my heart take all this trouble? I miss myself, my smile, and the beauty of my eyes, as if they lost their sparkle with Hazem’s passing!")]), _vm._v(" "), _c('p', [_vm._v("Jawad grabbed my hand and led me to Malik’s house. Malik smiled when he saw me.")]), _vm._v(" "), _c('p', [_vm._v("“Come on, my dear, don’t go there again.”")]), _vm._v(" "), _c('p', [_vm._v("“I will go every day to water my flowers.”")]), _vm._v(" "), _c('p', [_vm._v("“Are they beautiful?”")]), _vm._v(" "), _c('p', [_vm._v("“Very beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“I will accompany you tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', [_vm._v("Dalal said spontaneously, “Can I go to see your flowers?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “I can take you now.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “We’ll go tomorrow, you must rest now. Nader will come in a little while to visit you.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to see him.”")]), _vm._v(" "), _c('p', [_vm._v("“We must understand from him how we will get the girls back; he knows all the methods of the nobleman. Beware; he shouldn’t know that we have exposed him.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll change my clothes first. Don’t worry I will be conscious of what I have to say.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a strong woman, you must face this matter with courage; I depend on you.”")]), _vm._v(" "), _c('p', [_vm._v("“Strong? Is there strength in losing loved ones, where is the strength now? If I die, will you be strong?”")]), _vm._v(" "), _c('p', [_vm._v("“No. Please! I may bear the pain of the whole world but not your absence. My dear, I mean strong to get your girls back. Be strong like Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("“There is no one like Hazem, he was very persistent. He confronted Karim with boldness and said to him, ‘I am the master of the house.’ Although he knew that Nader loved me, he was patient with me.”")]), _vm._v(" "), _c('p', [_vm._v("“He was certain that your love for Nader was false, as he hoped that you would eventually return to him.”")]), _vm._v(" "), _c('p', [_vm._v("I said while tears welled up from my eyes and my voice became stifled, “But they killed him before he knew.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Enough, please, do you think Hazem would be content to see you grieving to such extent? Go now, change your clothes, and come quickly, I’m afraid he’s selling the little ones.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him eagerly, “No, that won’t happen, we’ll get them before he disposes them.”")]), _vm._v(" "), _c('p', [_vm._v("I wore a black dress with a white collar. I greeted him quietly. He looked sad.")]), _vm._v(" "), _c('p', [_vm._v("“My condolences, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “You are late, what was the reason?”")]), _vm._v(" "), _c('p', [_vm._v("I was steady, I wanted to know who the real Nader was and what he wanted from me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “I was traveling and when I found out I came right away.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “It’s okay, you’re here now.”")]), _vm._v(" "), _c('p', [_vm._v("“I see that you are very sad, your eyes are red from crying; I wish I had brought Ashraf with me to examine them.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “No, not from sorrow, but the ashes of the earth burned my eyes. Do you know the nobleman Karim? They told me that you have many acquaintances, and you have good relations with important people.”")]), _vm._v(" "), _c('p', [_vm._v("“Why, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“He took my girls.”")]), _vm._v(" "), _c('p', [_vm._v("“You were about to die because of your girls; forget about them.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, does he not know that I am Lady Zaina Malik? How dare he take them without my permission or my father’s permission? This is an insult to our position.”")]), _vm._v(" "), _c('p', [_vm._v("“He has them now.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and put my hand on his hand that I wished to cut off, and said;")]), _vm._v(" "), _c('p', [_vm._v("“Listen, my dear, we will marry soon, and it is a shame that he stole our girls. We have the right to take them back. Who will work in our wedding party?”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll get you a million girls.”")]), _vm._v(" "), _c('p', [_vm._v("“I want my girls, my dear; even if you have to pay him money, give me all the girls back. I don’t want to go in a war with him; on the contrary, I want the girls to come back quietly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Yes, Nader, tell him that I am ready to pay any amount. And we will ignore that he burnt our land. We appreciate his painful affliction for his wife. As for the issue of Hazem’s murder, we have nothing to do with it; two people had quarreled, as a result, one killed the other.”")]), _vm._v(" "), _c('p', [_vm._v("I responded to Malik’s words, “Yes, let him bring back the girls. Let us begin a new era with him, that we may share our trade with him in the future.”")]), _vm._v(" "), _c('p', [_vm._v("Nader was very enthusiastic.")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll go now and see what to do.”")]), _vm._v(" "), _c('p', [_vm._v("He left quickly and promised me that he would return immediately after meeting him.")]), _vm._v(" "), _c('p', [_vm._v("Kamal was waiting for a sign from Malik to attack Karim’s house and arrest him, but Malik asked him to wait until Laila and the girls returned. The girls will testify against Karim and his wickedness.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Malik and said, “You saw how strong I am.”")]), _vm._v(" "), _c('p', [_vm._v("“This is the Zaina I know, go to your room now, and try to sleep until he comes back.”")]), _vm._v(" "), _c('p', [_vm._v("“Send Jawad to watch him, people like him are not honest.”")]), _vm._v(" "), _c('p', [_vm._v("“I have sent those who are stronger than Jawad.”")]), _vm._v(" "), _c('p', [_vm._v("Nader went in his car directly to Karim’s house. His servants greeted him warmly as Mr. Malik. A long conversation took place between them, as Nader told me. Nader was able to convince Karim that we would pay a significant amount in return for the girls. He was also able to convince him that we would work with him in the future and there would be business between us. Karim considered the girls as an acquired right to him after Hazem insulted him, as if he owns the universe. How mean he is; he took advantage of their weakness.")]), _vm._v(" "), _c('p', [_vm._v("Nader came back to us alone; I greeted him with great tension.")]), _vm._v(" "), _c('p', [_vm._v("“Where are Laila and the rest?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “After much effort, he agreed to return them to you, but you must pay him the money first.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Well, tomorrow we send the money and he sends the girls.”")]), _vm._v(" "), _c('p', [_vm._v("I replied nervously, “We see the girls first and then we give him the money. We don’t know if they are alive or not; he killed Hazem in cold blood, and whoever kills once, he will kill a million times! I will go to him.”")]), _vm._v(" "), _c('p', [_vm._v("Malik yelled at me, “You will not leave your place; I swear if he sees you, he will imprison you with him. You do not know how much beautiful you are!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nader:")]), _vm._v(" “He’s right, don’t you trust me? Tomorrow I’ll give him the money and we’ll take the girls.”")]), _vm._v(" "), _c('p', [_vm._v("I was afraid if I insisted more that Nader would give up and refuse to interfere, so I went up to my room without even asking permission.")]), _vm._v(" "), _c('p', [_vm._v("We were trying to get them back at any cost. How worried I was for them! During that period, Salma was exploiting them in the most horrific way. She made Maryam her maidservant, and was threatening her if she did not listen to her words, she would torment her daughters.")]), _vm._v(" "), _c('p', [_vm._v("As for Laila, she used to serve in the kitchen with the rest of the maids. They were subjected to a humiliation they have never been subjected to before.")]), _vm._v(" "), _c('p', [_vm._v("In spite all what happened, the women in the house sympathize with them. Salma had huge authority in the house and everything was under her control. She even used to sell girls and set their prices. With Maryam, all this does not work; her knife is always present if anyone approaches her daughters!")]), _vm._v(" "), _c('p', [_vm._v("Indeed, Salma had plotted to send Maryam’s daughter to a rich house to work as a maid. One of the women reported the news to Maryam, and since the noble was busy with Reem’s death, he was not concerned with Salma and the women’s affairs. After a week, Sarah should be handed over to the man. So Maryam had time to rescue her girl. In agreement with the women of the house, Maryam took a knife stealthily and went up to Salma’s room. She did not find her, but she found Reem’s child there. She took him and ran towards the kitchen. Salma was instructing the ladies in the kitchen. Maryam gave the baby to Laila, and asked her to wait for her in the hall, one of the girls noticed Maryam and smiled; she hated Salma more than her. She whispered to her friend to give her a knife. She was the closest to Salma, so she stabbed her three times. In every stab, she was saying “die,” her voice was mixed with pain, humiliation and contempt for Salma’s personality. Salma fell on the ground and her blood filled the place. The women started screaming loudly. The killer girl laughed and said how I not thought of that, her laughter was nothing but pent-up screams of pain.")]), _vm._v(" "), _c('p', [_vm._v("Maryam approached Salma, while Salma was taking her last breath she whispered to her, “Don’t worry, my dear, I’ll take care of your husband and your baby.”")]), _vm._v(" "), _c('p', [_vm._v("O her boldness! How did she think of killing her; inside the nobleman’s house and among all the women? She was going to be imprisoned instead of that girl, she didn’t care! She was also able to bring the child; no one has that courage but Maryam. Perhaps her grief for her brother, her deep passion for her girls, and the cruelty of Salma granted her all this strength. It was that lady’s knife that saved her from prison and will also bring her back to her home.")]), _vm._v(" "), _c('p', [_vm._v("All people in the house gathered around them. Karim came and watched Salma as a dead body.")]), _vm._v(" "), _c('p', [_vm._v("“What is the matter?” he shouted at them.")]), _vm._v(" "), _c('p', [_vm._v("The girl cried. “I killed her with my knife.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Is this the right time?”")]), _vm._v(" "), _c('p', [_vm._v("Karim asked the guards to hand the girl over to the police. He never cared about Salma’s death; she didn’t mean anything to him. Maybe he was already bearing her presence in his house for Reem, or maybe in order to facilitate some of his work!")]), _vm._v(" "), _c('p', [_vm._v("The girl looked at him and said, “Come on, take me to prison. The prison there is more merciful than my prison here!”")]), _vm._v(" "), _c('p', [_vm._v("He asked his men to clean up the mess and then turned to Maryam and said, “Aren’t you the ones whom we brought here a week ago with their girls?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Yes, sir.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Gather your women and leave the house today, go home; your lady has set you free. Send her my regards.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, sir, thank you.”")]), _vm._v(" "), _c('p', [_vm._v("Karim asked his men to take them home. He never noticed that the child was with Laila.")]), _vm._v(" "), _c('p', [_vm._v("Maryam brought the girls and Laila. They tried to hide the child, but Karim’s men did not care at all; perhaps they thought it was one of their children, because they used to see women with their children inside the house.")]), _vm._v(" "), _c('p', [_vm._v("The girls came home just as Nader had promised. Maryam went directly to Hazem’s house, called him, but he did not answer her.")]), _vm._v(" "), _c('p', [_vm._v("She realized that he had left her; she sat on the floor and started crying.")]), _vm._v(" "), _c('p', [_vm._v("Laila put her hand on her shoulder, while tears were welling up from her eyes.")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, my dear, we’ll get through it, he was defending all of us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Are we going to exceed his death? How do we get over his death? I was the reason, yes, as Zaina said, I dragged the woe to the house; I am the reason behind my brother’s death. Where is Zaina? I want to give her the baby; I promised her I would take him back.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Don’t worry; she doesn’t know we’re here yet. I am sure she’ll come as soon as she knows about our presence. Come on, my dear, be strong, we have a lot to do.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Who will take care of the land?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “We will take care of it. Come now, my dear, we must prepare the house to receive Zaina. God knows how much she suffered in our absence.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “She hates me now, I know, she doesn’t even wish to meet me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Zaina does not know how to hate, my dear, otherwise she would not have taken you out of the nobleman’s house.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Right, she helped me, so she doesn’t hate me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Come home, the girls are hungry and they must be fed.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Where are Samar and the little girls? Oh my God, I do not see them, I am afraid that he killed them as he killed Hazem. Oh my dear Hazem, I will not see him after today!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Don’t worry, definitely, Zaina took them, let’s go home.”")]), _vm._v(" "), _c('p', [_vm._v("They came home and watched it just as I saw it, cold and empty! Laila was at that moment the strongest, she ordered the girls to help her. Within a few hours they cleaned the house well.")]), _vm._v(" "), _c('p', [_vm._v("Jawad passed by them and was very happy to see them, I had sent him before to check their presence; he ran back to me.")]), _vm._v(" "), _c('p', [_vm._v("“Zaina, the girls are at home.”")]), _vm._v(" "), _c('p', [_vm._v("“Really, do everyone returned? Are they all okay?”")]), _vm._v(" "), _c('p', [_vm._v("“Laila is waiting for you and says the girls are hungry.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I will ask Dalal to send them food.”")]), _vm._v(" "), _c('p', [_vm._v("“Come on, let us go there.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go tomorrow, take the food please, and tell them I will see them tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“How strange you are! You were praying to get them back, and when they return, you don’t want to see them!”")]), _vm._v(" "), _c('p', [_vm._v("“What will I tell them if they ask me about Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("“Dear Zaina they know about his death, come on, let us go there.”")]), _vm._v(" "), _c('p', [_vm._v("“But the house is very cold and I am tired.”")]), _vm._v(" "), _c('p', [_vm._v("“Well then, I’ll come tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, do not forget the food.”")]), _vm._v(" "), _c('p', [_vm._v("Malik was looking at me from afar sadly, he did not wish to see me like this, I was crumbling and corrosive to myself.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Go my dear, may be seeing them will decrease your pain.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him with a smile, and went up to my room, whispering to myself that they could not reduce their pain how could they reduce mine?")]), _vm._v(" "), _c('p', [_vm._v("Jawad returned with food for the girls. Malik also gave him a sum of money to hand over to Laila to buy everything they needed.")]), _vm._v(" "), _c('p', [_vm._v("Laila was the strongest and most focused among us, despite her love for Hazem, but he was not her brother or her lover, her affliction was much less than ours.")]), _vm._v(" "), _c('p', [_vm._v("Despite Maryam’s great sadness for him, her care for the girls took most of her time and thinking, as this was enough to distract her from thinking about him, but I had nothing to distract me from thinking about him.")]), _vm._v(" "), _c('p', [_vm._v("In the evening, after I had spent most of my day in bed, I brought my box and took out the scarf that he had bought me one day and put it on my shoulder. I took off the precious necklace that Nader had given me, and put in its place the simple and beautiful necklace that Hazem had given me. He would buy me anything with all his savings; he was so generous with me. How stingy I was in my feelings with him, how much I would like to see him even for a few minutes and apologize to him for my cruelty! Oh my God, will I ever get through this ordeal? Indeed, death will be better for me and will have mercy on me at this moment!")]), _vm._v(" "), _c('p', [_vm._v("Laila could not wait for tomorrow, so in the evening she came to visit me with little Zaina.")]), _vm._v(" "), _c('p', [_vm._v("She looked at me and said, “How are you?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “How am I? How do you find me? How I could be and Hazem is dead, they killed him!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they killed him.”")]), _vm._v(" "), _c('p', [_vm._v("The little girl jumped up at me and said, “You saw what Salma did to us, the fool died because she is evil.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Yes, she was killed at home.”")]), _vm._v(" "), _c('p', [_vm._v("“Was she killed? Who killed her?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know; a girl stabbed her by her knife.”")]), _vm._v(" "), _c('p', [_vm._v("“Who?”")]), _vm._v(" "), _c('p', [_vm._v("“Not whom you think! All the women there hate her. She killed by a girl whom Salma used to be cruel with her and was humiliating her.”")]), _vm._v(" "), _c('p', [_vm._v("“She deserved it. I hope that knife will pierce and destroy Karim’s heart.”")]), _vm._v(" "), _c('p', [_vm._v("“Do not worry, my dear, his day will come soon. Every unjust deserves that ending! Well, I wanted to check on you. Thank God that you are fine, I will leave you now. We will wait for you tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t go, stay here. If it gets late, I will send someone to bring you back or you can sleep here.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “Yes, I’ll sleep next to you.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Yeah, you’ll sleep next to me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I’ll stay, but we won’t sleep here, I can’t leave Maryam alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t she come with you?”")]), _vm._v(" "), _c('p', [_vm._v("“She takes care of the little girls; she found that they need care after her absence. Samar also needs care, she must stay with them. It is not appropriate to bring everyone with me my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I approached her and pulled her by her hand.")]), _vm._v(" "), _c('p', [_vm._v("“Come sit down and tell me what happened with you.”")]), _vm._v(" "), _c('p', [_vm._v("She told me everything; how Salma was about to sell Sarah, and how she treated them fiercely. She also told me that she saw Nader; he was coming to the house every day. Salma was greeting him warmly and offering him the most beautiful girls. Salma and Maryam were watching everything. Despite the bitterness of the days and the humiliation they had been subjected to, they were aware of everything and every detail.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I don’t know why he was presenting himself to them as Mr. Malik?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “In order to appear a very rich man, and at the same time, he did not want anyone to know him; he feared scandal in front of his society and his partners!”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe.”")]), _vm._v(" "), _c('p', [_vm._v("“How is Maryam?”")]), _vm._v(" "), _c('p', [_vm._v("“Sad, in pain, but solid. Don’t worry about her she will recover. You have to fear for yourself. If you stay like this, you will lose your health. You are withering, my dear, we all need you; don’t you see that the land is scorched and needs care?”")]), _vm._v(" "), _c('p', [_vm._v("“The one who took care of her had died!”")]), _vm._v(" "), _c('p', [_vm._v("“Who taught him how to take care of it? Would he have known anything about farming without you? Would he accept to see you in such situation? He never wanted his rose to wither.”")]), _vm._v(" "), _c('p', [_vm._v("“Who waters that rose and nourishes it? Who will take care of me and restore my luster?”")]), _vm._v(" "), _c('p', [_vm._v("“You are the one who made your splendor, and you are also the one who made Hazem what he was. Be strong for his sake, for all of us, for the sake of Reem’s son, did not she leave him as a trust with you?”")]), _vm._v(" "), _c('p', [_vm._v("“His father took him!”")]), _vm._v(" "), _c('p', [_vm._v("“Maryam brought him back; he is beautiful, and he has your eyes and the eyes of his mother, what do you think if we call him Hazem? Did you not swear that if you had a child, you would name him Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("“Really, I want to see him.”")]), _vm._v(" "), _c('p', [_vm._v("“Come to see him tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“No, now I’ll go with you.”")]), _vm._v(" "), _c('p', [_vm._v("Malik was sitting close to us and overheard all our conversations. He came towards us and said, “I’ll go with you; I want to see the child.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Come on, you’ll see little Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("We all went home. Maryam was standing in front of the door carrying the baby. She knew that Laila would come back with me. I looked at her, but I was not angry with her as I thought, on the contrary, I was very sad for her.")]), _vm._v(" "), _c('p', [_vm._v("She suffered so much; she lost the last member of her family. Actually, he was her only family. I had sworn one day that when I saw her I would slap her. Instead of that, I took the child from her and gave it to Laila, and then I hugged her, and said, “It’s okay, my dear, I know nothing will compensate us for him, but he will remain in our hearts as long as we live.”")]), _vm._v(" "), _c('p', [_vm._v("She did not answer, but sat on the chair and cried. I turned to Laila and tears filled my eyes. I took the child and looked directly into his eyes, he was very beautiful, and he looks like Reem and carries the color of our eyes. I hugged him and kissed him and then brought him back to Maryam and said, “I can’t take care of him now, but you’ll take over until he’s a little older and then I’ll raise him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “He’s under my care, don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("“I never worry about a child with you.”")]), _vm._v(" "), _c('p', [_vm._v("I approached her and whispered in her ear, “Who killed Salma?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I swear I would, but that girl outran me. It is better to get back to the kids, or else I’d be in jail where she is now.”")]), _vm._v(" "), _c('p', [_vm._v("“Good.”")]), _vm._v(" "), _c('p', [_vm._v("Malik approached and said, “Can I hold baby Hazem now?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Yes, sir.”")]), _vm._v(" "), _c('p', [_vm._v("He took him in his hands and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“How similar to you, Zaina!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “How not and he is my child.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam took the baby and put him in his bed. Laila made us coffee. I took my cup and went to my flower garden. Malik followed me and everyone followed him. We sat around the garden. I couldn’t drink coffee. I returned the cup to Laila and asked Malik to come home. I left them after I promised them that I would come back tomorrow.")]), _vm._v(" "), _c('p', [_vm._v("We didn’t know where to start repairing the land, I didn’t care too much. The first time Malik, with Nader’s help, sent a team of specialists to save it. Certainly, at that time I would have gone crazy if it didn’t recover. Hazem did all the hard work until the land bloomed and returned to giving. Today, I don’t care even if it doesn’t bloom again; maybe because Malik provides us with money, or maybe because everyone is exhausted. In fact, because her master is no longer there; if he was alive, he would plant it alone without anyone’s help!")]), _vm._v(" "), _c('p', [_vm._v("I was coming every day to check on the house and my flowers and then come back to spend my day with Malik. He took care of me and helped me a lot. I was sitting on the sofa in the big hall, and he was sitting next to me reading for me a book or telling me a story. I was sitting with him and my mind was completely absent from him.")]), _vm._v(" "), _c('p', [_vm._v("Nader used to come to us every day. He did not get the attention from me that he wanted. He tried hard to make me happy, and when he asked me about the reason for all this, I said because of the scorched land. He wanted to help me in fixing it and returning it to its first course, but I refused. The only goal from meeting him was to gather information about the nobleman!")]), _vm._v(" "), _c('p', [_vm._v("Kamal enlisted himself for the matter. He placed watchmen throughout the city. All he wished was to prove the nobleman’s guilt and arrest him.")]), _vm._v(" "), _c('p', [_vm._v("Karim remained in a state of grief for Reem for two weeks, and then reappeared in the city looking for beautiful young girls. He passed through all the houses and did not choose anyone. the first time in years that he roamed the whole city and came back empty-handed, perhaps he was looking for a girl with beautiful blue eyes to make up for him of Reem.")]), _vm._v(" "), _c('p', [_vm._v("The families have not yet known about him. Kamal wanted us to keep the matter a secret till he was arrested. He was slow to arrest him because of Karim’s extensive relations with important people and personalities. He had to be quilted so that everyone would disavow him.")]), _vm._v(" "), _c('p', [_vm._v("The house was back as it was; some of the wounds were healed. Laila was steadfastly able to put things in order, while Maryam’s responsibility was to take care of the girls.")]), _vm._v(" "), _c('p', [_vm._v("After Salma’s death, Jawad’s mother’s condition deteriorated very much. Salma was her source of livelihood. Her staying with her husband depended on how much money she gained for him. He expelled her and her only refuge was her son Jawad.")]), _vm._v(" "), _c('p', [_vm._v("I went to the girls after I had been away from them for two days. I brought them a large box of cakes; Dalal prepared it for them. Sarah jumped towards me and took it. I smiled and asked about my little child Hazem. I turned and saw Jawad’s mother sitting with Laila complaining about her condition.")]), _vm._v(" "), _c('p', [_vm._v("Without realizing anything, I looked at Maryam and asked her angrily, “What is she doing here?”")]), _vm._v(" "), _c('p', [_vm._v("Jawad’s mother got up and walked towards me.")]), _vm._v(" "), _c('p', [_vm._v("“Please.”")]), _vm._v(" "), _c('p', [_vm._v("I couldn’t hear her anymore; I interrupted her and added firmly, “Leave now.”")]), _vm._v(" "), _c('p', [_vm._v("I got out of the house; I couldn’t sit there any longer. Jawad followed me; he grabbed my hand and said, “She is my mother.”")]), _vm._v(" "), _c('p', [_vm._v("I told him, angrily, “Since when? Since she’s been punishing you and leaving you out of the house in the cold, or since she sold us all to Salma, or since you took to her Gaith and she kicked him out; since when is she your mother? Please answer me…since when do you consider her a mother?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Calm down, I’ll take them and go, but I won’t give them up.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him with tears in my eyes, “You will leave me, you will leave, and who is left for me? Leave, did you know? I will leave and will not come back here.”")]), _vm._v(" "), _c('p', [_vm._v("Laila came out, she called me, “Zaina, please, she is his mother, these are not your morals.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her wrathfully.")]), _vm._v(" "), _c('p', [_vm._v("“I said I’ll leave and do whatever you want.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “You should know that I would not keep her for her sake, but for the sake of my brothers, it was you who taught me this. You are the one who cared for me when she expelled me. I never had a mother but you. Do you remember our old days? Do you remember the market and baskets? Who used to feed and shelter me? Please do not leave, allow me to repair my house, and I promise you that you will never see her, not even coincidentally.”")]), _vm._v(" "), _c('p', [_vm._v("Laila put her hand on my shoulder and said, “She is regretful. Everyone makes mistakes and we must forgive.”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “Do what you want, I will not forgive her and I do not want to see her. I will go now and I will return tomorrow.” I looked at a Jawad and said, “Bring Gaith, he is not safe with Nader after today.”")]), _vm._v(" "), _c('p', [_vm._v("I came home and told Malik what had happened while I was crying.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “How about you go and sit for a few days in our house?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to, who will take care of my flowers?”")]), _vm._v(" "), _c('p', [_vm._v("“I will send Dalal to look after them.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will not travel.”")]), _vm._v(" "), _c('p', [_vm._v("“At least bring your clothes and come back.”")]), _vm._v(" "), _c('p', [_vm._v("When he said, your clothes, I suddenly thought of the jewels that I had taken from the dresses that hung in this house. I was afraid that he would check them and not find the jewels. So I must go there. I will travel tomorrow, after I check my flowers. I will bring the jewels. If he sees them, I will tell him that I was afraid that they will be stolen, so I brought them with me. In any case, I will return them to him.")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and said, “Well, Dad, I’ll go tomorrow. I’ll sit there for a week and then come back. I want to sit alone and think; I must think of the coming days.”")]), _vm._v(" "), _c('p', [_vm._v("Oh my God, how am I going to accept the idea of having Jawad’s mother in my house after she betrayed us!")]), _vm._v(" "), _c('p', [_vm._v("I never slept that night! Many things were running through my head; I was afraid that Malik would insist on traveling with me, I wanted to go alone. I prepared myself for the trip because I decided to leave so early.")]), _vm._v(" "), _c('p', [_vm._v("I found Malik waiting for me.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go with you, baby.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “What woke you up so early?”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t sleep thinking of you, my dear. I’ll go with you, spend a week there, and then come back together.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go alone, please, I want to sit alone.”")]), _vm._v(" "), _c('p', [_vm._v("“No, my daughter, there are no servants there. I will go and Dalal with you so that you will not sit alone.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go alone, I don’t need servants. I won’t be able to take care of you. I won’t spend the week; I promise I’ll be back early.”")]), _vm._v(" "), _c('p', [_vm._v("“Then take Dalal with you, no one is there to serve you, all the servants are here.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “I promise you, my dear, I will never bother you.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll go to visit my land, and when I come back, you’ll be ready.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Don’t be late, it’s too early.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry, it’s my house.”")]), _vm._v(" "), _c('p', [_vm._v("I went to the flower garden, it was very beautiful and watered, Laila must have taken care of it; I sat on the chair and contemplated it.")]), _vm._v(" "), _c('p', [_vm._v("“Your garden is very beautiful, Mrs. Zaina…”")]), _vm._v(" "), _c('p', [_vm._v("I heard the voice; it panicked me, I stopped and turned towards him.")]), _vm._v(" "), _c('p', [_vm._v("“My God, who are you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The man:")]), _vm._v(" “I am nobleman Karim.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him. It was the first time we met face to face. I don’t know why I didn’t recognize him. Maybe I forgot what he looked like, or I have never known him. Maybe time changed him!")]), _vm._v(" "), _c('p', [_vm._v("I was firm and strong, I answered him calmly, “What do you want?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Is this how the lady receives her guest?”")]), _vm._v(" "), _c('p', [_vm._v("“Does the guest come without an appointment? Don’t you think it is too early to make a visit?”")]), _vm._v(" "), _c('p', [_vm._v("I don’t know where I got the audacity to answer him that way!")]), _vm._v(" "), _c('p', [_vm._v("“You’re right, I’m sorry I came so early and without an appointment.”")]), _vm._v(" "), _c('p', [_vm._v("“The reason?”")]), _vm._v(" "), _c('p', [_vm._v("“I am looking for my son. Your maids took him. I did not want to enter into new battles with you, so I came myself.”")]), _vm._v(" "), _c('p', [_vm._v("“We did not start any battle with you. You came to us suddenly. You killed our man and took my girls. I fixed the situation with you and asked to bring them back calmly and politely.”")]), _vm._v(" "), _c('p', [_vm._v("“My wife died at your house.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily, “A bleeding pregnant woman knocked on our door, should we leave her to die in the street? The man you killed saved her from death on the street, he saved your child. She died because of hemorrhage. It was only our fault that we helped her.”")]), _vm._v(" "), _c('p', [_vm._v("“Your man, madam, attacked me.”")]), _vm._v(" "), _c('p', [_vm._v("“Rather, your maid, Salma, is the one who caused problems.”")]), _vm._v(" "), _c('p', [_vm._v("“She’s dead.”")]), _vm._v(" "), _c('p', [_vm._v("“We will all die someday.”")]), _vm._v(" "), _c('p', [_vm._v("“Where’s my baby?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, I don’t spend my days here. In fact, I’ll travel soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Please ask your maids, for they may have taken him when they left.”")]), _vm._v(" "), _c('p', [_vm._v("I looked straight at him and said, “Well, but if they say no, you will leave them alone, and if the child is with them, I will return him to you and you will leave them in peace.”")]), _vm._v(" "), _c('p', [_vm._v("I walked but he grabbed my hand and looked at my eyes and said, “My God, how beautiful your eyes are!”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand hard and said, “I’m Lady Zaina Malik, never do that again.”")]), _vm._v(" "), _c('p', [_vm._v("Jawad woke up to my screams and came quickly.")]), _vm._v(" "), _c('p', [_vm._v("“What is there?” He noticed the nobleman so he spoke softly, “Lady Zaina! You came early, is there something wrong?”")]), _vm._v(" "), _c('p', [_vm._v("He turned to the nobleman and said, “Welcome, sir, how may I serve you?”")]), _vm._v(" "), _c('p', [_vm._v("Karim did not answer him, but was focused on my face and my eyes!")]), _vm._v(" "), _c('p', [_vm._v("I asked Jawad to follow me; we headed toward the house while Karim remained stabled in his place.")]), _vm._v(" "), _c('p', [_vm._v("I went to Maryam’s room and woke her up.")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry! You must wake up, my dear.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What’s the matter, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Karim is outside.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam was surprised.")]), _vm._v(" "), _c('p', [_vm._v("“What does he want?”")]), _vm._v(" "), _c('p', [_vm._v("“He wants his child, come on, get him ready.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I won’t give him the baby, it’s our baby.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s his baby, please!”")]), _vm._v(" "), _c('p', [_vm._v("“If he gets close to him, I’ll kill him.”")]), _vm._v(" "), _c('p', [_vm._v("I laughed from her appearance, while she was still lying on the bed, she was threatening him.")]), _vm._v(" "), _c('p', [_vm._v("“Your knife will not work with him. Just getting close to him, a bullet will pierce your heart like the one that penetrated Hazem’s heart. I can’t lose you, let’s give him the baby and this time I promise you as I promise myself that I will take him back.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam began to shed tears.")]), _vm._v(" "), _c('p', [_vm._v("“Well, how did he know he was here?”")]), _vm._v(" "), _c('p', [_vm._v("“Perhaps one of his servants saw him with you and told Karim.”")]), _vm._v(" "), _c('p', [_vm._v("“I thought they didn’t notice.”")]), _vm._v(" "), _c('p', [_vm._v("“Perhaps at first they did not notice, but when they began to look for him, they remembered that you were carrying him the day he set you free. Come on, dress him with the most beautiful clothes, and bring him outside to me.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, but you promised.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll take him back, it’s my baby.”")]), _vm._v(" "), _c('p', [_vm._v("I went out to the nobleman and said, “Your child is with us, Salma gave him to my girls and told them to take care of him, and we thought you didn’t care about him.”")]), _vm._v(" "), _c('p', [_vm._v("“He is my son.”")]), _vm._v(" "), _c('p', [_vm._v("“So how do you leave him with Salma? Wasn’t he supposed to enjoy the bosom of his father?”")]), _vm._v(" "), _c('p', [_vm._v("“I was very sad for my wife, then she is his aunt, I didn’t think she would neglect him!”")]), _vm._v(" "), _c('p', [_vm._v("“You were sad for your wife! Why did she run away from your palace?”")]), _vm._v(" "), _c('p', [_vm._v("He was offended by the cynical manner of my words, so he answered angrily, “She did not run away, she was delirious and did not know what to do; her madness led her to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, the child has come.”")]), _vm._v(" "), _c('p', [_vm._v("I took him from Maryam and gave him to Karim. He looked at me and said, “I see you took good care of him.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “We do not neglect anyone, let alone an orphan child born in our house!”")]), _vm._v(" "), _c('p', [_vm._v("He looked at me again and said, “Oh my God. How beautiful are you!”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and my heart was afraid, I was afraid that he would connect my eyes to Reem’s, I was afraid that he would find out that I was her sister.")]), _vm._v(" "), _c('p', [_vm._v("“When will you marry the noble Malik?”")]), _vm._v(" "), _c('p', [_vm._v("“His name is Nader, not Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("“The one who wants to marry me, and I have not yet agreed, is Nader and not Malik. Malik is my father, and my name is Zaina Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“How is that? He told me he was Malik. Isn’t he the same guy you sent to get the girls back?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, his name is Nader, and he owns a factory in the neighboring neighborhood, and he has a brother who a doctor is named Ashraf. How could he convince you that he is Malik himself?”")]), _vm._v(" "), _c('p', [_vm._v("“He was deceiving me, how are you going to marry a con man?”")]), _vm._v(" "), _c('p', [_vm._v("“Who said I would marry him? He asked for my father approval to marry me but I did not agree yet.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you agree to a liar?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will not agree. And now excuse me, I have to leave; I am traveling.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you know my wife, Reem?”")]), _vm._v(" "), _c('p', [_vm._v("My heart started pounding and I was afraid of confusion.")]), _vm._v(" "), _c('p', [_vm._v("“No, I didn’t know her till she came to us.”")]), _vm._v(" "), _c('p', [_vm._v("“She was beautiful but nothing compared to you.”")]), _vm._v(" "), _c('p', [_vm._v("“May God have mercy on her soul.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I took a lot of your time, we’ll meet again.”")]), _vm._v(" "), _c('p', [_vm._v("“I do not think so.”")]), _vm._v(" "), _c('p', [_vm._v("“But your man promised me that there would be business between us.”")]), _vm._v(" "), _c('p', [_vm._v("“With my father, not with me, Mr. Karim.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, excuse me again, bye-bye.”")]), _vm._v(" "), _c('p', [_vm._v("“Good bye.”")]), _vm._v(" "), _c('p', [_vm._v("He walked carrying the child until he got outside. Then his car approached and he got into it. I was sure that he did not come alone, but when he saw me alone beside the flowers, he knew that I was the lady, so he acted politely and was afraid that his men would frighten me.")]), _vm._v(" "), _c('p', [_vm._v("Maryam looked at me sadly and said, “You’re going to bring him back, right?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("I went back to Malik. Jawad was with me. He was afraid of Karim so he insisted to accompany me. My eyes had fascinated Karim so we didn’t know how he would react. I told Malik about everything that happened.")]), _vm._v(" "), _c('p', [_vm._v("Malik shouted, “Why did you tell him about Nader?”")]), _vm._v(" "), _c('p', [_vm._v("“He will hate him and take revenge on him.”")]), _vm._v(" "), _c('p', [_vm._v("“I must tell Kamal what happened, we must watch you well so that he does not come near you. Go now and take Jawad with you, and I will stay here watching his actions.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll go now, take good care of yourself.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and kissed him on his cheek.")]), _vm._v(" "), _c('p', [_vm._v("“Take care, baby, only three days and you’ll be back.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, only three days.”")]), _vm._v(" "), _c('p', [_vm._v("I got into the car and Jawad rode next to me. We sat waiting for Dalal to come. He took out messages from his pocket and said, “These messages arrived in response to the messages you asked me to send.”")]), _vm._v(" "), _c('p', [_vm._v("I took them from his hand and immediately put them in my bag, I did not want Dalal to see them. I deliberately asked Dalal to sit in the front next to the driver, while Jawad sat next me in the back seat!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Maryam is very sad.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I know, but he is the father of the child and I do not want any problems with him.”")]), _vm._v(" "), _c('p', [_vm._v("How I wish when I saw Karim to tell him he was a bastard! How I wanted to ask him why you killed the poor young man, I acted calmly out of fear for the rest of the family.")]), _vm._v(" "), _c('p', [_vm._v("My God, what is this life? For many years, I saved up money to buy a dress and shoes for meeting him. I waited for this meeting for a long time, and today I am wearing the most beautiful dress and the most luxurious shoes and I did not want to meet him. I was a noble lady in every sense of the word and I did not want to see him. The meeting took place at a difficult time. What I wished most was to insult and belittle him in front of himself. Previously, my limbs were trembling just to hear his name, and today everything inside me hates him and I will continue to hate him until he gets his punishment. He stole from me the most precious thing that I owned. How strange life is, we do not feel the value of a human being except when we lose him, while waiting for another, whom we considered everything, and when we meet him we hate him! I waited for him for a long time, and today his eyes almost stuck to me and I was throwing them away. How trivial he seemed today, even though he was a legend for me. Today he is just an insect that poisoned my life! I spent a lifetime waiting for him and I will spend the rest waiting for his destruction!")]), _vm._v(" "), _c('p', [_vm._v("I took out the letters from my bag, one from the school and what was left from Malik’s ex-wife. I opened the first and it was from the school principal; it was a brief short message.")]), _vm._v(" "), _c('p', [_vm._v("Dear Mr. Malik:")]), _vm._v(" "), _c('p', [_vm._v("We wish the girl happiness and calm and thank you for your letter.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("The second message was addressed to the girl in response to my message:")]), _vm._v(" "), _c('p', [_vm._v("My dear,")]), _vm._v(" "), _c('p', [_vm._v("I wish you a happy life and I hope you come to visit me.")]), _vm._v(" "), _c('p', [_vm._v("Your loving mother.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("As for the last letter, it was addressed to Malik from his ex-wife:")]), _vm._v(" "), _c('p', [_vm._v("Dear Malik…")]), _vm._v(" "), _c('p', [_vm._v("How are you, the girl sent me a message that she’s getting married, do you know that she’s getting married?")]), _vm._v(" "), _c('p', [_vm._v("Didn’t you tell me you’d keep her in your house and you will sue me if I talked to her? Weird, you’ve been looking for her for a long time!")]), _vm._v(" "), _c('p', [_vm._v("Look for her and solve the problem. She will expose you after knowing that you are not her father. The girl is very bad and will compromise you. she knew that you do not have children and that you adopted her, or rather you bought her from your dear friend, Prankster, you wanted to buy his beautiful blue-eyed girl, but he deceived you and gave you the other girl; his step daughter. Well, my dear, do you remember Mr. Fouad? End the matter. I will not receive your messages after today, as I am married and have children, and I do not want my family to know anything about you.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("I put the letter back in my bag. I was totally stunned of what I read. Jawad noticed and asked, “What is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing, my dear, nothing at all.”")]), _vm._v(" "), _c('p', [_vm._v("I thank God that Malik did not come with us, I must enter his room and discover all his secrets, oh my God, if his daughter had not died, he would have killed her, what is the story of that man?")]), _vm._v(" "), _c('p', [_vm._v("He did not grieve for her, did not shed a tear for her. Then is it possible for her to be my sister? Are all my sisters evil? Thank God I wasn’t like them; my mother never mentioned that she had a daughter from another husband. Perhaps when she was calling me she wanted to tell me that. So Reem’s warning to me was from Malik himself not from Nader! I have to reveal everything today!")]), _vm._v(" "), _c('p', [_vm._v("I entered the house and asked Dalal to make me a cup of coffee. I went to the kitchen and asked Jawad to stay in the hall. He looked at me and said, “You know how much I love you.”")]), _vm._v(" "), _c('p', [_vm._v("I was surprised by what he said and asked him, “Why are you telling me that?”")]), _vm._v(" "), _c('p', [_vm._v("“If Karim approaches you, I will kill him!”")]), _vm._v(" "), _c('p', [_vm._v("I approached him, grabbed his hand, and said, “Do not interfere in it, I do not have the strength to lose someone else, we will use the trick with him until we trap him.”")]), _vm._v(" "), _c('p', [_vm._v("“What will you do now?”")]), _vm._v(" "), _c('p', [_vm._v("“I have something I want to search in Malik’s room. Wait for me here and don’t let Dalal follow me. If she brings coffee, ask her to wait for me here.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, be careful, I want you to forgive me no matter what happened.”")]), _vm._v(" "), _c('p', [_vm._v("“For what should I forgive you?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, maybe I did something wrong with you one day, maybe I acted foolishly.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re scaring me, what’s up?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing, but sometimes we act out of our control, we do it only for the ones we love.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you scare me again.”")]), _vm._v(" "), _c('p', [_vm._v("Dalal came with a cup of coffee.")]), _vm._v(" "), _c('p', [_vm._v("“Here is your coffee, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you. I’ll take it to my room. Please, I don’t want anyone to bother me.” I looked at Jawad and said, “Get Jawad away from me, he’s weird today. Make him some food, maybe he’s hungry and he started delirious.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand and almost dropped a cup of coffee from it. He said confusingly, “Will you forgive me no matter what happened?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him angrily.")]), _vm._v(" "), _c('p', [_vm._v("“You almost burned me with coffee! Either you say what you have or shut up; oh my God the boy has gone crazy!”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room and muttered, “As if I could bear all this! I came to rest here. Is it not enough for me to meet the stupid Karim in the morning, and now another idiot disturbs my day? He asked me to forgive him, no, I will not forgive anyone after today!”")]), _vm._v(" "), _c('p', [_vm._v("I said that and shut my room’s door so hard. Its sound resounded throughout the house.")]), _vm._v(" "), _c('p', [_vm._v("The light was off. Suddenly, I heard a voice saying, “Why are you angry, little girl? Didn’t your father teach you to close the door quietly? You woke me up.”")]), _vm._v(" "), _c('p', [_vm._v("I froze in my place and my heart almost stopped. My hands were trembling, so the cup of coffee fell from my hand. I said in a stifled voice, “Who is there?”")]), _vm._v(" "), _c('p', [_vm._v("The man approached me and turned on the light. He was standing right in front of me. I started screaming. He put his hand on my mouth and said, “Hush, don’t make a fuss.” I looked at him and froze. Then after a few moments, he raised his hand from my mouth and said, “Don’t scream, I’m still tired and I have a strong headache.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him in my confused voice, “It’s really you. Oh my God I’m illusion. My God, you’ve gone. I become crazy, you might be his ghost!”")]), _vm._v(" "), _c('p', [_vm._v("He holds my hand, which was trembling greatly, and said, “No, dear, it’s me.”")]), _vm._v(" "), _c('p', [_vm._v("“But you’re dead.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I’m not dead, I was just wounded.”")]), _vm._v(" "), _c('p', [_vm._v("Oh my God, how wide my imagination has become. Perhaps my anger from Jawad blinded me. I sat on my bed and smiled and said to myself, “Good that I came here. If I acted in front of anyone like this, I would be accused of insanity. Oh my God, I see Hazem in broad daylight.”")]), _vm._v(" "), _c('p', [_vm._v("He came and sat next to me and put his hand on mine.")]), _vm._v(" "), _c('p', [_vm._v("“You are not crazy, and I didn’t die, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("I yelled at him and said, “Enough ghost, get away from me a little or my heart will stop.”")]), _vm._v(" "), _c('p', [_vm._v("He put his other hand on top of mine and said, “I am Hazem, my dear Zaina, and I did not die.”")]), _vm._v(" "), _c('p', [_vm._v("I withdrew my hand and stopped. I put my hand on his cheek and said, “You are dead, and I cried a lot. I prayed to God to see you and tell you how much I love you, and that I regret neglecting you, but please leave now, before someone comes and sees me talking to myself and accusing me of being crazy.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled, got up, put his hand on mine, and whispered, “How I wished for this touch, your hand is so warm.” He came close to me and kissed me on my cheek and whispered, “How I wanted to kill Nader when he kissed your hand, and how I wished I were in his place!”")]), _vm._v(" "), _c('p', [_vm._v("I would have passed out if Dalal hadn’t been entering my room.")]), _vm._v(" "), _c('p', [_vm._v("She said with joy, “You saw, my dear, that Hazem has returned to you. Aren’t you happy, my daughter?”")]), _vm._v(" "), _c('p', [_vm._v("I looked at her and asked, “Do you really see him?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, we are the ones who helped him!”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Hazem.")]), _vm._v(" "), _c('p', [_vm._v("“You’re alive, my God, you’re alive!” I started crying hysterically while I hit him on his chest.")]), _vm._v(" "), _c('p', [_vm._v("“You’re alive and no one told me!”")]), _vm._v(" "), _c('p', [_vm._v("He held my hand and said, “I’m still wounded, calm down, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("He pulled me and hugged me to his chest until I calmed down. I looked at him.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, you’re alive! Thank God.”")]), _vm._v(" "), _c('p', [_vm._v("He hugged me again and said, “I am alive. I didn’t know that you would grieve for me like this; I didn’t know that you love me as I love you!”")]), _vm._v(" "), _c('p', [_vm._v("I turned away from him and proudly answered him, “Who said I love you, only you love me!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “It’s okay, but you promised me that you would marry me.”")]), _vm._v(" "), _c('p', [_vm._v("“When? I didn’t promise you anything.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “You crook! You almost died while crying for him.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to her.")]), _vm._v(" "), _c('p', [_vm._v("“Look who’s talking? You saw my tears and my sadness and you did not pity me, and it was Jawad who saved him! That’s why he was asking me to forgive him!”")]), _vm._v(" "), _c('p', [_vm._v("He appeared suddenly and said, “We were afraid that we would lose him. He bled a lot, so it was better for you to think that he was dead, because he really almost died. Then it was better for Karim to think of his death so that he would not follow him and kill him. If that happened, you will grieve again!”")]), _vm._v(" "), _c('p', [_vm._v("I asked them, “And who else knows?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Only Doctor Ashraf. Even your father, my dear, does not know.”")]), _vm._v(" "), _c('p', [_vm._v("“How did it all happen? Then how you trust Ashraf, he will tell Nader, and Nader will tell Karim!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “No, my dear, Ashraf is completely different from his brother. I have good news for you; Nader will travel, take his family, and flee to another country, he sold all his possessions.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him in amazement, “His family? Do you mean his mother and his sister?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Even his wife and children!”")]), _vm._v(" "), _c('p', [_vm._v("I answered in astonishment, “What a prankster! He is married and has children.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Yes, he was deceiving you, Zaina.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I always warned you about him.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, anyway, I wouldn’t marry him, thank God he’s gone.”")]), _vm._v(" "), _c('p', [_vm._v("“You will not marry anyone but me, or I will kill him with my own hands!”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “We won’t kill anyone, come back to bed and sleep and I’ll go home…”")]), _vm._v(" "), _c('p', [_vm._v("I was deliberately teasing him to bring out all the feelings of love from inside him. How much I longed for him, it was not he who came back to life, but me!")]), _vm._v(" "), _c('p', [_vm._v("He replied in exasperating, “You’re not leaving, you have just come. Doesn’t it mean anything to you that I’m still alive?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, didn’t it mean anything to you that I grieved for you? Did you not pity me when that brat told you that I was sad and abstained from food?”")]), _vm._v(" "), _c('p', [_vm._v("Hazem, in his usual innocence.")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, but I had to hide and recover, and then I’ll take revenge on them all. Don’t go, at least stay for tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll stay until tomorrow.” I looked at him tenderly. “And the day after tomorrow, and another day!”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Won’t you eat now? Come on, you should eat please.”")]), _vm._v(" "), _c('p', [_vm._v("He was worried that I was abstaining from food. He always thought of me, he always worried about me; he always sat under my window in my days of sadness, tiredness, and anger.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Well, I’ll make food for everyone. Come on, Jawad, come and help me.”")]), _vm._v(" "), _c('p', [_vm._v("They meant to leave us alone.")]), _vm._v(" "), _c('p', [_vm._v("“I want to see the wound,” I asked him quietly.")]), _vm._v(" "), _c('p', [_vm._v("“No, you won’t see it.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll see it, come on, and sit on the chair so I can see it.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand firmly and said, “You won’t see it!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him more sharply, “I will see it and take your hand away from me!”")]), _vm._v(" "), _c('p', [_vm._v("“Well, calm down.” He took off his shirt violently and said, “Look, what do you want to see?”")]), _vm._v(" "), _c('p', [_vm._v("It was a severe wound in his chest, may God have mercy on him, how close it was to his heart. Thank God the bullet did not penetrate his heart.")]), _vm._v(" "), _c('p', [_vm._v("I gave him the shirt without saying a word. He put it on quickly and said, “Have you rested now?”")]), _vm._v(" "), _c('p', [_vm._v("I sat next to him and placed my hand gently over the wound.")]), _vm._v(" "), _c('p', [_vm._v("“It will recover, don’t worry, and why are you angry? Lighten up your rage; you always terrify me with it!”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry, my beautiful, I don’t like you to see me tired. When I was sick, I used to get up quickly; so you don’t see me tired. I like always to be in your eyes strong and brave.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ve always loved to fall asleep and then you carry me with your strong hands! But my dear, we are human and we get tired, then don’t worry your wound will heal, and my strong man will come back.”")]), _vm._v(" "), _c('p', [_vm._v("“But Ashraf told me it would leave a scar.”")]), _vm._v(" "), _c('p', [_vm._v("“The important thing is that you are alive, my God!”")]), _vm._v(" "), _c('p', [_vm._v("I started jumping in front of him as a little girl, screaming, “The important thing is that you are alive, and let it leave a million scars.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and said, “Don’t be sad when I call you little girl!”")]), _vm._v(" "), _c('p', [_vm._v("How tired and pale he looked, I had never seen him like this, thank God he was alive, how close he was to death.")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “I want to hear the full story.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Jawad will tell you everything while we eat.”")]), _vm._v(" "), _c('p', [_vm._v("Then he stood right in front of me and looked into my eyes, saying, “Oh my God, how pale you are, I have never known you like this, and perhaps you have not eaten for a long time.”")]), _vm._v(" "), _c('p', [_vm._v("I answered him, “It is you who must eat and recover.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m strong, don’t worry. Let’s go down to listen to the story from Jawad. I never asked him about it. I was only concerned about you; I was afraid that they would approach you or hurt you. I was raving about you, how much I miss you and your anger, and how I wish I could make you coffee! How are our flowers?”")]), _vm._v(" "), _c('p', [_vm._v("“Withered, lacking life, just like I am in your absence, and just wanting to see you!”")]), _vm._v(" "), _c('p', [_vm._v("“Tell them that I came back and I will water them from my heart to come back to life, as I came back now when I saw you. My God, how beautiful to see you, how much I love you, my little girl!”")]), _vm._v(" "), _c('p', [_vm._v("I kissed him on his cheek; he became as confused as he always is in front of me.")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Come on, my dear, it’s time to eat and hear stories.”")]), _vm._v(" "), _c('p', [_vm._v("Dalal prepared us a sumptuous dinner. I would not have believed that I was with Hazem and we would have dinner together. I said to Jawad, “Come on, Jawad, you deceiver! Tell me what happened in detail.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Well, after I drove you home in your hysterical state. I came back and saw one of Karim’s men roaming around the farm.”")]), _vm._v(" "), _c('p', [_vm._v("He asked me, “What are you doing here?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him that I saw a fire from afar and came to see what had happened. I obviated him and headed towards the house. I found Samar and the baby girls. I asked her to calm down until I came back. When the man left, I approached Hazem to check on him.")]), _vm._v(" "), _c('p', [_vm._v("So if he was dead, I would take him to bury him. I put my head on his chest, he was breathing. I was astonished and about to go crazy. I brought his cart and put him in it and took him immediately towards Ashraf. I was very worried about him and I was very afraid to lose him. Ashraf received me warmly. He started treating him. Hazem had lost a lot of blood, but Ashraf was a brilliant doctor and was able to control that. I asked him to keep it a secret, and he told me we had to find him a house, he wouldn’t be able to keep him there for long time. I left him in the morning and went back to Samar. She was afraid and alone. She was embracing the girls in her arms. I thank God; there was no one from Karim’s men. I took her and went to Malik’s house. You were asleep. Dalal asked me to get in and eat. I answered her without feeling, “I can’t, there is a wounded person who needs me.”")]), _vm._v(" "), _c('p', [_vm._v("She asked me, “Who is he, is he Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “How did you know?”")]), _vm._v(" "), _c('p', [_vm._v("She said, “No one is injured but him. Should I tell Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I said to her, “No, please, I am afraid that Karim will know about his existence and kill him, and his condition is serious, he may die, what should we tell her then, but we must find him a house to hide in.”")]), _vm._v(" "), _c('p', [_vm._v("She said, “Take him to Malik’s house and I will not tell anyone. When he recovers, we will tell Zaina and she will take over the matter.”")]), _vm._v(" "), _c('p', [_vm._v("She gave me the key and I took him there. I left Ashraf with him and he took care of him completely.")]), _vm._v(" "), _c('p', [_vm._v("I replied sadly, “I wish you had told me, I would have taken care of him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Good he didn’t tell you, you would have sat next to me crying the whole time.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him in astonishment.")]), _vm._v(" "), _c('p', [_vm._v("“And who told you that I didn’t cry all the time? Then where did you get this confidence that I would cry all the time?”")]), _vm._v(" "), _c('p', [_vm._v("“Jawad used to bring me your news every day.”")]), _vm._v(" "), _c('p', [_vm._v("I directed my words to Jawad.")]), _vm._v(" "), _c('p', [_vm._v("“You’d come every day and come back, oh my God, and I didn’t feel of that!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Because you were too busy mourning me.”")]), _vm._v(" "), _c('p', [_vm._v("I felt like I was starting to give up my pride in front of him so I wanted to keep a little! I answered him angrily, “No, I’m not. I went to the garden, and I wasn’t crying. I sat with Reem’s son and the girls and wasn’t crying. Then part of my sadness was for the girls’ absence. As well as, it was necessary to manage the girls’ affairs and watch Nader closely.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Yes, my dear, and his name was on your lips between every word.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Stop, vanity will eat his head!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “It’s okay, he’s sick, and let him be haughty by your love.”")]), _vm._v(" "), _c('p', [_vm._v("I said to Jawad and Dalal, “Well, Jawad; I will not forgive you, nor you, Dalal!”")]), _vm._v(" "), _c('p', [_vm._v("Hazem smiled and said, “Your name was on my lips at every moment, and I was raving about you. Neither pain nor fever distracted me from you!”")]), _vm._v(" "), _c('p', [_vm._v("He knew how to satisfy my ego and preserve my pride.")]), _vm._v(" "), _c('p', [_vm._v("Dalal smiled and said, “How beautiful you are, yet she was raving about you.”")]), _vm._v(" "), _c('p', [_vm._v("“Enough, Dalal!”")]), _vm._v(" "), _c('p', [_vm._v("I stopped her and added, “Enough for today.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem looked at me and said, “I don’t deserve your attention!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, you deserve it, but you don’t have to know everything.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to know, it’s enough that you are in front of me. Please eat your food now and you must rest a little.”")]), _vm._v(" "), _c('p', [_vm._v("“You should rest.”")]), _vm._v(" "), _c('p', [_vm._v("The evening came quickly. Ashraf came to us, as he does every day, to check on his patient. He greeted me and said, “How are you, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Fine, thank God.”")]), _vm._v(" "), _c('p', [_vm._v("“You should know that I have nothing to do with my brother. Since we were young, we are different.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, thanks for saving Hazem’s life.”")]), _vm._v(" "), _c('p', [_vm._v("“This is my job. I didn’t tell anyone, I swear. The important thing now, did you see what your friend has done?”")]), _vm._v(" "), _c('p', [_vm._v("“Who?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me angrily, “Laila. She went crazy. I went to her today and she kicked me out. Imagine she kicked me out. What I do?”")]), _vm._v(" "), _c('p', [_vm._v("She says, “I can’t trust you; you are definitely as evil as your brother.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Excuse her; she’s been through a lot lately.”")]), _vm._v(" "), _c('p', [_vm._v("“I love her and I want to marry her!”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Well, I promise you’ll marry her. When I come back, I’ll talk to her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Are you coming back now?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“No, I’ll sit here until Hazem recovers and then he will come back with me.”")]), _vm._v(" "), _c('p', [_vm._v("“This is too much!”")]), _vm._v(" "), _c('p', [_vm._v("“I will send her Jawad tomorrow and he will explain everything to her, rest assured. I promise you that you will marry her soon, God willing.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“I heard that Nader will leave soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he sold everything. He quarreled with Karim today. Karim visited him in the factory and revealed his deception. He threatened him if he did not give him his money, he would kill him, and asked him to stay away from you for good.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Why is Karim interested in Zaina?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “He saw her this morning; she seems to have aroused his curiosity.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I swear if he approaches her, I will kill him with my own hands.”")]), _vm._v(" "), _c('p', [_vm._v("I said to Hazem, “We will not kill anyone; there is no blood after today, please enough.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Come on, Hazem, to check on your wound.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem")]), _vm._v(": “I’m fine, I don’t want to.”")]), _vm._v(" "), _c('p', [_vm._v("Then he addressed me directly, “Why didn’t you tell me that you saw him today?”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you angry? I’m still stunned that you’re alive! It didn’t even occur to my mind to tell you about him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “You should take your medicine.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him and said, “Go up to your room and take your medicine, I want you to recover quickly.”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed his hand and we went upstairs, followed by Ashraf and behind him was Dalal.")]), _vm._v(" "), _c('p', [_vm._v("Ashraf examined the wound and was pleased with the results, after which he gave him his treatment and said, “Thank God, things are getting better. We’ll let you sleep.”")]), _vm._v(" "), _c('p', [_vm._v("I said to Ashraf, “Thank you, Ashraf.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “And you, my dear, are you not going to sleep? It was a long and hard day!”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “As soon as he sleeps, I will go to my father’s room and sleep there.”")]), _vm._v(" "), _c('p', [_vm._v("I sat next to his bed, he had to fall asleep immediately because of the effect of the medicine, but my effect on him was stronger!")]), _vm._v(" "), _c('p', [_vm._v("Tell me what happened in my absence. He said it and his eyes were roaming in my eyes!")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll tell you in boring detail,” I replied.")]), _vm._v(" "), _c('p', [_vm._v("“Once upon a time, there was a beautiful lady named Zaina, who was loved by a tall, broad-shouldered young man. She thought that he was only fit to be her brother. Suddenly, he left her without permission and took her soul and all she has with him.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Come close, please.”")]), _vm._v(" "), _c('p', [_vm._v("I approached him. He held my hand and kissed it.")]), _vm._v(" "), _c('p', [_vm._v("Then he said, “And when he came back he brought her soul back to her, and mixed it with his soul, and they became a tale for every time!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, you’ve become a poet! Where did you learn this?”")]), _vm._v(" "), _c('p', [_vm._v("“You taught me to read, and I wanted to impress you, so I read all the books you have!”")]), _vm._v(" "), _c('p', [_vm._v("“When?”")]), _vm._v(" "), _c('p', [_vm._v("“I was reading in my room.”")]), _vm._v(" "), _c('p', [_vm._v("“I only watched you reading when we were sitting together.”")]), _vm._v(" "), _c('p', [_vm._v("“I was reading when you were traveling for Malik. Then, my dear, you rarely ever visited me in my room.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, so beautiful! You are a diligent student.”")]), _vm._v(" "), _c('p', [_vm._v("“You are the most beautiful teacher in the universe.”")]), _vm._v(" "), _c('p', [_vm._v("“If I stay by your side you will never sleep, I will leave you and come back in the morning.”")]), _vm._v(" "), _c('p', [_vm._v("I kissed him on his forehead and was about to leave, he pulled my hand and said, “Please sleep and rest, it was a hard day.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and went to Malik’s room to sleep in, the house was very quiet. All the secrets of Malik had to be revealed, I should know who that girl is, is she really my sister?")]), _vm._v(" "), _c('p', [_vm._v("I searched everywhere in the room. I didn’t find anything. I knew that everything was in the drawer, from which I took the money, but unfortunately, it was locked and inevitably the key was with him.")]), _vm._v(" "), _c('p', [_vm._v("I want to know everything; I thought to break the drawer’s lock. If Malik asked me about it, I would pretend that I needed the money. I thought about it, but I didn’t dare to break it. I was tired so I lay on his bed. It was perfectly comfortable as my bed. I adjusted the pillow. I felt that there was something under it. Oh my God it must have been the key. Was it possible that he forgot it? Funny thing; he might forgot the key or maybe it was another copy of it. I jumped and opened the drawer. I took out everything inside it. I sat on the bed and laid everything in front of me. There were title deeds to his lands and properties, some bankcards and letters from his associates, a lot of packets of money; there wasn’t anything attracted my attention. Then I found a notebook! A thick notebook actually; it was about two hundred pages.")]), _vm._v(" "), _c('p', [_vm._v("I opened it and started reading. It’s his memoirs, but his whole life in detail. Sleep escaped from my eyes while I was reading!")]), _vm._v(" "), _c('p', [_vm._v("His whole life in pages, and I am in most of its lines since I was a child until now. My God, as if his life was based on me only, I did not feel the time while reading it. The sun was about to rise and the light of the dawn was slowly entering the room. It’s been two whole days and I am awake, but I can’t stop reading.")]), _vm._v(" "), _c('p', [_vm._v("I reached the last page. The sun had risen on the world and the light filled the place. With the last page, my eyes sank with tears. Malik was standing in front of me, surprised by my boldness, waiting for my reaction to what I read. I didn’t feel him when he entered.")]), _vm._v(" "), _c('p', [_vm._v("I jumped up and hugged him and said, “Oh my God, how much you suffered, you are the greatest father in the world!”")]), _vm._v(" "), _c('p', [_vm._v("He sat down on the chair and I sat on the floor in front of him. I put my head on his knee. He sighed deeply and began to speak, “God did not write for me to have children, and all I wished was a little girl who would fill the world for me. Your father was working for me as a farmer on your land that you own today. One day, he came to me and he was so happy. He told me that his wife had given birth to a very beautiful baby girl, whom he named Zaina, so I asked him to bring her to see. You were so beautiful and wonderful. I did not wish from God anything but to have a child like you. He used to bring you to me every day. How I held you between my hands and kissed you! After a while, they went to visit your mother’s family, her sister passed away, leaving behind two children. They left you with me for a whole year. I was very attached to you, but you were very young and you never remember that. When they came back, your father came to take you. They were so tired and broken. Your father was broke and he needed money badly; their conditions were very difficult. I asked him to keep you with me, but he refused. I offered him a large sum of money, but he did not agree. He offered to give me a child of your mother’s sister’s daughters, I agreed. I expected a beautiful girl like my dear Zaina; I called her Zaina out of my love for you. She was not as beautiful as you, not even has your manners and calm. I was very tired because of her. At first, my wife loved her and considered her as a daughter, but she did not stand her for long. Your mother would come every now and then to check on her. Her sister was Salma, but you, my dear, only had one sister named Reem. Your mother did not want her niece to feel alienated, so she told you that Salma is your sister. I was watching you from afar and following all your news. On one day, the nobleman came; I saw you from afar, you were sitting in front of a tree near my house. I approached you, you were very afraid of me. I asked you, ‘What is wrong with you, little one?’ You answered me, ‘The nobleman is coming and he will surely choose me, because I am the most beautiful girl in the village.’ I whispered to you, ‘Fill yourself with mud and he will never come near you…’ You jumped happily and started spinning around with mud until you became dirty.”")]), _vm._v(" "), _c('p', [_vm._v("I replied surprised, “It was you?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, I knew that if you left with him, I would never see you again. My daughter Zaina tired me a lot, and my wife wanted to have a child from her own womb, but I would never have one or achieve her wish. She took the girl and left, I never cared about their leaving. I divorced my wife; she got married from another man. We put the girl in a boarding school and I was supervising her from afar. She ran away from school and destroyed my last dreams to be my good daughter. I was watching you after your father died, while you were working hard and diligently to feed your family. Every day, I send customers to buy all your vegetables so you don’t come home empty-handed. How I admire you for taking care of those around you, since you were a child and you are a wonderful little lady. When your mother and your sisters left you, and received your friends and their kids and protected them from poverty and homelessness, I decided to give you the land; no one deserves it but you. I wrote you a letter and claimed it was from your father. I bought you a doll that I always wanted to give you, and also a bracelet that not deserved to be worn by anyone but you.”")]), _vm._v(" "), _c('p', [_vm._v("“My God! No one took care of me the way you and Hazem took care of me. Hazem is alive, and you are alive and you are both mine. I never want anything else in this world except you both.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “You naughty girl. Hazem is your own; you love him very much.”")]), _vm._v(" "), _c('p', [_vm._v("He said that word and I fell asleep on his knee, and then Hazem entered the room. Malik smiled and said, “Your little one has fallen asleep; can you put her on the bed? Or is your injury stopping you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “A thousand wounds do not prevent me from carrying her. I always wait for the moment she sleeps to carry her and put her in her bed.”")]), _vm._v(" "), _c('p', [_vm._v("He was so strong. Although he was wounded, he carried me and put me on Malik’s bed. I slept deeply for hours. Everyone waited for me to wake up. When I woke up, Malik and Hazem were sitting next to me.")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “You waited so long.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Will my little princess get up? We want to eat.”")]), _vm._v(" "), _c('p', [_vm._v("I told them in amazement, “You haven’t eaten yet! What were you two doing all the time?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We’re watching you.”")]), _vm._v(" "), _c('p', [_vm._v("“My God! I’m going to my room to change my clothes, while you go downstairs and wait for me. We will all eat.”")]), _vm._v(" "), _c('p', [_vm._v("We had wonderful evenings. I have spent here a week. They were the happiest days of my life.")]), _vm._v(" "), _c('p', [_vm._v("Every day Malik used to tell me his stories with me, he told me things that really shocked me.")]), _vm._v(" "), _c('p', [_vm._v("One of the stories, when Laila left me with her little girl and went to rescue Maryam from her brother’s clutches, he sent a man to guard the house. He was afraid for me because I stayed alone in the house.")]), _vm._v(" "), _c('p', [_vm._v("Malik tried his best to get close to Hazem so he began to talk to him and teach him many things about life. He also promised him that he would work with him and introduce him to businessmen. Hazem did not like the idea; he preferred to work on the land. He told him that he would repair it and would be patient with it until it recovered. He would plant new crops, and if he had the opportunity, he would expand it. Malik liked the idea, and promised him that he would give him a large area of his land to plant and join it on our land. Hazem would be the supervisor. It was also necessary to bring farmers to work under his supervision.")]), _vm._v(" "), _c('p', [_vm._v("After two consecutive weeks, Hazem almost recovered, and asked us to go home.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We must go back, Maryam must know that I am alive, and we must start working on the land.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “That’s right, you promised me to talk to Laila.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Well, you know I sent her Jawad to inform her about the truth, and now she’s calm and wants to see you, but she’s waiting for me to come back.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We’ll go tomorrow morning.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “All right, let’s all go to sleep now. We will get up early and leave.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “But, Karim? He is still at large and if he saw Hazem, he might kill him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I’ll kill him first!”")]), _vm._v(" "), _c('p', [_vm._v("I said to him angrily, “I told you a hundred times, we won’t kill anyone.”")]), _vm._v(" "), _c('p', [_vm._v("“Then let him kill me, what’s wrong with you? I will never be afraid of him.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “Then stay here until it’s over.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will not stay, I will go back to my home and my previous life, and he will go to hell.”")]), _vm._v(" "), _c('p', [_vm._v("I answered firmly, “You will stay here until the police arrest him. He is stronger than you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem (wrathfully):")]), _vm._v(" “Do you think I’m a coward?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course not, but he is the strongest, not physically, but he has weapons, guards and authority, and who are you in front of him?”")]), _vm._v(" "), _c('p', [_vm._v("He got angry at me and got up and said, “I’ll go now, if he comes close to me, I will finish him by my hands!”")]), _vm._v(" "), _c('p', [_vm._v("I answered him angrily, “Don’t be a fool, man’s stupidity kills him.”")]), _vm._v(" "), _c('p', [_vm._v("“Am I stupid then?”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, you’re so stupid you’re going to get us bad.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m leaving now and you have nothing to do with me.”")]), _vm._v(" "), _c('p', [_vm._v("He walked towards the door. I ran and stood in front of the door as a barrier between them.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Go away, please.”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t go away, pass me if you can.”")]), _vm._v(" "), _c('p', [_vm._v("“Get away at once.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not going away.”")]), _vm._v(" "), _c('p', [_vm._v("He shouted out loud, “Go away, or I’ll throw you away.”")]), _vm._v(" "), _c('p', [_vm._v("Tears started to fall from my eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, could you really hurt me? I won’t walk away and do whatever you want, you’ll hit me? What will you do?”")]), _vm._v(" "), _c('p', [_vm._v("He calmed down as soon as he saw my tears. What he hated the most in life was seeing me crying.")]), _vm._v(" "), _c('p', [_vm._v("“Well, what do you want?”")]), _vm._v(" "), _c('p', [_vm._v("“First, don’t you yell at me again because I’m afraid of your yelling.”")]), _vm._v(" "), _c('p', [_vm._v("“And secondly?”")]), _vm._v(" "), _c('p', [_vm._v("“You stay here at home until we finish from Karim. Kamal spoke to my father today and told him that there wouldn’t be much left to set him up.”")]), _vm._v(" "), _c('p', [_vm._v("“And thirdly?”")]), _vm._v(" "), _c('p', [_vm._v("“I will travel tomorrow, check on the girls, and come back immediately. I promise. Come on, please, I am very afraid for you, please promise me that you will not leave until I tell you that the situation is safe.”")]), _vm._v(" "), _c('p', [_vm._v("He was quick to respond to my requests, and this time he agreed but reluctantly! His face almost stuck to me, his kiss would have settled on my mouth and in my heart, but his shyness from Malik prevented him. He moved away and said, “Okay as you like.”")]), _vm._v(" "), _c('p', [_vm._v("I completed gently, “And fourthly.” Then I was silent.")]), _vm._v(" "), _c('p', [_vm._v("He said, “Fourth, I love you so much, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("He does not fear anyone. If he didn’t see my tears, my insistence and also his fear of losing me, he would never have agreed.")]), _vm._v(" "), _c('p', [_vm._v("I woke up early the next morning. I was getting ready to travel with Malik. Hazem entered my room resentfully, hating everything:")]), _vm._v(" "), _c('p', [_vm._v("So you’re leaving without me.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, I will not be late, I promise you. You promised me that you would stay here, and you would have never broken a promise you made to me.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled complimenting and said, “Okay.”")]), _vm._v(" "), _c('p', [_vm._v("Malik then came in, panting.")]), _vm._v(" "), _c('p', [_vm._v("“We are not traveling today, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him, “Why?”")]), _vm._v(" "), _c('p', [_vm._v("“You will stay in your room and do not leave it whatever you hear.”")]), _vm._v(" "), _c('p', [_vm._v("“Why? What is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“Kamal spoke to me, Karim went crazy, he knew that he was completely revealed and his end is so near. He passed your house looking for you.”")]), _vm._v(" "), _c('p', [_vm._v("“Are the girls okay?”")]), _vm._v(" "), _c('p', [_vm._v("“They’re all fine. He wants only to see you, he might come here, so stay here, don’t leave your room until I tell you to.”")]), _vm._v(" "), _c('p', [_vm._v("He turned to Hazem and said, “You stay with her in anticipation, and I am the one who will confront him.”")]), _vm._v(" "), _c('p', [_vm._v("He warned me again, “Do not leave your room no matter what you hear and whatever happens, do you understand?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Oh, my God, I’m afraid he will hurt you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Don’t worry, Kamal and his guards are coming, but Karim may arrive first. I warn you for the last time, don’t leave your room.”")]), _vm._v(" "), _c('p', [_vm._v("I was so worried and my heart started beating so fast; I was afraid for the girls; I was afraid he might have hurt them or take them.")]), _vm._v(" "), _c('p', [_vm._v("Malik left us and went downstairs. I could not sit because of the tension and fear. Hazem was more steadfast than me; he was waiting for Karim to enter the room to topple him! A few minutes later, the door of the house was knocked, and Dalal opened the door.")]), _vm._v(" "), _c('p', [_vm._v("She was not supposed to open a door in his face, but Kamal asked Malik to let him in to make it easier for him to arrest him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Where is your lady?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal:")]), _vm._v(" “Not here, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“Liar, I went to her house in the country, and they told me she was here. Come on; tell her to come here at once!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dalal (firmly):")]), _vm._v(" “But she’s not here. Leave your name and your phone number, sir, and I’ll tell her you’ve come and she’ll call you!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim (angrily):")]), _vm._v(" “I told you to call her right away!”")]), _vm._v(" "), _c('p', [_vm._v("Jawad came out and said, “Hello, Mr. Karim, you are welcome, please sit down, and enjoy our hospitality.”")]), _vm._v(" "), _c('p', [_vm._v("Then he asked Dalal to make him a cup of coffee.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “I don’t want anything; I want to meet Lady Zaina.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “She is not here sir, but Mr. Malik, her father, is here if you like.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Karim:")]), _vm._v(" “Lady Zaina, I know she’s here.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “She is not here, she has traveled, and perhaps if you go back to her country house now, you will find her there.”")]), _vm._v(" "), _c('p', [_vm._v("Karim screamed loudly, “Untruthful.”")]), _vm._v(" "), _c('p', [_vm._v("I was so nervous.")]), _vm._v(" "), _c('p', [_vm._v("“I’ll go down and face him. I told Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem was sitting on the sofa looking at the floor; he looked at me out of the corner of his eye and said, “Stay in your seat.”")]), _vm._v(" "), _c('p', [_vm._v("He was carrying the anger and hatred of the world inside that look; I knew that he wished he would come down and eliminate him. I answered him more sharply, “I’m going down, what will happen if he sees me?”")]), _vm._v(" "), _c('p', [_vm._v("More calmly and more firmly, without even looking at me he said, “Sit down.”")]), _vm._v(" "), _c('p', [_vm._v("Karim screamed loudly, “Where’s Zaina? I want to see her now.”")]), _vm._v(" "), _c('p', [_vm._v("Malik went out to meet him.")]), _vm._v(" "), _c('p', [_vm._v("“How impolite you are! They told you she’s not here, please leave or I will call the police.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled wryly and took out his pistol.")]), _vm._v(" "), _c('p', [_vm._v("“Either I see her now or you won’t see her after today.”")]), _vm._v(" "), _c('p', [_vm._v("He fired a bullet in the air that took my breath away.")]), _vm._v(" "), _c('p', [_vm._v("I ran to the door and wanted to get out. Hazem grabbed my hand and then threw me on my bed.")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t I tell you to sit down? What’s wrong with you, you idiot, you’re going to get everyone killed.”")]), _vm._v(" "), _c('p', [_vm._v("He frightened me more than a bullet, so he walked out of the room and locked the door.")]), _vm._v(" "), _c('p', [_vm._v("Two minutes after he left, I heard another shot. The blood in my veins stopped and my heart froze. I sat on the bed. My soul almost came out of me because of fear; he must have seen him coming down the stairs, so he shot him and killed him.")]), _vm._v(" "), _c('p', [_vm._v("Oh my God, he killed him again! I have no strength to grief him again. After about half an hour, he opened the door and said, “Come on baby, come on, it’s over.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t answer him, I was frozen in my place that I didn’t even notice that the speaker is Hazem himself. He came close to me and grabbed my hand and said, “Come on, Zaina, come on, it’s over.”")]), _vm._v(" "), _c('p', [_vm._v("I stood without saying a word and then fainted. I don’t know how long I stayed like this, but when I woke up, everyone was around me scared and sad.")]), _vm._v(" "), _c('p', [_vm._v("I looked at the Malik and asked him, “What happened?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “He was threatening to kill everyone if you didn’t get down. He fired a bullet in the air, and the second bullet was directed at Jawad. His hand was slightly injured, and there is no danger from it, praise is to God.”")]), _vm._v(" "), _c('p', [_vm._v("I said eagerly, “Where is Hazem?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I’m fine my little girl.”")]), _vm._v(" "), _c('p', [_vm._v("“I heard the shooting and I thought he killed Hazem.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “He did not kill anyone, but a third bullet came from Kamal’s pistol and penetrated Karim’s head.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “I didn’t hear it.”")]), _vm._v(" "), _c('p', [_vm._v("I didn’t hear a third shot, I was frozen then lost all my senses, and thank God no one died.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Hazem and said, “You are alive, thank God!”")]), _vm._v(" "), _c('p', [_vm._v("Then I remembered how he threw me on the bed.")]), _vm._v(" "), _c('p', [_vm._v("I added firmly, “Don’t shout at me again, or I won’t talk to you as long as I live.”")]), _vm._v(" "), _c('p', [_vm._v("He took my hand and kissed it and said, “I promise with my life that I will never yell at you.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “He wanted to kill us, my God! What did we do to him?”")]), _vm._v(" "), _c('p', [_vm._v("He was screaming and saying, “I’ll take her with me and leave you alone.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “We’ll talk later, Zaina is tired.”")]), _vm._v(" "), _c('p', [_vm._v("He ended the conversation abruptly as if something had happened, and they didn’t want to tell me about it.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “We’ll leave you to rest, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I said to Jawad, “No, come Jawad, tell me what you have.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Nothing, my dear, I’m just tired of my injury. Actually, Ashraf said that your heart is tired and you should rest.”")]), _vm._v(" "), _c('p', [_vm._v("“My heart is tired! What does that mean? I looked at Ashraf and asked him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Nothing serious, my dear, your exposure to successive shocks has exhausted your heart a little and you have to rest completely. Thank God we have finished the evil man today and you should rest and never think of anything that bothers you.”")]), _vm._v(" "), _c('p', [_vm._v("I lost a part of my heart, my God! Years of waiting to meet Karim make me lose a part of my heart, I am still young and my heart is tired.")]), _vm._v(" "), _c('p', [_vm._v("He left and years of my beautiful life left with him. On the day he wanted me, the day the dream came true, I hate nothing in the world as I hated him. He was nothing for me but a villain silly evil man.")]), _vm._v(" "), _c('p', [_vm._v("I turned to Malik and said, “I want the child, please bring me Reem’s child, I promised Maryam that I would return him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Does Maryam know the child?”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Yes, she took care of him for days.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem laughed and said, “Do you think she’ll wait until now to get him? She may have brought him the second day straight after his departure. Calm down, my dear, the child will be yours.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, he will be my child. We named him Hazem. He will be my child.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Don’t worry; don’t ever think about anyone, think only about yourself and your health.”")]), _vm._v(" "), _c('p', [_vm._v("I asked, “Am I so sick?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “No, my dear, believe me, it’s just exhaustion.”")]), _vm._v(" "), _c('p', [_vm._v("We had to stay at home for a few more days until I was cured. I was very worried about Reem’s child, how I wished he was next to me and hugged him to my chest.")]), _vm._v(" "), _c('p', [_vm._v("I sent Jawad to check on the girls, and to be sure if Maryam had brought Reem’s baby. Jawad went and did not return. I was very worried about him, so I sent Ashraf. He went to them and checked on them, but he did not see any of Jawad’s family, neither Jawad nor his mother or his sister, Samar.")]), _vm._v(" "), _c('p', [_vm._v("Ashraf did not tell me about Jawad’s position, out of fear for me. Maryam brought the baby and brought him back to her bosom again.")]), _vm._v(" "), _c('p', [_vm._v("During the period of my fatigue, Malik was with me. He did not leave my room for a single moment, so I worried about him very much; I was afraid that he would get tired and get sick as well.")]), _vm._v(" "), _c('p', [_vm._v("On a quiet evening, I got up from my bed and asked everyone to leave me and Malik alone.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What’s the matter, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("“There is something I want you to see, but please don’t get it badly, you know I’m an honest girl and I don’t take anything that doesn’t belong to me.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Little darling, I don’t like long intros, what’s up? I promise I will not misunderstand you.”")]), _vm._v(" "), _c('p', [_vm._v("I went to my locker and took out the jewelry bag; my conscience was bugging me every day. Malik is a great man, and then I am not a thief. I wouldn’t steal anything. I might die tomorrow, if he found out what would he say? I secured her on my house and my property and she robs me. The possessions must be returned to its owner.")]), _vm._v(" "), _c('p', [_vm._v("I gave him the bag, he smiled and said, “What is this?”")]), _vm._v(" "), _c('p', [_vm._v("“Open it up and you’ll know what’s in it.”")]), _vm._v(" "), _c('p', [_vm._v("Malik opened the bag and saw the jewels, turned them over with his hand and put them back in the bag and asked me, “How did they get here, and why?”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I would never lie to you, one day I went to borrow a dress from your house, and you told me I could wear whatever I wanted.”")]), _vm._v(" "), _c('p', [_vm._v("“This is correct.”")]), _vm._v(" "), _c('p', [_vm._v("“I discovered that inside each dress was a piece of jewelry, which I collected and put in the bag, I sold one of them. I really needed the money at that time. Then I was afraid someone would steal them so I brought them her. Forgive me I didn’t tell you from the beginning, please, I’m not a thief.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and said, “Every piece in this bag I bought for you, I imagined you wearing it. Take the bag, my dear, and put it back in its place. Don’t tell anyone about it, it is yours now, and no one has anything to do with you.”")]), _vm._v(" "), _c('p', [_vm._v("I jumped up to him and kissed him on the cheek, put the bag in the closet and closed it.")]), _vm._v(" "), _c('p', [_vm._v("I was so relieved that I told him about the jewelry, now it’s mine, and I’m free to do whatever I want with it.")]), _vm._v(" "), _c('p', [_vm._v("I asked him to travel in the morning. I missed Laila and the girls so much. As well as, the absence of Jawad worried me so much. I couldn’t wait for the dawn! I got dressed, prepared my bag, put the jewelry bag inside it, and woke everyone up to travel.")]), _vm._v(" "), _c('p', [_vm._v("I was very happy to be back. I was imagining how Maryam would receive her brother. How much I was eager to see my little boy Hazem. All I was worried about was Jawad, where did he go? I should know but I shouldn’t be too worried because Karim is dead now; maybe his stepfather asked him to work with him.")]), _vm._v(" "), _c('p', [_vm._v("We got home and everyone was outside waiting for us. As usual, one of them noticed the car from afar and called everyone to get out. And this time it was the little Zaina, she saw the car coming from afar, so she sped home, screaming, “Zaina came, come all of you.”")]), _vm._v(" "), _c('p', [_vm._v("They all went out and Maryam was holding the child between her hands. I got out of the car and headed towards them eager to meet them. Laila hugged me immediately. Malik followed me with a wide smile and Ashraf directly behind him. I took the child from Maryam and held him to my chest.")]), _vm._v(" "), _c('p', [_vm._v("Hazem came down after I held the baby in my hand. I planned this in advance. If Maryam saw Hazem while she was carrying the baby, she would drop the baby to the ground out of shock.")]), _vm._v(" "), _c('p', [_vm._v("At first, she looked at him and turned, and then she realized what her eyes had seen. What alerted her the most, Sarah’s cry, saying, “Look it is my uncle Hazem; he is alive.” The little girl jumped towards him and hugged him, while Maryam, from the surprise, put her hand on her mouth. She couldn’t believe what she saw.")]), _vm._v(" "), _c('p', [_vm._v("Laila walked over to him and hugged him.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, you’re alive!”")]), _vm._v(" "), _c('p', [_vm._v("After a while, he approached his sister, whose tears drown her eyes, and hugged her, saying, “It’s okay, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t believe you’re alive, thank God!”")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina jumped up at him, exclaiming, “Zaina almost died because of your departure!”")]), _vm._v(" "), _c('p', [_vm._v("I grabbed her tightly and said, “Shut up before I cut your tongue.”")]), _vm._v(" "), _c('p', [_vm._v("He turned to me and said, “It’s okay my dear, I was dying every moment because of longing for you.”")]), _vm._v(" "), _c('p', [_vm._v("He always overwhelms me with his amazing reactions and lovely answers!")]), _vm._v(" "), _c('p', [_vm._v("Laila looked at him and was trying to tease me.")]), _vm._v(" "), _c('p', [_vm._v("“Indeed, and I must tell you that she almost died of your departure.”")]), _vm._v(" "), _c('p', [_vm._v("I told her maliciously, “Well then, I’ll tell you a secret, Mr. Ashraf, Laila—”")]), _vm._v(" "), _c('p', [_vm._v("Before I could finish my words, she jumped up and put her hand over my mouth, and turned to Hazem and said, “She never mourns your passing!”")]), _vm._v(" "), _c('p', [_vm._v("Malik laughed and said, “Shall we stay outside?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (in confusion):")]), _vm._v(" “What a fool I am! Come on, please get in sir. I’ll make you coffee. Then, she asked everyone to come in.”")]), _vm._v(" "), _c('p', [_vm._v("I approached her and whispered in her ear, “Did you notice how stupid you are?”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “How I miss your jokes and fun.”")]), _vm._v(" "), _c('p', [_vm._v("We all entered the house. I was afraid of its cold, but it was warm and tidy indescribably. The furniture was very beautiful and new, Malik sent luxurious furniture after they painted the house with white glossy paint while we were in the other city. Warmth and beauty surrounded the house from every side.")]), _vm._v(" "), _c('p', [_vm._v("The house inevitably derives its warmth from its inhabitants, and perhaps the love among its members kindled the flame within it.")]), _vm._v(" "), _c('p', [_vm._v("The heat started to flow inside me. I examined everything with my wide eyes; I saw a new house with new features. Some nostalgia leaked inside me for his old family, I watched Reem jumping on me and saying Zaina came back with money and food.")]), _vm._v(" "), _c('p', [_vm._v("In the corner, I watched my father telling me one of his fairy tales, as I fell asleep at his feet while he was smoothing my hair. My mother was in the kitchen calling, come on girls, the food is ready, but Salma, as usual, does not like anything! How could she take my mother from me? She deprived the house of its warmth after my father’s death, and made my mother’s heart cruel on me as a stone.")]), _vm._v(" "), _c('p', [_vm._v("I saw Maryam when she entered my house for the first time, holding her child and Laila next to her, full of her brother’s blood. I was incredibly brave, I risked of my life for them.")]), _vm._v(" "), _c('p', [_vm._v("I remembered how many times the rain fell like a torrent, while Jawad was at my doorstep telling me that he had no refuge today but me, How many times I have dried his clothes and shared my food with him! Oh my God, when Hazem entered my house for the first time, he looked at me and said, “I came to check on my sister.” With his innocence and spontaneity, he added, “She did not tell me that her friend is very beautiful.” Even though he knew me since we were kids.")]), _vm._v(" "), _c('p', [_vm._v("The house old family died and became in the darkness of absence, each chose his own destiny while I never chose any part of the details of my life, a life full of surprises!")]), _vm._v(" "), _c('p', [_vm._v("We sat around the breakfast table. The smile was lady of the session. Samar entered the house suddenly; in my absence, they fixed the house of Hazem and Jawad, so Jawad’s family returned to live in it, even Ghaith returned to them after Nader’s departure. I was never satisfied with their presence, but Jawad deserves our support and help.")]), _vm._v(" "), _c('p', [_vm._v("She approached Hazem and greeted him, “Thank God for your safety.”")]), _vm._v(" "), _c('p', [_vm._v("He never looked at her; but he answered her while he was looking at the floor.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("I was very pleased with his behavior; he wanted to prove to me that he could not bear to look at her.")]), _vm._v(" "), _c('p', [_vm._v("She approached me and asked, “Where is Jawad, Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, I am worried about him as much as you are, believe me!”")]), _vm._v(" "), _c('p', [_vm._v("I went upstairs after breakfast, and Hazem followed me. I entered my room, but today it was not mine, it was a royal room of a noble lady! I looked inside and it was equipped with the most luxurious furniture. They were able to remove the old room furniture, but they could not remove Reem’s image from my head! The sound of her screaming is still in my head, “Take care of my baby.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem put his hand on my shoulder and said, “It’s okay, my dear, you must forget, we must start over.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, she died in my arms! The last thing she said was ‘take care of my baby.’”")]), _vm._v(" "), _c('p', [_vm._v("“We must forget and start a new life.”")]), _vm._v(" "), _c('p', [_vm._v("“You are absolutely right. We must put a small bed for the baby here.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “He will stay with Maryam until he grows up a little, you cannot take care of him at night, and she is more experienced than you in dealing with babies.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re right, I’ll take care of him at day and she at night.”")]), _vm._v(" "), _c('p', [_vm._v("“How about you get some sleep?”")]), _vm._v(" "), _c('p', [_vm._v("“And what are you going to do?”")]), _vm._v(" "), _c('p', [_vm._v("“I have to take care of the land, and I have to look for Jawad.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam came to us and said, “My God! I can’t believe you’re alive, and the strangest thing is that you and Zaina are together, I never expected that!”")]), _vm._v(" "), _c('p', [_vm._v("No one expected me to fall in love with Hazem, not even me, I always considered him as my father, as a big brother, as a man of the house, but as a lover! That’s really a surprise.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I never imagined her with anyone but me, and I never lost faith that in the end she would be mine.”")]), _vm._v(" "), _c('p', [_vm._v("I said in amazement, “Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("“Certainly, little girl, I have always considered you all I have in life, and I have not prayed to God for anything but that you be mine.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “God granted you what you wish, you swindler.”")]), _vm._v(" "), _c('p', [_vm._v("“You are the one who deceived my heart and stole it from me; you robbed me of my mind and my comfort, how much I wanted to kill everyone who approached you!”")]), _vm._v(" "), _c('p', [_vm._v("“No one will approach me, and no one will be killed.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (sarcastically):")]), _vm._v(" “I don’t promise you anything.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “My God, how stubborn you are!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I swear by God, if anyone approached you or my girls, I would cut him off with my own hands.”")]), _vm._v(" "), _c('p', [_vm._v("I put my hands on my ears and said, “No more killing after today.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Well, I was joking, now let’s close the door; I want you with something very necessary.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem to Maryam:")]), _vm._v(" “She is still tired, we can talk later.”")]), _vm._v(" "), _c('p', [_vm._v("I interrupted him, “I’m fine, what’s up? Is it about Jawad?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “No, honey, we haven’t seen him for a while.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Where did he disappear to? Anyway, I do not feel distressed, I feel that he is fine and will return soon.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I am also not worried about him; perhaps he has found a better job than here.”")]), _vm._v(" "), _c('p', [_vm._v("“Jawad never leaves me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Everyone leaves everyone for money.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “I will look for him, what is the matter now, Maryam?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Well, Zaina, when I went to get the baby, I saw Reem’s maid.”")]), _vm._v(" "), _c('p', [_vm._v("I asked her, “How did you get the baby?”")]), _vm._v(" "), _c('p', [_vm._v("I knew the girls well there. When I went, they arranged my entry into the house, and took me to the child’s room. When I entered, Reem’s maid did not argue with me. On the contrary, she asked me, “Do you know Reem’s sister Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her yes, but she is dead, and the maid said to me, “Reem told me that she did not die.”")]), _vm._v(" "), _c('p', [_vm._v("So I said to her, “Well, what do you want from her?”")]), _vm._v(" "), _c('p', [_vm._v("She took out a small box from Reem’s closet and said, “Give it to Reem’s sister, please. That was her will if she died. She trusted me a lot, and told me that she would give birth in her sister’s house, and that her sister would take care of the child; even if his father took him, Zaina would seek to get him back.”")]), _vm._v(" "), _c('p', [_vm._v("I asked Maryam, “Where did she get all that confidence from?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “She knows her sister well and what her heart contains.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, I was the one who took care of her, I raised her.”")]), _vm._v(" "), _c('p', [_vm._v("I took the box from Maryam. I was very surprised and scared. I sat on the bed and Hazem sat across from me, while Maryam sat on a chair across from us. Moments later, Laila entered and sat on another chair next to Maryam. I opened the box that was full of messages and scattered them in front of me.")]), _vm._v(" "), _c('p', [_vm._v("I also found a bracelet similar to the one I found in my dad’s box.")]), _vm._v(" "), _c('p', [_vm._v("Didn’t Malik tell me he bought the bracelet for me, how did Reem get this?")]), _vm._v(" "), _c('p', [_vm._v("I turned to Maryam and asked, “When you arranged the house, where did you put my old things?”")]), _vm._v(" "), _c('p', [_vm._v("“In the closet, I have arranged everything in your closet, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I went to the closet to take out my chest; I remembered that it was still in Malik’s house. But yes, I put the bracelet with the jewels.")]), _vm._v(" "), _c('p', [_vm._v("I opened the jewelry bag and took out the bracelet. I was careful they could not notice what was in the bag, so I took out the bracelet and closed the bag quickly. I compared the two bracelets; they looked exactly like each other. Whoever bought them meant the two of us.")]), _vm._v(" "), _c('p', [_vm._v("Yes, my father bought it. Perhaps this is what he meant when he said that the bracelet would be evidence for me. It was evidence of Malik’s lying and betrayal. It was also evidence that my sister was only Reem. As for Salma and the dead girl, they are not my sisters. Otherwise, my father would have bought them bracelets as well.")]), _vm._v(" "), _c('p', [_vm._v("I started to open the envelopes and read them, all the letters were addressed to me and apparently, they had never been opened before. The letters were arranged according to the dates that were written on the envelopes, the oldest one was only two years ago, and the last one was two days before Reem’s death.")]), _vm._v(" "), _c('p', [_vm._v("I asked Maryam and Laila to go down to Malik and sit with him while I read the letters, I was afraid that he would follow us upstairs and find out about the letters. He must be distracted. The bracelet issue worried me and confused me very much. Hazem and I were left alone, so I started reading them one by one.")]), _vm._v(" "), _c('p', [_vm._v("Dear Zaina (they all started like this.)")]), _vm._v(" "), _c('p', [_vm._v("First of all, forgive me, I did not invite you to my wedding, but I was really afraid that Karim would like you and leave me. I had little self-confidence. Then I regretted that. He loves me not for poetry, but rather he loves my beauty, my eyes and my submission to him!")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("This was her first letter. Perhaps at that time, she began to feel alienation and loneliness and her conscience began to reprimand her. I read all of them; they were just conveying the details of her daily life, and her suffering with Salma’s greed, and how Salma was completely controlling my mother, and how she persuaded the nobleman to work with him. She even mentioned Salma’s doubts about Maryam’s relationship with her husband.")]), _vm._v(" "), _c('p', [_vm._v("She mentioned that when she yearned and started missing me, she wrote me a letter, but she didn’t not send it, because she knew that it would not arrive; Salma was in control of her affairs so if she saw any letter, she would tear it and threatened her to tell my mother. My mother was always by Salma’s side, when Reem refused any request to Salma, she resorted to her mother to scold her. So Reem didn’t tell anyone about letters except her maid. She also wrote about her maids and how much Karim took care of her. I felt a little bored until I reached the last letter, which was very long and detailed…")]), _vm._v(" "), _c('p', [_vm._v("Dear Zaina…")]), _vm._v(" "), _c('p', [_vm._v("I am pregnant and very tired and I think this is my last letter to you, you must know, my dear, I am tormented. I hate my life in this house, I was so happy until I found out Karim’s reality. He is a bad and selfish man; He buys little girls from their families and sells them, but he doesn’t work alone, there is a big man supporting him. He is Malik the man you live with. I know you are alive. My mother told me that when you were a little girl, Malik wanted you as his daughter, so he stole you from our parents for a whole year. Then our father was able to bring you back by trick and deception. When Malik wanted to get you back, our mother suggested to give him one of her nieces, she did her best to keep you away from him; he is a very evil man. He was not convinced of the girl, so he sent her to a boarding school. He started to stalk you quietly. He kept Karim away from you; he was afraid that Karim would choose you because you are very beautiful.")]), _vm._v(" "), _c('p', [_vm._v("When I was born, my father bought us two similar bracelets. If we parted one day, they would be a clue to each other. Our eyes were the biggest clues, but he didn’t realize that even though we were carrying his eyes.")]), _vm._v(" "), _c('p', [_vm._v("Malik was sending a man named Nader to arrange things with Karim. The man introduced himself to Karim as Mr. Malik. One of my maids knew him but we didn’t dare to inform Karim. I know that Nader wanted to engage you; it was Malik plan to keep you close to him.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Dear Zaina,")]), _vm._v(" "), _c('p', [_vm._v("My mother died after she saw you riding in the car with Malik. She knew that you were alive and that he persuaded you to become his daughter. He saw her and sent orders to Karim to get rid of her, that night she died; I know that he killed her.")]), _vm._v(" "), _c('p', [_vm._v("Beware of Salma, she is very evil, she was never a sister to us and she carried the grudges of the world against you, so when my mother had the opportunity to keep her away from you, she took her out of the house. Our mother was deliberately cruel to you to stop Salma from hurting you. My mother convinced Salma that she was her favorite daughter to protect you from her clutches. She was in pain every day over the way she treated you and prayed to God to forgive her, and I pray to God that you will forgive me. Please, Zaina, if I die, take care of my child. If it is a girl, call her Reem. I hope she carries our eyes. If it’s a girl Karim will throw her on the street, so please make sure you find her, When Malik knows that Karim is no longer fit for work, he will get rid of him, as he got rid of many before him. His tool now is Nader, so beware of them, beware, Zaina, he may kill everyone you love. Perhaps he wants Nader to marry you to keep you under his wing. Please, please forgive me, forgive me, my dear sister.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("My God, who is Malik? Who do I believe? I read his diary! Does the man lie in his diary? He definitely wrote them in this way because he wanted me read it! Oh my God, he would never forget his key! The bracelet is the best evidence that Reem does not lie. My mother was eager to speak with me on that day; her death day. What should I do now?")]), _vm._v(" "), _c('p', [_vm._v("Is it conceivable that Malik was the one who ordered Karim to kill Hazem? Why didn’t Dalal tell him that Hazem was in his house? Didn’t she really tell him he was alive! He wanted to recruit Hazem for him. He asked him to work for him when he found out that he was alive and that I was fond of him. So, Nader’s refusal to live in Malik’s house when he asked me to marry him was out of fear of him, not manly as he wanted me to understand. Malik was sure that Nader would come back when we quarreled. He was surprised by my love for Hazem. How did he know that I loved him in the first place? Perhaps, Jawad’s mother and daughter were the ones who informed him, or may be Nader doubted that Hazem loved me and told Malik. He was jealous from him. I don’t think it was jealousy; certainly he was afraid of his plan to fail.")]), _vm._v(" "), _c('p', [_vm._v("I must act quickly, there must be a solution, and we must trap Malik and surround him from everywhere.")]), _vm._v(" "), _c('p', [_vm._v("I returned the letters to the box; Hazem read them all except the last one. I put them back in the envelope and put them in the box. I did not want Hazem to read the last one. I was afraid that he would revolt against Malik. I would tell him the truth, but not now.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Wait, I haven’t read the last one yet. Why did you put it in the box?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Nothing in it, like the others. Come on, my dear, come down to them now. I will change my clothes and follow you. If Malik asks you what we were doing, tell him I was arranging my closet, never tell him about the letters.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I won’t tell him anything, don’t worry.”")]), _vm._v(" "), _c('p', [_vm._v("How am I going to get out of this mess? Oh my God, he would hurt my family if he knew I found out about him!")]), _vm._v(" "), _c('p', [_vm._v("I came down after about half an hour, Malik was telling a story to the girls, a wonderful scene; as if he was a grandfather gathered his grandchildren around him. How can a person with such tenderness be a murderer and a criminal!")]), _vm._v(" "), _c('p', [_vm._v("The house was filled with smiles of the little girls; for the first time they have a grandfather, they do not even know what the father is! I will not interrupt their happiness, and then I must make sure that what Reem said was true. She couldn’t lie, what is the point of lying to me about something like this?")]), _vm._v(" "), _c('p', [_vm._v("I walked towards him, put my hand on his shoulder and bent down and kissed him on the cheek, then asked him, “Are you happy?”")]), _vm._v(" "), _c('p', [_vm._v("He put his hand on mine and added, “Very.”")]), _vm._v(" "), _c('p', [_vm._v("“For the first time in years, we have a father and grandfather in this house.”")]), _vm._v(" "), _c('p', [_vm._v("“I am a wonderful father, my dear, but I am still too young to be a grandfather dear.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “I was thinking what to call you; I’ll call you Grandpa Malik.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “What a girl, you never miss anything like your mother! I’ll go to check on my flowers.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Don’t be late; we must go home, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“No, we will stay here, there is a place for everyone, even you, my dear, and we will prepare a room for you and for Dalal too.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, with this wonderful family atmosphere, I will stay forever.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “I’ll go now and then come back to make tea for you myself.”")]), _vm._v(" "), _c('p', [_vm._v("I went out and Hazem followed me quickly. He grabbed my hand and was very worried about me. We reached our garden; it was much nicer than before. We sat on the chairs surrounded by flowers. I looked very worried and confused.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Won’t you tell me what the last message contained?”")]), _vm._v(" "), _c('p', [_vm._v("“Keep quiet, there’s someone in your house.”")]), _vm._v(" "), _c('p', [_vm._v("It was Jawad’s mother, and as I knew her, she was trying to eavesdrop on our conversation. I went to her; I was very angry with her. I started yelling at her even though it’s not my nature.")]), _vm._v(" "), _c('p', [_vm._v("“What are you doing, woman? You are spying on our conversation, are you never ashamed of yourself?”")]), _vm._v(" "), _c('p', [_vm._v("Everyone in the house came because of my screaming. Laila was the first one arrived.")]), _vm._v(" "), _c('p', [_vm._v("She said, “What’s wrong with you, Zaina? What is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“That woman is never ashamed, no matter what you do with her, she remains bad.”")]), _vm._v(" "), _c('p', [_vm._v("Malik arrived panting.")]), _vm._v(" "), _c('p', [_vm._v("“Take it easy, girl.”")]), _vm._v(" "), _c('p', [_vm._v("I spoke to him, “In one hour, she must take her family and leaves, and when Jawad comes, I will tell him myself, and if he does not like it, he should go with her.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “You never fired anyone!”")]), _vm._v(" "), _c('p', [_vm._v("I approached her and whispered in her ear, “She will cause us a lot of troubles.”")]), _vm._v(" "), _c('p', [_vm._v("Then I started shouting at the woman, “You’re leaving now!”")]), _vm._v(" "), _c('p', [_vm._v("Laila understood me, “Well, calm down, Lady Zaina, she won’t stay here for a minute.”")]), _vm._v(" "), _c('p', [_vm._v("I went to Malik and asked him, “Please give her some money to take her children and rent an apartment for them as she used to, and we will send her a sum every month.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “That’s very fair. Please, madam, gather your things, and in an hour, I’ll be back, and I don’t want to see any of you.”")]), _vm._v(" "), _c('p', [_vm._v("I went home angrily. Samar followed me, and Hazem was right behind. She said wrathfully, “Who do you think yourself to treat us like this?”")]), _vm._v(" "), _c('p', [_vm._v("I turned to her and grabbed her by the shoulders, in anger.")]), _vm._v(" "), _c('p', [_vm._v("“Leave before I bring the police to you, then you idiot, ask your mother why I did that; she is the one who brought me to this. After an hour if I go out and find any of you, you will sleep in prison today.”")]), _vm._v(" "), _c('p', [_vm._v("I entered the house and everyone followed me. I headed towards the stairs; I wanted to go up to my room.")]), _vm._v(" "), _c('p', [_vm._v("Malik shouted from afar, “Stop, girl.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “What else?”")]), _vm._v(" "), _c('p', [_vm._v("“A logical explanation for everything that is going on. Immediately, I did what you asked and gave her the money. I didn’t want to embarrass you in front of her, but now I want a reason for all this noise.”")]), _vm._v(" "), _c('p', [_vm._v("I went towards him and grabbed his hand calmly like a little child and said, “Is it okay to keep my enemy inside my house? She was working with Salma and Karim, and I found her spying on Hazem and me, I’m afraid she’s complicit with someone to hurt me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Well, you know that your heart has become weak, and anger like this could take your life. Then what I hate the most is kicking people out of my house, since when have you been like this?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What’s the story of your heart?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What’s the matter, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Ask Ashraf, I’m going to sleep and when I wake up I want her outside my house and her stupid daughter too.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Malik. “I also do not like to expel anyone, but she is not anyone, she is nobody!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (sadly):")]), _vm._v(" “Well, my dear, the important thing is that you must rest, you are the most valuable thing we have and your health is important to us.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, casting my eyes towards everyone, “I hope everyone cares too.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “I’m like my mother, I love you very much.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “We love her too, and my mother always says that she is the mother of all of us.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at Maryam and smiled, and then I said, “No my dear, your mother is the mother of all of us.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam in amazement, “Do you really think so?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her with confidence, “You are the only mother I know in this world.”")]), _vm._v(" "), _c('p', [_vm._v("I went up to my room and the anger almost killed me from Jawad’s mother and his sister and from Malik’s reaction more. Although he gave her the money and agreed to expel her, he was definitely upset. I have to find a solution; I could not stand what was happening. I was afraid of falling to the ground, so I immediately lay on the bed.")]), _vm._v(" "), _c('p', [_vm._v("Hazem entered my room and asked me, “Are you fine?”")]), _vm._v(" "), _c('p', [_vm._v("“Not at all!”")]), _vm._v(" "), _c('p', [_vm._v("He handed me a glass of water and a tablet of medicine that Ashraf had prescribed to me, which I took and I fell into a deep sleep.")]), _vm._v(" "), _c('p', [_vm._v("Once upon a time, there was a young man who asked me to teach him reading, and today I wake up and find him reading my private papers. He did not calm down until he read the last letter of Reem’s letters. How did he have the audacity to open my papers? He was afraid even to touch any of my things for not dropping it on the ground. He was violent and reckless and today I see him as a handsome young man sitting on the sofa and in front of him my cup of coffee, he only likes to drink coffee in my own cup! He was wearing black pants and a navy blue shirt. He was carrying my papers.")]), _vm._v(" "), _c('p', [_vm._v("I asked him calmly, “What are you doing?”")]), _vm._v(" "), _c('p', [_vm._v("“You have finally woken up, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“I asked you, answer me.”")]), _vm._v(" "), _c('p', [_vm._v("“We must go to Kamal; I have read the last letter more than ten times. You should know that Kamal is a very good and honest man, we will tell him everything. You will tell him that you are not Malik’s daughter and that he forced you to lie, and also you will tell him to give you back your real name, or rather your true identity. He should register the land and the house in your name, because they are yours in the first place, but with your death Malik took them to him. Listen to me, Zaina, he is a very evil man, you don’t know his reality. You don’t know his true identity.”")]), _vm._v(" "), _c('p', [_vm._v("I replied in astonishment, “And lose everything I wished for? I will not be a noble lady anymore. I will return to work in the scorched earth that needs years to recover, and perhaps I will return to carry baskets and return to be Zaina the vegetable seller.”")]), _vm._v(" "), _c('p', [_vm._v("“You are noble with your morals, stop illusion. He may kill you, then who said I will make you work one day, I will work and provide you with everything.”")]), _vm._v(" "), _c('p', [_vm._v("“What will you provide me?”")]), _vm._v(" "), _c('p', [_vm._v("“So, as I thought, you were turning away from me because of my poverty, you never loved me.”")]), _vm._v(" "), _c('p', [_vm._v("“Now we have the money, and I will make you a nobleman. Don’t think of him?”")]), _vm._v(" "), _c('p', [_vm._v("“He’s a criminal!”")]), _vm._v(" "), _c('p', [_vm._v("“And so is your sister.”")]), _vm._v(" "), _c('p', [_vm._v("“A while ago, you called her everyone’s mother, then she killed whoever was going to kill her or her daughters, but he kills for pleasure. I will not let you deal with him anymore. You will do what I tell you, or I will stick a knife in his heart.”")]), _vm._v(" "), _c('p', [_vm._v("“Just like your sister. Aren’t you who were covering her crimes in the first place? I will not let you approach Malik. I will leave with him today and you will not see us again. It is better for you to get out of my way. I will leave you the house and the land. Go back alone to sell the baskets.”")]), _vm._v(" "), _c('p', [_vm._v("“Leave then, I won’t stand in your way as long as you agree to stay with a criminal. I promise I won’t meddle in your affairs again.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s better; don’t interfere with my affairs again.”")]), _vm._v(" "), _c('p', [_vm._v("“Go now, I don’t want to get angry, I promised you.”")]), _vm._v(" "), _c('p', [_vm._v("“You come out, this is my room and I want to change my clothes, and I will not come here again.”")]), _vm._v(" "), _c('p', [_vm._v("He came out quietly, he looked at me with a look before he left that almost took my heart with it, as if he was a small child, he wanted to jump on his mother and say to her how are you going to leave me like this?")]), _vm._v(" "), _c('p', [_vm._v("All my life I dreamed of being a noble lady and today he wants me to give up everything! I hurt him so much with my words. I feel like everything will collapse in front of me.")]), _vm._v(" "), _c('p', [_vm._v("I hid the jewelry bag in a place that no one would ever reach; there are places in my room that no one else knows. I went to Malik, he was in the room that Maryam had prepared for him to sleep in; he was still awake.")]), _vm._v(" "), _c('p', [_vm._v("He smiled when he saw me and said, “Hello, sweetie.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him sadly and said, “I want to go home.”")]), _vm._v(" "), _c('p', [_vm._v("“Now?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my dear, as long as that is your wish.”")]), _vm._v(" "), _c('p', [_vm._v("We went out without even telling anyone. Everyone was in their rooms getting ready to sleep. Hazem was standing in my place where I always stood; he was watching us from the window of my room till we left.")]), _vm._v(" "), _c('p', [_vm._v("We got home; Malik overwhelmed with concern.")]), _vm._v(" "), _c('p', [_vm._v("“Why did you ask me to leave them now?”")]), _vm._v(" "), _c('p', [_vm._v("“I quarreled with Hazem, he is very stubborn and nervous, and when he gets angry, he terrifies me.”")]), _vm._v(" "), _c('p', [_vm._v("“Believe me, my daughter; he is not fit for you.”")]), _vm._v(" "), _c('p', [_vm._v("“No one is fit for Zaina, it’s okay, I’ll be alone for the rest of my life.”")]), _vm._v(" "), _c('p', [_vm._v("“You are beautiful, and you will find a thousand men who wish to marry you. Then do not forget that you are Malik’s daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“Rather, Fouad’s daughter, and perhaps it is my fate to die early.”")]), _vm._v(" "), _c('p', [_vm._v("“What nonsense, girl? You are my daughter and you will not die.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, I don’t care anymore, you should sleep, my dear, come to your room, I will read you a beautiful story before bed.”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you crying? Why are you so sad?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, please go to sleep.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, we’ll talk in the morning. Come now and tell me your beautiful story.”")]), _vm._v(" "), _c('p', [_vm._v("We went up to his room; he put on his pajamas and lay on his bed. I began to read to him the story. Before he fell asleep, he held my hand and said, “Whatever happens, my little girl, you will remain my daughter whom I love.”")]), _vm._v(" "), _c('p', [_vm._v("I kissed him on his forehead, closed the door, hurried out of the house, and asked the driver to take me to the city house.")]), _vm._v(" "), _c('p', [_vm._v("I called Kamal, although it was late, and asked him to come immediately. I had taken Reem’s letters with me before I left. He came quickly and Hazem was with him. I looked at Hazem and asked him, “What are you doing here?”")]), _vm._v(" "), _c('p', [_vm._v("“I waited for you but you were late, so I went to Mr. Kamal, as we agreed to tell him everything.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem had gone alone and told Kamal all about Malik, and that Malik had forced me to be his daughter, and had also told him that I had sent him. How noble his behavior was! Although I expelled him from my life and insulted him, he tried to save me to the end. Perhaps he was sure that I would do that, and what I told him was only to keep him out of harm. I was very afraid of Malik, so I decided to remove Hazem away. He had to be insulted in order to believe me, but his heart was sure that I love him and I fear for him!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “Is what he told me true, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Mr. Kamal, I am not his daughter, he is the mastermind and mainstay of Karim’s business, he is the owner of everything, but he hides behind a group of men, including Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“We caught Nader.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really? How and when?”")]), _vm._v(" "), _c('p', [_vm._v("“Today in the morning; he ran away a while ago. One of the businessmen invited him to work with him, then we got a call that telling us where he was, we arrested him, and he confessed about Malik.”")]), _vm._v(" "), _c('p', [_vm._v("I asked, “Perhaps Malik invited him to work with him?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “Malik who told us about his place, he said that one of his men saw him by chance.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “So, he wants to finish him. Perhaps he wants to put someone else in his place.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “We’ll find out. Now tell me Lady Zaina why have you come now?”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “I don’t know, sir? All I want is to get my identity back and be Zaina Fouad. Perhaps God has placed me with Him to reveal him to you, and save the poor girls.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “Oh, my God, if only you knew how they are now, miserable and homeless.”")]), _vm._v(" "), _c('p', [_vm._v("I answered, “I wish I could help them, what are you going to do with Malik now?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “This is my job now, but Mrs. Zaina, how can a conscious girl like you accept changing her name and identity? That’s what I don’t understand, every time I see you, I found you glad that he’s your father.”")]), _vm._v(" "), _c('p', [_vm._v("A voice came from afar.")]), _vm._v(" "), _c('p', [_vm._v("“Because her heart is weak, Kamal, she is really not my daughter, and I will free her from me.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, it’s Malik’s voice, he has followed us…!”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him and my eyes filled with tears:")]), _vm._v(" "), _c('p', [_vm._v("“I—”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “There is no need to talk, take your friend and leave now, and I will deal with Mr. Kamal and with the accusations of Nader and Reem. Thank you for letting me take care of you, or rather thank you for taking care of me. I will send you all your things, and I promise I will never bother you and your family again. I will adjust all your papers, the car is waiting for you, and I wish you a happy life.”")]), _vm._v(" "), _c('p', [_vm._v("We were about to leave without saying a word, I didn’t even give Kamal Reem’s letters. When I was at the door, I turned; Malik looked at me sadly, I turned to Kamal and asked him, “Is there any information about Jawad?”")]), _vm._v(" "), _c('p', [_vm._v("Malik told Kamal that Jawad had been missing for a while.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “No, he might have found a job in a better place.”")]), _vm._v(" "), _c('p', [_vm._v("I said sadly, “Will he leave without saying goodbye?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Many leave without saying goodbye!”")]), _vm._v(" "), _c('p', [_vm._v("Hazem grabbed my hand and said, “Come on, Zaina, let’s go, the dawn will break.”")]), _vm._v(" "), _c('p', [_vm._v("He was afraid that I would be affected by Malik and stay with him. Oh my God, that sad look on Malik’s face, I had never seen it before. Only today I felt that his daughter died, he lost his girl whom he had been waiting for so long to hold her in his arms, He lost the hope that he lived and was going to spend the rest of his life for, and he lost his only love and passion for life!")]), _vm._v(" "), _c('p', [_vm._v("I got in the car and I was sad and corroded on myself. I couldn’t look at Hazem’s face; even he looked away from me and leaned his head on the car window.")]), _vm._v(" "), _c('p', [_vm._v("What puzzled me very much was how did Malik know about Reem’s letters, or rather her accusations, There is no doubt that he was watching her as well, and perhaps one of her maids was conveying her news to him, or it was possible that Reem had spoken about him in front of someone knew him and told him everything. It is very confusing and I am tired of thinking about it. I think it is enough what happened to me until now. I will return to my normal life without thinking of anyone.")]), _vm._v(" "), _c('p', [_vm._v("How beautiful to wake up to a cup of coffee mixed with love! That’s how he woke me up every day on the smell of coffee. We drank it together while talking about land and girls affairs. Then Laila’s voice interrupted the lovely moments. “Breakfast is ready.” We had breakfast and everyone went to work. Of course we will not go back to selling in the market, we ladies. With what I have left of the money, we rented a shop in the city market.")]), _vm._v(" "), _c('p', [_vm._v("We filled the shop with a lot of merchandise. I had also sold some jewels for fixing the land. Hazem and I started working on the land. I didn’t work much because we hired workers; I had only to supervise. Hazem carried the whole burden of work on his shoulders; he never complained nor grumbled. His smile and concern covered the whole place; he was always optimistic and patient!")]), _vm._v(" "), _c('p', [_vm._v("Our awful night at Malik’s house passed as if it had never been, we didn’t reproach about anything and we never mentioned it. When we came back from his house that day, each one headed to his room without even looking at the other’s face, as if it was a fleeting, cruel night that took what it took from the soul of each one of us and left! The patient may have to amputate one of his limbs sometimes to get rid of the pain and suffering, and so did we, we amputated that night of our lives so that we would not be exposed to its aches or the side effects it left!")]), _vm._v(" "), _c('p', [_vm._v("Ashraf married Laila, and she stipulated that he live with us, so he opened a clinic for him in our city and it brought in a good amount. As for Maryam, she asked us to bring Faris to live with us. I didn’t mind, he came with his child from Salma, and he was very loyal to Maryam. Also he was so generous and gave Maryam whatever she asked. We became a large family, and the noise filled the place. Hazem stayed in his apartment. When I wanted to escape from the girls’ quarrels, I would sit in his house or in my flower garden.")]), _vm._v(" "), _c('p', [_vm._v("The miserable girls were liberated from Karim’s home, some of them returned to their families, and some of them did not find a place for them. I was sad for everyone, I wanted so badly to find a solution for them, but my family is too big and I can’t do anything. Karim’s house was left empty; I wished I could use it to educate the girls.")]), _vm._v(" "), _c('p', [_vm._v("The days passed quickly, and Jawad was still hidden. Malik was completely absent from our life. I missed him so much. Sometimes, I longed for his house and to sit on that sofa facing him. We were drinking tea while he was telling me the stories of the merchants. I longed for the noble lady who he made. I never wore shabby or old clothes, my clothes were always beautiful. Malik sent me all the clothes he had. Most of those who see me call me Lady Zaina. I was the lady of my house but I lost the dream of being that lady who owned land and businesses. After the last problem with Hazem, he did not dare to ask me to marry him. He cared about me and did not leave me, but he was very afraid of that step, he always felt that he was the reason for destroying my dreams. If he had not insisted on defaming Malik, the man would not have exposed and I would remain his lovely daughter.")]), _vm._v(" "), _c('p', [_vm._v("It’s been two whole months since our separation from Malik. Kamal visited us and he had a lot.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “How are you, Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Fine, how is he?”")]), _vm._v(" "), _c('p', [_vm._v("“Who?”")]), _vm._v(" "), _c('p', [_vm._v("“You know who I mean!”")]), _vm._v(" "), _c('p', [_vm._v("“He’s fine, he’s better than you, how’s the land?”")]), _vm._v(" "), _c('p', [_vm._v("“It recovers, but slowly.”")]), _vm._v(" "), _c('p', [_vm._v("“I see that you hired people to work for it, and I heard that you rented a shop.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Mr. Kamal, it is necessary to expand work; my family is big as you can see.”")]), _vm._v(" "), _c('p', [_vm._v("“You didn’t marry that boy?”")]), _vm._v(" "), _c('p', [_vm._v("“Not yet, we need some time, the land must recover first.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope so. Well, it has been proven that Malik is completely innocent of all the charges against him.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear, nothing has been proven against him. Karim was the leader with the help of Nader. It has been proven that Nader was lying about his accusations, and he did not carry any evidence against Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“But Reem, and her letters?”")]), _vm._v(" "), _c('p', [_vm._v("“It was proven that Reem’s claims were fake, and she was forced by her husband to say that.”")]), _vm._v(" "), _c('p', [_vm._v("“And her letters that she wrote to me?”")]), _vm._v(" "), _c('p', [_vm._v("“Which letters?”")]), _vm._v(" "), _c('p', [_vm._v("I brought the letters and handed them to him, he read them and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“My dear, these letters are only evidence that the girl is forced by her husband to write them. Throw them away, they are useless.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you believe all of that? Can you believe that he has nothing to do with what happened?”")]), _vm._v(" "), _c('p', [_vm._v("“We are working according to the evidences; there is no evidence against the man. By the way, I brought you your papers; you are back Zaina Fouad as you were, my lady.”")]), _vm._v(" "), _c('p', [_vm._v("“Malik has granted you additional land to join it to your land. It is good and you can use it while your land is healed. He has also granted you a large amount of money. He has bought Karim’s house and wants you to transform it to a school for broken girls; the girls who were hurt by Karim and his men. Teach them something useful, teach them to embroider and sewing and agriculture, teach them to read and write, teach them how to face life and how to be strong like you in facing difficulties. He told me that he would sit in his house close to you, if you needed his help, you would find him there. He promised not to approach you at all unless you wanted to visit him. I told Malik once how much I wish to turn Karim’s house from a place of corruption to a place of reform. He engraved the idea in his mind and today he sent me money to implement it.”")]), _vm._v(" "), _c('p', [_vm._v("Kamal left and Hazem was very upset.")]), _vm._v(" "), _c('p', [_vm._v("“Will we accept this fraudster’s money? Will we help the girls with the money of those who committed crimes against them?”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Yes, that’s right! It’s the money they deserve. It’s their money; didn’t he earn it through them? They’ll enjoy it, and then maybe he’s really innocent. You heard Kamal; there is nothing been proven against him.”")]), _vm._v(" "), _c('p', [_vm._v("“A point of view. You should know that I have nothing to do with them or with Karim’s house. I only work on the land, but that work is your responsibility.”")]), _vm._v(" "), _c('p', [_vm._v("I walked over to him, put my hand on his shoulder, and said, “Who will allow you to approach them or work with them; you have nothing to do with a girl in the world but me.”")]), _vm._v(" "), _c('p', [_vm._v("He shook his head, smiling, with his head down.")]), _vm._v(" "), _c('p', [_vm._v("“You crook! I love you so much baby.”")]), _vm._v(" "), _c('p', [_vm._v("I turned away from him a little and added, “It’s been a long time since you said it.”")]), _vm._v(" "), _c('p', [_vm._v("“No, Lady Zaina, every day I say it hundreds of times, but your heart does not hear it, your heart always ignores me.”")]), _vm._v(" "), _c('p', [_vm._v("“So you don’t know anything about my heart.”")]), _vm._v(" "), _c('p', [_vm._v("He came close to me and looked straight in my eyes.")]), _vm._v(" "), _c('p', [_vm._v("“Isn’t it time? Won’t you have mercy on my enamored heart with you and accept me as your husband?”")]), _vm._v(" "), _c('p', [_vm._v("“When the earth blooms, we’ll get married, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have any doubts?”")]), _vm._v(" "), _c('p', [_vm._v("“Will you be my wife? Lady Zaina; will you finally be my wife!”")]), _vm._v(" "), _c('p', [_vm._v("“Mr. Hazem is going to marry his little girl Zaina, why do you always call me a little girl?”")]), _vm._v(" "), _c('p', [_vm._v("Once upon the time, when I was a child, there was a young man pulling his cart. It was my first visit to the market; I was very confused and the baskets were heavy. I carried them and started teetering, they almost fell, so that young man ran towards me and took them from me. He put them in his cart and drove me to the market.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “You have the most beautiful eyes in the universe. When you grow up I will marry you.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at him haughtily and arrogantly, and replied, “You fool, I will marry the nobleman.”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “Are you challenging me?”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Yes, I challenge you and you will see, one day you will call me Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("He gave me the baskets and muttered as he walked, “I will dedicate my whole life to you, even if you do not like me, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("Every time I met him, he used to carry my baskets and said, “You are still too little to carry the baskets.” And from that time on, he called me little girl. Every time I asked him why he called me little girl he smiled, until he told me the story of my baskets.")]), _vm._v(" "), _c('p', [_vm._v("He took care of me and carried my baskets for two years and then he left for a while. When he came back he was a strong young man, he came back with Maryam, a friend of the market. I distinguished him at that time when he asked me, “How are you, little girl?” Maryam became Laila’s friend. Then Laila introduced Maryam to her brother and they got married.")]), _vm._v(" "), _c('p', [_vm._v("Years passed and everyone grew up.")]), _vm._v(" "), _c('p', [_vm._v("After Kamal visit, we sat around the dining table. I put a set of papers in front of me in which I wrote a complete plan for converting the house into a school. Laila made a list of the names of the affected girls, so that we could invite them later. She is the city’s expert, and knows all its residents. Malik sent us an engineer to organize the house, and indeed he laid out a plan for the house in a way that we cannot do.")]), _vm._v(" "), _c('p', [_vm._v("We worked very hard until we arranged everything. We started sending invitations to all the girls to attend. At first, the families were afraid of paying exorbitant amounts for the girls to enroll in school. After they were sure that we did not want anything from them, they began to send girls. Some girls refrained from attending, preferring to leave the city and work in nearby villages.")]), _vm._v(" "), _c('p', [_vm._v("Some of them felt ashamed of what they were, Laila persuaded the largest number to attend. Crisis must be faced by conquering it, if they surrender themselves to despair, depression and awful memories, they will die out of pain and sad on their situation. They shouldn’t lock themselves in their previous life; they should get up and go on. Sadness and painful memories keep the man a prisoner to his past and a prisoner to those who hurt him. Girls should defeat Karim and men like him by going on and starting new life full of hope and hard working.")]), _vm._v(" "), _c('p', [_vm._v("I am sure that when they enter the house, they will not feel that it is the house in which they were tortured and humiliated. We have changed all the features of the house. I have not seen it yet, I always avoided entering it because one day I was watching the nobleman, when he was sitting on his chair and reading my letters. I would see the girls learning, but unfortunately, I only saw the part he wanted people to see!")]), _vm._v(" "), _c('p', [_vm._v("We finally open the school. It was not a regular school; it was a school for everything. We hired some female teachers and craftswomen so that we could teach the girls everything.")]), _vm._v(" "), _c('p', [_vm._v("I attended the opening as the school lady and its owner. I welcomed all the girls with a wide smile; I wanted to compel the broken hearts, who suffered from the oppression of their families first, then the nobleman, then the entire community. Laila and Maryam were by my side. They worked hard for this day. They looked also noble and elegant. Who would have thought that the little girls, who were saddled with baskets, would stand today as the ladies of the city to help the girls of the city? I felt that I took the place of Karim, the nobleman of the city, today. He was choosing the girls pretending to help and educate them, and today I am doing that.")]), _vm._v(" "), _c('p', [_vm._v("Today I am the lady who will save the girls from what Karim has done. Some fathers came with their daughters; when they saw me; they were assured that their girls would one day become noble ladies, and that they were also in safe hands. They might say to themselves, “Here is the vegetable seller in front of us wearing a dress and a necklace; their price is equal to the price of one house of our homes.” She achieved her dreams by her hardworking, consistence and patience, not by selling herself to the nobleman.")]), _vm._v(" "), _c('p', [_vm._v("There were some looks of optimism about the girls’ future, and other looks regretting what they did to their girls, and others are relieved that they found a way out for girls who returned wrecked and exhausted.")]), _vm._v(" "), _c('p', [_vm._v("Circumstances of life force us to do many things that we are not satisfied with, but nothing compels a father or mother to throw a piece of them into an unknown place. Poverty and ignorance are not a reason to sell an innocent child without fault, except that she was the daughter of the one who gave himself the right to sell her!")]), _vm._v(" "), _c('p', [_vm._v("He came from afar, from among the crowd with a smile on his face. He was happy to see this great achievement, he approached me and extended his hand to shake my hand and said, “Congratulations for the school, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("I shook hands with him. My tears were almost running down my cheek, so he took out a handkerchief from his pocket and said:")]), _vm._v(" "), _c('p', [_vm._v("Do not drop it from your eye, pick it up with the handkerchief before it runs down your cheek and ruins the beauty of your face, you must remain firm and strong as I know you.")]), _vm._v(" "), _c('p', [_vm._v("I actually wiped my tear with his handkerchief. I smiled and invited him for a tour in the school, and I will accompany him. I want to watch it and check its rooms and facilities. From the beginning the engineer was working with Maryam and Laila, they took care of everything. I only saw its scheme on the papers.")]), _vm._v(" "), _c('p', [_vm._v("We roamed between the school’s rooms and desks. He liked everything, but he gave me some notes, which I agreed without arguing. He was an expert in such projects more than me. The tour ended quickly, he looked at me and said, “Are you going to manage it by yourself?”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Yes, Mr. Malik, if you allow me; you are the one who paid for all of this.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “No one else can manage its affairs but you. Your pure heart will realize the pain and dreams of these girls.”")]), _vm._v(" "), _c('p', [_vm._v("I came back to live in my house near you, you can come to visit me if you want. I will send you every month an amount to support the school, it needs a lot. You may also receive donations from some rich people since it is a free school, I will strive for that.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“Can I invite you for coffee after you finish?”")]), _vm._v(" "), _c('p', [_vm._v("“No dear, you are invited to drink coffee in our house.”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t stand a lot of children and noise, if you agree; my house is open to you.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, after I finish here, I will come to your house, but no coffee, I drank too much.”")]), _vm._v(" "), _c('p', [_vm._v("His eyes flashed with happiness.")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’m waiting for you.”")]), _vm._v(" "), _c('p', [_vm._v("I left the school more than an hour after Malik left. Laila and Mariam took my place. I walked towards Malik’s house, I was very happy that I would sit and talk with him like the old days. I will not tell him a story or read a book with him. I will ask him about my doubts about him, no, I will not ask him about anything. I will greet him and return immediately. It took a long time to reach his house; the way was too long. I wish I had asked him to leave the car for me, or I would have rented a cart. We would buy a car for Hazem, as I would buy a cart with a boy to take me wherever I want.")]), _vm._v(" "), _c('p', [_vm._v("I finally arrived, panting. He was sure that I would come. I found him standing at the door waiting for me. I greeted him quietly. He invited me to come in. He called Dalal and said, “Come, she came. How many times have you asked about her and desired to see her?”")]), _vm._v(" "), _c('p', [_vm._v("She came quickly and hugged me.")]), _vm._v(" "), _c('p', [_vm._v("“I miss you so much, Lady Zaina, and the place misses you so much!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “That’s a fact. Bring us something to drink, Dalal.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “No thanks, I’m in a hurry, I just came to say hello to you.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Sit down; I want to talk to you about school and land.”")]), _vm._v(" "), _c('p', [_vm._v("I sat on the sofa and he sat across from me as we used to do. He said to me, “Why haven’t you visited the land yet?”")]), _vm._v(" "), _c('p', [_vm._v("“I couldn’t, then should I accept it? I feel that it is yours and I have no right to own it.”")]), _vm._v(" "), _c('p', [_vm._v("“The land belongs to those who can take care of it, and you and Hazem are the best who take care of it.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I will visit it soon, I must leave now, thank you for inviting me, Mr. Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m always here for you.”")]), _vm._v(" "), _c('p', [_vm._v("While I was about to go out, he said, “Do you really believe I could hurt anyone?”")]), _vm._v(" "), _c('p', [_vm._v("“Definitely not, it’s impossible… Farewell.”")]), _vm._v(" "), _c('p', [_vm._v("Do I believe? I don’t know. The police never proved anything against him. Maybe he is really an innocent man; he does his best to make those girls happy. He was, and still is trying to make me happy in various ways. I was sure that I was still his daughter in his eyes, and the most I know is that there is an inner nostalgia inside my heart for him as a father.")]), _vm._v(" "), _c('p', [_vm._v("I went back to the house as I came walking. Hazem was waiting for me at the door, and the anxiety about me almost killed him.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Where have you been? You’re too late.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “We must buy a cart for transportation, and you must have a car like other businessmen.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem (firmly):")]), _vm._v(" “Where have you been?”")]), _vm._v(" "), _c('p', [_vm._v("“At Malik’s house, he invited me to a cup of coffee.” I was talking to him as I went up to my room, I didn’t even see his face.")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand and turned me towards him.")]), _vm._v(" "), _c('p', [_vm._v("“How dare you go there? Did you lose your mind?”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand hard and said, “It is none of your business, I do what I like. Then perhaps the man is innocent and we wronged him. Yes, look what he does for the girls, he is innocent. Perhaps Reem’s letter was written by Salma to separate us, or she was the one who pushed Reem to do so. Salma never loved me.”")]), _vm._v(" "), _c('p', [_vm._v("“What about Nader’s accusation?”")]), _vm._v(" "), _c('p', [_vm._v("“He wanted to blame someone to prove that he was innocent. He was a liar; he wanted to marry me while he was married to another woman. Malik was the only one who was honest with me, the only one who treated me like his daughter honestly. Please do not interfere between me and him again; it is enough for me what happened with him because of your interference.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you will never change, a stubborn, even foolish lady!”")]), _vm._v(" "), _c('p', [_vm._v("He left me and went downstairs; he was very upset with me. The headache almost killed me, I stood at my window, and as usual, he sat on the chair below. Whenever he gets angry, he calls me a fool, my God I’m tired, and whom should I believe? It’s none of my business; I’m going crazy if I keep thinking!")]), _vm._v(" "), _c('p', [_vm._v("I followed him down. He was holding a paper and a pen. I pulled out the paper to see what he wrote:")]), _vm._v(" "), _c('p', [_vm._v("‘Zaina is foolish, Zaina is stupid, and my little girl lost her mind!’")]), _vm._v(" "), _c('p', [_vm._v("I tore the paper angrily, while he was gazing at me:")]), _vm._v(" "), _c('p', [_vm._v("“Did I teach you to read and write to write Zaina is foolish? Is that what you’re good at?”")]), _vm._v(" "), _c('p', [_vm._v("“Why did you follow me?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t know, maybe to find out how stupid and mad I am! I don’t want to see you, understand? Since I’m a fool I don’t want to see you again. I will do what I like. Go away now and don’t come back again.”")]), _vm._v(" "), _c('p', [_vm._v("He answered me coldly, “Well, I will leave, as you wish, I will not return. Actually, these are your house and your land, and I can no longer bear your expulsion of me, I am leaving.”")]), _vm._v(" "), _c('p', [_vm._v("He went towards his house. My heart almost fell from me, what did I do? If he leaves, I will kill myself. He is right, I always fire him; I do it because I know he will not leave. How long will he bear my anger, my cruelty, and my expulsion of him? My God, if I am unable to bear his leaving, why do I fire him? The headache was about to gnaw at my head. I followed him to his house. He had put a bag on his bed and started collecting his things.")]), _vm._v(" "), _c('p', [_vm._v("“What are you doing? I asked him softly and in a low sweet voice.”")]), _vm._v(" "), _c('p', [_vm._v("“Get out? I do what you command me.”")]), _vm._v(" "), _c('p', [_vm._v("“Return your things and stop being reckless.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I won’t sit here for a minute.”")]), _vm._v(" "), _c('p', [_vm._v("“A minute has passed, you are still here.”")]), _vm._v(" "), _c('p', [_vm._v("He left the bag on the bed and headed toward the door. I stood in front of the door as an obstacle for him to get out; he looked into my eyes and said, “Your eyes are red, it’s okay if you want to cry; this is the work of girls.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will not cry over your departure. My eyes are red because I suffer from a severe headache.”")]), _vm._v(" "), _c('p', [_vm._v("“Then let me go, Lady Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you really going to leave me?”")]), _vm._v(" "), _c('p', [_vm._v("“Isn’t that your wish?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s your desire; you were waiting for me to tell you to leave. Leave me and walk, it’s okay if that is your desire, do not use me as an excuse!”")]), _vm._v(" "), _c('p', [_vm._v("“I never thought of leaving you. You know, I’d rather die than leaving you.”")]), _vm._v(" "), _c('p', [_vm._v("“Liar, you’re leaving now!”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and got so close to me that he almost stuck to me.")]), _vm._v(" "), _c('p', [_vm._v("“If you don’t go away, I’ll carry you.”")]), _vm._v(" "), _c('p', [_vm._v("“If you can, just try to get close.”")]), _vm._v(" "), _c('p', [_vm._v("“More than that? Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and said, “When are we getting married?”")]), _vm._v(" "), _c('p', [_vm._v("I smiled.")]), _vm._v(" "), _c('p', [_vm._v("“Minutes ago you were arranging your bags to leave!”")]), _vm._v(" "), _c('p', [_vm._v("“I’m leaving. Who told you I’d stay here, but I’ll take you with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh really! Who said I would go with you?”")]), _vm._v(" "), _c('p', [_vm._v("He held my hand and said, “Come with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Where will you take me? I can’t joke now, the headache almost kills me.”")]), _vm._v(" "), _c('p', [_vm._v("“I hope to make pain run through my body and leave you. Come and I promise you will recover from it quickly, come on, little one.”")]), _vm._v(" "), _c('p', [_vm._v("“I was just an idiot!”")]), _vm._v(" "), _c('p', [_vm._v("“My God! Why don’t you be convinced that I fear for you more than myself? When you expose yourself to danger, you make me lose my mind. Now come and let us forget what happened.”")]), _vm._v(" "), _c('p', [_vm._v("We walked for a while, we reach to a place behind my house, which I had not seen before, or perhaps not noticed. We stopped before a beautiful little land planted with different kinds of vegetables, and near it a very beautiful small house.")]), _vm._v(" "), _c('p', [_vm._v("“What’s your opinion?” he asked me.")]), _vm._v(" "), _c('p', [_vm._v("“With what?”")]), _vm._v(" "), _c('p', [_vm._v("“The land!”")]), _vm._v(" "), _c('p', [_vm._v("“Fruitful and beautiful, why do you ask?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s your dowry.”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("“This little land I bought and planted for you; to be your dowry.”")]), _vm._v(" "), _c('p', [_vm._v("I replied in astonishment, “When and how? Oh my God, you did that for me!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear. Two years ago, its owner had offered it for sale. It was barren and I bought it cheaply. I decided to plant it and actually, I worked hard on it until it bore fruit, and then I started building our house.”")]), _vm._v(" "), _c('p', [_vm._v("“Our house?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think that we will live in your house, it is full of people. Listen, my dear, I fear for you from the men who are there. Every day I sleep in front of your room, I am bored, Zaina. I want you to be only mine. Come now, I will show you the house.”")]), _vm._v(" "), _c('p', [_vm._v("We went to the house. It was small but very beautiful and warm. There was a small hall which contained a fireplace and a rocking chair, a sofa for two and a small table. Upstairs, there was a very beautiful, wonderful bedroom, with luxurious furniture and embroidered curtains, he did not forget anything, and even the kitchen was small but very beautiful.")]), _vm._v(" "), _c('p', [_vm._v("A wooden house that was full of love and tenderness, full of Hazem in every corner and every place. There was a painting in the middle of the room, hanging on the wall; it’s my picture, how beautiful! It is the most beautiful house ever.")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand and pulled me out.")]), _vm._v(" "), _c('p', [_vm._v("“What’s your opinion?”")]), _vm._v(" "), _c('p', [_vm._v("“My God! Another flower garden, similar to ours there, but very beautiful, it is even more beautiful!”")]), _vm._v(" "), _c('p', [_vm._v("I turned and he was standing right behind me, I hugged him and then I looked straight into his eyes as he does and said, “How wonderful you are, I love you so much.”")]), _vm._v(" "), _c('p', [_vm._v("He kissed me and said, “Shall we get married today?”")]), _vm._v(" "), _c('p', [_vm._v("I turned away from him, laughing.")]), _vm._v(" "), _c('p', [_vm._v("“Not today.”")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“The day after tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("“The day after tomorrow, our wedding will be the day after tomorrow, very appropriate.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we will marry, but you must promise me that you will not call me a fool anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you serious?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, such words annoyed me.”")]), _vm._v(" "), _c('p', [_vm._v("“Will we get married the day after tomorrow? Are you serious?”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, enough waiting.”")]), _vm._v(" "), _c('p', [_vm._v("He picked me up, and started screaming, “We’re getting married, great, how wonderful! I will never call you a fool after today.”")]), _vm._v(" "), _c('p', [_vm._v("He harnessed all his capabilities, and even his whole life, to make me happy, perhaps God compensated me with him for my whole family.")]), _vm._v(" "), _c('p', [_vm._v("We walked to house; it was raining, he looked at me and said, “Hurry up.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “We’ll run.”")]), _vm._v(" "), _c('p', [_vm._v("I started running and he followed me and shouted, “Don’t run so fast.”")]), _vm._v(" "), _c('p', [_vm._v("I stood in the middle of the road gasping, I shouldn’t have run, he was right behind me.")]), _vm._v(" "), _c('p', [_vm._v("“Are you tired, little girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Yeah, we’ll wait a bit and then we’ll move on.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("He picked me up and walked me towards the house. Laila opened the door for us.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, what’s wrong with you?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her in a weak and fatigue voice, “Nothing.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We’ll get married the day after tomorrow.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What? Oh really!”")]), _vm._v(" "), _c('p', [_vm._v("She cried out in a loud voice, “Maryam, come and listen.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at Hazem and said, “Take me to my room quickly.”")]), _vm._v(" "), _c('p', [_vm._v("He laughed and said, “They will follow us.”")]), _vm._v(" "), _c('p', [_vm._v("He put me on my bed with. His eyes were full of worry about me.")]), _vm._v(" "), _c('p', [_vm._v("“Shall I bring Ashraf to see you?”")]), _vm._v(" "), _c('p', [_vm._v("I said, “There is no need.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam entered the room quickly, as if she was in a race with her daughter and Laila.")]), _vm._v(" "), _c('p', [_vm._v("“Are you really getting married the day after tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Yeah, we’re getting married the day after tomorrow.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We must prepare the marriage papers, and this takes time.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Everything is ready and waiting for Zaina to sign them.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Bring them to sign.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “How are we going to get ready for the party?”")]), _vm._v(" "), _c('p', [_vm._v("Little Zaina sat on my bed and was the only one who dared to do so.")]), _vm._v(" "), _c('p', [_vm._v("“We should buy dresses for the party.”")]), _vm._v(" "), _c('p', [_vm._v("I pulled her and put her in front of me.")]), _vm._v(" "), _c('p', [_vm._v("“First, no big party. We will have a small party for the family only. Second, we will all go to the market tomorrow and buy very beautiful dresses.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “And third: We will not tell Malik about it. It will be a party in the house for us alone. After a month, we tell everyone that we have been married for a while.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “No big party.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Delicious food and a little party at home, and we’ll wear the most beautiful clothes.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We’ve been waiting for this wedding all our lives.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “We can hold a small party in front of the outside house around the flower garden, and set a large table with the most delicious foods.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “It is not at all conceivable that the wedding of Lady Zaina, which we have been waiting for so long, should be like this. Let all people know, they have nothing to do with us. The party will be in the garden of the house, but we will decorate the place and arrange it to look suitable for a wedding. We will invite the schoolgirls to celebrate their principal, and we will prepare food for everyone. Let the city know that the new lady of the city married Mr. Hazem, the agricultural expert and the owner of the land. Come on, Maryam, come on, bring these girls, and follow me. Let’s leave Zaina to rest. We have a lot of work.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam looked at Hazem before leaving and said, “How happy I am for you, you will achieve your dream that you always wanted.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem approached me and said, “We won’t be able to convince them. They are stronger and undefeatable. I was so tired I couldn’t smile.”")]), _vm._v(" "), _c('p', [_vm._v("He said after I worried him, “What is wrong with you, my dear?”")]), _vm._v(" "), _c('p', [_vm._v("He put his hand on my forehead; my temperature was high. He called out to Ashraf, who came and Laila was directly behind him.")]), _vm._v(" "), _c('p', [_vm._v("“What is wrong with her?” she asked. She was very afraid for me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “What is the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “She had a headache this morning, and now she has a high temperature.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Oh my God her wedding is the day after tomorrow!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “No wedding before a week.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “What? What is her problem? Is she okay?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Her heart is a little tired, I will give her an injection for three days, she will sleep a lot these days, and then she will be fine, God willing.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “And what will we tell her about the wedding date when she wakes up?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Every day we tell her the day after tomorrow until she recovers.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Good, you have time to prepare yourselves for a proper celebration.”")]), _vm._v(" "), _c('p', [_vm._v("The week passed quickly; everyone was busy in preparing for the wedding. Dalal came to visit me with a message from Malik.")]), _vm._v(" "), _c('p', [_vm._v("“Dear Zaina, meet me in the new land in an hour, I want you with something necessary.”")]), _vm._v(" "), _c('p', [_vm._v("I tore up the letter and threw it away; I was afraid Hazem would see it, because he hated Malik so much, and he wouldn’t let me to go there. I got dressed and got out quickly while Hazem was busy with the ground. I arrived before Malik. I didn’t pay any attention to the land. I wanted to know what he wanted and come back quickly.")]), _vm._v(" "), _c('p', [_vm._v("I heard his voice coming from behind me.")]), _vm._v(" "), _c('p', [_vm._v("“Do you like it?”")]), _vm._v(" "), _c('p', [_vm._v("“Spacious and contains a lot, it will make a lot of money.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s yours now and it will pay off for you and your family.”")]), _vm._v(" "), _c('p', [_vm._v("He came a little closer so I turned towards him.")]), _vm._v(" "), _c('p', [_vm._v("“What is the necessary issue? Tell me quickly, what do you want? I have to come back.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you afraid of him if you’re late?”")]), _vm._v(" "), _c('p', [_vm._v("“Who do you mean?”")]), _vm._v(" "), _c('p', [_vm._v("“Your fiancé; Hazem! I heard you two are getting married tomorrow.”")]), _vm._v(" "), _c('p', [_vm._v("“Rather the day after tomorrow. I am not afraid of Hazem, I fear his wrath. You know how much I love him! I fear for him from the breeze, and if something bad happened to him, I would die from my grief over him.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s like I’m going to kill him, what’s wrong with you, baby? Do you still suspect that I am a criminal? Ask Kamal, he visited me yesterday and apologized to me. He told me that he arrested all those involved; he was ashamed of himself while talking to me because he suspected me. Believe me, my dear; I did not harm anyone in my life. You all wronged me. The important thing is I wanted to gift you the wedding dress that I prepared for you, I will send it to you Today. I will also send workers to arrange the place.”")]), _vm._v(" "), _c('p', [_vm._v("“No need, Laila has arranged everything, she is very good, and I will buy a dress, you do not have to bother yourself with me.”")]), _vm._v(" "), _c('p', [_vm._v("“Share with me your joy; I have been waiting for this day for a long time, please.”")]), _vm._v(" "), _c('p', [_vm._v("Tears were running out of his eyes. I smiled and said, “Okay, but please don’t get close to Hazem and don’t make him angry, I know you don’t like him very much.”")]), _vm._v(" "), _c('p', [_vm._v("“On the contrary, I love whoever you love.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll wait for you at the party, bye-bye.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and went home quickly and as usual, Hazem was at the door.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Where have you been? I was worried about you.”")]), _vm._v(" "), _c('p', [_vm._v("“I was taking a walk.”")]), _vm._v(" "), _c('p', [_vm._v("I hurried in; he followed me and asked me, “Were you with Malik?”")]), _vm._v(" "), _c('p', [_vm._v("“Is there no other place to go besides Malik?”")]), _vm._v(" "), _c('p', [_vm._v("“I told you not to go to him, why don’t you hear what I say?”")]), _vm._v(" "), _c('p', [_vm._v("I answered him sharply, “Why should I accomplish you orders?”")]), _vm._v(" "), _c('p', [_vm._v("He answered me angrily, “I’m afraid for you from him.”")]), _vm._v(" "), _c('p', [_vm._v("Maryam came out because of our screams, followed by Laila.")]), _vm._v(" "), _c('p', [_vm._v("I said to Hazem sternly, “I told you a thousand times not to talk to me nervously, then I didn’t go to his house, I went to the new land and saw him there.”")]), _vm._v(" "), _c('p', [_vm._v("“We don’t want that land.”")]), _vm._v(" "), _c('p', [_vm._v("“We want it; I will use its money to take care of the girls. Moreover, Kamal went to him yesterday and apologized to him because he wronged him and told him that he arrested all the involved people, so he is innocent and we must apologize to him.”")]), _vm._v(" "), _c('p', [_vm._v("“Whatever, don’t go to him, do you understand?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I will do as I wish. I think it is best to postpone the wedding now.”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("“We will postpone our wedding.”")]), _vm._v(" "), _c('p', [_vm._v("“As you like.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We will not postpone anything.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “As she likes.”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Then you hate me, if you don’t want to marry now, why did you ask me to.”")]), _vm._v(" "), _c('p', [_vm._v("“I will not answer you.”")]), _vm._v(" "), _c('p', [_vm._v("He left home after agreeing to postpone the marriage. I looked at Laila and said with tears running down my cheeks, “Did you see? He hates me, when I told him you hate me, he didn’t deny it and agreed to postpone the wedding.”")]), _vm._v(" "), _c('p', [_vm._v("She came close to me and hugged me and whispered, “It is harmful to ask him to leave whenever you get angry, then he will leave, and you will regret it.”")]), _vm._v(" "), _c('p', [_vm._v("“I do it every time to know how much he loves me, when he comes back I know he loves me so much.”")]), _vm._v(" "), _c('p', [_vm._v("Ten minutes later, he came carrying a white dress. He looked at me and said, “I bought it yesterday from the most luxurious wedding dress shop in the neighboring city, you will wear it the day after tomorrow, and I hope you like it.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam (in amazement):")]), _vm._v(" “Didn’t you get angry with her and agreed to postpone the marriage?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled and said, “She always asks me to leave, but she does not mean that; as if she is telling me that I love you very much and do not ever leave me, so I never grieve from her. I will not leave her no matter how hard she tries, and no matter whatever she says. Sure, we will marry the day after tomorrow.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “My God! He keeps you by heart, you crook!”")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “But when I told you that you hate me, you didn’t reply, which means you hate me.”")]), _vm._v(" "), _c('p', [_vm._v("He approached me and put his finger on my mouth.")]), _vm._v(" "), _c('p', [_vm._v("“I don’t hear such a word, it doesn’t even exist. All I know is that I love you madly, and when you turn into a crazy woman, I don’t hear your words. Come on now, try on the dress.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “He’s right in every word; you’ve always said stupid things when you’re angry!”")]), _vm._v(" "), _c('p', [_vm._v("Maryam approached me and put her hand around my shoulder. She addressed Laila and Hazem, “You two, stop teasing her. Is there a lady but Zaina? She is the most beautiful and gorgeous lady ever.”")]), _vm._v(" "), _c('p', [_vm._v("She then held my hand and added, “Come on, honey, let’s try on the dress.”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “Well, just you and me, and Laila won’t come with us.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila (angrily):")]), _vm._v(" “I’ll go up, or else…”")]), _vm._v(" "), _c('p', [_vm._v("“What are you going to do?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Please.”")]), _vm._v(" "), _c('p', [_vm._v("While I went up the stairs, Hazem called me, “Zaina…” I turned towards him. He said, “Please do not go to Malik’s house, even if he is innocent. Do not go there at all.”")]), _vm._v(" "), _c('p', [_vm._v("“I promise I will never go.”")]), _vm._v(" "), _c('p', [_vm._v("The dress was very beautiful, but what am I going to do with the dress that Malik will send? I’ll give it to Laila; she’s always wanted a wedding dress. She will wear it at home, and we’ll throw her a little party.")]), _vm._v(" "), _c('p', [_vm._v("Suddenly, the girls came in, they stood petrify when they saw me in the dress.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “How beautiful you are! Can I touch it?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “Nobody can touch it, come on, and go down quickly.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “Zaina is prettier than my mother.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Lynn:")]), _vm._v(" “Yes, of course she is more beautiful!”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Little Zaina:")]), _vm._v(" “She is more beautiful than my mother, too.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Thank you very much, go out now.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sarah:")]), _vm._v(" “When I get married, I’ll borrow it.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “On your wedding day, I will buy you the most beautiful dress and you too. Now go out quietly.”")]), _vm._v(" "), _c('p', [_vm._v("They came out resentful. They wanted to stay but it was impossible. They are troublesome and the dress might get dirty because of them.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, Malik sent his dress with a beautiful diamond necklace. I didn’t see the dress; I put it in my closet immediately. I took the necklace; it was perfect with Hazem’s dress.")]), _vm._v(" "), _c('p', [_vm._v("The wedding day was a wonderful day. Malik harnessed all his possibilities to make the place look like a palace. Laila and Maryam used all their efforts in preparing the food and organizing the party. The wedding looked like royal weddings as if I was the sultana of the city and people were around me trying to please me! My blue eyes shone like a moon in the darkest night. I looked like one of the most beautiful princesses of the ‘Once Upon a Time’ stories.")]), _vm._v(" "), _c('p', [_vm._v("Hazem looked handsome, charming, and noble; he wore a very luxurious suit, we danced and danced without feeling tired or shy. I saw in him everything I wished in this world; a handsome noble man who loves me very much. I will be the most precious thing he has. I do not want anyone else in this life but him, and all I wish is that God protects him for me.")]), _vm._v(" "), _c('p', [_vm._v("I shared my days between my house and my house! It is not a puzzle; the girls’ house is my home where I spend my day, and I come back in the evening to the small house to spend my evening and night with Hazem. We drink our evening coffee and look at each other around our flower garden, then he picks me up and puts me on my bed. I wake up in the morning with his arms around me. He makes my morning coffee and wakes me up with whispers, “Enough sleeping, little girl.”")]), _vm._v(" "), _c('p', [_vm._v("Then, he goes to the land and I go to school. On cold days or when I’m lazy, I leave the job to Laila. Mariam’s main job is to take care of the girls, some days I have to have lunch with them.")]), _vm._v(" "), _c('p', [_vm._v("Hazem work was the most important work, and indeed the land began to bloom again. He hardly agreed to supervise the land that Malik gave me, but provided that he takes a monthly wage on it and has nothing to do with its profits at all. The important thing is that we benefit from its revenues for the school.")]), _vm._v(" "), _c('p', [_vm._v("Gradually, the relationship between us and Malik re-established. He was the greatest benefactor in the city, and of course, everything he did to please me! All he wished was for me to return his pampered girl; the daughter he had always dreamed of. The family was convinced that he was innocent, and Maryam had a great influence on her brother Hazem to convince him that Malik was a good man. Hazem did not like him because he was very jealous for me. He did not like anyone to approach me.")]), _vm._v(" "), _c('p', [_vm._v("Malik started visiting us more often, but we never told him about our new home and that was Hazem’s wish.")]), _vm._v(" "), _c('p', [_vm._v("Hazem, Reem’s son, became four. He is very beautiful. He calls me (Mom); I only hear it from his mouth. He looks like me to a great extent. He jumps on me and plays with me. I used to take him with me wherever I went, but he still slept with Maryam.")]), _vm._v(" "), _c('p', [_vm._v("He often asked me, “Why don’t you sleep next to me?”")]), _vm._v(" "), _c('p', [_vm._v("I always promise him when he grows up, he will sleep in my house.")]), _vm._v(" "), _c('p', [_vm._v("Maryam was more able than I to take care of him. Hazem loved him very much and considered him as his child. I will have never given birth to a child because my heart is weak. I was not destined to have a child from me. Hazem never cared about this issue. Little Hazem compensated us for all children in the world. All that made us happy was our intense love for each other. It was as if we had the world between our fingers. There is nothing more beautiful than a partner who loves you and compensates you for the injustice of the world, and its misery.")]), _vm._v(" "), _c('p', [_vm._v("The world becomes very cruel on us when we remember people, who are very dear to our heart, but they suddenly left us and their fate remains unknown to us. While I was inspecting my shop in the market in which I was once a small seller, I saw a young boy carrying bags behind a young woman. They reminded me of Jawad. Oh my God, how long would he be vanished! I miss my little boy who has always slept beside my bed. how many nights we spent in front of the fireplace waiting for his clothes to dry, when his mother would kicked him out in the harsh rainy nights, he found no shelter but me. How many times I shared my food with him. I miss him when he was deceiving me to get more money for his mother; I pretended that I didn’t understand and gave him whatever he needed. I wish I had any news about him. Is he still alive? I hope so.")]), _vm._v(" "), _c('p', [_vm._v("I met a lady in the market who was looking for me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Lady:")]), _vm._v(" “Are you Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, and who are you?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Lady:")]), _vm._v(" “I am looking for a job; they said you have vacancies in your school.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, come tomorrow morning to school, and we’ll meet there.”")]), _vm._v(" "), _c('p', [_vm._v("“Can’t we talk now, I live in a neighboring city and if you accept to hire me, I and my family will move to live in this city.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, we’ll walk to my house and you’ll tell me about yourself.”")]), _vm._v(" "), _c('p', [_vm._v("“I studied literature at university, but I did not work because I married a police officer. Unfortunately, he was killed in one of his missions, so I had to work. I worked in several schools. I heard that your school takes care of the girls who were victims of Karim, the same person that killed my husband, so I would like to teach them.”")]), _vm._v(" "), _c('p', [_vm._v("I stopped walking and asked her, “What is your husband’s name, madam?”")]), _vm._v(" "), _c('p', [_vm._v("“Amjad, may God have mercy on him.”")]), _vm._v(" "), _c('p', [_vm._v("I almost fell on the ground, his last look still engraved in my mind and also his words; oh my God, how could I forget that sentence: “What did I do to you?”")]), _vm._v(" "), _c('p', [_vm._v("I tried to be steady; I didn’t want her to notice anything.")]), _vm._v(" "), _c('p', [_vm._v("“Since you are part of that case, you have the right to work at the school.”")]), _vm._v(" "), _c('p', [_vm._v("“I wish I was a good part of it. Perhaps I came to atone for my husband’s mistakes. I was supposed to work with it the moment it opened, but unfortunately, I didn’t hear about it until a few days ago.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean by atonement for his mistakes?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s a long story.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ll tell me about it, it’s still a long way home, and the weather is nice, so let’s walk and talk. You can also introduce yourself fully to me.”")]), _vm._v(" "), _c('p', [_vm._v("“Well; my husband was a good officer until he met Karim. At first, he found baby girls here and there, every year, one or two. The case exhausted him greatly, and he was eager to know who was throwing them. By searching and insisting, he discovered that Karim brings young girls to his house to trade them. And whoever becomes pregnant, he waits until she gives birth. Karim threw the child in the street, if the newborn is a girl, but if it is a boy, he sold it to rich families. You know, we live in an unjust society that hates the female; they should know that every female is equivalent to a million men! However, when my husband found out about him, Karim promised that if he ignored the case, he would give him a large amount of money, and he would seek to promote him at work. One day, a very beautiful girl came to him because someone accused her of being the one who threw girls. He couldn’t hide his infatuation with her. He kept talking about her beauty for days. For a moment, I thought he would divorce me and married her. Anyway, when the beautiful girl innocence was proven, she sympathized with the baby girl and took her to raise her.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “I am very tired. Happy to meet you and I promise you will be happy to work with us. Come tomorrow morning and you will meet Laila, my assistant, she will arrange all your affairs. Excuse me now, I have to leave.”")]), _vm._v(" "), _c('p', [_vm._v("I got into the first carriage that passed by me and came back to my small house quickly. Suddenly, I felt cold. I lit the heater and sat next to it. I felt very lonely and began to deny my soul! I started shivering from the cold. I got up from my place with difficulty and went to the kitchen to prepare something hot; it would help me to have some warm, but in the middle of the hall I fell on the ground.")]), _vm._v(" "), _c('p', [_vm._v("A despicable nobleman and a corrupt policeman, a false father and a selfish sister, a missing young man, and a lost girl among them, lost children here and there, mixed lineages, a life that is not fit for life! Despite all the pain, there must be a gift from God for every tormented person in this life, and my gift was Hazem.")]), _vm._v(" "), _c('p', [_vm._v("I woke up in my bed and Hazem was beside me. He was collapsed from the severity of his fear for me.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Thank God, you finally woke up! I thought I lost you forever, oh my God how scared I was, I felt so lonely, I almost lost my mind, honestly I almost went crazy.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “That’s exactly how I felt when I thought you were dead, lost and homeless and alone, don’t worry my dear, I’m fine.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “What happened? I entered the house and you were lying on the floor with blood dripping from your head.”")]), _vm._v(" "), _c('p', [_vm._v("“I felt dizzy, and may have hit the edge of the table when I fell.”")]), _vm._v(" "), _c('p', [_vm._v("“You should never be alone at home.”")]), _vm._v(" "), _c('p', [_vm._v("“Will you leave your job and stay with me? Don’t worry, it’s just an accident.”")]), _vm._v(" "), _c('p', [_vm._v("“But…”")]), _vm._v(" "), _c('p', [_vm._v("“Please, I have no energy to talk; I want to see Maryam and Laila, how about we go there?”")]), _vm._v(" "), _c('p', [_vm._v("“But you’re tired!”")]), _vm._v(" "), _c('p', [_vm._v("“I can walk with you, I’ll change my clothes and we’ll go together.”")]), _vm._v(" "), _c('p', [_vm._v("When we arrived, the girls were fighting. Oh my God, they became young and still screaming. They stopped fighting when they saw me. They gathered around me complaining on each other.")]), _vm._v(" "), _c('p', [_vm._v("I shouted at them, “Enough, to your rooms, I won’t hear a single word. Where are your mothers? Is this how ladies behave?”")]), _vm._v(" "), _c('p', [_vm._v("They were ashamed of themselves and went to the rooms in silence. Maryam came and said, “Excuse me, Rahma is very tired and Ashraf is checking her.”")]), _vm._v(" "), _c('p', [_vm._v("“I will go to Hazem’s house. Please follow me with Laila. I want to sit in a quiet place. Ask the girls to take care of each other and never follow us.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my dear, as you wish.”")]), _vm._v(" "), _c('p', [_vm._v("They were very late so I had to go home after an hour of waiting. I entered shouting, “Where are you, Maryam? Didn’t I ask you to follow me?”")]), _vm._v(" "), _c('p', [_vm._v("Ashraf appeared, he looked very sad, I asked him, “What is the matter? What is wrong with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Rahma has passed away. May God have mercy on her soul.”")]), _vm._v(" "), _c('p', [_vm._v("“What? Why?”")]), _vm._v(" "), _c('p', [_vm._v("“She had a strong fever, her body was too weak to bear it, and she died immediately.”")]), _vm._v(" "), _c('p', [_vm._v("Tears started streaming from my eyes. I entered Maryam’s room. Laila was next to her. Maryam was sitting on the sofa and tears were running down her cheeks, and yet she was very strong. She looked at me sadly and said, “Do not be sad, my dear, I will have another girl, but I will not call her Rahami.”")]), _vm._v(" "), _c('p', [_vm._v("Laila was silent as usual in such situations, unable to speak!")]), _vm._v(" "), _c('p', [_vm._v("I told them, “I’m going home; I have no power to cry more.”")]), _vm._v(" "), _c('p', [_vm._v("I can’t bear to lose, she left early, and may God have mercy on her soul.")]), _vm._v(" "), _c('p', [_vm._v("I turned to Laila and said, “You must go to school; there is a lady who will meet you. She will work with us in the school. Please arrange her affairs.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Is this appropriate now?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry, but I promised her, and she will come from a far place. She also takes care of orphans.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam in a stifled voice:")]), _vm._v(" “Please meet her; the death of our girl does not mean that the lives of others should stop.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I will go.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("I looked one last time at the girl lying on the bed. She was like an angel. She entered the house and today she will leave like an angel, her lifeless face still shining like the moon.")]), _vm._v(" "), _c('p', [_vm._v("Who convinces a mother to be patient over the death of her child? Is there a place for patience here? Despite all her strength, Maryam collapsed for days. I did not leave my house until she herself came and took me out of it.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I am fine, and life must go on. My dear, one of life’s laws is losing loved ones by death, it is difficult! I know, and I felt its difficulty, but it is a must, and we should accept it. Come on, my dear, you must go back to your life; Hazem is very worried about you and told me that you are not eating.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “It’s good that you’re fine.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “I met the lady; do you know who she is?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her, “She is Officer Amjad’s wife.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “You didn’t tell us!”")]), _vm._v(" "), _c('p', [_vm._v("“I met her on the day of Rahma’s death, and I came to tell you about her, but what happened had happened.”")]), _vm._v(" "), _c('p', [_vm._v("“Laila does not want her with us, she is afraid that she would know that we are the cause of his death.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “No, she is convinced that Karim killed him, because he was a corrupt policeman. My dear, she is taking care of orphans, she must be helped.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “What do you mean by spoiled?”")]), _vm._v(" "), _c('p', [_vm._v("“I will tell you his story in your house.”")]), _vm._v(" "), _c('p', [_vm._v("We went to the big house. Laila made us coffee.")]), _vm._v(" "), _c('p', [_vm._v("I told them what had happened.")]), _vm._v(" "), _c('p', [_vm._v("Laila said angrily, “Why did she come after all these years? I didn’t like her, and I don’t want her with us please.”")]), _vm._v(" "), _c('p', [_vm._v("I asked, “Why are you nervous?”")]), _vm._v(" "), _c('p', [_vm._v("“I work a lot and I’m alone in school.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t mean to leave you, I’m sorry.”")]), _vm._v(" "), _c('p', [_vm._v("“I swear by God, I do not mean you, Zaina. We must bring an assistant. I know it is difficult to choose one, because I don’t trust anyone. At the same time, it is very important to hire one, at least in the days of your absence.”")]), _vm._v(" "), _c('p', [_vm._v("“Sarah and little Zaina and Lynn, take them with you and train them. They are young ladies and they must work. Work is necessary for them to be strong; they do nothing but fight all day.”")]), _vm._v(" "), _c('p', [_vm._v("“How didn’t I think about them?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they are our girls, we will trust no one else, and one day they will be the responsible ones.”")]), _vm._v(" "), _c('p', [_vm._v("“Tomorrow I will take them with me. The most important thing now is what should I say to Shaima?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “I’ll go with you tomorrow and tell her to leave, she has no place between us, it’s strange to show up after all these years!”")]), _vm._v(" "), _c('p', [_vm._v("I told them, “So, manage everything, I won’t go until you’re done with it.”")]), _vm._v(" "), _c('p', [_vm._v("Laila prepared another cup of coffee after feeling comfortable that she would get rid of Amjad’s wife Shaima. We were talking and arranging the girls’ affairs. Sarah entered us, frightened, as if she had seen a ghost. She approached me and whispered in my ear while she was trembling, “There’s someone at Jawad’s house.”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “What? What is wrong with you? I didn’t hear what you said.”")]), _vm._v(" "), _c('p', [_vm._v("“My mother sent me to clean Jawad’s house, and I heard a movement, and saw a man’s shadow.”")]), _vm._v(" "), _c('p', [_vm._v("“Perhaps your Uncle Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("Sarah said while she was still trembling, “No, Hazem is working on the farm.”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down, I’ll go to check.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “We’ll come with you.”")]), _vm._v(" "), _c('p', [_vm._v("We hurried home. I entered first. My God, he was lying on the ground, rickety, full of wounds and his clothes were torn while blood covered most of his body. I approached him; he was trembling and muttering: “Don’t come near me.” I took out a handkerchief and wiped his face, he didn’t notice me and didn’t feel our presence; I wiped his face again. He screamed out of pain.")]), _vm._v(" "), _c('p', [_vm._v("“It’s Jawad!” I cried in amazement.")]), _vm._v(" "), _c('p', [_vm._v("He looked at me and said, “Don’t shout, speak in a whisper, he will hear us.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Laila.")]), _vm._v(" "), _c('p', [_vm._v("“Please bring Ashraf.”")]), _vm._v(" "), _c('p', [_vm._v("I asked Sarah to bring Hazem to put him on his bed. Everyone came quickly. They carried him and put him on the bed. Ashraf asked everyone to get out, and he asked Hazem and Faris to stay with him to help him.")]), _vm._v(" "), _c('p', [_vm._v("I told them, “I won’t go out until I check on him.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ashraf:")]), _vm._v(" “Please, we must take off his clothes.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m not going out; I’ll turn around when you take his clothes off.”")]), _vm._v(" "), _c('p', [_vm._v("I turned to Laila and asked her to take the girls home, and asked Maryam to bring him hot water and clean clothes.")]), _vm._v(" "), _c('p', [_vm._v("There were many wounds on his entire body. He never stopped shivering. Ashraf bandaged all his wounds, cleaned his body and hair and put on him clean clothes. He injected him with several medicines. Jawad slept quietly for several hours. I stayed by his side. Hazem never left me. Maryam and Laila took turns going and back. He slept for more than twelve hours. Hazem tried to convince me a lot to go home and sleep and that he would tell me as soon as Jawad woke up, but I refused sharply. I sat on the chair impatiently waiting for him to wake up.")]), _vm._v(" "), _c('p', [_vm._v("He finally woke up, frightened, curled up on himself, and started babbling, “He will not find me, I will run away and he will not find me, I will return to Zaina and he will not find me.”")]), _vm._v(" "), _c('p', [_vm._v("When I heard my name, I approached him and touched his hair with my hand, saying, “Don’t worry baby, I’m here, I’m Zaina, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("I gave him a glass of water, and Maryam had prepared the food for him. He finally calmed down a little and sat.")]), _vm._v(" "), _c('p', [_vm._v("He stared at me for a long time and said, “It’s really you, you are Zaina!”")]), _vm._v(" "), _c('p', [_vm._v("“I searched for you a lot, as if I was in a dream. I missed you a lot. You went without saying goodbye; I miss my little boy Jawad.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “I want us to be alone.”")]), _vm._v(" "), _c('p', [_vm._v("“Hazem will stay with us, he’s my husband.”")]), _vm._v(" "), _c('p', [_vm._v("“No, alone, as we were talking.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Well, I’ll wait for you outside.”")]), _vm._v(" "), _c('p', [_vm._v("Hazem left quietly.")]), _vm._v(" "), _c('p', [_vm._v("Jawad said, “He killed my mother and Samar!”")]), _vm._v(" "), _c('p', [_vm._v("I said in surprise, “Who? Why?”")]), _vm._v(" "), _c('p', [_vm._v("“He wants you; he wants me to kill Hazem.”")]), _vm._v(" "), _c('p', [_vm._v("I stood trembling.")]), _vm._v(" "), _c('p', [_vm._v("“Who wants to kill Hazem?”")]), _vm._v(" "), _c('p', [_vm._v("“He kidnapped me when you sent me to check on the girls, remember? When you were tired at Malik’s house in the big city; when I went out, a man kidnapped me and put me in his car. I found myself in a dark place. He came in and said, ‘I will make you very rich, but on condition, that you leave your village and forget that you are one of them.’”")]), _vm._v(" "), _c('p', [_vm._v("“Who did that?”")]), _vm._v(" "), _c('p', [_vm._v("“I asked him what you want me to do. He wanted me to take Karim’s place, to be a gentleman, and to choose young girls in a city far from here…! I refused and told him that I would not accept that they deal with girls as commodities. He offered a huge amount of money, and tried to convince me that it was a very rewarding job. I refused vehemently. He locked me in a cold, dark and closed room with no window. I stayed for months inside it. He threw to me crumbs of food every day. One day, he came to me and said, ‘If you don’t agree, I will kill your mother.’ I told him, ‘Please leave her alone and I will do whatever you want.’”")]), _vm._v(" "), _c('p', [_vm._v("“Did you accept?”")]), _vm._v(" "), _c('p', [_vm._v("“He dressed me the most luxurious clothes and watches, and bought me a car with a driver, and put me in a very luxurious house. He brought my mother and my sister; they were happy to work there. They worked as Salma did. Actually, Samar turned to another Salma and started choosing girls. She took them to a special home and there they teach them speaking, dancing, and other things. Their trainer was an expert lady named Shaimaa.”")]), _vm._v(" "), _c('p', [_vm._v("“Shaimaa? So he was the one who sent her to spy on us, what a cunning one, perhaps Laila had sensed from the start that she was bad, so she wanted her to leave.”")]), _vm._v(" "), _c('p', [_vm._v("He completed sadly, “One time, I entered one of the little girls’ rooms. I saw him raping her. I closed the door quickly and went back to my room. I didn’t know that he noticed me. After an hour, two huge men entered my room; they beat me and put me in that dark room. They tormented me severely.”")]), _vm._v(" "), _c('p', [_vm._v("“All of this! Oh my God, how did you get out?”")]), _vm._v(" "), _c('p', [_vm._v("He came to me after a dark week and said, “I am wrong that I made you nobleman, I will torment you till you die.”")]), _vm._v(" "), _c('p', [_vm._v("I begged him to leave me alone. He smiled and said, “If I leave you alone, you will go to Zaina and tell her everything. I won’t let you leave, but I can forgive you if you do what I tell you…”")]), _vm._v(" "), _c('p', [_vm._v("“I won’t go back to that dirty work,” I replied angrily.")]), _vm._v(" "), _c('p', [_vm._v("“You are not fit for it anymore,” he added, mockingly.")]), _vm._v(" "), _c('p', [_vm._v("“He asked me to accomplish strange request. He asked me to kill Hazem and kidnap you for him. Do not enter his house, Zaina. He wants you for himself. Your marriage to Hazem angered him. Every day he enters my room and threatens me if I do not fulfill what he asked for, he will kill my family. He really did it when I insisted on refusing; he killed my mother and my sister. Malik loves you very much and wants you for himself, he is mad of you!”")]), _vm._v(" "), _c('p', [_vm._v("“Malik! Malik! He killed them for me? And he wants to kill my husband? Why? Who am I! I am just a weak girl who almost has a heart. What a greedy savage man. Why does he want to kill Hazem? I used to live in his house and he never came near me!”")]), _vm._v(" "), _c('p', [_vm._v("So Reem did not lie and was not delirious.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jawad:")]), _vm._v(" “Yes, he considered you his daughter, but after your marriage, he felt that he would lose you forever. He said that he deserved you, not an ignorant as Hazem. Anyway, when he killed them, he threatened me that if I did not kill Hazem, he would destroy the rest of my family.”")]), _vm._v(" "), _c('p', [_vm._v("Before yesterday, he entered my room and said, “I will kill you if you do not go.”")]), _vm._v(" "), _c('p', [_vm._v("I replied, “Kill me and relieve me.” He sent a man and tortured me. I agreed out of fatigue, “Take me out and I will kill him.” He took me to his house for treatment. Kamal was there. He did not notice Kamal when we entered his house, but Kamal saw me and ignored me. He realized that Malik was an evil man. In the morning, Kamal sent a man to help me escape. Malik did not notice because he traveled before dawn; he came here to meet you. Never enter his house.")]), _vm._v(" "), _c('p', [_vm._v("I put my hand on his cheek and said, “Rest assured, my dear, he won’t know where you are. I will send you to a safe place. Forgive me. You will recover and you will be back, Jawad, a wonderful young gentleman. You will marry a beautiful girl, yes, a very beautiful girl.”")]), _vm._v(" "), _c('p', [_vm._v("“Never enter his house, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“Sleep, my little one, I will not enter. I promised Hazem that I would not enter it as long as I lived, as if he felt how malice Malik is.”")]), _vm._v(" "), _c('p', [_vm._v("I stayed beside him until he fell into a deep sleep. I put his blanket on him and went out. Hazem was standing at the door; he looked at me and said, “What are you going to do?”")]), _vm._v(" "), _c('p', [_vm._v("He was calm, steady, and strong. I knew from his look that he had heard everything, but he let me decide. We walked together towards the house. I asked him, “Do you promise me something, and I promise that nothing will hurt me.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hazem:")]), _vm._v(" “Anything, the important thing is that you stay safe and confident in what you are going to do.”")]), _vm._v(" "), _c('p', [_vm._v("He knew I was firm and what I would do would be useful and everyone would benefit.")]), _vm._v(" "), _c('p', [_vm._v("I said to him, “Good, we will have an emergency meeting.”")]), _vm._v(" "), _c('p', [_vm._v("I entered the big house. I do not know where all this calm came from, perhaps the decision needed calm and thought, or perhaps from the intensity of the fire that was inside me; I was afraid that it would burn what was left of my heart, so I poured snow over the fire!")]), _vm._v(" "), _c('p', [_vm._v("With a soft smile I asked the girls to go to their room, I was firm, but I spoke with a coldness I had never experienced before. They went up quietly.")]), _vm._v(" "), _c('p', [_vm._v("“What’s the matter, Zaina?” Laila asked me suspiciously.")]), _vm._v(" "), _c('p', [_vm._v("I told them everything. We came up with a firm plan from which Malik would never get out innocent again no matter how hard he would try.")]), _vm._v(" "), _c('p', [_vm._v("The next morning, Laila went to school. She met Shaimaa and started a discussion with her about how to develop the school’s affairs. Sarah went with Laila to learn everything about managing the school. Shaima looked at Sarah and said, “You are very beautiful, are you Mrs. Laila’s daughter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She is my niece, and I think that she will be my assistant at school. Zaina is tired and will not come often. She must be trained.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Shaima:")]), _vm._v(" “Oh really? What is the problem with Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“She is pregnant, you know how hard and painful the first months of pregnancy.”")]), _vm._v(" "), _c('p', [_vm._v("“Glad to hear that, when I saw her she was tired too. If you want I can train Sarah for you, I am an expert in school affairs.”")]), _vm._v(" "), _c('p', [_vm._v("“No thanks. Listen to me, Mrs. Shaima. Indeed, you will not work with us, and this is the last meeting between us.”")]), _vm._v(" "), _c('p', [_vm._v("“But I moved from my city to settle here. Lady Zaina told me that I have a place with you.”")]), _vm._v(" "), _c('p', [_vm._v("“Zaina did not ask me before she promised you; she did not take my opinion. I am responsible now, and I am informing you that you don’t have a place among us. Please go back to where you came from.”")]), _vm._v(" "), _c('p', [_vm._v("She rose wrathfully from her place and left without uttering a word.")]), _vm._v(" "), _c('p', [_vm._v("At noon, Malik sent his driver to me. He wanted to meet me on the farm, and this is what I was seeking for. Shaimaa must have gone to him and told him what happened between her and Laila. Jawad must be hidden, as Malik is watching us very well and I am afraid that he will find out everything.")]), _vm._v(" "), _c('p', [_vm._v("I asked Hazem to put Jawad in his old cart, cover him and take him to our small house and stay with him. I begged him not to leave the house no matter what happened, but then I thought, since Malik is watching us, surely, he knows about the small house.")]), _vm._v(" "), _c('p', [_vm._v("In the basement of the school, there are many rooms; perhaps Karim was using them to hide his dirty works I sent Maryam to the school to arrange a room for them. She prepared a good room for Hazem, Jawad, and Doctor Ashraf.")]), _vm._v(" "), _c('p', [_vm._v("Hazem never argued with me, he took Jawad and the doctor and headed to school, while I went to meet Malik.")]), _vm._v(" "), _c('p', [_vm._v("He approached me and asked, “Do you trust that Laila?”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t trust anyone, can you ask them to bring a chair to sit on; I’m tired.”")]), _vm._v(" "), _c('p', [_vm._v("“Come to my house, it’s near; we’ll sit there and talk.”")]), _vm._v(" "), _c('p', [_vm._v("“Not today, I miss your house so much.”")]), _vm._v(" "), _c('p', [_vm._v("“Why? Oh my dear, you look so tired.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, pregnancy is tiring, and problems with everyone, I am tired of everyone.”")]), _vm._v(" "), _c('p', [_vm._v("“What is going on with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Where’s the chair?”")]), _vm._v(" "), _c('p', [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', [_vm._v("He asked one of the workers to bring us two chairs at once; we sat across from each other. I was wearing my most beautiful dress, and a nice hat. I meant to look very beautiful! He looked at me directly and said, “Can I bring you something to eat?” Wasn’t the house better?")]), _vm._v(" "), _c('p', [_vm._v("“Why did you call me? And why did you ask me about Laila?”")]), _vm._v(" "), _c('p', [_vm._v("“I see you’re in a bad mood!”")]), _vm._v(" "), _c('p', [_vm._v("“When you find out that you took bad decision, how is your mood going to be? When you discover that you were next to the one you love, and then you leave him for someone who does not deserve, how is your mood going to be?”")]), _vm._v(" "), _c('p', [_vm._v("“When you discover suddenly that you are fond of a person and you cannot get close to him, what do you do and how do you live?”")]), _vm._v(" "), _c('p', [_vm._v("“I do not understand you.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s okay, this is my life now and I have to be patient with it until I find a solution.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, why did Laila expel Mrs. Shaimaa?”")]), _vm._v(" "), _c('p', [_vm._v("“Did she really kick her out? And what is your relationship with her?”")]), _vm._v(" "), _c('p', [_vm._v("“I do not know her; she was the wife of an officer who he died at work. Kamal told me that, after she left your school, she called Kamal and sought help from him, so he spoke to me to solve her problem.”")]), _vm._v(" "), _c('p', [_vm._v("“Who gives her the authority to kick her out? Laila must be punished. I will stop her work at school.”")]), _vm._v(" "), _c('p', [_vm._v("“If you don’t tell me what’s up with you today, I’ll be really angry, Zaina.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you still care about me?”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand and said, “A lot, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m going to have a baby soon and I feel I chose the wrong father for him; oh my God he’s not fit to be a father! I can’t even stand him as a husband. Four months ago, I found out that I don’t love him, I can’t stand his presence in my life; what should I do? Whom do I turn to? I have no father, no mother, and no one.”")]), _vm._v(" "), _c('p', [_vm._v("The smile would have betrayed him if had he not realized himself at the last moment, but his looks were so clear, full of happiness and victory, and that’s what I really wanted.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Have I never been your father?”")]), _vm._v(" "), _c('p', [_vm._v("“I wish you were, I wish I was your daughter really, how warm your embrace was, oh my God, what I lost!”")]), _vm._v(" "), _c('p', [_vm._v("“You are still my daughter, sweetheart!”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know that I’m glad you called me today? But I must leave now, although I want to consult you on more than one subject.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing will happen if we stay another half an hour. Stay, my dear, and I’ll get you something to drink.”")]), _vm._v(" "), _c('p', [_vm._v("“I am tired of Laila and her control over me, I want to separate from all of them, I want to my child a noble family.”")]), _vm._v(" "), _c('p', [_vm._v("“Go back to my house and you’ll find everything you want.”")]), _vm._v(" "), _c('p', [_vm._v("“First of all, I want to expand my business.”")]), _vm._v(" "), _c('p', [_vm._v("“How?”")]), _vm._v(" "), _c('p', [_vm._v("“I want your house.”")]), _vm._v(" "), _c('p', [_vm._v("He pulled his hand away from me and walked away a little.")]), _vm._v(" "), _c('p', [_vm._v("“My house?”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you astonished? I want you to give it to me and turn it into a school for kids. Give me also some money, don’t worry you’ll live in my house.”")]), _vm._v(" "), _c('p', [_vm._v("“Perhaps the pregnancy has eaten your mind!”")]), _vm._v(" "), _c('p', [_vm._v("I got up and said, “I knew that you would not help me to be the noble lady that I want, it’s okay, I will do it alone, I will go to the lawyer and ask him to divorce me from Hazem and then…”")]), _vm._v(" "), _c('p', [_vm._v("“Are you getting divorced?”")]), _vm._v(" "), _c('p', [_vm._v("“You think I’m kidding, I kicked him out today and took all his money; he went back to his old cart.”")]), _vm._v(" "), _c('p', [_vm._v("I knew he was watching him and saw him with his old cart, we asked Faris to watch him from afar.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, one of my men told me he saw Mr. Hazem pulling a wretched old cart.”")]), _vm._v(" "), _c('p', [_vm._v("“Did he tell you where he went?”")]), _vm._v(" "), _c('p', [_vm._v("“He was heading out of town. Unfortunately, my man got busy with a passerby and didn’t follow him.”")]), _vm._v(" "), _c('p', [_vm._v("He was talking without concentration, the shock of the divorce made him say everything. Faris was the passerby who made his man busy. He prevented him from following Hazem as I planned.")]), _vm._v(" "), _c('p', [_vm._v("I said, “Today I will expel his sister and her family, because I can no longer stand their noise.”")]), _vm._v(" "), _c('p', [_vm._v("“And Laila?”")]), _vm._v(" "), _c('p', [_vm._v("“Laila! No, she’s my friend, I’ll hold her accountable for her mistakes but no, and I won’t fire her. If I kick her out, I lose the last member of my family.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, don’t throw her out.”")]), _vm._v(" "), _c('p', [_vm._v("It was necessary to keep Laila so that he would not suspect us. He knows that I love her and that she is the only sister I have in this world.")]), _vm._v(" "), _c('p', [_vm._v("“I will leave now.”")]), _vm._v(" "), _c('p', [_vm._v("“If I agree to turn my house to a school, will you live with me in my house in the neighboring city?”")]), _vm._v(" "), _c('p', [_vm._v("“Who runs my business?”")]), _vm._v(" "), _c('p', [_vm._v("“There are a lot of people who need work like this. You sit in your house and people run your business. At the end of every month, you meet with them. They give you reports for everything.”")]), _vm._v(" "), _c('p', [_vm._v("“If I live with you, how will you introduce me to people? Who will I be?”")]), _vm._v(" "), _c('p', [_vm._v("“My daughter, you were and still are.”")]), _vm._v(" "), _c('p', [_vm._v("“It doesn’t work anymore; I don’t want to be your daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“Why? You will be my daughter and your child will be my grandson.”")]), _vm._v(" "), _c('p', [_vm._v("“I do not want.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want?”")]), _vm._v(" "), _c('p', [_vm._v("“I want a pedigree worthy of my child; I want a father for my child, goodbye now.”")]), _vm._v(" "), _c('p', [_vm._v("He grabbed my hand tightly and said, “What do you mean, girl?”")]), _vm._v(" "), _c('p', [_vm._v("“Why do I only fit to be your daughter? Why can’t I be your wife? Goodbye, I don’t want to see you again, I’m leaving here for good.”")]), _vm._v(" "), _c('p', [_vm._v("I left him and went home, I was exhausted. Everyone was eagerly waiting for me. How eager I was to see Faris to check on Hazem and Jawad!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Faris:")]), _vm._v(" “Rest assured they are safe, no one has seen them there.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, now you will take all the girls including little Zaina and little Hazem and keep them at your house. I want the house empty in an hour. Only I, Laila and Maryam, will stay here. Please take care of them and bring them back tomorrow evening.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “What are you thinking about?”")]), _vm._v(" "), _c('p', [_vm._v("I told her, “Not now.”")]), _vm._v(" "), _c('p', [_vm._v("Faris left with the girls. Laila looked at me and said, “What are you thinking about? What are we going to do now?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re going to Malik.”")]), _vm._v(" "), _c('p', [_vm._v("“Me, Zaina? To Malik?”")]), _vm._v(" "), _c('p', [_vm._v("“Calm down, he will never attack you; on the contrary, you will go to him to put out his fire.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, what do you want me to tell him?”")]), _vm._v(" "), _c('p', [_vm._v("“You will tell him that I may die, and you will invite him to come here in the evening.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maryam:")]), _vm._v(" “God forbid.”")]), _vm._v(" "), _c('p', [_vm._v("I looked at Maryam and smiled.")]), _vm._v(" "), _c('p', [_vm._v("“Do you still have that knife?”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and said, “It never left me.”")]), _vm._v(" "), _c('p', [_vm._v("At first, he did not accept to meet her under the pretext of being busy, but when she told Dalal that it was very necessary and related to Zaina, he came quickly. Perhaps he did not believe me much or doubted something, as he is an expert in malice and fraud. Suddenly I tell him that I don’t want my husband and I want him; he must have thought that it was a hoax!")]), _vm._v(" "), _c('p', [_vm._v("He asked Laila calmly, “What is the matter?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “Zaina is very tired, she is behaving very stupidly, and she expelled her husband. She even took his clothes, he has become homeless. Moreover, she has just expelled Maryam’s family!”")]), _vm._v(" "), _c('p', [_vm._v("“Why are you telling me that? I have nothing to do.”")]), _vm._v(" "), _c('p', [_vm._v("“Because she is raving about you.”")]), _vm._v(" "), _c('p', [_vm._v("“Enough woman, I tried to convince her for years to be my daughter, and you know what she did.”")]), _vm._v(" "), _c('p', [_vm._v("“She was conscious and aware of what she was doing. It was not her fault that they tried to set you up a trap. After all the rumors, she had the right to stay away from you, but today she is raving about you and her child.”")]), _vm._v(" "), _c('p', [_vm._v("“What do you want now?”")]), _vm._v(" "), _c('p', [_vm._v("“Ashraf told me that her heart is very weak, and as soon as she gives birth, she may die.”")]), _vm._v(" "), _c('p', [_vm._v("“What did you say?”")]), _vm._v(" "), _c('p', [_vm._v("She started crying as if it was true; the thought of my death aroused her feelings of sadness. Perhaps she lived the idea and it was good to make him believe her.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Calm down, sit down, and tell me what’s up.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “She was very happy with the pregnancy. She waited for that moment for a long time. Ashraf told her to postpone it; at least until she finishes her treatment, but she refused.”")]), _vm._v(" "), _c('p', [_vm._v("Stubborn! Ever since she knew about her pregnancy, she became sad. She believed that she did not choose a man worthy to be a father for her child; she always dreamed of being a noble lady and giving her children that title. A week ago, she entered my room and said, “I will divorce Hazem and expel him, and I will ask Malik to marry me and give my child money and noble parentage.”")]), _vm._v(" "), _c('p', [_vm._v("I thought she was insane, but she expelled Hazem; she was not joking. A while ago, she asked if she died while giving birth, and did not give her newborn what she dreamed of, we must bury the child with her. She does not want him to suffer in life as she did. Then she added, “There is no father who has your tenderness and generosity.” She experienced it herself. I am afraid she will hurt herself.")]), _vm._v(" "), _c('p', [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m afraid if you don’t do what she asked you to do, she will kill herself. She is tired and doesn’t think with her mind. Ashraf told me to do what she asks, even if it is an illusion until she gives birth. Maybe God will save her life and live to raise her child, and then she will return to her nature. Ashraf gives her a cure that may help her to survive.”")]), _vm._v(" "), _c('p', [_vm._v("He almost lost his mind; he believes now the story.")]), _vm._v(" "), _c('p', [_vm._v("He said, “What do you advise me to do? Please I am ready for everything.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, she was honest when she said that you were the kindest father she has ever met.”")]), _vm._v(" "), _c('p', [_vm._v("“I have never considered her but a daughter, and I will give her my life.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, can you come in the evening and do what she asks of you? Just make her think you agree for all her requests. Don’t be afraid, I’m a witness and my husband Ashraf too on everything.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, I’ll come, I promise.”")]), _vm._v(" "), _c('p', [_vm._v("“She will know when she’s back to her normality how foolish she was when she walked away from you.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you think so?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sure of that.”")]), _vm._v(" "), _c('p', [_vm._v("He came eager, afraid, and worried. He even arrived early; I expected that. How easy it is for an honest lover to fall into the nets of his lover! He is convinced of his beloved’s words and is subject to his orders. I know that he loves me very much, as a daughter or a girlfriend, there is no difference. The most important thing today is to rest the girls from his evil and greed. Who would have believed that Malik is a womanizer? In a more correct sense, he is a trader of women who trades in their innocence and violates their honor.")]), _vm._v(" "), _c('p', [_vm._v("A woman was never created to be a slave to a man; she was not created to be a means of enjoyment. She is a mother, a sister, a wife, and everything virtuous in life.")]), _vm._v(" "), _c('p', [_vm._v("He came in while I was lying on the sofa claiming tiredness and exhaustion. Laila was sitting on the floor crying and saying, “Please, my dear, calm down.”")]), _vm._v(" "), _c('p', [_vm._v("He approached me quickly and sat in Laila’s place and asked her to leave us alone. She went with her eyes asking me, “Are you safe?”")]), _vm._v(" "), _c('p', [_vm._v("I answered her in her own way, “Don’t be afraid.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “What’s wrong with you, little girl? What is the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe I made a mistake when I decided to get pregnant.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry, I’ll get you the most skilled doctors, and I’ll raise your baby girl.”")]), _vm._v(" "), _c('p', [_vm._v("I smiled and said, “Why do you think it will be a girl? Why not to be a boy?”")]), _vm._v(" "), _c('p', [_vm._v("“No, my dear, you will have a beautiful girl like you who will have your eyes and be my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you agree?”")]), _vm._v(" "), _c('p', [_vm._v("“For what?”")]), _vm._v(" "), _c('p', [_vm._v("“To marry me and my daughter carry your name?”")]), _vm._v(" "), _c('p', [_vm._v("“No, but when you give birth to your baby, I’ll take her and adopt her.”")]), _vm._v(" "), _c('p', [_vm._v("I pulled my hand hard and said, “You crook, you want to steal my daughter from me, maybe you want me to die and take my daughter.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t mean that, believe me!”")]), _vm._v(" "), _c('p', [_vm._v("“My God! My heart will stop and my daughter and I will die.”")]), _vm._v(" "), _c('p', [_vm._v("“Sit down and relax, where’s Laila? Come and testify, I will fulfill all Zaina’s requests now.”")]), _vm._v(" "), _c('p', [_vm._v("I said, “You will call the lawyer and tell him that I am your heir, if you die, God forbid.”")]), _vm._v(" "), _c('p', [_vm._v("He rose angrily and said, “Are you crazy?”")]), _vm._v(" "), _c('p', [_vm._v("“Wasn’t I your daughter and you were going to do it anyway?”")]), _vm._v(" "), _c('p', [_vm._v("Laila approached him and whispered to him, “Agree on all her requests. Believe me, if she dies, I will give you the girl at once.”")]), _vm._v(" "), _c('p', [_vm._v("He looked at Laila and said, “You idiot! Who said I want her to die?” Then he added, “Listen, Zaina, I will give you the house to do with it what you want, but I will not leave you my wealth, you may live a hundred years and I may die before you.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t say that, leave please, don’t die, I can’t be alive while you are dead. I didn’t know a father but you. Leave now, thank you for coming. Maybe I was delirious, I was definitely delirious, please forgive me. I’ll make you coffee by myself and then if you want to leave, leave.”")]), _vm._v(" "), _c('p', [_vm._v("“Why didn’t you stay under my wing? If you were my daughter, I would make you inherit everything, and I would be the grandfather of the baby girl now.”")]), _vm._v(" "), _c('p', [_vm._v("“You insist it’s a baby girl? You better leave.”")]), _vm._v(" "), _c('p', [_vm._v("I meant that, I want him to leave. I can no longer complete the plan, and he is very smart and I am afraid that he will reveal us. From the intensity of the tension, my nose began to bleed and blood flowed quickly. He approached me and said, “Oh, my God, you’re bleeding!”")]), _vm._v(" "), _c('p', [_vm._v("I took tissues and started wiping the blood. He said to me, “Well, my dear, I will call the lawyer, but promise me when you will give birth to the baby, you will both stay with me.”")]), _vm._v(" "), _c('p', [_vm._v("“If I live.”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Laila:")]), _vm._v(" “You will live and raise the child.”")]), _vm._v(" "), _c('p', [_vm._v("He called the lawyer and told him, “I want you to write my will. I want to leave everything I own to Zaina Fouad after my death.”")]), _vm._v(" "), _c('p', [_vm._v("He was silent for a few moments, as if the other was telling him something. He added, “It’s okay; I will go to Shaimaa and speak with her. I will give her money. She can stay in her house.” He turned to me and said, “Are you comfortable now?”")]), _vm._v(" "), _c('p', [_vm._v("“I want you to write it down on a piece of paper and sign it.”")]), _vm._v(" "), _c('p', [_vm._v("“Is this necessary?”")]), _vm._v(" "), _c('p', [_vm._v("“Sure. When you go home, you will tell the lawyer that you were joking or babbling.”")]), _vm._v(" "), _c('p', [_vm._v("The blood was still flowing from my nose…")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Malik:")]), _vm._v(" “Well, bring a pen and paper.”")]), _vm._v(" "), _c('p', [_vm._v("Laila brought a piece of paper and a pen and whispered to him again, “It’s okay, I’ll rip it off.”")]), _vm._v(" "), _c('p', [_vm._v("He wrote in the paper that I was his heir and signed it.")]), _vm._v(" "), _c('p', [_vm._v("Maryam came from behind him; I looked at her and said, “Don’t, please.”")]), _vm._v(" "), _c('p', [_vm._v("She smiled and plunged her knife into him.")]), _vm._v(" "), _c('p', [_vm._v("“I will tear you apart as you tore the hearts of girls, when you threw their infants out into the streets. I will deprive you from life as you deprived those girls from their freedom and turned them to whores.”")]), _vm._v(" "), _c('p', [_vm._v("I asked him, while he was writhing in pain, “Did you really kidnap me from my father?”")]), _vm._v(" "), _c('p', [_vm._v("He smiled in spite of all his pain.")]), _vm._v(" "), _c('p', [_vm._v("“He loved you and I was very jealous of him. After I poisoned him, I stole his box. He left you the letter, the doll, and the bracelet. He left you to me. I didn’t know you were so strong, and I will die now in your hands.”")]), _vm._v(" "), _c('p', [_vm._v("I pulled the knife from Maryam’s hand and stuck it directly into his heart. I never thought I would use that knife that I always hated! I couldn’t look any more, I opened the door; Hazem was standing behind it. He couldn’t leave us; he was watching us all the time. I was broken, collapsed, crying, he hugged me and said, “It’s okay, my dear, it is okay.”")]), _vm._v(" "), _c('p', [_vm._v("I fainted; Hazem carried me and put me on my bed. He completed the task with his sister, as they did with Amjad; they threw him into the river. Maryam cleaned up the mess, as if nothing had happened.")]), _vm._v(" "), _c('p', [_vm._v("Laila was very attentive to Malik’s call with the lawyer. She took the knife that was covered with Malik’s blood. After wiping our fingerprints on it, she hid it in Shaimaa’s house.")]), _vm._v(" "), _c('p', [_vm._v("Several days later, Kamal and other investigators visited us and asked to see me immediately…")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “How are you, Lady Zaina?”")]), _vm._v(" "), _c('p', [_vm._v("“Very tired, only yesterday I was able to get out of my bed; your appearance is very worrying, what’s the matter?”")]), _vm._v(" "), _c('p', [_vm._v("“Malik has died.”")]), _vm._v(" "), _c('p', [_vm._v("“What?”")]), _vm._v(" "), _c('p', [_vm._v("I was basically tired and sad. Tears started to flow from my eyes. I was definitely not crying for him. Actually, he was not worth a tear, but I was sad about the situation and the image when I inserted the knife in his heart. I was sad over beautiful moments I spent with him; whenever I remembered them, he would be there. Whenever I wore a dress or a necklace, he would be present. I wish I had never met him, but it is good that I met him. I revealed him. How many girls will be tormented under his hands, if I didn’t stop him? I may have been put on his way to end the suffering of them. I am suffering from the torrent of memories; I wish I could stop them. He is the one who forced us to do this, I must adapt to the new situation.")]), _vm._v(" "), _c('p', [_vm._v("I asked Kamal, “When and how?”")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kamal:")]), _vm._v(" “On the same day he visited you, he left you and headed to Shaimaa’s house. She killed him. The lawyer told us that there was a big dispute between them. We found the crime instrument in her house; she stabbed him with a knife. Strange! I almost believed her that she did not see him that night; she defended herself fiercely, but all the evidence were against her. The lawyer and Dalal assure us that Malik told them he would visit her that day. Moreover, there was a boy in the neighborhood who told us that a man came to visit her.”")]), _vm._v(" "), _c('p', [_vm._v("“By the way, my dear, Malik left you all his wealth, he told the lawyer to write in his will that Zaina Fouad will be the owner of his wealth completely. He told me on that day that he would leave everything for me, and gave me a paper on that. I did not understand anything; he called the lawyer and told him that. Perhaps he felt that his time had come.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, my dear, you should visit the lawyer and finish the papers with him.”")]), _vm._v(" "), _c('p', [_vm._v("Kamal left after he offered his condolences.")]), _vm._v(" "), _c('p', [_vm._v("I looked at Laila and said, “I inherited everything, I want nothing… I’m going to my small house now. Get Jawad and let him enjoy his freedom, and let him marry the most beautiful girl, and let him live in his house. Bring all the oppressed girls in the neighboring city and the villages in which Malik was controlling. We will turn his house into a school. We will turn his house, in another city, to an orphanage for all those little girls who have lost their mothers unjustly. May some of them meet their real mothers and live with them.”")]), _vm._v(" "), _c('p', [_vm._v("I gave my orders firmly because today I am the lady of the city and its noblewoman. I became noble when I defended the rights and sanctity of the city. The nobility of morals is not surpassed by any nobility of life!")]), _vm._v(" "), _c('p', [_vm._v("I lost Malik and lost a part of myself after that. I lost the quiet Zaina who hates to see blood, I lost the innocent Zaina. I need time to recover from Malik, who embraced me as a daughter. He died between my hands and by my knife! It became my knife after it was my enemy all my life!")]), _vm._v(" "), _c('p', [_vm._v("I walked back to my house. I stood among my flowers beside my small house, rather my wonderful kingdom. I was wearing a long white dress decorated with red flowers, putting on my head a white hat with a red ribbon. I put my father’s bracelet around my wrist. I mixed with the beauty of my garden. Hazem followed me and approached me, after which he put his hand on my shoulder, and said, “I love you, my little girl.”")]), _vm._v(" "), _c('p', [_vm._v("The woman was created to be the most powerful creature on earth. What a woman can bear, no one can tolerate in any place and time.")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9789948043430',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(82)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(84);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 84 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.202aa1a2490afd2e21b2.js